import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AdminCreateUserOutputObject: { input: any; output: any; }
  DeleteFileOutputObject: { input: any; output: any; }
  ForgotPasswordOutputObject: { input: any; output: any; }
  GetPresignedUploadUrlOutputObject: { input: any; output: any; }
  InsertMultipleFileS3OutputObject: { input: any; output: any; }
  LoginCognitoOutputObject: { input: any; output: any; }
  RegisterOutputObject: { input: any; output: any; }
  ResendConfirmOutputObject: { input: any; output: any; }
  ResetPasswordOutputObject: { input: any; output: any; }
  VerifyEmailOutputObject: { input: any; output: any; }
  banners_scalar: { input: any; output: any; }
  bigint: { input: any; output: any; }
  categories_scalar: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  numeric: { input: any; output: any; }
  posts_scalar: { input: any; output: any; }
  timestamp: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
  users_scalar: { input: any; output: any; }
};

export type AdminCreateUserOutput = {
  __typename?: 'AdminCreateUserOutput';
  code: Scalars['String']['output'];
  data?: Maybe<Scalars['AdminCreateUserOutputObject']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type DeleteFileOutput = {
  __typename?: 'DeleteFileOutput';
  code: Scalars['String']['output'];
  data?: Maybe<Scalars['DeleteFileOutputObject']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ForgotPasswordOutput = {
  __typename?: 'ForgotPasswordOutput';
  code: Scalars['String']['output'];
  data?: Maybe<Scalars['ForgotPasswordOutputObject']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type GetPresignedUploadUrlOutput = {
  __typename?: 'GetPresignedUploadUrlOutput';
  code: Scalars['String']['output'];
  data?: Maybe<Scalars['GetPresignedUploadUrlOutputObject']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type InsertMultipleFileS3Input = {
  filename?: InputMaybe<Scalars['String']['input']>;
  filetype: Scalars['String']['input'];
  object_id: Scalars['Int']['input'];
  subtype: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type InsertMultipleFileS3Output = {
  __typename?: 'InsertMultipleFileS3Output';
  code: Scalars['String']['output'];
  data?: Maybe<Scalars['InsertMultipleFileS3OutputObject']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type LoginCognitoOutput = {
  __typename?: 'LoginCognitoOutput';
  code: Scalars['String']['output'];
  data?: Maybe<Scalars['LoginCognitoOutputObject']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type RegisterOutput = {
  __typename?: 'RegisterOutput';
  code: Scalars['String']['output'];
  data?: Maybe<Scalars['RegisterOutputObject']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ResendConfirmOutput = {
  __typename?: 'ResendConfirmOutput';
  code: Scalars['String']['output'];
  data?: Maybe<Scalars['ResendConfirmOutputObject']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ResetPasswordOutput = {
  __typename?: 'ResetPasswordOutput';
  code: Scalars['String']['output'];
  data?: Maybe<Scalars['ResetPasswordOutputObject']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

export type VerifyEmailOutput = {
  __typename?: 'VerifyEmailOutput';
  code: Scalars['String']['output'];
  data?: Maybe<Scalars['VerifyEmailOutputObject']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AdminChangeUserPasswordOutput = {
  __typename?: 'adminChangeUserPasswordOutput';
  code: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "advertisement_types" */
export type Advertisement_Types = {
  __typename?: 'advertisement_types';
  description?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "advertisement_types" */
export type Advertisement_Types_Aggregate = {
  __typename?: 'advertisement_types_aggregate';
  aggregate?: Maybe<Advertisement_Types_Aggregate_Fields>;
  nodes: Array<Advertisement_Types>;
};

/** aggregate fields of "advertisement_types" */
export type Advertisement_Types_Aggregate_Fields = {
  __typename?: 'advertisement_types_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Advertisement_Types_Max_Fields>;
  min?: Maybe<Advertisement_Types_Min_Fields>;
};


/** aggregate fields of "advertisement_types" */
export type Advertisement_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Advertisement_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "advertisement_types". All fields are combined with a logical 'AND'. */
export type Advertisement_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Advertisement_Types_Bool_Exp>>;
  _not?: InputMaybe<Advertisement_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Advertisement_Types_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "advertisement_types" */
export enum Advertisement_Types_Constraint {
  /** unique or primary key constraint on columns "value" */
  AdvertisementTypesPkey = 'advertisement_types_pkey'
}

export enum Advertisement_Types_Enum {
  /** Tư vấn quảng cáo */
  AbvertisingConsulting = 'ABVERTISING_CONSULTING',
  /** Đặt báo online */
  OrderNewspaperOnline = 'ORDER_NEWSPAPER_ONLINE'
}

/** Boolean expression to compare columns of type "advertisement_types_enum". All fields are combined with logical 'AND'. */
export type Advertisement_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Advertisement_Types_Enum>;
  _in?: InputMaybe<Array<Advertisement_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Advertisement_Types_Enum>;
  _nin?: InputMaybe<Array<Advertisement_Types_Enum>>;
};

/** input type for inserting data into table "advertisement_types" */
export type Advertisement_Types_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Advertisement_Types_Max_Fields = {
  __typename?: 'advertisement_types_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Advertisement_Types_Min_Fields = {
  __typename?: 'advertisement_types_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "advertisement_types" */
export type Advertisement_Types_Mutation_Response = {
  __typename?: 'advertisement_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Advertisement_Types>;
};

/** input type for inserting object relation for remote table "advertisement_types" */
export type Advertisement_Types_Obj_Rel_Insert_Input = {
  data: Advertisement_Types_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Advertisement_Types_On_Conflict>;
};

/** on_conflict condition type for table "advertisement_types" */
export type Advertisement_Types_On_Conflict = {
  constraint: Advertisement_Types_Constraint;
  update_columns?: Array<Advertisement_Types_Update_Column>;
  where?: InputMaybe<Advertisement_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "advertisement_types". */
export type Advertisement_Types_Order_By = {
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: advertisement_types */
export type Advertisement_Types_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "advertisement_types" */
export enum Advertisement_Types_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "advertisement_types" */
export type Advertisement_Types_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "advertisement_types" */
export type Advertisement_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Advertisement_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Advertisement_Types_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "advertisement_types" */
export enum Advertisement_Types_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Advertisement_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Advertisement_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Advertisement_Types_Bool_Exp;
};

/** columns and relationships of "advertisements" */
export type Advertisements = {
  __typename?: 'advertisements';
  city: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by?: Maybe<Users>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  district: Scalars['String']['output'];
  email: Scalars['String']['output'];
  full_name: Scalars['String']['output'];
  has_invoice: Scalars['Boolean']['output'];
  id: Scalars['bigint']['output'];
  phone_number: Scalars['String']['output'];
  street: Scalars['String']['output'];
  type: Advertisement_Types_Enum;
  /** An object relationship */
  type_obj: Advertisement_Types;
  ward: Scalars['String']['output'];
};

/** aggregated selection of "advertisements" */
export type Advertisements_Aggregate = {
  __typename?: 'advertisements_aggregate';
  aggregate?: Maybe<Advertisements_Aggregate_Fields>;
  nodes: Array<Advertisements>;
};

/** aggregate fields of "advertisements" */
export type Advertisements_Aggregate_Fields = {
  __typename?: 'advertisements_aggregate_fields';
  avg?: Maybe<Advertisements_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Advertisements_Max_Fields>;
  min?: Maybe<Advertisements_Min_Fields>;
  stddev?: Maybe<Advertisements_Stddev_Fields>;
  stddev_pop?: Maybe<Advertisements_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Advertisements_Stddev_Samp_Fields>;
  sum?: Maybe<Advertisements_Sum_Fields>;
  var_pop?: Maybe<Advertisements_Var_Pop_Fields>;
  var_samp?: Maybe<Advertisements_Var_Samp_Fields>;
  variance?: Maybe<Advertisements_Variance_Fields>;
};


/** aggregate fields of "advertisements" */
export type Advertisements_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Advertisements_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Advertisements_Avg_Fields = {
  __typename?: 'advertisements_avg_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "advertisements". All fields are combined with a logical 'AND'. */
export type Advertisements_Bool_Exp = {
  _and?: InputMaybe<Array<Advertisements_Bool_Exp>>;
  _not?: InputMaybe<Advertisements_Bool_Exp>;
  _or?: InputMaybe<Array<Advertisements_Bool_Exp>>;
  city?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Users_Bool_Exp>;
  created_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  district?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  has_invoice?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  street?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Advertisement_Types_Enum_Comparison_Exp>;
  type_obj?: InputMaybe<Advertisement_Types_Bool_Exp>;
  ward?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "advertisements" */
export enum Advertisements_Constraint {
  /** unique or primary key constraint on columns "id" */
  AdvertisementsPkey = 'advertisements_pkey'
}

/** input type for incrementing numeric columns in table "advertisements" */
export type Advertisements_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "advertisements" */
export type Advertisements_Insert_Input = {
  city?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  has_invoice?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Advertisement_Types_Enum>;
  type_obj?: InputMaybe<Advertisement_Types_Obj_Rel_Insert_Input>;
  ward?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Advertisements_Max_Fields = {
  __typename?: 'advertisements_max_fields';
  city?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  ward?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Advertisements_Min_Fields = {
  __typename?: 'advertisements_min_fields';
  city?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  ward?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "advertisements" */
export type Advertisements_Mutation_Response = {
  __typename?: 'advertisements_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Advertisements>;
};

/** on_conflict condition type for table "advertisements" */
export type Advertisements_On_Conflict = {
  constraint: Advertisements_Constraint;
  update_columns?: Array<Advertisements_Update_Column>;
  where?: InputMaybe<Advertisements_Bool_Exp>;
};

/** Ordering options when selecting data from "advertisements". */
export type Advertisements_Order_By = {
  city?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Users_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  district?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  has_invoice?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  type_obj?: InputMaybe<Advertisement_Types_Order_By>;
  ward?: InputMaybe<Order_By>;
};

/** primary key columns input for table: advertisements */
export type Advertisements_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "advertisements" */
export enum Advertisements_Select_Column {
  /** column name */
  City = 'city',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  District = 'district',
  /** column name */
  Email = 'email',
  /** column name */
  FullName = 'full_name',
  /** column name */
  HasInvoice = 'has_invoice',
  /** column name */
  Id = 'id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  Street = 'street',
  /** column name */
  Type = 'type',
  /** column name */
  Ward = 'ward'
}

/** input type for updating data in table "advertisements" */
export type Advertisements_Set_Input = {
  city?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  has_invoice?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Advertisement_Types_Enum>;
  ward?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Advertisements_Stddev_Fields = {
  __typename?: 'advertisements_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Advertisements_Stddev_Pop_Fields = {
  __typename?: 'advertisements_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Advertisements_Stddev_Samp_Fields = {
  __typename?: 'advertisements_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "advertisements" */
export type Advertisements_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Advertisements_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Advertisements_Stream_Cursor_Value_Input = {
  city?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  has_invoice?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Advertisement_Types_Enum>;
  ward?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Advertisements_Sum_Fields = {
  __typename?: 'advertisements_sum_fields';
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "advertisements" */
export enum Advertisements_Update_Column {
  /** column name */
  City = 'city',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  District = 'district',
  /** column name */
  Email = 'email',
  /** column name */
  FullName = 'full_name',
  /** column name */
  HasInvoice = 'has_invoice',
  /** column name */
  Id = 'id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  Street = 'street',
  /** column name */
  Type = 'type',
  /** column name */
  Ward = 'ward'
}

export type Advertisements_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Advertisements_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Advertisements_Set_Input>;
  /** filter the rows which have to be updated */
  where: Advertisements_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Advertisements_Var_Pop_Fields = {
  __typename?: 'advertisements_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Advertisements_Var_Samp_Fields = {
  __typename?: 'advertisements_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Advertisements_Variance_Fields = {
  __typename?: 'advertisements_variance_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "banners" */
export type Banners = {
  __typename?: 'banners';
  /** An array relationship */
  banners_categories: Array<Banners_Categories>;
  /** An aggregate relationship */
  banners_categories_aggregate: Banners_Categories_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by?: Maybe<Users>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  deleted_by?: Maybe<Users>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['bigint']['output'];
  /** An object relationship */
  image_subtype?: Maybe<Image_Subtypes>;
  /** A computed field, executes function "get_banner_images" */
  images?: Maybe<Array<Images>>;
  position?: Maybe<Image_Subtypes_Enum>;
  /** An object relationship */
  position_obj?: Maybe<Image_Subtypes>;
  target_link?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  updated_by?: Maybe<Users>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};


/** columns and relationships of "banners" */
export type BannersBanners_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Banners_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Banners_Categories_Order_By>>;
  where?: InputMaybe<Banners_Categories_Bool_Exp>;
};


/** columns and relationships of "banners" */
export type BannersBanners_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Banners_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Banners_Categories_Order_By>>;
  where?: InputMaybe<Banners_Categories_Bool_Exp>;
};


/** columns and relationships of "banners" */
export type BannersImagesArgs = {
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};

/** aggregated selection of "banners" */
export type Banners_Aggregate = {
  __typename?: 'banners_aggregate';
  aggregate?: Maybe<Banners_Aggregate_Fields>;
  nodes: Array<Banners>;
};

export type Banners_Aggregate_Bool_Exp = {
  count?: InputMaybe<Banners_Aggregate_Bool_Exp_Count>;
};

export type Banners_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Banners_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Banners_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "banners" */
export type Banners_Aggregate_Fields = {
  __typename?: 'banners_aggregate_fields';
  avg?: Maybe<Banners_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Banners_Max_Fields>;
  min?: Maybe<Banners_Min_Fields>;
  stddev?: Maybe<Banners_Stddev_Fields>;
  stddev_pop?: Maybe<Banners_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Banners_Stddev_Samp_Fields>;
  sum?: Maybe<Banners_Sum_Fields>;
  var_pop?: Maybe<Banners_Var_Pop_Fields>;
  var_samp?: Maybe<Banners_Var_Samp_Fields>;
  variance?: Maybe<Banners_Variance_Fields>;
};


/** aggregate fields of "banners" */
export type Banners_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Banners_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "banners" */
export type Banners_Aggregate_Order_By = {
  avg?: InputMaybe<Banners_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Banners_Max_Order_By>;
  min?: InputMaybe<Banners_Min_Order_By>;
  stddev?: InputMaybe<Banners_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Banners_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Banners_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Banners_Sum_Order_By>;
  var_pop?: InputMaybe<Banners_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Banners_Var_Samp_Order_By>;
  variance?: InputMaybe<Banners_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "banners" */
export type Banners_Arr_Rel_Insert_Input = {
  data: Array<Banners_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Banners_On_Conflict>;
};

/** aggregate avg on columns */
export type Banners_Avg_Fields = {
  __typename?: 'banners_avg_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "banners" */
export type Banners_Avg_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "banners". All fields are combined with a logical 'AND'. */
export type Banners_Bool_Exp = {
  _and?: InputMaybe<Array<Banners_Bool_Exp>>;
  _not?: InputMaybe<Banners_Bool_Exp>;
  _or?: InputMaybe<Array<Banners_Bool_Exp>>;
  banners_categories?: InputMaybe<Banners_Categories_Bool_Exp>;
  banners_categories_aggregate?: InputMaybe<Banners_Categories_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Users_Bool_Exp>;
  created_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_by?: InputMaybe<Users_Bool_Exp>;
  deleted_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  image_subtype?: InputMaybe<Image_Subtypes_Bool_Exp>;
  images?: InputMaybe<Images_Bool_Exp>;
  position?: InputMaybe<Image_Subtypes_Enum_Comparison_Exp>;
  position_obj?: InputMaybe<Image_Subtypes_Bool_Exp>;
  target_link?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Users_Bool_Exp>;
  updated_by_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** columns and relationships of "banners_categories" */
export type Banners_Categories = {
  __typename?: 'banners_categories';
  /** An object relationship */
  banner: Banners;
  banner_id: Scalars['bigint']['output'];
  /** An object relationship */
  category: Categories;
  category_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "banners_categories" */
export type Banners_Categories_Aggregate = {
  __typename?: 'banners_categories_aggregate';
  aggregate?: Maybe<Banners_Categories_Aggregate_Fields>;
  nodes: Array<Banners_Categories>;
};

export type Banners_Categories_Aggregate_Bool_Exp = {
  count?: InputMaybe<Banners_Categories_Aggregate_Bool_Exp_Count>;
};

export type Banners_Categories_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Banners_Categories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Banners_Categories_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "banners_categories" */
export type Banners_Categories_Aggregate_Fields = {
  __typename?: 'banners_categories_aggregate_fields';
  avg?: Maybe<Banners_Categories_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Banners_Categories_Max_Fields>;
  min?: Maybe<Banners_Categories_Min_Fields>;
  stddev?: Maybe<Banners_Categories_Stddev_Fields>;
  stddev_pop?: Maybe<Banners_Categories_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Banners_Categories_Stddev_Samp_Fields>;
  sum?: Maybe<Banners_Categories_Sum_Fields>;
  var_pop?: Maybe<Banners_Categories_Var_Pop_Fields>;
  var_samp?: Maybe<Banners_Categories_Var_Samp_Fields>;
  variance?: Maybe<Banners_Categories_Variance_Fields>;
};


/** aggregate fields of "banners_categories" */
export type Banners_Categories_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Banners_Categories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "banners_categories" */
export type Banners_Categories_Aggregate_Order_By = {
  avg?: InputMaybe<Banners_Categories_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Banners_Categories_Max_Order_By>;
  min?: InputMaybe<Banners_Categories_Min_Order_By>;
  stddev?: InputMaybe<Banners_Categories_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Banners_Categories_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Banners_Categories_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Banners_Categories_Sum_Order_By>;
  var_pop?: InputMaybe<Banners_Categories_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Banners_Categories_Var_Samp_Order_By>;
  variance?: InputMaybe<Banners_Categories_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "banners_categories" */
export type Banners_Categories_Arr_Rel_Insert_Input = {
  data: Array<Banners_Categories_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Banners_Categories_On_Conflict>;
};

/** aggregate avg on columns */
export type Banners_Categories_Avg_Fields = {
  __typename?: 'banners_categories_avg_fields';
  banner_id?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "banners_categories" */
export type Banners_Categories_Avg_Order_By = {
  banner_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "banners_categories". All fields are combined with a logical 'AND'. */
export type Banners_Categories_Bool_Exp = {
  _and?: InputMaybe<Array<Banners_Categories_Bool_Exp>>;
  _not?: InputMaybe<Banners_Categories_Bool_Exp>;
  _or?: InputMaybe<Array<Banners_Categories_Bool_Exp>>;
  banner?: InputMaybe<Banners_Bool_Exp>;
  banner_id?: InputMaybe<Bigint_Comparison_Exp>;
  category?: InputMaybe<Categories_Bool_Exp>;
  category_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "banners_categories" */
export enum Banners_Categories_Constraint {
  /** unique or primary key constraint on columns "id" */
  BannersCategoriesPkey = 'banners_categories_pkey'
}

/** input type for incrementing numeric columns in table "banners_categories" */
export type Banners_Categories_Inc_Input = {
  banner_id?: InputMaybe<Scalars['bigint']['input']>;
  category_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "banners_categories" */
export type Banners_Categories_Insert_Input = {
  banner?: InputMaybe<Banners_Obj_Rel_Insert_Input>;
  banner_id?: InputMaybe<Scalars['bigint']['input']>;
  category?: InputMaybe<Categories_Obj_Rel_Insert_Input>;
  category_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Banners_Categories_Max_Fields = {
  __typename?: 'banners_categories_max_fields';
  banner_id?: Maybe<Scalars['bigint']['output']>;
  category_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "banners_categories" */
export type Banners_Categories_Max_Order_By = {
  banner_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Banners_Categories_Min_Fields = {
  __typename?: 'banners_categories_min_fields';
  banner_id?: Maybe<Scalars['bigint']['output']>;
  category_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "banners_categories" */
export type Banners_Categories_Min_Order_By = {
  banner_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "banners_categories" */
export type Banners_Categories_Mutation_Response = {
  __typename?: 'banners_categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Banners_Categories>;
};

/** on_conflict condition type for table "banners_categories" */
export type Banners_Categories_On_Conflict = {
  constraint: Banners_Categories_Constraint;
  update_columns?: Array<Banners_Categories_Update_Column>;
  where?: InputMaybe<Banners_Categories_Bool_Exp>;
};

/** Ordering options when selecting data from "banners_categories". */
export type Banners_Categories_Order_By = {
  banner?: InputMaybe<Banners_Order_By>;
  banner_id?: InputMaybe<Order_By>;
  category?: InputMaybe<Categories_Order_By>;
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: banners_categories */
export type Banners_Categories_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "banners_categories" */
export enum Banners_Categories_Select_Column {
  /** column name */
  BannerId = 'banner_id',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "banners_categories" */
export type Banners_Categories_Set_Input = {
  banner_id?: InputMaybe<Scalars['bigint']['input']>;
  category_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Banners_Categories_Stddev_Fields = {
  __typename?: 'banners_categories_stddev_fields';
  banner_id?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "banners_categories" */
export type Banners_Categories_Stddev_Order_By = {
  banner_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Banners_Categories_Stddev_Pop_Fields = {
  __typename?: 'banners_categories_stddev_pop_fields';
  banner_id?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "banners_categories" */
export type Banners_Categories_Stddev_Pop_Order_By = {
  banner_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Banners_Categories_Stddev_Samp_Fields = {
  __typename?: 'banners_categories_stddev_samp_fields';
  banner_id?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "banners_categories" */
export type Banners_Categories_Stddev_Samp_Order_By = {
  banner_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "banners_categories" */
export type Banners_Categories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Banners_Categories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Banners_Categories_Stream_Cursor_Value_Input = {
  banner_id?: InputMaybe<Scalars['bigint']['input']>;
  category_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Banners_Categories_Sum_Fields = {
  __typename?: 'banners_categories_sum_fields';
  banner_id?: Maybe<Scalars['bigint']['output']>;
  category_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "banners_categories" */
export type Banners_Categories_Sum_Order_By = {
  banner_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "banners_categories" */
export enum Banners_Categories_Update_Column {
  /** column name */
  BannerId = 'banner_id',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Id = 'id'
}

export type Banners_Categories_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Banners_Categories_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Banners_Categories_Set_Input>;
  /** filter the rows which have to be updated */
  where: Banners_Categories_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Banners_Categories_Var_Pop_Fields = {
  __typename?: 'banners_categories_var_pop_fields';
  banner_id?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "banners_categories" */
export type Banners_Categories_Var_Pop_Order_By = {
  banner_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Banners_Categories_Var_Samp_Fields = {
  __typename?: 'banners_categories_var_samp_fields';
  banner_id?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "banners_categories" */
export type Banners_Categories_Var_Samp_Order_By = {
  banner_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Banners_Categories_Variance_Fields = {
  __typename?: 'banners_categories_variance_fields';
  banner_id?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "banners_categories" */
export type Banners_Categories_Variance_Order_By = {
  banner_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "banners" */
export enum Banners_Constraint {
  /** unique or primary key constraint on columns "id" */
  BannersPkey = 'banners_pkey'
}

/** input type for incrementing numeric columns in table "banners" */
export type Banners_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "banners" */
export type Banners_Insert_Input = {
  banners_categories?: InputMaybe<Banners_Categories_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  image_subtype?: InputMaybe<Image_Subtypes_Obj_Rel_Insert_Input>;
  position?: InputMaybe<Image_Subtypes_Enum>;
  position_obj?: InputMaybe<Image_Subtypes_Obj_Rel_Insert_Input>;
  target_link?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Banners_Max_Fields = {
  __typename?: 'banners_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  target_link?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "banners" */
export type Banners_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  target_link?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Banners_Min_Fields = {
  __typename?: 'banners_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  target_link?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "banners" */
export type Banners_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  target_link?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "banners" */
export type Banners_Mutation_Response = {
  __typename?: 'banners_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Banners>;
};

/** input type for inserting object relation for remote table "banners" */
export type Banners_Obj_Rel_Insert_Input = {
  data: Banners_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Banners_On_Conflict>;
};

/** on_conflict condition type for table "banners" */
export type Banners_On_Conflict = {
  constraint: Banners_Constraint;
  update_columns?: Array<Banners_Update_Column>;
  where?: InputMaybe<Banners_Bool_Exp>;
};

/** Ordering options when selecting data from "banners". */
export type Banners_Order_By = {
  banners_categories_aggregate?: InputMaybe<Banners_Categories_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Users_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by?: InputMaybe<Users_Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_subtype?: InputMaybe<Image_Subtypes_Order_By>;
  images_aggregate?: InputMaybe<Images_Aggregate_Order_By>;
  position?: InputMaybe<Order_By>;
  position_obj?: InputMaybe<Image_Subtypes_Order_By>;
  target_link?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Users_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: banners */
export type Banners_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "banners" */
export enum Banners_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Position = 'position',
  /** column name */
  TargetLink = 'target_link',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "banners" */
export type Banners_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  position?: InputMaybe<Image_Subtypes_Enum>;
  target_link?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Banners_Stddev_Fields = {
  __typename?: 'banners_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "banners" */
export type Banners_Stddev_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Banners_Stddev_Pop_Fields = {
  __typename?: 'banners_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "banners" */
export type Banners_Stddev_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Banners_Stddev_Samp_Fields = {
  __typename?: 'banners_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "banners" */
export type Banners_Stddev_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "banners" */
export type Banners_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Banners_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Banners_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  position?: InputMaybe<Image_Subtypes_Enum>;
  target_link?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Banners_Sum_Fields = {
  __typename?: 'banners_sum_fields';
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "banners" */
export type Banners_Sum_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "banners" */
export enum Banners_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Position = 'position',
  /** column name */
  TargetLink = 'target_link',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Banners_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Banners_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Banners_Set_Input>;
  /** filter the rows which have to be updated */
  where: Banners_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Banners_Var_Pop_Fields = {
  __typename?: 'banners_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "banners" */
export type Banners_Var_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Banners_Var_Samp_Fields = {
  __typename?: 'banners_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "banners" */
export type Banners_Var_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Banners_Variance_Fields = {
  __typename?: 'banners_variance_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "banners" */
export type Banners_Variance_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** columns and relationships of "categories" */
export type Categories = {
  __typename?: 'categories';
  /** A computed field, executes function "get_all_posts" */
  all_posts?: Maybe<Array<Posts>>;
  /** An array relationship */
  children: Array<Categories>;
  /** An aggregate relationship */
  children_aggregate: Categories_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by?: Maybe<Users>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  deleted_by?: Maybe<Users>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['bigint']['output'];
  layout_at_home?: Maybe<Layouts_Enum>;
  /** An object relationship */
  layout_at_home_obj?: Maybe<Layouts>;
  layout_at_parent_cate?: Maybe<Layouts_Enum>;
  /** An object relationship */
  layout_at_parent_cate_obj?: Maybe<Layouts>;
  layout_page?: Maybe<Layout_Pages_Enum>;
  layout_page_bottom?: Maybe<Layout_Page_Bottoms_Enum>;
  /** An object relationship */
  layout_page_bottom_obj?: Maybe<Layout_Page_Bottoms>;
  /** An object relationship */
  layout_page_obj?: Maybe<Layout_Pages>;
  layout_page_top?: Maybe<Layout_Page_Tops_Enum>;
  /** An object relationship */
  layout_page_top_obj?: Maybe<Layout_Page_Tops>;
  /** A computed field, executes function "get_category_name_i18n" */
  name?: Maybe<Scalars['String']['output']>;
  name_i18n?: Maybe<Scalars['jsonb']['output']>;
  order_at_home?: Maybe<Scalars['Int']['output']>;
  order_at_menu?: Maybe<Scalars['Int']['output']>;
  order_at_parent_cate?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  parent_category?: Maybe<Categories>;
  parent_id?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  path_full_slug?: Maybe<Categories_Full_Slug>;
  /** An array relationship */
  posts_categories: Array<Posts_Categories>;
  /** An aggregate relationship */
  posts_categories_aggregate: Posts_Categories_Aggregate;
  /** An array relationship */
  related_categories: Array<Related_Categories>;
  /** An aggregate relationship */
  related_categories_aggregate: Related_Categories_Aggregate;
  slug: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  updated_by?: Maybe<Users>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};


/** columns and relationships of "categories" */
export type CategoriesAll_PostsArgs = {
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


/** columns and relationships of "categories" */
export type CategoriesChildrenArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


/** columns and relationships of "categories" */
export type CategoriesChildren_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


/** columns and relationships of "categories" */
export type CategoriesName_I18nArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "categories" */
export type CategoriesPosts_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Posts_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Categories_Order_By>>;
  where?: InputMaybe<Posts_Categories_Bool_Exp>;
};


/** columns and relationships of "categories" */
export type CategoriesPosts_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Categories_Order_By>>;
  where?: InputMaybe<Posts_Categories_Bool_Exp>;
};


/** columns and relationships of "categories" */
export type CategoriesRelated_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Related_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Related_Categories_Order_By>>;
  where?: InputMaybe<Related_Categories_Bool_Exp>;
};


/** columns and relationships of "categories" */
export type CategoriesRelated_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Related_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Related_Categories_Order_By>>;
  where?: InputMaybe<Related_Categories_Bool_Exp>;
};

/** aggregated selection of "categories" */
export type Categories_Aggregate = {
  __typename?: 'categories_aggregate';
  aggregate?: Maybe<Categories_Aggregate_Fields>;
  nodes: Array<Categories>;
};

export type Categories_Aggregate_Bool_Exp = {
  count?: InputMaybe<Categories_Aggregate_Bool_Exp_Count>;
};

export type Categories_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Categories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Categories_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "categories" */
export type Categories_Aggregate_Fields = {
  __typename?: 'categories_aggregate_fields';
  avg?: Maybe<Categories_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Categories_Max_Fields>;
  min?: Maybe<Categories_Min_Fields>;
  stddev?: Maybe<Categories_Stddev_Fields>;
  stddev_pop?: Maybe<Categories_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Categories_Stddev_Samp_Fields>;
  sum?: Maybe<Categories_Sum_Fields>;
  var_pop?: Maybe<Categories_Var_Pop_Fields>;
  var_samp?: Maybe<Categories_Var_Samp_Fields>;
  variance?: Maybe<Categories_Variance_Fields>;
};


/** aggregate fields of "categories" */
export type Categories_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Categories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "categories" */
export type Categories_Aggregate_Order_By = {
  avg?: InputMaybe<Categories_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Categories_Max_Order_By>;
  min?: InputMaybe<Categories_Min_Order_By>;
  stddev?: InputMaybe<Categories_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Categories_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Categories_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Categories_Sum_Order_By>;
  var_pop?: InputMaybe<Categories_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Categories_Var_Samp_Order_By>;
  variance?: InputMaybe<Categories_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Categories_Append_Input = {
  name_i18n?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "categories" */
export type Categories_Arr_Rel_Insert_Input = {
  data: Array<Categories_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Categories_On_Conflict>;
};

/** aggregate avg on columns */
export type Categories_Avg_Fields = {
  __typename?: 'categories_avg_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order_at_home?: Maybe<Scalars['Float']['output']>;
  order_at_menu?: Maybe<Scalars['Float']['output']>;
  order_at_parent_cate?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "categories" */
export type Categories_Avg_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_at_home?: InputMaybe<Order_By>;
  order_at_menu?: InputMaybe<Order_By>;
  order_at_parent_cate?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "categories". All fields are combined with a logical 'AND'. */
export type Categories_Bool_Exp = {
  _and?: InputMaybe<Array<Categories_Bool_Exp>>;
  _not?: InputMaybe<Categories_Bool_Exp>;
  _or?: InputMaybe<Array<Categories_Bool_Exp>>;
  all_posts?: InputMaybe<Posts_Bool_Exp>;
  children?: InputMaybe<Categories_Bool_Exp>;
  children_aggregate?: InputMaybe<Categories_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Users_Bool_Exp>;
  created_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_by?: InputMaybe<Users_Bool_Exp>;
  deleted_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  layout_at_home?: InputMaybe<Layouts_Enum_Comparison_Exp>;
  layout_at_home_obj?: InputMaybe<Layouts_Bool_Exp>;
  layout_at_parent_cate?: InputMaybe<Layouts_Enum_Comparison_Exp>;
  layout_at_parent_cate_obj?: InputMaybe<Layouts_Bool_Exp>;
  layout_page?: InputMaybe<Layout_Pages_Enum_Comparison_Exp>;
  layout_page_bottom?: InputMaybe<Layout_Page_Bottoms_Enum_Comparison_Exp>;
  layout_page_bottom_obj?: InputMaybe<Layout_Page_Bottoms_Bool_Exp>;
  layout_page_obj?: InputMaybe<Layout_Pages_Bool_Exp>;
  layout_page_top?: InputMaybe<Layout_Page_Tops_Enum_Comparison_Exp>;
  layout_page_top_obj?: InputMaybe<Layout_Page_Tops_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  name_i18n?: InputMaybe<Jsonb_Comparison_Exp>;
  order_at_home?: InputMaybe<Int_Comparison_Exp>;
  order_at_menu?: InputMaybe<Int_Comparison_Exp>;
  order_at_parent_cate?: InputMaybe<Int_Comparison_Exp>;
  parent_category?: InputMaybe<Categories_Bool_Exp>;
  parent_id?: InputMaybe<Bigint_Comparison_Exp>;
  path_full_slug?: InputMaybe<Categories_Full_Slug_Bool_Exp>;
  posts_categories?: InputMaybe<Posts_Categories_Bool_Exp>;
  posts_categories_aggregate?: InputMaybe<Posts_Categories_Aggregate_Bool_Exp>;
  related_categories?: InputMaybe<Related_Categories_Bool_Exp>;
  related_categories_aggregate?: InputMaybe<Related_Categories_Aggregate_Bool_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Users_Bool_Exp>;
  updated_by_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "categories" */
export enum Categories_Constraint {
  /** unique or primary key constraint on columns "id" */
  CategoriesPkey = 'categories_pkey',
  /** unique or primary key constraint on columns "slug" */
  CategoriesSlugKey = 'categories_slug_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Categories_Delete_At_Path_Input = {
  name_i18n?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Categories_Delete_Elem_Input = {
  name_i18n?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Categories_Delete_Key_Input = {
  name_i18n?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "categories_full_slug" */
export type Categories_Full_Slug = {
  __typename?: 'categories_full_slug';
  full_slug?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "categories_full_slug" */
export type Categories_Full_Slug_Aggregate = {
  __typename?: 'categories_full_slug_aggregate';
  aggregate?: Maybe<Categories_Full_Slug_Aggregate_Fields>;
  nodes: Array<Categories_Full_Slug>;
};

/** aggregate fields of "categories_full_slug" */
export type Categories_Full_Slug_Aggregate_Fields = {
  __typename?: 'categories_full_slug_aggregate_fields';
  avg?: Maybe<Categories_Full_Slug_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Categories_Full_Slug_Max_Fields>;
  min?: Maybe<Categories_Full_Slug_Min_Fields>;
  stddev?: Maybe<Categories_Full_Slug_Stddev_Fields>;
  stddev_pop?: Maybe<Categories_Full_Slug_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Categories_Full_Slug_Stddev_Samp_Fields>;
  sum?: Maybe<Categories_Full_Slug_Sum_Fields>;
  var_pop?: Maybe<Categories_Full_Slug_Var_Pop_Fields>;
  var_samp?: Maybe<Categories_Full_Slug_Var_Samp_Fields>;
  variance?: Maybe<Categories_Full_Slug_Variance_Fields>;
};


/** aggregate fields of "categories_full_slug" */
export type Categories_Full_Slug_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Categories_Full_Slug_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Categories_Full_Slug_Avg_Fields = {
  __typename?: 'categories_full_slug_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "categories_full_slug". All fields are combined with a logical 'AND'. */
export type Categories_Full_Slug_Bool_Exp = {
  _and?: InputMaybe<Array<Categories_Full_Slug_Bool_Exp>>;
  _not?: InputMaybe<Categories_Full_Slug_Bool_Exp>;
  _or?: InputMaybe<Array<Categories_Full_Slug_Bool_Exp>>;
  full_slug?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** input type for inserting data into table "categories_full_slug" */
export type Categories_Full_Slug_Insert_Input = {
  full_slug?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Categories_Full_Slug_Max_Fields = {
  __typename?: 'categories_full_slug_max_fields';
  full_slug?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Categories_Full_Slug_Min_Fields = {
  __typename?: 'categories_full_slug_min_fields';
  full_slug?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** input type for inserting object relation for remote table "categories_full_slug" */
export type Categories_Full_Slug_Obj_Rel_Insert_Input = {
  data: Categories_Full_Slug_Insert_Input;
};

/** Ordering options when selecting data from "categories_full_slug". */
export type Categories_Full_Slug_Order_By = {
  full_slug?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "categories_full_slug" */
export enum Categories_Full_Slug_Select_Column {
  /** column name */
  FullSlug = 'full_slug',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Categories_Full_Slug_Stddev_Fields = {
  __typename?: 'categories_full_slug_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Categories_Full_Slug_Stddev_Pop_Fields = {
  __typename?: 'categories_full_slug_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Categories_Full_Slug_Stddev_Samp_Fields = {
  __typename?: 'categories_full_slug_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "categories_full_slug" */
export type Categories_Full_Slug_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Categories_Full_Slug_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Categories_Full_Slug_Stream_Cursor_Value_Input = {
  full_slug?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Categories_Full_Slug_Sum_Fields = {
  __typename?: 'categories_full_slug_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Categories_Full_Slug_Var_Pop_Fields = {
  __typename?: 'categories_full_slug_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Categories_Full_Slug_Var_Samp_Fields = {
  __typename?: 'categories_full_slug_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Categories_Full_Slug_Variance_Fields = {
  __typename?: 'categories_full_slug_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** input type for incrementing numeric columns in table "categories" */
export type Categories_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  order_at_home?: InputMaybe<Scalars['Int']['input']>;
  order_at_menu?: InputMaybe<Scalars['Int']['input']>;
  order_at_parent_cate?: InputMaybe<Scalars['Int']['input']>;
  parent_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "categories" */
export type Categories_Insert_Input = {
  children?: InputMaybe<Categories_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  layout_at_home?: InputMaybe<Layouts_Enum>;
  layout_at_home_obj?: InputMaybe<Layouts_Obj_Rel_Insert_Input>;
  layout_at_parent_cate?: InputMaybe<Layouts_Enum>;
  layout_at_parent_cate_obj?: InputMaybe<Layouts_Obj_Rel_Insert_Input>;
  layout_page?: InputMaybe<Layout_Pages_Enum>;
  layout_page_bottom?: InputMaybe<Layout_Page_Bottoms_Enum>;
  layout_page_bottom_obj?: InputMaybe<Layout_Page_Bottoms_Obj_Rel_Insert_Input>;
  layout_page_obj?: InputMaybe<Layout_Pages_Obj_Rel_Insert_Input>;
  layout_page_top?: InputMaybe<Layout_Page_Tops_Enum>;
  layout_page_top_obj?: InputMaybe<Layout_Page_Tops_Obj_Rel_Insert_Input>;
  name_i18n?: InputMaybe<Scalars['jsonb']['input']>;
  order_at_home?: InputMaybe<Scalars['Int']['input']>;
  order_at_menu?: InputMaybe<Scalars['Int']['input']>;
  order_at_parent_cate?: InputMaybe<Scalars['Int']['input']>;
  parent_category?: InputMaybe<Categories_Obj_Rel_Insert_Input>;
  parent_id?: InputMaybe<Scalars['bigint']['input']>;
  path_full_slug?: InputMaybe<Categories_Full_Slug_Obj_Rel_Insert_Input>;
  posts_categories?: InputMaybe<Posts_Categories_Arr_Rel_Insert_Input>;
  related_categories?: InputMaybe<Related_Categories_Arr_Rel_Insert_Input>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Categories_Max_Fields = {
  __typename?: 'categories_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "get_category_name_i18n" */
  name?: Maybe<Scalars['String']['output']>;
  order_at_home?: Maybe<Scalars['Int']['output']>;
  order_at_menu?: Maybe<Scalars['Int']['output']>;
  order_at_parent_cate?: Maybe<Scalars['Int']['output']>;
  parent_id?: Maybe<Scalars['bigint']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "categories" */
export type Categories_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_at_home?: InputMaybe<Order_By>;
  order_at_menu?: InputMaybe<Order_By>;
  order_at_parent_cate?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Categories_Min_Fields = {
  __typename?: 'categories_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "get_category_name_i18n" */
  name?: Maybe<Scalars['String']['output']>;
  order_at_home?: Maybe<Scalars['Int']['output']>;
  order_at_menu?: Maybe<Scalars['Int']['output']>;
  order_at_parent_cate?: Maybe<Scalars['Int']['output']>;
  parent_id?: Maybe<Scalars['bigint']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "categories" */
export type Categories_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_at_home?: InputMaybe<Order_By>;
  order_at_menu?: InputMaybe<Order_By>;
  order_at_parent_cate?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "categories" */
export type Categories_Mutation_Response = {
  __typename?: 'categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Categories>;
};

/** input type for inserting object relation for remote table "categories" */
export type Categories_Obj_Rel_Insert_Input = {
  data: Categories_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Categories_On_Conflict>;
};

/** on_conflict condition type for table "categories" */
export type Categories_On_Conflict = {
  constraint: Categories_Constraint;
  update_columns?: Array<Categories_Update_Column>;
  where?: InputMaybe<Categories_Bool_Exp>;
};

/** Ordering options when selecting data from "categories". */
export type Categories_Order_By = {
  all_posts_aggregate?: InputMaybe<Posts_Aggregate_Order_By>;
  children_aggregate?: InputMaybe<Categories_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Users_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by?: InputMaybe<Users_Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  layout_at_home?: InputMaybe<Order_By>;
  layout_at_home_obj?: InputMaybe<Layouts_Order_By>;
  layout_at_parent_cate?: InputMaybe<Order_By>;
  layout_at_parent_cate_obj?: InputMaybe<Layouts_Order_By>;
  layout_page?: InputMaybe<Order_By>;
  layout_page_bottom?: InputMaybe<Order_By>;
  layout_page_bottom_obj?: InputMaybe<Layout_Page_Bottoms_Order_By>;
  layout_page_obj?: InputMaybe<Layout_Pages_Order_By>;
  layout_page_top?: InputMaybe<Order_By>;
  layout_page_top_obj?: InputMaybe<Layout_Page_Tops_Order_By>;
  name?: InputMaybe<Order_By>;
  name_i18n?: InputMaybe<Order_By>;
  order_at_home?: InputMaybe<Order_By>;
  order_at_menu?: InputMaybe<Order_By>;
  order_at_parent_cate?: InputMaybe<Order_By>;
  parent_category?: InputMaybe<Categories_Order_By>;
  parent_id?: InputMaybe<Order_By>;
  path_full_slug?: InputMaybe<Categories_Full_Slug_Order_By>;
  posts_categories_aggregate?: InputMaybe<Posts_Categories_Aggregate_Order_By>;
  related_categories_aggregate?: InputMaybe<Related_Categories_Aggregate_Order_By>;
  slug?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Users_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: categories */
export type Categories_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Categories_Prepend_Input = {
  name_i18n?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "categories" */
export enum Categories_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  LayoutAtHome = 'layout_at_home',
  /** column name */
  LayoutAtParentCate = 'layout_at_parent_cate',
  /** column name */
  LayoutPage = 'layout_page',
  /** column name */
  LayoutPageBottom = 'layout_page_bottom',
  /** column name */
  LayoutPageTop = 'layout_page_top',
  /** column name */
  NameI18n = 'name_i18n',
  /** column name */
  OrderAtHome = 'order_at_home',
  /** column name */
  OrderAtMenu = 'order_at_menu',
  /** column name */
  OrderAtParentCate = 'order_at_parent_cate',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "categories" */
export type Categories_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  layout_at_home?: InputMaybe<Layouts_Enum>;
  layout_at_parent_cate?: InputMaybe<Layouts_Enum>;
  layout_page?: InputMaybe<Layout_Pages_Enum>;
  layout_page_bottom?: InputMaybe<Layout_Page_Bottoms_Enum>;
  layout_page_top?: InputMaybe<Layout_Page_Tops_Enum>;
  name_i18n?: InputMaybe<Scalars['jsonb']['input']>;
  order_at_home?: InputMaybe<Scalars['Int']['input']>;
  order_at_menu?: InputMaybe<Scalars['Int']['input']>;
  order_at_parent_cate?: InputMaybe<Scalars['Int']['input']>;
  parent_id?: InputMaybe<Scalars['bigint']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Categories_Stddev_Fields = {
  __typename?: 'categories_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order_at_home?: Maybe<Scalars['Float']['output']>;
  order_at_menu?: Maybe<Scalars['Float']['output']>;
  order_at_parent_cate?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "categories" */
export type Categories_Stddev_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_at_home?: InputMaybe<Order_By>;
  order_at_menu?: InputMaybe<Order_By>;
  order_at_parent_cate?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Categories_Stddev_Pop_Fields = {
  __typename?: 'categories_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order_at_home?: Maybe<Scalars['Float']['output']>;
  order_at_menu?: Maybe<Scalars['Float']['output']>;
  order_at_parent_cate?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "categories" */
export type Categories_Stddev_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_at_home?: InputMaybe<Order_By>;
  order_at_menu?: InputMaybe<Order_By>;
  order_at_parent_cate?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Categories_Stddev_Samp_Fields = {
  __typename?: 'categories_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order_at_home?: Maybe<Scalars['Float']['output']>;
  order_at_menu?: Maybe<Scalars['Float']['output']>;
  order_at_parent_cate?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "categories" */
export type Categories_Stddev_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_at_home?: InputMaybe<Order_By>;
  order_at_menu?: InputMaybe<Order_By>;
  order_at_parent_cate?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "categories" */
export type Categories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Categories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Categories_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  layout_at_home?: InputMaybe<Layouts_Enum>;
  layout_at_parent_cate?: InputMaybe<Layouts_Enum>;
  layout_page?: InputMaybe<Layout_Pages_Enum>;
  layout_page_bottom?: InputMaybe<Layout_Page_Bottoms_Enum>;
  layout_page_top?: InputMaybe<Layout_Page_Tops_Enum>;
  name_i18n?: InputMaybe<Scalars['jsonb']['input']>;
  order_at_home?: InputMaybe<Scalars['Int']['input']>;
  order_at_menu?: InputMaybe<Scalars['Int']['input']>;
  order_at_parent_cate?: InputMaybe<Scalars['Int']['input']>;
  parent_id?: InputMaybe<Scalars['bigint']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Categories_Sum_Fields = {
  __typename?: 'categories_sum_fields';
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  order_at_home?: Maybe<Scalars['Int']['output']>;
  order_at_menu?: Maybe<Scalars['Int']['output']>;
  order_at_parent_cate?: Maybe<Scalars['Int']['output']>;
  parent_id?: Maybe<Scalars['bigint']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "categories" */
export type Categories_Sum_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_at_home?: InputMaybe<Order_By>;
  order_at_menu?: InputMaybe<Order_By>;
  order_at_parent_cate?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "categories" */
export enum Categories_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  LayoutAtHome = 'layout_at_home',
  /** column name */
  LayoutAtParentCate = 'layout_at_parent_cate',
  /** column name */
  LayoutPage = 'layout_page',
  /** column name */
  LayoutPageBottom = 'layout_page_bottom',
  /** column name */
  LayoutPageTop = 'layout_page_top',
  /** column name */
  NameI18n = 'name_i18n',
  /** column name */
  OrderAtHome = 'order_at_home',
  /** column name */
  OrderAtMenu = 'order_at_menu',
  /** column name */
  OrderAtParentCate = 'order_at_parent_cate',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Categories_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Categories_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Categories_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Categories_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Categories_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Categories_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Categories_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Categories_Set_Input>;
  /** filter the rows which have to be updated */
  where: Categories_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Categories_Var_Pop_Fields = {
  __typename?: 'categories_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order_at_home?: Maybe<Scalars['Float']['output']>;
  order_at_menu?: Maybe<Scalars['Float']['output']>;
  order_at_parent_cate?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "categories" */
export type Categories_Var_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_at_home?: InputMaybe<Order_By>;
  order_at_menu?: InputMaybe<Order_By>;
  order_at_parent_cate?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Categories_Var_Samp_Fields = {
  __typename?: 'categories_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order_at_home?: Maybe<Scalars['Float']['output']>;
  order_at_menu?: Maybe<Scalars['Float']['output']>;
  order_at_parent_cate?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "categories" */
export type Categories_Var_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_at_home?: InputMaybe<Order_By>;
  order_at_menu?: InputMaybe<Order_By>;
  order_at_parent_cate?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Categories_Variance_Fields = {
  __typename?: 'categories_variance_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order_at_home?: Maybe<Scalars['Float']['output']>;
  order_at_menu?: Maybe<Scalars['Float']['output']>;
  order_at_parent_cate?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "categories" */
export type Categories_Variance_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_at_home?: InputMaybe<Order_By>;
  order_at_menu?: InputMaybe<Order_By>;
  order_at_parent_cate?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "category_kpis" */
export type Category_Kpis = {
  __typename?: 'category_kpis';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  created_by?: Maybe<Users>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  deleted_by?: Maybe<Users>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  /** An array relationship */
  group_kpis: Array<Group_Kpis>;
  /** An aggregate relationship */
  group_kpis_aggregate: Group_Kpis_Aggregate;
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  updated_by?: Maybe<Users>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};


/** columns and relationships of "category_kpis" */
export type Category_KpisGroup_KpisArgs = {
  distinct_on?: InputMaybe<Array<Group_Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Group_Kpis_Order_By>>;
  where?: InputMaybe<Group_Kpis_Bool_Exp>;
};


/** columns and relationships of "category_kpis" */
export type Category_KpisGroup_Kpis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Group_Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Group_Kpis_Order_By>>;
  where?: InputMaybe<Group_Kpis_Bool_Exp>;
};

/** aggregated selection of "category_kpis" */
export type Category_Kpis_Aggregate = {
  __typename?: 'category_kpis_aggregate';
  aggregate?: Maybe<Category_Kpis_Aggregate_Fields>;
  nodes: Array<Category_Kpis>;
};

/** aggregate fields of "category_kpis" */
export type Category_Kpis_Aggregate_Fields = {
  __typename?: 'category_kpis_aggregate_fields';
  avg?: Maybe<Category_Kpis_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Category_Kpis_Max_Fields>;
  min?: Maybe<Category_Kpis_Min_Fields>;
  stddev?: Maybe<Category_Kpis_Stddev_Fields>;
  stddev_pop?: Maybe<Category_Kpis_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Category_Kpis_Stddev_Samp_Fields>;
  sum?: Maybe<Category_Kpis_Sum_Fields>;
  var_pop?: Maybe<Category_Kpis_Var_Pop_Fields>;
  var_samp?: Maybe<Category_Kpis_Var_Samp_Fields>;
  variance?: Maybe<Category_Kpis_Variance_Fields>;
};


/** aggregate fields of "category_kpis" */
export type Category_Kpis_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Category_Kpis_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Category_Kpis_Avg_Fields = {
  __typename?: 'category_kpis_avg_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "category_kpis". All fields are combined with a logical 'AND'. */
export type Category_Kpis_Bool_Exp = {
  _and?: InputMaybe<Array<Category_Kpis_Bool_Exp>>;
  _not?: InputMaybe<Category_Kpis_Bool_Exp>;
  _or?: InputMaybe<Array<Category_Kpis_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Users_Bool_Exp>;
  created_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_by?: InputMaybe<Users_Bool_Exp>;
  deleted_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  group_kpis?: InputMaybe<Group_Kpis_Bool_Exp>;
  group_kpis_aggregate?: InputMaybe<Group_Kpis_Aggregate_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Users_Bool_Exp>;
  updated_by_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "category_kpis" */
export enum Category_Kpis_Constraint {
  /** unique or primary key constraint on columns "id" */
  CategoryKipsPkey = 'category_kips_pkey'
}

/** input type for incrementing numeric columns in table "category_kpis" */
export type Category_Kpis_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "category_kpis" */
export type Category_Kpis_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  group_kpis?: InputMaybe<Group_Kpis_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Category_Kpis_Max_Fields = {
  __typename?: 'category_kpis_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Category_Kpis_Min_Fields = {
  __typename?: 'category_kpis_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "category_kpis" */
export type Category_Kpis_Mutation_Response = {
  __typename?: 'category_kpis_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Category_Kpis>;
};

/** input type for inserting object relation for remote table "category_kpis" */
export type Category_Kpis_Obj_Rel_Insert_Input = {
  data: Category_Kpis_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Category_Kpis_On_Conflict>;
};

/** on_conflict condition type for table "category_kpis" */
export type Category_Kpis_On_Conflict = {
  constraint: Category_Kpis_Constraint;
  update_columns?: Array<Category_Kpis_Update_Column>;
  where?: InputMaybe<Category_Kpis_Bool_Exp>;
};

/** Ordering options when selecting data from "category_kpis". */
export type Category_Kpis_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Users_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by?: InputMaybe<Users_Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  group_kpis_aggregate?: InputMaybe<Group_Kpis_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Users_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: category_kpis */
export type Category_Kpis_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "category_kpis" */
export enum Category_Kpis_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "category_kpis" */
export type Category_Kpis_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Category_Kpis_Stddev_Fields = {
  __typename?: 'category_kpis_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Category_Kpis_Stddev_Pop_Fields = {
  __typename?: 'category_kpis_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Category_Kpis_Stddev_Samp_Fields = {
  __typename?: 'category_kpis_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "category_kpis" */
export type Category_Kpis_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Category_Kpis_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Category_Kpis_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Category_Kpis_Sum_Fields = {
  __typename?: 'category_kpis_sum_fields';
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "category_kpis" */
export enum Category_Kpis_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Category_Kpis_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Category_Kpis_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Category_Kpis_Set_Input>;
  /** filter the rows which have to be updated */
  where: Category_Kpis_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Category_Kpis_Var_Pop_Fields = {
  __typename?: 'category_kpis_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Category_Kpis_Var_Samp_Fields = {
  __typename?: 'category_kpis_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Category_Kpis_Variance_Fields = {
  __typename?: 'category_kpis_variance_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "comments_likes" */
export type Comments_Likes = {
  __typename?: 'comments_likes';
  /** An object relationship */
  comment: Posts_Comments;
  comment_id: Scalars['bigint']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by?: Maybe<Users>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "comments_likes" */
export type Comments_Likes_Aggregate = {
  __typename?: 'comments_likes_aggregate';
  aggregate?: Maybe<Comments_Likes_Aggregate_Fields>;
  nodes: Array<Comments_Likes>;
};

export type Comments_Likes_Aggregate_Bool_Exp = {
  count?: InputMaybe<Comments_Likes_Aggregate_Bool_Exp_Count>;
};

export type Comments_Likes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Comments_Likes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Comments_Likes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "comments_likes" */
export type Comments_Likes_Aggregate_Fields = {
  __typename?: 'comments_likes_aggregate_fields';
  avg?: Maybe<Comments_Likes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Comments_Likes_Max_Fields>;
  min?: Maybe<Comments_Likes_Min_Fields>;
  stddev?: Maybe<Comments_Likes_Stddev_Fields>;
  stddev_pop?: Maybe<Comments_Likes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Comments_Likes_Stddev_Samp_Fields>;
  sum?: Maybe<Comments_Likes_Sum_Fields>;
  var_pop?: Maybe<Comments_Likes_Var_Pop_Fields>;
  var_samp?: Maybe<Comments_Likes_Var_Samp_Fields>;
  variance?: Maybe<Comments_Likes_Variance_Fields>;
};


/** aggregate fields of "comments_likes" */
export type Comments_Likes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Comments_Likes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "comments_likes" */
export type Comments_Likes_Aggregate_Order_By = {
  avg?: InputMaybe<Comments_Likes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Comments_Likes_Max_Order_By>;
  min?: InputMaybe<Comments_Likes_Min_Order_By>;
  stddev?: InputMaybe<Comments_Likes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Comments_Likes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Comments_Likes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Comments_Likes_Sum_Order_By>;
  var_pop?: InputMaybe<Comments_Likes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Comments_Likes_Var_Samp_Order_By>;
  variance?: InputMaybe<Comments_Likes_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "comments_likes" */
export type Comments_Likes_Arr_Rel_Insert_Input = {
  data: Array<Comments_Likes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Comments_Likes_On_Conflict>;
};

/** aggregate avg on columns */
export type Comments_Likes_Avg_Fields = {
  __typename?: 'comments_likes_avg_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "comments_likes" */
export type Comments_Likes_Avg_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "comments_likes". All fields are combined with a logical 'AND'. */
export type Comments_Likes_Bool_Exp = {
  _and?: InputMaybe<Array<Comments_Likes_Bool_Exp>>;
  _not?: InputMaybe<Comments_Likes_Bool_Exp>;
  _or?: InputMaybe<Array<Comments_Likes_Bool_Exp>>;
  comment?: InputMaybe<Posts_Comments_Bool_Exp>;
  comment_id?: InputMaybe<Bigint_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Users_Bool_Exp>;
  created_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "comments_likes" */
export enum Comments_Likes_Constraint {
  /** unique or primary key constraint on columns "id" */
  CommentsLikesPkey = 'comments_likes_pkey'
}

/** columns and relationships of "comments_likes_count" */
export type Comments_Likes_Count = {
  __typename?: 'comments_likes_count';
  comment_id?: Maybe<Scalars['bigint']['output']>;
  count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "comments_likes_count" */
export type Comments_Likes_Count_Aggregate = {
  __typename?: 'comments_likes_count_aggregate';
  aggregate?: Maybe<Comments_Likes_Count_Aggregate_Fields>;
  nodes: Array<Comments_Likes_Count>;
};

/** aggregate fields of "comments_likes_count" */
export type Comments_Likes_Count_Aggregate_Fields = {
  __typename?: 'comments_likes_count_aggregate_fields';
  avg?: Maybe<Comments_Likes_Count_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Comments_Likes_Count_Max_Fields>;
  min?: Maybe<Comments_Likes_Count_Min_Fields>;
  stddev?: Maybe<Comments_Likes_Count_Stddev_Fields>;
  stddev_pop?: Maybe<Comments_Likes_Count_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Comments_Likes_Count_Stddev_Samp_Fields>;
  sum?: Maybe<Comments_Likes_Count_Sum_Fields>;
  var_pop?: Maybe<Comments_Likes_Count_Var_Pop_Fields>;
  var_samp?: Maybe<Comments_Likes_Count_Var_Samp_Fields>;
  variance?: Maybe<Comments_Likes_Count_Variance_Fields>;
};


/** aggregate fields of "comments_likes_count" */
export type Comments_Likes_Count_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Comments_Likes_Count_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Comments_Likes_Count_Avg_Fields = {
  __typename?: 'comments_likes_count_avg_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "comments_likes_count". All fields are combined with a logical 'AND'. */
export type Comments_Likes_Count_Bool_Exp = {
  _and?: InputMaybe<Array<Comments_Likes_Count_Bool_Exp>>;
  _not?: InputMaybe<Comments_Likes_Count_Bool_Exp>;
  _or?: InputMaybe<Array<Comments_Likes_Count_Bool_Exp>>;
  comment_id?: InputMaybe<Bigint_Comparison_Exp>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
};

/** input type for inserting data into table "comments_likes_count" */
export type Comments_Likes_Count_Insert_Input = {
  comment_id?: InputMaybe<Scalars['bigint']['input']>;
  count?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Comments_Likes_Count_Max_Fields = {
  __typename?: 'comments_likes_count_max_fields';
  comment_id?: Maybe<Scalars['bigint']['output']>;
  count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Comments_Likes_Count_Min_Fields = {
  __typename?: 'comments_likes_count_min_fields';
  comment_id?: Maybe<Scalars['bigint']['output']>;
  count?: Maybe<Scalars['bigint']['output']>;
};

/** input type for inserting object relation for remote table "comments_likes_count" */
export type Comments_Likes_Count_Obj_Rel_Insert_Input = {
  data: Comments_Likes_Count_Insert_Input;
};

/** Ordering options when selecting data from "comments_likes_count". */
export type Comments_Likes_Count_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
};

/** select columns of table "comments_likes_count" */
export enum Comments_Likes_Count_Select_Column {
  /** column name */
  CommentId = 'comment_id',
  /** column name */
  Count = 'count'
}

/** aggregate stddev on columns */
export type Comments_Likes_Count_Stddev_Fields = {
  __typename?: 'comments_likes_count_stddev_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Comments_Likes_Count_Stddev_Pop_Fields = {
  __typename?: 'comments_likes_count_stddev_pop_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Comments_Likes_Count_Stddev_Samp_Fields = {
  __typename?: 'comments_likes_count_stddev_samp_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "comments_likes_count" */
export type Comments_Likes_Count_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Comments_Likes_Count_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Comments_Likes_Count_Stream_Cursor_Value_Input = {
  comment_id?: InputMaybe<Scalars['bigint']['input']>;
  count?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Comments_Likes_Count_Sum_Fields = {
  __typename?: 'comments_likes_count_sum_fields';
  comment_id?: Maybe<Scalars['bigint']['output']>;
  count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Comments_Likes_Count_Var_Pop_Fields = {
  __typename?: 'comments_likes_count_var_pop_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Comments_Likes_Count_Var_Samp_Fields = {
  __typename?: 'comments_likes_count_var_samp_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Comments_Likes_Count_Variance_Fields = {
  __typename?: 'comments_likes_count_variance_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
};

/** input type for incrementing numeric columns in table "comments_likes" */
export type Comments_Likes_Inc_Input = {
  comment_id?: InputMaybe<Scalars['bigint']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "comments_likes" */
export type Comments_Likes_Insert_Input = {
  comment?: InputMaybe<Posts_Comments_Obj_Rel_Insert_Input>;
  comment_id?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Comments_Likes_Max_Fields = {
  __typename?: 'comments_likes_max_fields';
  comment_id?: Maybe<Scalars['bigint']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "comments_likes" */
export type Comments_Likes_Max_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Comments_Likes_Min_Fields = {
  __typename?: 'comments_likes_min_fields';
  comment_id?: Maybe<Scalars['bigint']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "comments_likes" */
export type Comments_Likes_Min_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "comments_likes" */
export type Comments_Likes_Mutation_Response = {
  __typename?: 'comments_likes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Comments_Likes>;
};

/** on_conflict condition type for table "comments_likes" */
export type Comments_Likes_On_Conflict = {
  constraint: Comments_Likes_Constraint;
  update_columns?: Array<Comments_Likes_Update_Column>;
  where?: InputMaybe<Comments_Likes_Bool_Exp>;
};

/** Ordering options when selecting data from "comments_likes". */
export type Comments_Likes_Order_By = {
  comment?: InputMaybe<Posts_Comments_Order_By>;
  comment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Users_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: comments_likes */
export type Comments_Likes_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "comments_likes" */
export enum Comments_Likes_Select_Column {
  /** column name */
  CommentId = 'comment_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "comments_likes" */
export type Comments_Likes_Set_Input = {
  comment_id?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Comments_Likes_Stddev_Fields = {
  __typename?: 'comments_likes_stddev_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "comments_likes" */
export type Comments_Likes_Stddev_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Comments_Likes_Stddev_Pop_Fields = {
  __typename?: 'comments_likes_stddev_pop_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "comments_likes" */
export type Comments_Likes_Stddev_Pop_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Comments_Likes_Stddev_Samp_Fields = {
  __typename?: 'comments_likes_stddev_samp_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "comments_likes" */
export type Comments_Likes_Stddev_Samp_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "comments_likes" */
export type Comments_Likes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Comments_Likes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Comments_Likes_Stream_Cursor_Value_Input = {
  comment_id?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Comments_Likes_Sum_Fields = {
  __typename?: 'comments_likes_sum_fields';
  comment_id?: Maybe<Scalars['bigint']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "comments_likes" */
export type Comments_Likes_Sum_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "comments_likes" */
export enum Comments_Likes_Update_Column {
  /** column name */
  CommentId = 'comment_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id'
}

export type Comments_Likes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Comments_Likes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Comments_Likes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Comments_Likes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Comments_Likes_Var_Pop_Fields = {
  __typename?: 'comments_likes_var_pop_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "comments_likes" */
export type Comments_Likes_Var_Pop_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Comments_Likes_Var_Samp_Fields = {
  __typename?: 'comments_likes_var_samp_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "comments_likes" */
export type Comments_Likes_Var_Samp_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Comments_Likes_Variance_Fields = {
  __typename?: 'comments_likes_variance_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "comments_likes" */
export type Comments_Likes_Variance_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "genders" */
export type Genders = {
  __typename?: 'genders';
  description?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "genders" */
export type Genders_Aggregate = {
  __typename?: 'genders_aggregate';
  aggregate?: Maybe<Genders_Aggregate_Fields>;
  nodes: Array<Genders>;
};

/** aggregate fields of "genders" */
export type Genders_Aggregate_Fields = {
  __typename?: 'genders_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Genders_Max_Fields>;
  min?: Maybe<Genders_Min_Fields>;
};


/** aggregate fields of "genders" */
export type Genders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Genders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "genders". All fields are combined with a logical 'AND'. */
export type Genders_Bool_Exp = {
  _and?: InputMaybe<Array<Genders_Bool_Exp>>;
  _not?: InputMaybe<Genders_Bool_Exp>;
  _or?: InputMaybe<Array<Genders_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "genders" */
export enum Genders_Constraint {
  /** unique or primary key constraint on columns "value" */
  GendersPkey = 'genders_pkey'
}

export enum Genders_Enum {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER'
}

/** Boolean expression to compare columns of type "genders_enum". All fields are combined with logical 'AND'. */
export type Genders_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Genders_Enum>;
  _in?: InputMaybe<Array<Genders_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Genders_Enum>;
  _nin?: InputMaybe<Array<Genders_Enum>>;
};

/** input type for inserting data into table "genders" */
export type Genders_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Genders_Max_Fields = {
  __typename?: 'genders_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Genders_Min_Fields = {
  __typename?: 'genders_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "genders" */
export type Genders_Mutation_Response = {
  __typename?: 'genders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Genders>;
};

/** on_conflict condition type for table "genders" */
export type Genders_On_Conflict = {
  constraint: Genders_Constraint;
  update_columns?: Array<Genders_Update_Column>;
  where?: InputMaybe<Genders_Bool_Exp>;
};

/** Ordering options when selecting data from "genders". */
export type Genders_Order_By = {
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: genders */
export type Genders_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "genders" */
export enum Genders_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "genders" */
export type Genders_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "genders" */
export type Genders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Genders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Genders_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "genders" */
export enum Genders_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Genders_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Genders_Set_Input>;
  /** filter the rows which have to be updated */
  where: Genders_Bool_Exp;
};

export type Get_All_Posts_Args = {
  category_row?: InputMaybe<Scalars['categories_scalar']['input']>;
};

export type Get_Banner_Images_Args = {
  banner_row?: InputMaybe<Scalars['banners_scalar']['input']>;
};

export type Get_Post_Images_Args = {
  post_row?: InputMaybe<Scalars['posts_scalar']['input']>;
};

export type Get_Post_Thumbnail_Args = {
  post_row?: InputMaybe<Scalars['posts_scalar']['input']>;
};

export type Get_Posts_By_Category_Id_Args = {
  category_id?: InputMaybe<Scalars['bigint']['input']>;
};

export type Get_User_Avatar_Args = {
  user_row?: InputMaybe<Scalars['users_scalar']['input']>;
};

/** columns and relationships of "group_kpis" */
export type Group_Kpis = {
  __typename?: 'group_kpis';
  /** An object relationship */
  category_kpi: Category_Kpis;
  category_kpi_id: Scalars['bigint']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by?: Maybe<Users>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  deleted_by?: Maybe<Users>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['bigint']['output'];
  /** An array relationship */
  kpis: Array<Kpis>;
  /** An aggregate relationship */
  kpis_aggregate: Kpis_Aggregate;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  updated_by?: Maybe<Users>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};


/** columns and relationships of "group_kpis" */
export type Group_KpisKpisArgs = {
  distinct_on?: InputMaybe<Array<Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Kpis_Order_By>>;
  where?: InputMaybe<Kpis_Bool_Exp>;
};


/** columns and relationships of "group_kpis" */
export type Group_KpisKpis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Kpis_Order_By>>;
  where?: InputMaybe<Kpis_Bool_Exp>;
};

/** aggregated selection of "group_kpis" */
export type Group_Kpis_Aggregate = {
  __typename?: 'group_kpis_aggregate';
  aggregate?: Maybe<Group_Kpis_Aggregate_Fields>;
  nodes: Array<Group_Kpis>;
};

export type Group_Kpis_Aggregate_Bool_Exp = {
  count?: InputMaybe<Group_Kpis_Aggregate_Bool_Exp_Count>;
};

export type Group_Kpis_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Group_Kpis_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Group_Kpis_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "group_kpis" */
export type Group_Kpis_Aggregate_Fields = {
  __typename?: 'group_kpis_aggregate_fields';
  avg?: Maybe<Group_Kpis_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Group_Kpis_Max_Fields>;
  min?: Maybe<Group_Kpis_Min_Fields>;
  stddev?: Maybe<Group_Kpis_Stddev_Fields>;
  stddev_pop?: Maybe<Group_Kpis_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Group_Kpis_Stddev_Samp_Fields>;
  sum?: Maybe<Group_Kpis_Sum_Fields>;
  var_pop?: Maybe<Group_Kpis_Var_Pop_Fields>;
  var_samp?: Maybe<Group_Kpis_Var_Samp_Fields>;
  variance?: Maybe<Group_Kpis_Variance_Fields>;
};


/** aggregate fields of "group_kpis" */
export type Group_Kpis_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Group_Kpis_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "group_kpis" */
export type Group_Kpis_Aggregate_Order_By = {
  avg?: InputMaybe<Group_Kpis_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Group_Kpis_Max_Order_By>;
  min?: InputMaybe<Group_Kpis_Min_Order_By>;
  stddev?: InputMaybe<Group_Kpis_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Group_Kpis_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Group_Kpis_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Group_Kpis_Sum_Order_By>;
  var_pop?: InputMaybe<Group_Kpis_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Group_Kpis_Var_Samp_Order_By>;
  variance?: InputMaybe<Group_Kpis_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "group_kpis" */
export type Group_Kpis_Arr_Rel_Insert_Input = {
  data: Array<Group_Kpis_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Group_Kpis_On_Conflict>;
};

/** aggregate avg on columns */
export type Group_Kpis_Avg_Fields = {
  __typename?: 'group_kpis_avg_fields';
  category_kpi_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "group_kpis" */
export type Group_Kpis_Avg_Order_By = {
  category_kpi_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "group_kpis". All fields are combined with a logical 'AND'. */
export type Group_Kpis_Bool_Exp = {
  _and?: InputMaybe<Array<Group_Kpis_Bool_Exp>>;
  _not?: InputMaybe<Group_Kpis_Bool_Exp>;
  _or?: InputMaybe<Array<Group_Kpis_Bool_Exp>>;
  category_kpi?: InputMaybe<Category_Kpis_Bool_Exp>;
  category_kpi_id?: InputMaybe<Bigint_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Users_Bool_Exp>;
  created_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_by?: InputMaybe<Users_Bool_Exp>;
  deleted_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  kpis?: InputMaybe<Kpis_Bool_Exp>;
  kpis_aggregate?: InputMaybe<Kpis_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Users_Bool_Exp>;
  updated_by_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "group_kpis" */
export enum Group_Kpis_Constraint {
  /** unique or primary key constraint on columns "id" */
  GroupKpisPkey = 'group_kpis_pkey'
}

/** input type for incrementing numeric columns in table "group_kpis" */
export type Group_Kpis_Inc_Input = {
  category_kpi_id?: InputMaybe<Scalars['bigint']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "group_kpis" */
export type Group_Kpis_Insert_Input = {
  category_kpi?: InputMaybe<Category_Kpis_Obj_Rel_Insert_Input>;
  category_kpi_id?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  kpis?: InputMaybe<Kpis_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Group_Kpis_Max_Fields = {
  __typename?: 'group_kpis_max_fields';
  category_kpi_id?: Maybe<Scalars['bigint']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "group_kpis" */
export type Group_Kpis_Max_Order_By = {
  category_kpi_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Group_Kpis_Min_Fields = {
  __typename?: 'group_kpis_min_fields';
  category_kpi_id?: Maybe<Scalars['bigint']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "group_kpis" */
export type Group_Kpis_Min_Order_By = {
  category_kpi_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "group_kpis" */
export type Group_Kpis_Mutation_Response = {
  __typename?: 'group_kpis_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Group_Kpis>;
};

/** input type for inserting object relation for remote table "group_kpis" */
export type Group_Kpis_Obj_Rel_Insert_Input = {
  data: Group_Kpis_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Group_Kpis_On_Conflict>;
};

/** on_conflict condition type for table "group_kpis" */
export type Group_Kpis_On_Conflict = {
  constraint: Group_Kpis_Constraint;
  update_columns?: Array<Group_Kpis_Update_Column>;
  where?: InputMaybe<Group_Kpis_Bool_Exp>;
};

/** Ordering options when selecting data from "group_kpis". */
export type Group_Kpis_Order_By = {
  category_kpi?: InputMaybe<Category_Kpis_Order_By>;
  category_kpi_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Users_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by?: InputMaybe<Users_Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kpis_aggregate?: InputMaybe<Kpis_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Users_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: group_kpis */
export type Group_Kpis_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "group_kpis" */
export enum Group_Kpis_Select_Column {
  /** column name */
  CategoryKpiId = 'category_kpi_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "group_kpis" */
export type Group_Kpis_Set_Input = {
  category_kpi_id?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Group_Kpis_Stddev_Fields = {
  __typename?: 'group_kpis_stddev_fields';
  category_kpi_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "group_kpis" */
export type Group_Kpis_Stddev_Order_By = {
  category_kpi_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Group_Kpis_Stddev_Pop_Fields = {
  __typename?: 'group_kpis_stddev_pop_fields';
  category_kpi_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "group_kpis" */
export type Group_Kpis_Stddev_Pop_Order_By = {
  category_kpi_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Group_Kpis_Stddev_Samp_Fields = {
  __typename?: 'group_kpis_stddev_samp_fields';
  category_kpi_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "group_kpis" */
export type Group_Kpis_Stddev_Samp_Order_By = {
  category_kpi_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "group_kpis" */
export type Group_Kpis_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Group_Kpis_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Group_Kpis_Stream_Cursor_Value_Input = {
  category_kpi_id?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Group_Kpis_Sum_Fields = {
  __typename?: 'group_kpis_sum_fields';
  category_kpi_id?: Maybe<Scalars['bigint']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "group_kpis" */
export type Group_Kpis_Sum_Order_By = {
  category_kpi_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "group_kpis" */
export enum Group_Kpis_Update_Column {
  /** column name */
  CategoryKpiId = 'category_kpi_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Group_Kpis_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Group_Kpis_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Group_Kpis_Set_Input>;
  /** filter the rows which have to be updated */
  where: Group_Kpis_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Group_Kpis_Var_Pop_Fields = {
  __typename?: 'group_kpis_var_pop_fields';
  category_kpi_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "group_kpis" */
export type Group_Kpis_Var_Pop_Order_By = {
  category_kpi_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Group_Kpis_Var_Samp_Fields = {
  __typename?: 'group_kpis_var_samp_fields';
  category_kpi_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "group_kpis" */
export type Group_Kpis_Var_Samp_Order_By = {
  category_kpi_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Group_Kpis_Variance_Fields = {
  __typename?: 'group_kpis_variance_fields';
  category_kpi_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "group_kpis" */
export type Group_Kpis_Variance_Order_By = {
  category_kpi_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "image_subtypes" */
export type Image_Subtypes = {
  __typename?: 'image_subtypes';
  /** An array relationship */
  banners: Array<Banners>;
  /** An aggregate relationship */
  banners_aggregate: Banners_Aggregate;
  description: Scalars['String']['output'];
  /** An array relationship */
  images: Array<Images>;
  /** An aggregate relationship */
  images_aggregate: Images_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "image_subtypes" */
export type Image_SubtypesBannersArgs = {
  distinct_on?: InputMaybe<Array<Banners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Banners_Order_By>>;
  where?: InputMaybe<Banners_Bool_Exp>;
};


/** columns and relationships of "image_subtypes" */
export type Image_SubtypesBanners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Banners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Banners_Order_By>>;
  where?: InputMaybe<Banners_Bool_Exp>;
};


/** columns and relationships of "image_subtypes" */
export type Image_SubtypesImagesArgs = {
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


/** columns and relationships of "image_subtypes" */
export type Image_SubtypesImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};

/** aggregated selection of "image_subtypes" */
export type Image_Subtypes_Aggregate = {
  __typename?: 'image_subtypes_aggregate';
  aggregate?: Maybe<Image_Subtypes_Aggregate_Fields>;
  nodes: Array<Image_Subtypes>;
};

/** aggregate fields of "image_subtypes" */
export type Image_Subtypes_Aggregate_Fields = {
  __typename?: 'image_subtypes_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Image_Subtypes_Max_Fields>;
  min?: Maybe<Image_Subtypes_Min_Fields>;
};


/** aggregate fields of "image_subtypes" */
export type Image_Subtypes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Image_Subtypes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "image_subtypes". All fields are combined with a logical 'AND'. */
export type Image_Subtypes_Bool_Exp = {
  _and?: InputMaybe<Array<Image_Subtypes_Bool_Exp>>;
  _not?: InputMaybe<Image_Subtypes_Bool_Exp>;
  _or?: InputMaybe<Array<Image_Subtypes_Bool_Exp>>;
  banners?: InputMaybe<Banners_Bool_Exp>;
  banners_aggregate?: InputMaybe<Banners_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  images?: InputMaybe<Images_Bool_Exp>;
  images_aggregate?: InputMaybe<Images_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "image_subtypes" */
export enum Image_Subtypes_Constraint {
  /** unique or primary key constraint on columns "value" */
  ImageSubtypesPkey = 'image_subtypes_pkey'
}

export enum Image_Subtypes_Enum {
  /** BEAUTI_CATEGORY_BOTTOM */
  BeautiCategoryBottom = 'BEAUTI_CATEGORY_BOTTOM',
  /** HOME_RIGHT_1 */
  HomeRight_1 = 'HOME_RIGHT_1',
  /** HOME_RIGHT_2 */
  HomeRight_2 = 'HOME_RIGHT_2',
  /** HOME_RIGHT_3 */
  HomeRight_3 = 'HOME_RIGHT_3',
  /** LARGE_CATEGORY_RIGHT_1 */
  LargeCategoryRight_1 = 'LARGE_CATEGORY_RIGHT_1',
  /** LARGE_CATEGORY_RIGHT_2 */
  LargeCategoryRight_2 = 'LARGE_CATEGORY_RIGHT_2',
  /** LARGE_CATEGORY_RIGHT_3 */
  LargeCategoryRight_3 = 'LARGE_CATEGORY_RIGHT_3',
  /** LARGE_CATEGORY_RIGHT_4 */
  LargeCategoryRight_4 = 'LARGE_CATEGORY_RIGHT_4',
  /** POST_DETAIL_BOTTOM */
  PostDetailBottom = 'POST_DETAIL_BOTTOM',
  /** POST_DETAIL_RIGHT_1 */
  PostDetailRight_1 = 'POST_DETAIL_RIGHT_1',
  /** POST_DETAIL_RIGHT_2 */
  PostDetailRight_2 = 'POST_DETAIL_RIGHT_2',
  /** Post images */
  PostImages = 'POST_IMAGES',
  /** Image in post conent */
  PostImageContent = 'POST_IMAGE_CONTENT',
  /** Post thumbnail */
  PostThumbnail = 'POST_THUMBNAIL',
  /** SEARCH_BOTTOM_1 */
  SearchBottom_1 = 'SEARCH_BOTTOM_1',
  /** SEARCH_BOTTOM_2 */
  SearchBottom_2 = 'SEARCH_BOTTOM_2',
  /** SEARCH_BOTTOM_3 */
  SearchBottom_3 = 'SEARCH_BOTTOM_3',
  /** SEARCH_TOP */
  SearchTop = 'SEARCH_TOP',
  /** SETTING_AD_QUOTE */
  SettingAdQuote = 'SETTING_AD_QUOTE',
  /** SETTING_DISPLAY_BANNER_QUOTE */
  SettingDisplayBannerQuote = 'SETTING_DISPLAY_BANNER_QUOTE',
  /** setting favicon */
  SettingFavicon = 'SETTING_FAVICON',
  /** setting logo */
  SettingLogo = 'SETTING_LOGO',
  /** SETTING_PR_POST_QUOTE */
  SettingPrPostQuote = 'SETTING_PR_POST_QUOTE',
  /** SMALL_CATEGORY_RIGHT_1 */
  SmallCategoryRight_1 = 'SMALL_CATEGORY_RIGHT_1',
  /** SMALL_CATEGORY_RIGHT_2 */
  SmallCategoryRight_2 = 'SMALL_CATEGORY_RIGHT_2',
  /** User avatar */
  UserAvatar = 'USER_AVATAR'
}

/** Boolean expression to compare columns of type "image_subtypes_enum". All fields are combined with logical 'AND'. */
export type Image_Subtypes_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Image_Subtypes_Enum>;
  _in?: InputMaybe<Array<Image_Subtypes_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Image_Subtypes_Enum>;
  _nin?: InputMaybe<Array<Image_Subtypes_Enum>>;
};

/** input type for inserting data into table "image_subtypes" */
export type Image_Subtypes_Insert_Input = {
  banners?: InputMaybe<Banners_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Images_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Image_Subtypes_Max_Fields = {
  __typename?: 'image_subtypes_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Image_Subtypes_Min_Fields = {
  __typename?: 'image_subtypes_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "image_subtypes" */
export type Image_Subtypes_Mutation_Response = {
  __typename?: 'image_subtypes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Image_Subtypes>;
};

/** input type for inserting object relation for remote table "image_subtypes" */
export type Image_Subtypes_Obj_Rel_Insert_Input = {
  data: Image_Subtypes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Image_Subtypes_On_Conflict>;
};

/** on_conflict condition type for table "image_subtypes" */
export type Image_Subtypes_On_Conflict = {
  constraint: Image_Subtypes_Constraint;
  update_columns?: Array<Image_Subtypes_Update_Column>;
  where?: InputMaybe<Image_Subtypes_Bool_Exp>;
};

/** Ordering options when selecting data from "image_subtypes". */
export type Image_Subtypes_Order_By = {
  banners_aggregate?: InputMaybe<Banners_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Images_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: image_subtypes */
export type Image_Subtypes_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "image_subtypes" */
export enum Image_Subtypes_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "image_subtypes" */
export type Image_Subtypes_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "image_subtypes" */
export type Image_Subtypes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Image_Subtypes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Image_Subtypes_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "image_subtypes" */
export enum Image_Subtypes_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Image_Subtypes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Image_Subtypes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Image_Subtypes_Bool_Exp;
};

/** columns and relationships of "image_types" */
export type Image_Types = {
  __typename?: 'image_types';
  description: Scalars['String']['output'];
  /** An array relationship */
  images: Array<Images>;
  /** An aggregate relationship */
  images_aggregate: Images_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "image_types" */
export type Image_TypesImagesArgs = {
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


/** columns and relationships of "image_types" */
export type Image_TypesImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};

/** aggregated selection of "image_types" */
export type Image_Types_Aggregate = {
  __typename?: 'image_types_aggregate';
  aggregate?: Maybe<Image_Types_Aggregate_Fields>;
  nodes: Array<Image_Types>;
};

/** aggregate fields of "image_types" */
export type Image_Types_Aggregate_Fields = {
  __typename?: 'image_types_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Image_Types_Max_Fields>;
  min?: Maybe<Image_Types_Min_Fields>;
};


/** aggregate fields of "image_types" */
export type Image_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Image_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "image_types". All fields are combined with a logical 'AND'. */
export type Image_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Image_Types_Bool_Exp>>;
  _not?: InputMaybe<Image_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Image_Types_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  images?: InputMaybe<Images_Bool_Exp>;
  images_aggregate?: InputMaybe<Images_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "image_types" */
export enum Image_Types_Constraint {
  /** unique or primary key constraint on columns "value" */
  ImageTypesPkey = 'image_types_pkey'
}

export enum Image_Types_Enum {
  /** Banner image */
  Banner = 'BANNER',
  /** Post image */
  Post = 'POST',
  /** Setting images */
  Setting = 'SETTING',
  /** User image */
  User = 'USER'
}

/** Boolean expression to compare columns of type "image_types_enum". All fields are combined with logical 'AND'. */
export type Image_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Image_Types_Enum>;
  _in?: InputMaybe<Array<Image_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Image_Types_Enum>;
  _nin?: InputMaybe<Array<Image_Types_Enum>>;
};

/** input type for inserting data into table "image_types" */
export type Image_Types_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Images_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Image_Types_Max_Fields = {
  __typename?: 'image_types_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Image_Types_Min_Fields = {
  __typename?: 'image_types_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "image_types" */
export type Image_Types_Mutation_Response = {
  __typename?: 'image_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Image_Types>;
};

/** input type for inserting object relation for remote table "image_types" */
export type Image_Types_Obj_Rel_Insert_Input = {
  data: Image_Types_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Image_Types_On_Conflict>;
};

/** on_conflict condition type for table "image_types" */
export type Image_Types_On_Conflict = {
  constraint: Image_Types_Constraint;
  update_columns?: Array<Image_Types_Update_Column>;
  where?: InputMaybe<Image_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "image_types". */
export type Image_Types_Order_By = {
  description?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Images_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: image_types */
export type Image_Types_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "image_types" */
export enum Image_Types_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "image_types" */
export type Image_Types_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "image_types" */
export type Image_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Image_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Image_Types_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "image_types" */
export enum Image_Types_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Image_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Image_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Image_Types_Bool_Exp;
};

/** columns and relationships of "images" */
export type Images = {
  __typename?: 'images';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by?: Maybe<Users>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  deleted_by?: Maybe<Users>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  filename: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  image_subtype: Image_Subtypes;
  /** An object relationship */
  image_type: Image_Types;
  object_id: Scalars['bigint']['output'];
  subtype: Image_Subtypes_Enum;
  type: Image_Types_Enum;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  updated_by?: Maybe<Users>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "images" */
export type Images_Aggregate = {
  __typename?: 'images_aggregate';
  aggregate?: Maybe<Images_Aggregate_Fields>;
  nodes: Array<Images>;
};

export type Images_Aggregate_Bool_Exp = {
  count?: InputMaybe<Images_Aggregate_Bool_Exp_Count>;
};

export type Images_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Images_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Images_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "images" */
export type Images_Aggregate_Fields = {
  __typename?: 'images_aggregate_fields';
  avg?: Maybe<Images_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Images_Max_Fields>;
  min?: Maybe<Images_Min_Fields>;
  stddev?: Maybe<Images_Stddev_Fields>;
  stddev_pop?: Maybe<Images_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Images_Stddev_Samp_Fields>;
  sum?: Maybe<Images_Sum_Fields>;
  var_pop?: Maybe<Images_Var_Pop_Fields>;
  var_samp?: Maybe<Images_Var_Samp_Fields>;
  variance?: Maybe<Images_Variance_Fields>;
};


/** aggregate fields of "images" */
export type Images_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Images_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "images" */
export type Images_Aggregate_Order_By = {
  avg?: InputMaybe<Images_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Images_Max_Order_By>;
  min?: InputMaybe<Images_Min_Order_By>;
  stddev?: InputMaybe<Images_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Images_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Images_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Images_Sum_Order_By>;
  var_pop?: InputMaybe<Images_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Images_Var_Samp_Order_By>;
  variance?: InputMaybe<Images_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "images" */
export type Images_Arr_Rel_Insert_Input = {
  data: Array<Images_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Images_On_Conflict>;
};

/** aggregate avg on columns */
export type Images_Avg_Fields = {
  __typename?: 'images_avg_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  object_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "images" */
export type Images_Avg_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "images". All fields are combined with a logical 'AND'. */
export type Images_Bool_Exp = {
  _and?: InputMaybe<Array<Images_Bool_Exp>>;
  _not?: InputMaybe<Images_Bool_Exp>;
  _or?: InputMaybe<Array<Images_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Users_Bool_Exp>;
  created_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_by?: InputMaybe<Users_Bool_Exp>;
  deleted_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  filename?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  image_subtype?: InputMaybe<Image_Subtypes_Bool_Exp>;
  image_type?: InputMaybe<Image_Types_Bool_Exp>;
  object_id?: InputMaybe<Bigint_Comparison_Exp>;
  subtype?: InputMaybe<Image_Subtypes_Enum_Comparison_Exp>;
  type?: InputMaybe<Image_Types_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Users_Bool_Exp>;
  updated_by_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "images" */
export enum Images_Constraint {
  /** unique or primary key constraint on columns "id" */
  ImagesPkey = 'images_pkey'
}

/** input type for incrementing numeric columns in table "images" */
export type Images_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  object_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "images" */
export type Images_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  image_subtype?: InputMaybe<Image_Subtypes_Obj_Rel_Insert_Input>;
  image_type?: InputMaybe<Image_Types_Obj_Rel_Insert_Input>;
  object_id?: InputMaybe<Scalars['bigint']['input']>;
  subtype?: InputMaybe<Image_Subtypes_Enum>;
  type?: InputMaybe<Image_Types_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Images_Max_Fields = {
  __typename?: 'images_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  object_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "images" */
export type Images_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  filename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Images_Min_Fields = {
  __typename?: 'images_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  object_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "images" */
export type Images_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  filename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "images" */
export type Images_Mutation_Response = {
  __typename?: 'images_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Images>;
};

/** on_conflict condition type for table "images" */
export type Images_On_Conflict = {
  constraint: Images_Constraint;
  update_columns?: Array<Images_Update_Column>;
  where?: InputMaybe<Images_Bool_Exp>;
};

/** Ordering options when selecting data from "images". */
export type Images_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Users_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by?: InputMaybe<Users_Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  filename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_subtype?: InputMaybe<Image_Subtypes_Order_By>;
  image_type?: InputMaybe<Image_Types_Order_By>;
  object_id?: InputMaybe<Order_By>;
  subtype?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Users_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: images */
export type Images_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "images" */
export enum Images_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Filename = 'filename',
  /** column name */
  Id = 'id',
  /** column name */
  ObjectId = 'object_id',
  /** column name */
  Subtype = 'subtype',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "images" */
export type Images_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  object_id?: InputMaybe<Scalars['bigint']['input']>;
  subtype?: InputMaybe<Image_Subtypes_Enum>;
  type?: InputMaybe<Image_Types_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Images_Stddev_Fields = {
  __typename?: 'images_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  object_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "images" */
export type Images_Stddev_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Images_Stddev_Pop_Fields = {
  __typename?: 'images_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  object_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "images" */
export type Images_Stddev_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Images_Stddev_Samp_Fields = {
  __typename?: 'images_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  object_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "images" */
export type Images_Stddev_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "images" */
export type Images_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Images_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Images_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  object_id?: InputMaybe<Scalars['bigint']['input']>;
  subtype?: InputMaybe<Image_Subtypes_Enum>;
  type?: InputMaybe<Image_Types_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Images_Sum_Fields = {
  __typename?: 'images_sum_fields';
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  object_id?: Maybe<Scalars['bigint']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "images" */
export type Images_Sum_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "images" */
export enum Images_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Filename = 'filename',
  /** column name */
  Id = 'id',
  /** column name */
  ObjectId = 'object_id',
  /** column name */
  Subtype = 'subtype',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Images_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Images_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Images_Set_Input>;
  /** filter the rows which have to be updated */
  where: Images_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Images_Var_Pop_Fields = {
  __typename?: 'images_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  object_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "images" */
export type Images_Var_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Images_Var_Samp_Fields = {
  __typename?: 'images_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  object_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "images" */
export type Images_Var_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Images_Variance_Fields = {
  __typename?: 'images_variance_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  object_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "images" */
export type Images_Variance_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** columns and relationships of "kpis" */
export type Kpis = {
  __typename?: 'kpis';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by?: Maybe<Users>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  deleted_by?: Maybe<Users>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  fee?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  group_kpi?: Maybe<Group_Kpis>;
  group_kpis_id?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['bigint']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  posts_kpis: Array<Posts_Kpis>;
  /** An aggregate relationship */
  posts_kpis_aggregate: Posts_Kpis_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  updated_by?: Maybe<Users>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};


/** columns and relationships of "kpis" */
export type KpisFeeArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "kpis" */
export type KpisPosts_KpisArgs = {
  distinct_on?: InputMaybe<Array<Posts_Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Kpis_Order_By>>;
  where?: InputMaybe<Posts_Kpis_Bool_Exp>;
};


/** columns and relationships of "kpis" */
export type KpisPosts_Kpis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Kpis_Order_By>>;
  where?: InputMaybe<Posts_Kpis_Bool_Exp>;
};

/** aggregated selection of "kpis" */
export type Kpis_Aggregate = {
  __typename?: 'kpis_aggregate';
  aggregate?: Maybe<Kpis_Aggregate_Fields>;
  nodes: Array<Kpis>;
};

export type Kpis_Aggregate_Bool_Exp = {
  count?: InputMaybe<Kpis_Aggregate_Bool_Exp_Count>;
};

export type Kpis_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Kpis_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Kpis_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "kpis" */
export type Kpis_Aggregate_Fields = {
  __typename?: 'kpis_aggregate_fields';
  avg?: Maybe<Kpis_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Kpis_Max_Fields>;
  min?: Maybe<Kpis_Min_Fields>;
  stddev?: Maybe<Kpis_Stddev_Fields>;
  stddev_pop?: Maybe<Kpis_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Kpis_Stddev_Samp_Fields>;
  sum?: Maybe<Kpis_Sum_Fields>;
  var_pop?: Maybe<Kpis_Var_Pop_Fields>;
  var_samp?: Maybe<Kpis_Var_Samp_Fields>;
  variance?: Maybe<Kpis_Variance_Fields>;
};


/** aggregate fields of "kpis" */
export type Kpis_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Kpis_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "kpis" */
export type Kpis_Aggregate_Order_By = {
  avg?: InputMaybe<Kpis_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Kpis_Max_Order_By>;
  min?: InputMaybe<Kpis_Min_Order_By>;
  stddev?: InputMaybe<Kpis_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Kpis_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Kpis_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Kpis_Sum_Order_By>;
  var_pop?: InputMaybe<Kpis_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Kpis_Var_Samp_Order_By>;
  variance?: InputMaybe<Kpis_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Kpis_Append_Input = {
  fee?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "kpis" */
export type Kpis_Arr_Rel_Insert_Input = {
  data: Array<Kpis_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Kpis_On_Conflict>;
};

/** aggregate avg on columns */
export type Kpis_Avg_Fields = {
  __typename?: 'kpis_avg_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  group_kpis_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "kpis" */
export type Kpis_Avg_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  group_kpis_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "kpis". All fields are combined with a logical 'AND'. */
export type Kpis_Bool_Exp = {
  _and?: InputMaybe<Array<Kpis_Bool_Exp>>;
  _not?: InputMaybe<Kpis_Bool_Exp>;
  _or?: InputMaybe<Array<Kpis_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Users_Bool_Exp>;
  created_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_by?: InputMaybe<Users_Bool_Exp>;
  deleted_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  fee?: InputMaybe<Jsonb_Comparison_Exp>;
  group_kpi?: InputMaybe<Group_Kpis_Bool_Exp>;
  group_kpis_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  posts_kpis?: InputMaybe<Posts_Kpis_Bool_Exp>;
  posts_kpis_aggregate?: InputMaybe<Posts_Kpis_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Users_Bool_Exp>;
  updated_by_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "kpis" */
export enum Kpis_Constraint {
  /** unique or primary key constraint on columns "id" */
  KpisPkey = 'kpis_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Kpis_Delete_At_Path_Input = {
  fee?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Kpis_Delete_Elem_Input = {
  fee?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Kpis_Delete_Key_Input = {
  fee?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "kpis" */
export type Kpis_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  group_kpis_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "kpis" */
export type Kpis_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  fee?: InputMaybe<Scalars['jsonb']['input']>;
  group_kpi?: InputMaybe<Group_Kpis_Obj_Rel_Insert_Input>;
  group_kpis_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  posts_kpis?: InputMaybe<Posts_Kpis_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Kpis_Max_Fields = {
  __typename?: 'kpis_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  group_kpis_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "kpis" */
export type Kpis_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  group_kpis_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Kpis_Min_Fields = {
  __typename?: 'kpis_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  group_kpis_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "kpis" */
export type Kpis_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  group_kpis_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "kpis" */
export type Kpis_Mutation_Response = {
  __typename?: 'kpis_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Kpis>;
};

/** input type for inserting object relation for remote table "kpis" */
export type Kpis_Obj_Rel_Insert_Input = {
  data: Kpis_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Kpis_On_Conflict>;
};

/** on_conflict condition type for table "kpis" */
export type Kpis_On_Conflict = {
  constraint: Kpis_Constraint;
  update_columns?: Array<Kpis_Update_Column>;
  where?: InputMaybe<Kpis_Bool_Exp>;
};

/** Ordering options when selecting data from "kpis". */
export type Kpis_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Users_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by?: InputMaybe<Users_Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  fee?: InputMaybe<Order_By>;
  group_kpi?: InputMaybe<Group_Kpis_Order_By>;
  group_kpis_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  posts_kpis_aggregate?: InputMaybe<Posts_Kpis_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Users_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: kpis */
export type Kpis_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Kpis_Prepend_Input = {
  fee?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "kpis" */
export enum Kpis_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Fee = 'fee',
  /** column name */
  GroupKpisId = 'group_kpis_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "kpis" */
export type Kpis_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  fee?: InputMaybe<Scalars['jsonb']['input']>;
  group_kpis_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Kpis_Stddev_Fields = {
  __typename?: 'kpis_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  group_kpis_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "kpis" */
export type Kpis_Stddev_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  group_kpis_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Kpis_Stddev_Pop_Fields = {
  __typename?: 'kpis_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  group_kpis_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "kpis" */
export type Kpis_Stddev_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  group_kpis_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Kpis_Stddev_Samp_Fields = {
  __typename?: 'kpis_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  group_kpis_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "kpis" */
export type Kpis_Stddev_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  group_kpis_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "kpis" */
export type Kpis_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Kpis_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Kpis_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  fee?: InputMaybe<Scalars['jsonb']['input']>;
  group_kpis_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Kpis_Sum_Fields = {
  __typename?: 'kpis_sum_fields';
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  group_kpis_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "kpis" */
export type Kpis_Sum_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  group_kpis_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "kpis" */
export enum Kpis_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Fee = 'fee',
  /** column name */
  GroupKpisId = 'group_kpis_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Kpis_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Kpis_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Kpis_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Kpis_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Kpis_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Kpis_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Kpis_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Kpis_Set_Input>;
  /** filter the rows which have to be updated */
  where: Kpis_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Kpis_Var_Pop_Fields = {
  __typename?: 'kpis_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  group_kpis_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "kpis" */
export type Kpis_Var_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  group_kpis_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Kpis_Var_Samp_Fields = {
  __typename?: 'kpis_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  group_kpis_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "kpis" */
export type Kpis_Var_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  group_kpis_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Kpis_Variance_Fields = {
  __typename?: 'kpis_variance_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  group_kpis_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "kpis" */
export type Kpis_Variance_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  group_kpis_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "languages" */
export type Languages = {
  __typename?: 'languages';
  name: Scalars['String']['output'];
};

/** aggregated selection of "languages" */
export type Languages_Aggregate = {
  __typename?: 'languages_aggregate';
  aggregate?: Maybe<Languages_Aggregate_Fields>;
  nodes: Array<Languages>;
};

/** aggregate fields of "languages" */
export type Languages_Aggregate_Fields = {
  __typename?: 'languages_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Languages_Max_Fields>;
  min?: Maybe<Languages_Min_Fields>;
};


/** aggregate fields of "languages" */
export type Languages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Languages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "languages". All fields are combined with a logical 'AND'. */
export type Languages_Bool_Exp = {
  _and?: InputMaybe<Array<Languages_Bool_Exp>>;
  _not?: InputMaybe<Languages_Bool_Exp>;
  _or?: InputMaybe<Array<Languages_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "languages" */
export enum Languages_Constraint {
  /** unique or primary key constraint on columns "name" */
  LanguagesPkey = 'languages_pkey'
}

export enum Languages_Enum {
  EnUs = 'en_US',
  ViVn = 'vi_VN'
}

/** Boolean expression to compare columns of type "languages_enum". All fields are combined with logical 'AND'. */
export type Languages_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Languages_Enum>;
  _in?: InputMaybe<Array<Languages_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Languages_Enum>;
  _nin?: InputMaybe<Array<Languages_Enum>>;
};

/** input type for inserting data into table "languages" */
export type Languages_Insert_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Languages_Max_Fields = {
  __typename?: 'languages_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Languages_Min_Fields = {
  __typename?: 'languages_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "languages" */
export type Languages_Mutation_Response = {
  __typename?: 'languages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Languages>;
};

/** on_conflict condition type for table "languages" */
export type Languages_On_Conflict = {
  constraint: Languages_Constraint;
  update_columns?: Array<Languages_Update_Column>;
  where?: InputMaybe<Languages_Bool_Exp>;
};

/** Ordering options when selecting data from "languages". */
export type Languages_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: languages */
export type Languages_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "languages" */
export enum Languages_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "languages" */
export type Languages_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "languages" */
export type Languages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Languages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Languages_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "languages" */
export enum Languages_Update_Column {
  /** column name */
  Name = 'name'
}

export type Languages_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Languages_Set_Input>;
  /** filter the rows which have to be updated */
  where: Languages_Bool_Exp;
};

/** columns and relationships of "layout_page_bottoms" */
export type Layout_Page_Bottoms = {
  __typename?: 'layout_page_bottoms';
  description?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "layout_page_bottoms" */
export type Layout_Page_Bottoms_Aggregate = {
  __typename?: 'layout_page_bottoms_aggregate';
  aggregate?: Maybe<Layout_Page_Bottoms_Aggregate_Fields>;
  nodes: Array<Layout_Page_Bottoms>;
};

/** aggregate fields of "layout_page_bottoms" */
export type Layout_Page_Bottoms_Aggregate_Fields = {
  __typename?: 'layout_page_bottoms_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Layout_Page_Bottoms_Max_Fields>;
  min?: Maybe<Layout_Page_Bottoms_Min_Fields>;
};


/** aggregate fields of "layout_page_bottoms" */
export type Layout_Page_Bottoms_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Layout_Page_Bottoms_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "layout_page_bottoms". All fields are combined with a logical 'AND'. */
export type Layout_Page_Bottoms_Bool_Exp = {
  _and?: InputMaybe<Array<Layout_Page_Bottoms_Bool_Exp>>;
  _not?: InputMaybe<Layout_Page_Bottoms_Bool_Exp>;
  _or?: InputMaybe<Array<Layout_Page_Bottoms_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "layout_page_bottoms" */
export enum Layout_Page_Bottoms_Constraint {
  /** unique or primary key constraint on columns "value" */
  LayoutBottomsPkey = 'layout_bottoms_pkey'
}

export enum Layout_Page_Bottoms_Enum {
  /** Danh sách danh mục */
  ListCategories = 'LIST_CATEGORIES',
  /** Danh sách bài viết */
  ListPosts = 'LIST_POSTS'
}

/** Boolean expression to compare columns of type "layout_page_bottoms_enum". All fields are combined with logical 'AND'. */
export type Layout_Page_Bottoms_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Layout_Page_Bottoms_Enum>;
  _in?: InputMaybe<Array<Layout_Page_Bottoms_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Layout_Page_Bottoms_Enum>;
  _nin?: InputMaybe<Array<Layout_Page_Bottoms_Enum>>;
};

/** input type for inserting data into table "layout_page_bottoms" */
export type Layout_Page_Bottoms_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Layout_Page_Bottoms_Max_Fields = {
  __typename?: 'layout_page_bottoms_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Layout_Page_Bottoms_Min_Fields = {
  __typename?: 'layout_page_bottoms_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "layout_page_bottoms" */
export type Layout_Page_Bottoms_Mutation_Response = {
  __typename?: 'layout_page_bottoms_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Layout_Page_Bottoms>;
};

/** input type for inserting object relation for remote table "layout_page_bottoms" */
export type Layout_Page_Bottoms_Obj_Rel_Insert_Input = {
  data: Layout_Page_Bottoms_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Layout_Page_Bottoms_On_Conflict>;
};

/** on_conflict condition type for table "layout_page_bottoms" */
export type Layout_Page_Bottoms_On_Conflict = {
  constraint: Layout_Page_Bottoms_Constraint;
  update_columns?: Array<Layout_Page_Bottoms_Update_Column>;
  where?: InputMaybe<Layout_Page_Bottoms_Bool_Exp>;
};

/** Ordering options when selecting data from "layout_page_bottoms". */
export type Layout_Page_Bottoms_Order_By = {
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: layout_page_bottoms */
export type Layout_Page_Bottoms_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "layout_page_bottoms" */
export enum Layout_Page_Bottoms_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "layout_page_bottoms" */
export type Layout_Page_Bottoms_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "layout_page_bottoms" */
export type Layout_Page_Bottoms_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Layout_Page_Bottoms_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Layout_Page_Bottoms_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "layout_page_bottoms" */
export enum Layout_Page_Bottoms_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Layout_Page_Bottoms_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Layout_Page_Bottoms_Set_Input>;
  /** filter the rows which have to be updated */
  where: Layout_Page_Bottoms_Bool_Exp;
};

/** columns and relationships of "layout_page_tops" */
export type Layout_Page_Tops = {
  __typename?: 'layout_page_tops';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "layout_page_tops" */
export type Layout_Page_Tops_Aggregate = {
  __typename?: 'layout_page_tops_aggregate';
  aggregate?: Maybe<Layout_Page_Tops_Aggregate_Fields>;
  nodes: Array<Layout_Page_Tops>;
};

/** aggregate fields of "layout_page_tops" */
export type Layout_Page_Tops_Aggregate_Fields = {
  __typename?: 'layout_page_tops_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Layout_Page_Tops_Max_Fields>;
  min?: Maybe<Layout_Page_Tops_Min_Fields>;
};


/** aggregate fields of "layout_page_tops" */
export type Layout_Page_Tops_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Layout_Page_Tops_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "layout_page_tops". All fields are combined with a logical 'AND'. */
export type Layout_Page_Tops_Bool_Exp = {
  _and?: InputMaybe<Array<Layout_Page_Tops_Bool_Exp>>;
  _not?: InputMaybe<Layout_Page_Tops_Bool_Exp>;
  _or?: InputMaybe<Array<Layout_Page_Tops_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "layout_page_tops" */
export enum Layout_Page_Tops_Constraint {
  /** unique or primary key constraint on columns "value" */
  HomeLayoutsPkey = 'home_layouts_pkey'
}

export enum Layout_Page_Tops_Enum {
  /** Một lớn năm nhỏ */
  OneLargeFiveSmall = 'ONE_LARGE_FIVE_SMALL',
  /** Hai lớn hai nhỏ */
  TwoLargeTwoSmall = 'TWO_LARGE_TWO_SMALL'
}

/** Boolean expression to compare columns of type "layout_page_tops_enum". All fields are combined with logical 'AND'. */
export type Layout_Page_Tops_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Layout_Page_Tops_Enum>;
  _in?: InputMaybe<Array<Layout_Page_Tops_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Layout_Page_Tops_Enum>;
  _nin?: InputMaybe<Array<Layout_Page_Tops_Enum>>;
};

/** input type for inserting data into table "layout_page_tops" */
export type Layout_Page_Tops_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Layout_Page_Tops_Max_Fields = {
  __typename?: 'layout_page_tops_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Layout_Page_Tops_Min_Fields = {
  __typename?: 'layout_page_tops_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "layout_page_tops" */
export type Layout_Page_Tops_Mutation_Response = {
  __typename?: 'layout_page_tops_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Layout_Page_Tops>;
};

/** input type for inserting object relation for remote table "layout_page_tops" */
export type Layout_Page_Tops_Obj_Rel_Insert_Input = {
  data: Layout_Page_Tops_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Layout_Page_Tops_On_Conflict>;
};

/** on_conflict condition type for table "layout_page_tops" */
export type Layout_Page_Tops_On_Conflict = {
  constraint: Layout_Page_Tops_Constraint;
  update_columns?: Array<Layout_Page_Tops_Update_Column>;
  where?: InputMaybe<Layout_Page_Tops_Bool_Exp>;
};

/** Ordering options when selecting data from "layout_page_tops". */
export type Layout_Page_Tops_Order_By = {
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: layout_page_tops */
export type Layout_Page_Tops_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "layout_page_tops" */
export enum Layout_Page_Tops_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "layout_page_tops" */
export type Layout_Page_Tops_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "layout_page_tops" */
export type Layout_Page_Tops_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Layout_Page_Tops_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Layout_Page_Tops_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "layout_page_tops" */
export enum Layout_Page_Tops_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Layout_Page_Tops_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Layout_Page_Tops_Set_Input>;
  /** filter the rows which have to be updated */
  where: Layout_Page_Tops_Bool_Exp;
};

/** columns and relationships of "layout_pages" */
export type Layout_Pages = {
  __typename?: 'layout_pages';
  /** An array relationship */
  categories: Array<Categories>;
  /** An aggregate relationship */
  categories_aggregate: Categories_Aggregate;
  description?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};


/** columns and relationships of "layout_pages" */
export type Layout_PagesCategoriesArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


/** columns and relationships of "layout_pages" */
export type Layout_PagesCategories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};

/** aggregated selection of "layout_pages" */
export type Layout_Pages_Aggregate = {
  __typename?: 'layout_pages_aggregate';
  aggregate?: Maybe<Layout_Pages_Aggregate_Fields>;
  nodes: Array<Layout_Pages>;
};

/** aggregate fields of "layout_pages" */
export type Layout_Pages_Aggregate_Fields = {
  __typename?: 'layout_pages_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Layout_Pages_Max_Fields>;
  min?: Maybe<Layout_Pages_Min_Fields>;
};


/** aggregate fields of "layout_pages" */
export type Layout_Pages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Layout_Pages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "layout_pages". All fields are combined with a logical 'AND'. */
export type Layout_Pages_Bool_Exp = {
  _and?: InputMaybe<Array<Layout_Pages_Bool_Exp>>;
  _not?: InputMaybe<Layout_Pages_Bool_Exp>;
  _or?: InputMaybe<Array<Layout_Pages_Bool_Exp>>;
  categories?: InputMaybe<Categories_Bool_Exp>;
  categories_aggregate?: InputMaybe<Categories_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "layout_pages" */
export enum Layout_Pages_Constraint {
  /** unique or primary key constraint on columns "value" */
  LayoutPagePkey = 'layout_page_pkey'
}

export enum Layout_Pages_Enum {
  /** Nhà đẹp */
  BeautifulHouses = 'BEAUTIFUL_HOUSES',
  /** Thông thường */
  Normal = 'NORMAL'
}

/** Boolean expression to compare columns of type "layout_pages_enum". All fields are combined with logical 'AND'. */
export type Layout_Pages_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Layout_Pages_Enum>;
  _in?: InputMaybe<Array<Layout_Pages_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Layout_Pages_Enum>;
  _nin?: InputMaybe<Array<Layout_Pages_Enum>>;
};

/** input type for inserting data into table "layout_pages" */
export type Layout_Pages_Insert_Input = {
  categories?: InputMaybe<Categories_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Layout_Pages_Max_Fields = {
  __typename?: 'layout_pages_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Layout_Pages_Min_Fields = {
  __typename?: 'layout_pages_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "layout_pages" */
export type Layout_Pages_Mutation_Response = {
  __typename?: 'layout_pages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Layout_Pages>;
};

/** input type for inserting object relation for remote table "layout_pages" */
export type Layout_Pages_Obj_Rel_Insert_Input = {
  data: Layout_Pages_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Layout_Pages_On_Conflict>;
};

/** on_conflict condition type for table "layout_pages" */
export type Layout_Pages_On_Conflict = {
  constraint: Layout_Pages_Constraint;
  update_columns?: Array<Layout_Pages_Update_Column>;
  where?: InputMaybe<Layout_Pages_Bool_Exp>;
};

/** Ordering options when selecting data from "layout_pages". */
export type Layout_Pages_Order_By = {
  categories_aggregate?: InputMaybe<Categories_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: layout_pages */
export type Layout_Pages_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "layout_pages" */
export enum Layout_Pages_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "layout_pages" */
export type Layout_Pages_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "layout_pages" */
export type Layout_Pages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Layout_Pages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Layout_Pages_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "layout_pages" */
export enum Layout_Pages_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Layout_Pages_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Layout_Pages_Set_Input>;
  /** filter the rows which have to be updated */
  where: Layout_Pages_Bool_Exp;
};

/** columns and relationships of "layout_posts" */
export type Layout_Posts = {
  __typename?: 'layout_posts';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "layout_posts" */
export type Layout_Posts_Aggregate = {
  __typename?: 'layout_posts_aggregate';
  aggregate?: Maybe<Layout_Posts_Aggregate_Fields>;
  nodes: Array<Layout_Posts>;
};

/** aggregate fields of "layout_posts" */
export type Layout_Posts_Aggregate_Fields = {
  __typename?: 'layout_posts_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Layout_Posts_Max_Fields>;
  min?: Maybe<Layout_Posts_Min_Fields>;
};


/** aggregate fields of "layout_posts" */
export type Layout_Posts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Layout_Posts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "layout_posts". All fields are combined with a logical 'AND'. */
export type Layout_Posts_Bool_Exp = {
  _and?: InputMaybe<Array<Layout_Posts_Bool_Exp>>;
  _not?: InputMaybe<Layout_Posts_Bool_Exp>;
  _or?: InputMaybe<Array<Layout_Posts_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "layout_posts" */
export enum Layout_Posts_Constraint {
  /** unique or primary key constraint on columns "value" */
  LayoutPostPkey = 'layout_post_pkey'
}

export enum Layout_Posts_Enum {
  /** Content */
  Content = 'CONTENT',
  /** Gallery */
  Gallery = 'GALLERY'
}

/** Boolean expression to compare columns of type "layout_posts_enum". All fields are combined with logical 'AND'. */
export type Layout_Posts_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Layout_Posts_Enum>;
  _in?: InputMaybe<Array<Layout_Posts_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Layout_Posts_Enum>;
  _nin?: InputMaybe<Array<Layout_Posts_Enum>>;
};

/** input type for inserting data into table "layout_posts" */
export type Layout_Posts_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Layout_Posts_Max_Fields = {
  __typename?: 'layout_posts_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Layout_Posts_Min_Fields = {
  __typename?: 'layout_posts_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "layout_posts" */
export type Layout_Posts_Mutation_Response = {
  __typename?: 'layout_posts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Layout_Posts>;
};

/** input type for inserting object relation for remote table "layout_posts" */
export type Layout_Posts_Obj_Rel_Insert_Input = {
  data: Layout_Posts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Layout_Posts_On_Conflict>;
};

/** on_conflict condition type for table "layout_posts" */
export type Layout_Posts_On_Conflict = {
  constraint: Layout_Posts_Constraint;
  update_columns?: Array<Layout_Posts_Update_Column>;
  where?: InputMaybe<Layout_Posts_Bool_Exp>;
};

/** Ordering options when selecting data from "layout_posts". */
export type Layout_Posts_Order_By = {
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: layout_posts */
export type Layout_Posts_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "layout_posts" */
export enum Layout_Posts_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "layout_posts" */
export type Layout_Posts_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "layout_posts" */
export type Layout_Posts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Layout_Posts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Layout_Posts_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "layout_posts" */
export enum Layout_Posts_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Layout_Posts_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Layout_Posts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Layout_Posts_Bool_Exp;
};

/** columns and relationships of "layouts" */
export type Layouts = {
  __typename?: 'layouts';
  /** An array relationship */
  categories: Array<Categories>;
  /** An aggregate relationship */
  categories_aggregate: Categories_Aggregate;
  description?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};


/** columns and relationships of "layouts" */
export type LayoutsCategoriesArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


/** columns and relationships of "layouts" */
export type LayoutsCategories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};

/** aggregated selection of "layouts" */
export type Layouts_Aggregate = {
  __typename?: 'layouts_aggregate';
  aggregate?: Maybe<Layouts_Aggregate_Fields>;
  nodes: Array<Layouts>;
};

/** aggregate fields of "layouts" */
export type Layouts_Aggregate_Fields = {
  __typename?: 'layouts_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Layouts_Max_Fields>;
  min?: Maybe<Layouts_Min_Fields>;
};


/** aggregate fields of "layouts" */
export type Layouts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Layouts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "layouts". All fields are combined with a logical 'AND'. */
export type Layouts_Bool_Exp = {
  _and?: InputMaybe<Array<Layouts_Bool_Exp>>;
  _not?: InputMaybe<Layouts_Bool_Exp>;
  _or?: InputMaybe<Array<Layouts_Bool_Exp>>;
  categories?: InputMaybe<Categories_Bool_Exp>;
  categories_aggregate?: InputMaybe<Categories_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "layouts" */
export enum Layouts_Constraint {
  /** unique or primary key constraint on columns "value" */
  LayoutPkey = 'layout_pkey'
}

export enum Layouts_Enum {
  /** Bốn bài viết */
  FourItems = 'FOUR_ITEMS',
  /** Một lớn bốn nhỏ */
  OneLargeFourSmall = 'ONE_LARGE_FOUR_SMALL',
  /** Bên phải */
  RightModule = 'RIGHT_MODULE',
  /** Ba ảnh */
  ThreeImages = 'THREE_IMAGES',
  /** Hai lớn bốn nhỏ */
  TwoLargeFourSmall = 'TWO_LARGE_FOUR_SMALL'
}

/** Boolean expression to compare columns of type "layouts_enum". All fields are combined with logical 'AND'. */
export type Layouts_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Layouts_Enum>;
  _in?: InputMaybe<Array<Layouts_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Layouts_Enum>;
  _nin?: InputMaybe<Array<Layouts_Enum>>;
};

/** input type for inserting data into table "layouts" */
export type Layouts_Insert_Input = {
  categories?: InputMaybe<Categories_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Layouts_Max_Fields = {
  __typename?: 'layouts_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Layouts_Min_Fields = {
  __typename?: 'layouts_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "layouts" */
export type Layouts_Mutation_Response = {
  __typename?: 'layouts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Layouts>;
};

/** input type for inserting object relation for remote table "layouts" */
export type Layouts_Obj_Rel_Insert_Input = {
  data: Layouts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Layouts_On_Conflict>;
};

/** on_conflict condition type for table "layouts" */
export type Layouts_On_Conflict = {
  constraint: Layouts_Constraint;
  update_columns?: Array<Layouts_Update_Column>;
  where?: InputMaybe<Layouts_Bool_Exp>;
};

/** Ordering options when selecting data from "layouts". */
export type Layouts_Order_By = {
  categories_aggregate?: InputMaybe<Categories_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: layouts */
export type Layouts_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "layouts" */
export enum Layouts_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "layouts" */
export type Layouts_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "layouts" */
export type Layouts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Layouts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Layouts_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "layouts" */
export enum Layouts_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Layouts_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Layouts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Layouts_Bool_Exp;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  adminChangeUserPassword?: Maybe<AdminChangeUserPasswordOutput>;
  adminCreateUser?: Maybe<AdminCreateUserOutput>;
  deleteFileS3?: Maybe<DeleteFileOutput>;
  /** delete data from the table: "advertisement_types" */
  delete_advertisement_types?: Maybe<Advertisement_Types_Mutation_Response>;
  /** delete single row from the table: "advertisement_types" */
  delete_advertisement_types_by_pk?: Maybe<Advertisement_Types>;
  /** delete data from the table: "advertisements" */
  delete_advertisements?: Maybe<Advertisements_Mutation_Response>;
  /** delete single row from the table: "advertisements" */
  delete_advertisements_by_pk?: Maybe<Advertisements>;
  /** delete data from the table: "banners" */
  delete_banners?: Maybe<Banners_Mutation_Response>;
  /** delete single row from the table: "banners" */
  delete_banners_by_pk?: Maybe<Banners>;
  /** delete data from the table: "banners_categories" */
  delete_banners_categories?: Maybe<Banners_Categories_Mutation_Response>;
  /** delete single row from the table: "banners_categories" */
  delete_banners_categories_by_pk?: Maybe<Banners_Categories>;
  /** delete data from the table: "categories" */
  delete_categories?: Maybe<Categories_Mutation_Response>;
  /** delete single row from the table: "categories" */
  delete_categories_by_pk?: Maybe<Categories>;
  /** delete data from the table: "category_kpis" */
  delete_category_kpis?: Maybe<Category_Kpis_Mutation_Response>;
  /** delete single row from the table: "category_kpis" */
  delete_category_kpis_by_pk?: Maybe<Category_Kpis>;
  /** delete data from the table: "comments_likes" */
  delete_comments_likes?: Maybe<Comments_Likes_Mutation_Response>;
  /** delete single row from the table: "comments_likes" */
  delete_comments_likes_by_pk?: Maybe<Comments_Likes>;
  /** delete data from the table: "genders" */
  delete_genders?: Maybe<Genders_Mutation_Response>;
  /** delete single row from the table: "genders" */
  delete_genders_by_pk?: Maybe<Genders>;
  /** delete data from the table: "group_kpis" */
  delete_group_kpis?: Maybe<Group_Kpis_Mutation_Response>;
  /** delete single row from the table: "group_kpis" */
  delete_group_kpis_by_pk?: Maybe<Group_Kpis>;
  /** delete data from the table: "image_subtypes" */
  delete_image_subtypes?: Maybe<Image_Subtypes_Mutation_Response>;
  /** delete single row from the table: "image_subtypes" */
  delete_image_subtypes_by_pk?: Maybe<Image_Subtypes>;
  /** delete data from the table: "image_types" */
  delete_image_types?: Maybe<Image_Types_Mutation_Response>;
  /** delete single row from the table: "image_types" */
  delete_image_types_by_pk?: Maybe<Image_Types>;
  /** delete data from the table: "images" */
  delete_images?: Maybe<Images_Mutation_Response>;
  /** delete single row from the table: "images" */
  delete_images_by_pk?: Maybe<Images>;
  /** delete data from the table: "kpis" */
  delete_kpis?: Maybe<Kpis_Mutation_Response>;
  /** delete single row from the table: "kpis" */
  delete_kpis_by_pk?: Maybe<Kpis>;
  /** delete data from the table: "languages" */
  delete_languages?: Maybe<Languages_Mutation_Response>;
  /** delete single row from the table: "languages" */
  delete_languages_by_pk?: Maybe<Languages>;
  /** delete data from the table: "layout_page_bottoms" */
  delete_layout_page_bottoms?: Maybe<Layout_Page_Bottoms_Mutation_Response>;
  /** delete single row from the table: "layout_page_bottoms" */
  delete_layout_page_bottoms_by_pk?: Maybe<Layout_Page_Bottoms>;
  /** delete data from the table: "layout_page_tops" */
  delete_layout_page_tops?: Maybe<Layout_Page_Tops_Mutation_Response>;
  /** delete single row from the table: "layout_page_tops" */
  delete_layout_page_tops_by_pk?: Maybe<Layout_Page_Tops>;
  /** delete data from the table: "layout_pages" */
  delete_layout_pages?: Maybe<Layout_Pages_Mutation_Response>;
  /** delete single row from the table: "layout_pages" */
  delete_layout_pages_by_pk?: Maybe<Layout_Pages>;
  /** delete data from the table: "layout_posts" */
  delete_layout_posts?: Maybe<Layout_Posts_Mutation_Response>;
  /** delete single row from the table: "layout_posts" */
  delete_layout_posts_by_pk?: Maybe<Layout_Posts>;
  /** delete data from the table: "layouts" */
  delete_layouts?: Maybe<Layouts_Mutation_Response>;
  /** delete single row from the table: "layouts" */
  delete_layouts_by_pk?: Maybe<Layouts>;
  /** delete data from the table: "news_letters" */
  delete_news_letters?: Maybe<News_Letters_Mutation_Response>;
  /** delete single row from the table: "news_letters" */
  delete_news_letters_by_pk?: Maybe<News_Letters>;
  /** delete data from the table: "permissions" */
  delete_permissions?: Maybe<Permissions_Mutation_Response>;
  /** delete single row from the table: "permissions" */
  delete_permissions_by_pk?: Maybe<Permissions>;
  /** delete data from the table: "permissions_roles" */
  delete_permissions_roles?: Maybe<Permissions_Roles_Mutation_Response>;
  /** delete single row from the table: "permissions_roles" */
  delete_permissions_roles_by_pk?: Maybe<Permissions_Roles>;
  /** delete data from the table: "posts" */
  delete_posts?: Maybe<Posts_Mutation_Response>;
  /** delete single row from the table: "posts" */
  delete_posts_by_pk?: Maybe<Posts>;
  /** delete data from the table: "posts_categories" */
  delete_posts_categories?: Maybe<Posts_Categories_Mutation_Response>;
  /** delete single row from the table: "posts_categories" */
  delete_posts_categories_by_pk?: Maybe<Posts_Categories>;
  /** delete data from the table: "posts_comments" */
  delete_posts_comments?: Maybe<Posts_Comments_Mutation_Response>;
  /** delete single row from the table: "posts_comments" */
  delete_posts_comments_by_pk?: Maybe<Posts_Comments>;
  /** delete data from the table: "posts_kpis" */
  delete_posts_kpis?: Maybe<Posts_Kpis_Mutation_Response>;
  /** delete single row from the table: "posts_kpis" */
  delete_posts_kpis_by_pk?: Maybe<Posts_Kpis>;
  /** delete data from the table: "posts_likes" */
  delete_posts_likes?: Maybe<Posts_Likes_Mutation_Response>;
  /** delete single row from the table: "posts_likes" */
  delete_posts_likes_by_pk?: Maybe<Posts_Likes>;
  /** delete data from the table: "posts_sources" */
  delete_posts_sources?: Maybe<Posts_Sources_Mutation_Response>;
  /** delete single row from the table: "posts_sources" */
  delete_posts_sources_by_pk?: Maybe<Posts_Sources>;
  /** delete data from the table: "posts_tags" */
  delete_posts_tags?: Maybe<Posts_Tags_Mutation_Response>;
  /** delete single row from the table: "posts_tags" */
  delete_posts_tags_by_pk?: Maybe<Posts_Tags>;
  /** delete data from the table: "related_categories" */
  delete_related_categories?: Maybe<Related_Categories_Mutation_Response>;
  /** delete single row from the table: "related_categories" */
  delete_related_categories_by_pk?: Maybe<Related_Categories>;
  /** delete data from the table: "roles" */
  delete_roles?: Maybe<Roles_Mutation_Response>;
  /** delete single row from the table: "roles" */
  delete_roles_by_pk?: Maybe<Roles>;
  /** delete data from the table: "settings" */
  delete_settings?: Maybe<Settings_Mutation_Response>;
  /** delete single row from the table: "settings" */
  delete_settings_by_pk?: Maybe<Settings>;
  /** delete data from the table: "sources" */
  delete_sources?: Maybe<Sources_Mutation_Response>;
  /** delete single row from the table: "sources" */
  delete_sources_by_pk?: Maybe<Sources>;
  /** delete data from the table: "tags" */
  delete_tags?: Maybe<Tags_Mutation_Response>;
  /** delete single row from the table: "tags" */
  delete_tags_by_pk?: Maybe<Tags>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  forgotPassword?: Maybe<ForgotPasswordOutput>;
  insertFileS3?: Maybe<GetPresignedUploadUrlOutput>;
  insertMultipleFileS3?: Maybe<InsertMultipleFileS3Output>;
  /** insert data into the table: "advertisement_types" */
  insert_advertisement_types?: Maybe<Advertisement_Types_Mutation_Response>;
  /** insert a single row into the table: "advertisement_types" */
  insert_advertisement_types_one?: Maybe<Advertisement_Types>;
  /** insert data into the table: "advertisements" */
  insert_advertisements?: Maybe<Advertisements_Mutation_Response>;
  /** insert a single row into the table: "advertisements" */
  insert_advertisements_one?: Maybe<Advertisements>;
  /** insert data into the table: "banners" */
  insert_banners?: Maybe<Banners_Mutation_Response>;
  /** insert data into the table: "banners_categories" */
  insert_banners_categories?: Maybe<Banners_Categories_Mutation_Response>;
  /** insert a single row into the table: "banners_categories" */
  insert_banners_categories_one?: Maybe<Banners_Categories>;
  /** insert a single row into the table: "banners" */
  insert_banners_one?: Maybe<Banners>;
  /** insert data into the table: "categories" */
  insert_categories?: Maybe<Categories_Mutation_Response>;
  /** insert a single row into the table: "categories" */
  insert_categories_one?: Maybe<Categories>;
  /** insert data into the table: "category_kpis" */
  insert_category_kpis?: Maybe<Category_Kpis_Mutation_Response>;
  /** insert a single row into the table: "category_kpis" */
  insert_category_kpis_one?: Maybe<Category_Kpis>;
  /** insert data into the table: "comments_likes" */
  insert_comments_likes?: Maybe<Comments_Likes_Mutation_Response>;
  /** insert a single row into the table: "comments_likes" */
  insert_comments_likes_one?: Maybe<Comments_Likes>;
  /** insert data into the table: "genders" */
  insert_genders?: Maybe<Genders_Mutation_Response>;
  /** insert a single row into the table: "genders" */
  insert_genders_one?: Maybe<Genders>;
  /** insert data into the table: "group_kpis" */
  insert_group_kpis?: Maybe<Group_Kpis_Mutation_Response>;
  /** insert a single row into the table: "group_kpis" */
  insert_group_kpis_one?: Maybe<Group_Kpis>;
  /** insert data into the table: "image_subtypes" */
  insert_image_subtypes?: Maybe<Image_Subtypes_Mutation_Response>;
  /** insert a single row into the table: "image_subtypes" */
  insert_image_subtypes_one?: Maybe<Image_Subtypes>;
  /** insert data into the table: "image_types" */
  insert_image_types?: Maybe<Image_Types_Mutation_Response>;
  /** insert a single row into the table: "image_types" */
  insert_image_types_one?: Maybe<Image_Types>;
  /** insert data into the table: "images" */
  insert_images?: Maybe<Images_Mutation_Response>;
  /** insert a single row into the table: "images" */
  insert_images_one?: Maybe<Images>;
  /** insert data into the table: "kpis" */
  insert_kpis?: Maybe<Kpis_Mutation_Response>;
  /** insert a single row into the table: "kpis" */
  insert_kpis_one?: Maybe<Kpis>;
  /** insert data into the table: "languages" */
  insert_languages?: Maybe<Languages_Mutation_Response>;
  /** insert a single row into the table: "languages" */
  insert_languages_one?: Maybe<Languages>;
  /** insert data into the table: "layout_page_bottoms" */
  insert_layout_page_bottoms?: Maybe<Layout_Page_Bottoms_Mutation_Response>;
  /** insert a single row into the table: "layout_page_bottoms" */
  insert_layout_page_bottoms_one?: Maybe<Layout_Page_Bottoms>;
  /** insert data into the table: "layout_page_tops" */
  insert_layout_page_tops?: Maybe<Layout_Page_Tops_Mutation_Response>;
  /** insert a single row into the table: "layout_page_tops" */
  insert_layout_page_tops_one?: Maybe<Layout_Page_Tops>;
  /** insert data into the table: "layout_pages" */
  insert_layout_pages?: Maybe<Layout_Pages_Mutation_Response>;
  /** insert a single row into the table: "layout_pages" */
  insert_layout_pages_one?: Maybe<Layout_Pages>;
  /** insert data into the table: "layout_posts" */
  insert_layout_posts?: Maybe<Layout_Posts_Mutation_Response>;
  /** insert a single row into the table: "layout_posts" */
  insert_layout_posts_one?: Maybe<Layout_Posts>;
  /** insert data into the table: "layouts" */
  insert_layouts?: Maybe<Layouts_Mutation_Response>;
  /** insert a single row into the table: "layouts" */
  insert_layouts_one?: Maybe<Layouts>;
  /** insert data into the table: "news_letters" */
  insert_news_letters?: Maybe<News_Letters_Mutation_Response>;
  /** insert a single row into the table: "news_letters" */
  insert_news_letters_one?: Maybe<News_Letters>;
  /** insert data into the table: "permissions" */
  insert_permissions?: Maybe<Permissions_Mutation_Response>;
  /** insert a single row into the table: "permissions" */
  insert_permissions_one?: Maybe<Permissions>;
  /** insert data into the table: "permissions_roles" */
  insert_permissions_roles?: Maybe<Permissions_Roles_Mutation_Response>;
  /** insert a single row into the table: "permissions_roles" */
  insert_permissions_roles_one?: Maybe<Permissions_Roles>;
  /** insert data into the table: "posts" */
  insert_posts?: Maybe<Posts_Mutation_Response>;
  /** insert data into the table: "posts_categories" */
  insert_posts_categories?: Maybe<Posts_Categories_Mutation_Response>;
  /** insert a single row into the table: "posts_categories" */
  insert_posts_categories_one?: Maybe<Posts_Categories>;
  /** insert data into the table: "posts_comments" */
  insert_posts_comments?: Maybe<Posts_Comments_Mutation_Response>;
  /** insert a single row into the table: "posts_comments" */
  insert_posts_comments_one?: Maybe<Posts_Comments>;
  /** insert data into the table: "posts_kpis" */
  insert_posts_kpis?: Maybe<Posts_Kpis_Mutation_Response>;
  /** insert a single row into the table: "posts_kpis" */
  insert_posts_kpis_one?: Maybe<Posts_Kpis>;
  /** insert data into the table: "posts_likes" */
  insert_posts_likes?: Maybe<Posts_Likes_Mutation_Response>;
  /** insert a single row into the table: "posts_likes" */
  insert_posts_likes_one?: Maybe<Posts_Likes>;
  /** insert a single row into the table: "posts" */
  insert_posts_one?: Maybe<Posts>;
  /** insert data into the table: "posts_sources" */
  insert_posts_sources?: Maybe<Posts_Sources_Mutation_Response>;
  /** insert a single row into the table: "posts_sources" */
  insert_posts_sources_one?: Maybe<Posts_Sources>;
  /** insert data into the table: "posts_tags" */
  insert_posts_tags?: Maybe<Posts_Tags_Mutation_Response>;
  /** insert a single row into the table: "posts_tags" */
  insert_posts_tags_one?: Maybe<Posts_Tags>;
  /** insert data into the table: "related_categories" */
  insert_related_categories?: Maybe<Related_Categories_Mutation_Response>;
  /** insert a single row into the table: "related_categories" */
  insert_related_categories_one?: Maybe<Related_Categories>;
  /** insert data into the table: "roles" */
  insert_roles?: Maybe<Roles_Mutation_Response>;
  /** insert a single row into the table: "roles" */
  insert_roles_one?: Maybe<Roles>;
  /** insert data into the table: "settings" */
  insert_settings?: Maybe<Settings_Mutation_Response>;
  /** insert a single row into the table: "settings" */
  insert_settings_one?: Maybe<Settings>;
  /** insert data into the table: "sources" */
  insert_sources?: Maybe<Sources_Mutation_Response>;
  /** insert a single row into the table: "sources" */
  insert_sources_one?: Maybe<Sources>;
  /** insert data into the table: "tags" */
  insert_tags?: Maybe<Tags_Mutation_Response>;
  /** insert a single row into the table: "tags" */
  insert_tags_one?: Maybe<Tags>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  loginCognito?: Maybe<LoginCognitoOutput>;
  register?: Maybe<RegisterOutput>;
  /** resendConfirm */
  resendConfirm?: Maybe<ResendConfirmOutput>;
  resetPassword?: Maybe<ResetPasswordOutput>;
  /** update data of the table: "advertisement_types" */
  update_advertisement_types?: Maybe<Advertisement_Types_Mutation_Response>;
  /** update single row of the table: "advertisement_types" */
  update_advertisement_types_by_pk?: Maybe<Advertisement_Types>;
  /** update multiples rows of table: "advertisement_types" */
  update_advertisement_types_many?: Maybe<Array<Maybe<Advertisement_Types_Mutation_Response>>>;
  /** update data of the table: "advertisements" */
  update_advertisements?: Maybe<Advertisements_Mutation_Response>;
  /** update single row of the table: "advertisements" */
  update_advertisements_by_pk?: Maybe<Advertisements>;
  /** update multiples rows of table: "advertisements" */
  update_advertisements_many?: Maybe<Array<Maybe<Advertisements_Mutation_Response>>>;
  /** update data of the table: "banners" */
  update_banners?: Maybe<Banners_Mutation_Response>;
  /** update single row of the table: "banners" */
  update_banners_by_pk?: Maybe<Banners>;
  /** update data of the table: "banners_categories" */
  update_banners_categories?: Maybe<Banners_Categories_Mutation_Response>;
  /** update single row of the table: "banners_categories" */
  update_banners_categories_by_pk?: Maybe<Banners_Categories>;
  /** update multiples rows of table: "banners_categories" */
  update_banners_categories_many?: Maybe<Array<Maybe<Banners_Categories_Mutation_Response>>>;
  /** update multiples rows of table: "banners" */
  update_banners_many?: Maybe<Array<Maybe<Banners_Mutation_Response>>>;
  /** update data of the table: "categories" */
  update_categories?: Maybe<Categories_Mutation_Response>;
  /** update single row of the table: "categories" */
  update_categories_by_pk?: Maybe<Categories>;
  /** update multiples rows of table: "categories" */
  update_categories_many?: Maybe<Array<Maybe<Categories_Mutation_Response>>>;
  /** update data of the table: "category_kpis" */
  update_category_kpis?: Maybe<Category_Kpis_Mutation_Response>;
  /** update single row of the table: "category_kpis" */
  update_category_kpis_by_pk?: Maybe<Category_Kpis>;
  /** update multiples rows of table: "category_kpis" */
  update_category_kpis_many?: Maybe<Array<Maybe<Category_Kpis_Mutation_Response>>>;
  /** update data of the table: "comments_likes" */
  update_comments_likes?: Maybe<Comments_Likes_Mutation_Response>;
  /** update single row of the table: "comments_likes" */
  update_comments_likes_by_pk?: Maybe<Comments_Likes>;
  /** update multiples rows of table: "comments_likes" */
  update_comments_likes_many?: Maybe<Array<Maybe<Comments_Likes_Mutation_Response>>>;
  /** update data of the table: "genders" */
  update_genders?: Maybe<Genders_Mutation_Response>;
  /** update single row of the table: "genders" */
  update_genders_by_pk?: Maybe<Genders>;
  /** update multiples rows of table: "genders" */
  update_genders_many?: Maybe<Array<Maybe<Genders_Mutation_Response>>>;
  /** update data of the table: "group_kpis" */
  update_group_kpis?: Maybe<Group_Kpis_Mutation_Response>;
  /** update single row of the table: "group_kpis" */
  update_group_kpis_by_pk?: Maybe<Group_Kpis>;
  /** update multiples rows of table: "group_kpis" */
  update_group_kpis_many?: Maybe<Array<Maybe<Group_Kpis_Mutation_Response>>>;
  /** update data of the table: "image_subtypes" */
  update_image_subtypes?: Maybe<Image_Subtypes_Mutation_Response>;
  /** update single row of the table: "image_subtypes" */
  update_image_subtypes_by_pk?: Maybe<Image_Subtypes>;
  /** update multiples rows of table: "image_subtypes" */
  update_image_subtypes_many?: Maybe<Array<Maybe<Image_Subtypes_Mutation_Response>>>;
  /** update data of the table: "image_types" */
  update_image_types?: Maybe<Image_Types_Mutation_Response>;
  /** update single row of the table: "image_types" */
  update_image_types_by_pk?: Maybe<Image_Types>;
  /** update multiples rows of table: "image_types" */
  update_image_types_many?: Maybe<Array<Maybe<Image_Types_Mutation_Response>>>;
  /** update data of the table: "images" */
  update_images?: Maybe<Images_Mutation_Response>;
  /** update single row of the table: "images" */
  update_images_by_pk?: Maybe<Images>;
  /** update multiples rows of table: "images" */
  update_images_many?: Maybe<Array<Maybe<Images_Mutation_Response>>>;
  /** update data of the table: "kpis" */
  update_kpis?: Maybe<Kpis_Mutation_Response>;
  /** update single row of the table: "kpis" */
  update_kpis_by_pk?: Maybe<Kpis>;
  /** update multiples rows of table: "kpis" */
  update_kpis_many?: Maybe<Array<Maybe<Kpis_Mutation_Response>>>;
  /** update data of the table: "languages" */
  update_languages?: Maybe<Languages_Mutation_Response>;
  /** update single row of the table: "languages" */
  update_languages_by_pk?: Maybe<Languages>;
  /** update multiples rows of table: "languages" */
  update_languages_many?: Maybe<Array<Maybe<Languages_Mutation_Response>>>;
  /** update data of the table: "layout_page_bottoms" */
  update_layout_page_bottoms?: Maybe<Layout_Page_Bottoms_Mutation_Response>;
  /** update single row of the table: "layout_page_bottoms" */
  update_layout_page_bottoms_by_pk?: Maybe<Layout_Page_Bottoms>;
  /** update multiples rows of table: "layout_page_bottoms" */
  update_layout_page_bottoms_many?: Maybe<Array<Maybe<Layout_Page_Bottoms_Mutation_Response>>>;
  /** update data of the table: "layout_page_tops" */
  update_layout_page_tops?: Maybe<Layout_Page_Tops_Mutation_Response>;
  /** update single row of the table: "layout_page_tops" */
  update_layout_page_tops_by_pk?: Maybe<Layout_Page_Tops>;
  /** update multiples rows of table: "layout_page_tops" */
  update_layout_page_tops_many?: Maybe<Array<Maybe<Layout_Page_Tops_Mutation_Response>>>;
  /** update data of the table: "layout_pages" */
  update_layout_pages?: Maybe<Layout_Pages_Mutation_Response>;
  /** update single row of the table: "layout_pages" */
  update_layout_pages_by_pk?: Maybe<Layout_Pages>;
  /** update multiples rows of table: "layout_pages" */
  update_layout_pages_many?: Maybe<Array<Maybe<Layout_Pages_Mutation_Response>>>;
  /** update data of the table: "layout_posts" */
  update_layout_posts?: Maybe<Layout_Posts_Mutation_Response>;
  /** update single row of the table: "layout_posts" */
  update_layout_posts_by_pk?: Maybe<Layout_Posts>;
  /** update multiples rows of table: "layout_posts" */
  update_layout_posts_many?: Maybe<Array<Maybe<Layout_Posts_Mutation_Response>>>;
  /** update data of the table: "layouts" */
  update_layouts?: Maybe<Layouts_Mutation_Response>;
  /** update single row of the table: "layouts" */
  update_layouts_by_pk?: Maybe<Layouts>;
  /** update multiples rows of table: "layouts" */
  update_layouts_many?: Maybe<Array<Maybe<Layouts_Mutation_Response>>>;
  /** update data of the table: "news_letters" */
  update_news_letters?: Maybe<News_Letters_Mutation_Response>;
  /** update single row of the table: "news_letters" */
  update_news_letters_by_pk?: Maybe<News_Letters>;
  /** update multiples rows of table: "news_letters" */
  update_news_letters_many?: Maybe<Array<Maybe<News_Letters_Mutation_Response>>>;
  /** update data of the table: "permissions" */
  update_permissions?: Maybe<Permissions_Mutation_Response>;
  /** update single row of the table: "permissions" */
  update_permissions_by_pk?: Maybe<Permissions>;
  /** update multiples rows of table: "permissions" */
  update_permissions_many?: Maybe<Array<Maybe<Permissions_Mutation_Response>>>;
  /** update data of the table: "permissions_roles" */
  update_permissions_roles?: Maybe<Permissions_Roles_Mutation_Response>;
  /** update single row of the table: "permissions_roles" */
  update_permissions_roles_by_pk?: Maybe<Permissions_Roles>;
  /** update multiples rows of table: "permissions_roles" */
  update_permissions_roles_many?: Maybe<Array<Maybe<Permissions_Roles_Mutation_Response>>>;
  /** update data of the table: "posts" */
  update_posts?: Maybe<Posts_Mutation_Response>;
  /** update single row of the table: "posts" */
  update_posts_by_pk?: Maybe<Posts>;
  /** update data of the table: "posts_categories" */
  update_posts_categories?: Maybe<Posts_Categories_Mutation_Response>;
  /** update single row of the table: "posts_categories" */
  update_posts_categories_by_pk?: Maybe<Posts_Categories>;
  /** update multiples rows of table: "posts_categories" */
  update_posts_categories_many?: Maybe<Array<Maybe<Posts_Categories_Mutation_Response>>>;
  /** update data of the table: "posts_comments" */
  update_posts_comments?: Maybe<Posts_Comments_Mutation_Response>;
  /** update single row of the table: "posts_comments" */
  update_posts_comments_by_pk?: Maybe<Posts_Comments>;
  /** update multiples rows of table: "posts_comments" */
  update_posts_comments_many?: Maybe<Array<Maybe<Posts_Comments_Mutation_Response>>>;
  /** update data of the table: "posts_kpis" */
  update_posts_kpis?: Maybe<Posts_Kpis_Mutation_Response>;
  /** update single row of the table: "posts_kpis" */
  update_posts_kpis_by_pk?: Maybe<Posts_Kpis>;
  /** update multiples rows of table: "posts_kpis" */
  update_posts_kpis_many?: Maybe<Array<Maybe<Posts_Kpis_Mutation_Response>>>;
  /** update data of the table: "posts_likes" */
  update_posts_likes?: Maybe<Posts_Likes_Mutation_Response>;
  /** update single row of the table: "posts_likes" */
  update_posts_likes_by_pk?: Maybe<Posts_Likes>;
  /** update multiples rows of table: "posts_likes" */
  update_posts_likes_many?: Maybe<Array<Maybe<Posts_Likes_Mutation_Response>>>;
  /** update multiples rows of table: "posts" */
  update_posts_many?: Maybe<Array<Maybe<Posts_Mutation_Response>>>;
  /** update data of the table: "posts_sources" */
  update_posts_sources?: Maybe<Posts_Sources_Mutation_Response>;
  /** update single row of the table: "posts_sources" */
  update_posts_sources_by_pk?: Maybe<Posts_Sources>;
  /** update multiples rows of table: "posts_sources" */
  update_posts_sources_many?: Maybe<Array<Maybe<Posts_Sources_Mutation_Response>>>;
  /** update data of the table: "posts_tags" */
  update_posts_tags?: Maybe<Posts_Tags_Mutation_Response>;
  /** update single row of the table: "posts_tags" */
  update_posts_tags_by_pk?: Maybe<Posts_Tags>;
  /** update multiples rows of table: "posts_tags" */
  update_posts_tags_many?: Maybe<Array<Maybe<Posts_Tags_Mutation_Response>>>;
  /** update data of the table: "related_categories" */
  update_related_categories?: Maybe<Related_Categories_Mutation_Response>;
  /** update single row of the table: "related_categories" */
  update_related_categories_by_pk?: Maybe<Related_Categories>;
  /** update multiples rows of table: "related_categories" */
  update_related_categories_many?: Maybe<Array<Maybe<Related_Categories_Mutation_Response>>>;
  /** update data of the table: "roles" */
  update_roles?: Maybe<Roles_Mutation_Response>;
  /** update single row of the table: "roles" */
  update_roles_by_pk?: Maybe<Roles>;
  /** update multiples rows of table: "roles" */
  update_roles_many?: Maybe<Array<Maybe<Roles_Mutation_Response>>>;
  /** update data of the table: "settings" */
  update_settings?: Maybe<Settings_Mutation_Response>;
  /** update single row of the table: "settings" */
  update_settings_by_pk?: Maybe<Settings>;
  /** update multiples rows of table: "settings" */
  update_settings_many?: Maybe<Array<Maybe<Settings_Mutation_Response>>>;
  /** update data of the table: "sources" */
  update_sources?: Maybe<Sources_Mutation_Response>;
  /** update single row of the table: "sources" */
  update_sources_by_pk?: Maybe<Sources>;
  /** update multiples rows of table: "sources" */
  update_sources_many?: Maybe<Array<Maybe<Sources_Mutation_Response>>>;
  /** update data of the table: "tags" */
  update_tags?: Maybe<Tags_Mutation_Response>;
  /** update single row of the table: "tags" */
  update_tags_by_pk?: Maybe<Tags>;
  /** update multiples rows of table: "tags" */
  update_tags_many?: Maybe<Array<Maybe<Tags_Mutation_Response>>>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
  verifyEmail?: Maybe<VerifyEmailOutput>;
};


/** mutation root */
export type Mutation_RootAdminChangeUserPasswordArgs = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootAdminCreateUserArgs = {
  email: Scalars['String']['input'];
  full_name?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phone_number?: InputMaybe<Scalars['String']['input']>;
  role_id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDeleteFileS3Args = {
  filename: Scalars['String']['input'];
  filetype: Scalars['String']['input'];
  object_id: Scalars['String']['input'];
  subtype: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Advertisement_TypesArgs = {
  where: Advertisement_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Advertisement_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_AdvertisementsArgs = {
  where: Advertisements_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Advertisements_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_BannersArgs = {
  where: Banners_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Banners_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Banners_CategoriesArgs = {
  where: Banners_Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Banners_Categories_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CategoriesArgs = {
  where: Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Categories_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Category_KpisArgs = {
  where: Category_Kpis_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Category_Kpis_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Comments_LikesArgs = {
  where: Comments_Likes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Comments_Likes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_GendersArgs = {
  where: Genders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Genders_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Group_KpisArgs = {
  where: Group_Kpis_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Group_Kpis_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Image_SubtypesArgs = {
  where: Image_Subtypes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Image_Subtypes_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Image_TypesArgs = {
  where: Image_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Image_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ImagesArgs = {
  where: Images_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Images_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_KpisArgs = {
  where: Kpis_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Kpis_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_LanguagesArgs = {
  where: Languages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Languages_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Layout_Page_BottomsArgs = {
  where: Layout_Page_Bottoms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Layout_Page_Bottoms_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Layout_Page_TopsArgs = {
  where: Layout_Page_Tops_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Layout_Page_Tops_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Layout_PagesArgs = {
  where: Layout_Pages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Layout_Pages_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Layout_PostsArgs = {
  where: Layout_Posts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Layout_Posts_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_LayoutsArgs = {
  where: Layouts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Layouts_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_News_LettersArgs = {
  where: News_Letters_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_News_Letters_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PermissionsArgs = {
  where: Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Permissions_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Permissions_RolesArgs = {
  where: Permissions_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Permissions_Roles_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PostsArgs = {
  where: Posts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Posts_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Posts_CategoriesArgs = {
  where: Posts_Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Posts_Categories_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Posts_CommentsArgs = {
  where: Posts_Comments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Posts_Comments_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Posts_KpisArgs = {
  where: Posts_Kpis_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Posts_Kpis_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Posts_LikesArgs = {
  where: Posts_Likes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Posts_Likes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Posts_SourcesArgs = {
  where: Posts_Sources_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Posts_Sources_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Posts_TagsArgs = {
  where: Posts_Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Posts_Tags_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Related_CategoriesArgs = {
  where: Related_Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Related_Categories_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_RolesArgs = {
  where: Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Roles_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SettingsArgs = {
  where: Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Settings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SourcesArgs = {
  where: Sources_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sources_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TagsArgs = {
  where: Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tags_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootInsertFileS3Args = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  filetype: Scalars['String']['input'];
  object_id: Scalars['Int']['input'];
  subtype: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootInsertMultipleFileS3Args = {
  objects?: InputMaybe<Array<InputMaybe<InsertMultipleFileS3Input>>>;
};


/** mutation root */
export type Mutation_RootInsert_Advertisement_TypesArgs = {
  objects: Array<Advertisement_Types_Insert_Input>;
  on_conflict?: InputMaybe<Advertisement_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Advertisement_Types_OneArgs = {
  object: Advertisement_Types_Insert_Input;
  on_conflict?: InputMaybe<Advertisement_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AdvertisementsArgs = {
  objects: Array<Advertisements_Insert_Input>;
  on_conflict?: InputMaybe<Advertisements_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Advertisements_OneArgs = {
  object: Advertisements_Insert_Input;
  on_conflict?: InputMaybe<Advertisements_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BannersArgs = {
  objects: Array<Banners_Insert_Input>;
  on_conflict?: InputMaybe<Banners_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Banners_CategoriesArgs = {
  objects: Array<Banners_Categories_Insert_Input>;
  on_conflict?: InputMaybe<Banners_Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Banners_Categories_OneArgs = {
  object: Banners_Categories_Insert_Input;
  on_conflict?: InputMaybe<Banners_Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Banners_OneArgs = {
  object: Banners_Insert_Input;
  on_conflict?: InputMaybe<Banners_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CategoriesArgs = {
  objects: Array<Categories_Insert_Input>;
  on_conflict?: InputMaybe<Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Categories_OneArgs = {
  object: Categories_Insert_Input;
  on_conflict?: InputMaybe<Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Category_KpisArgs = {
  objects: Array<Category_Kpis_Insert_Input>;
  on_conflict?: InputMaybe<Category_Kpis_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Category_Kpis_OneArgs = {
  object: Category_Kpis_Insert_Input;
  on_conflict?: InputMaybe<Category_Kpis_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Comments_LikesArgs = {
  objects: Array<Comments_Likes_Insert_Input>;
  on_conflict?: InputMaybe<Comments_Likes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Comments_Likes_OneArgs = {
  object: Comments_Likes_Insert_Input;
  on_conflict?: InputMaybe<Comments_Likes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GendersArgs = {
  objects: Array<Genders_Insert_Input>;
  on_conflict?: InputMaybe<Genders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Genders_OneArgs = {
  object: Genders_Insert_Input;
  on_conflict?: InputMaybe<Genders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Group_KpisArgs = {
  objects: Array<Group_Kpis_Insert_Input>;
  on_conflict?: InputMaybe<Group_Kpis_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Group_Kpis_OneArgs = {
  object: Group_Kpis_Insert_Input;
  on_conflict?: InputMaybe<Group_Kpis_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Image_SubtypesArgs = {
  objects: Array<Image_Subtypes_Insert_Input>;
  on_conflict?: InputMaybe<Image_Subtypes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Image_Subtypes_OneArgs = {
  object: Image_Subtypes_Insert_Input;
  on_conflict?: InputMaybe<Image_Subtypes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Image_TypesArgs = {
  objects: Array<Image_Types_Insert_Input>;
  on_conflict?: InputMaybe<Image_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Image_Types_OneArgs = {
  object: Image_Types_Insert_Input;
  on_conflict?: InputMaybe<Image_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ImagesArgs = {
  objects: Array<Images_Insert_Input>;
  on_conflict?: InputMaybe<Images_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Images_OneArgs = {
  object: Images_Insert_Input;
  on_conflict?: InputMaybe<Images_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_KpisArgs = {
  objects: Array<Kpis_Insert_Input>;
  on_conflict?: InputMaybe<Kpis_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Kpis_OneArgs = {
  object: Kpis_Insert_Input;
  on_conflict?: InputMaybe<Kpis_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LanguagesArgs = {
  objects: Array<Languages_Insert_Input>;
  on_conflict?: InputMaybe<Languages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Languages_OneArgs = {
  object: Languages_Insert_Input;
  on_conflict?: InputMaybe<Languages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Layout_Page_BottomsArgs = {
  objects: Array<Layout_Page_Bottoms_Insert_Input>;
  on_conflict?: InputMaybe<Layout_Page_Bottoms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Layout_Page_Bottoms_OneArgs = {
  object: Layout_Page_Bottoms_Insert_Input;
  on_conflict?: InputMaybe<Layout_Page_Bottoms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Layout_Page_TopsArgs = {
  objects: Array<Layout_Page_Tops_Insert_Input>;
  on_conflict?: InputMaybe<Layout_Page_Tops_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Layout_Page_Tops_OneArgs = {
  object: Layout_Page_Tops_Insert_Input;
  on_conflict?: InputMaybe<Layout_Page_Tops_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Layout_PagesArgs = {
  objects: Array<Layout_Pages_Insert_Input>;
  on_conflict?: InputMaybe<Layout_Pages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Layout_Pages_OneArgs = {
  object: Layout_Pages_Insert_Input;
  on_conflict?: InputMaybe<Layout_Pages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Layout_PostsArgs = {
  objects: Array<Layout_Posts_Insert_Input>;
  on_conflict?: InputMaybe<Layout_Posts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Layout_Posts_OneArgs = {
  object: Layout_Posts_Insert_Input;
  on_conflict?: InputMaybe<Layout_Posts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LayoutsArgs = {
  objects: Array<Layouts_Insert_Input>;
  on_conflict?: InputMaybe<Layouts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Layouts_OneArgs = {
  object: Layouts_Insert_Input;
  on_conflict?: InputMaybe<Layouts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_News_LettersArgs = {
  objects: Array<News_Letters_Insert_Input>;
  on_conflict?: InputMaybe<News_Letters_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_News_Letters_OneArgs = {
  object: News_Letters_Insert_Input;
  on_conflict?: InputMaybe<News_Letters_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PermissionsArgs = {
  objects: Array<Permissions_Insert_Input>;
  on_conflict?: InputMaybe<Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Permissions_OneArgs = {
  object: Permissions_Insert_Input;
  on_conflict?: InputMaybe<Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Permissions_RolesArgs = {
  objects: Array<Permissions_Roles_Insert_Input>;
  on_conflict?: InputMaybe<Permissions_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Permissions_Roles_OneArgs = {
  object: Permissions_Roles_Insert_Input;
  on_conflict?: InputMaybe<Permissions_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PostsArgs = {
  objects: Array<Posts_Insert_Input>;
  on_conflict?: InputMaybe<Posts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Posts_CategoriesArgs = {
  objects: Array<Posts_Categories_Insert_Input>;
  on_conflict?: InputMaybe<Posts_Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Posts_Categories_OneArgs = {
  object: Posts_Categories_Insert_Input;
  on_conflict?: InputMaybe<Posts_Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Posts_CommentsArgs = {
  objects: Array<Posts_Comments_Insert_Input>;
  on_conflict?: InputMaybe<Posts_Comments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Posts_Comments_OneArgs = {
  object: Posts_Comments_Insert_Input;
  on_conflict?: InputMaybe<Posts_Comments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Posts_KpisArgs = {
  objects: Array<Posts_Kpis_Insert_Input>;
  on_conflict?: InputMaybe<Posts_Kpis_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Posts_Kpis_OneArgs = {
  object: Posts_Kpis_Insert_Input;
  on_conflict?: InputMaybe<Posts_Kpis_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Posts_LikesArgs = {
  objects: Array<Posts_Likes_Insert_Input>;
  on_conflict?: InputMaybe<Posts_Likes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Posts_Likes_OneArgs = {
  object: Posts_Likes_Insert_Input;
  on_conflict?: InputMaybe<Posts_Likes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Posts_OneArgs = {
  object: Posts_Insert_Input;
  on_conflict?: InputMaybe<Posts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Posts_SourcesArgs = {
  objects: Array<Posts_Sources_Insert_Input>;
  on_conflict?: InputMaybe<Posts_Sources_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Posts_Sources_OneArgs = {
  object: Posts_Sources_Insert_Input;
  on_conflict?: InputMaybe<Posts_Sources_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Posts_TagsArgs = {
  objects: Array<Posts_Tags_Insert_Input>;
  on_conflict?: InputMaybe<Posts_Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Posts_Tags_OneArgs = {
  object: Posts_Tags_Insert_Input;
  on_conflict?: InputMaybe<Posts_Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Related_CategoriesArgs = {
  objects: Array<Related_Categories_Insert_Input>;
  on_conflict?: InputMaybe<Related_Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Related_Categories_OneArgs = {
  object: Related_Categories_Insert_Input;
  on_conflict?: InputMaybe<Related_Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RolesArgs = {
  objects: Array<Roles_Insert_Input>;
  on_conflict?: InputMaybe<Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Roles_OneArgs = {
  object: Roles_Insert_Input;
  on_conflict?: InputMaybe<Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SettingsArgs = {
  objects: Array<Settings_Insert_Input>;
  on_conflict?: InputMaybe<Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Settings_OneArgs = {
  object: Settings_Insert_Input;
  on_conflict?: InputMaybe<Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SourcesArgs = {
  objects: Array<Sources_Insert_Input>;
  on_conflict?: InputMaybe<Sources_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sources_OneArgs = {
  object: Sources_Insert_Input;
  on_conflict?: InputMaybe<Sources_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TagsArgs = {
  objects: Array<Tags_Insert_Input>;
  on_conflict?: InputMaybe<Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tags_OneArgs = {
  object: Tags_Insert_Input;
  on_conflict?: InputMaybe<Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootLoginCognitoArgs = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootRegisterArgs = {
  display_name?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootResendConfirmArgs = {
  email: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootResetPasswordArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
  newPassword?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootUpdate_Advertisement_TypesArgs = {
  _set?: InputMaybe<Advertisement_Types_Set_Input>;
  where: Advertisement_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Advertisement_Types_By_PkArgs = {
  _set?: InputMaybe<Advertisement_Types_Set_Input>;
  pk_columns: Advertisement_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Advertisement_Types_ManyArgs = {
  updates: Array<Advertisement_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AdvertisementsArgs = {
  _inc?: InputMaybe<Advertisements_Inc_Input>;
  _set?: InputMaybe<Advertisements_Set_Input>;
  where: Advertisements_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Advertisements_By_PkArgs = {
  _inc?: InputMaybe<Advertisements_Inc_Input>;
  _set?: InputMaybe<Advertisements_Set_Input>;
  pk_columns: Advertisements_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Advertisements_ManyArgs = {
  updates: Array<Advertisements_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BannersArgs = {
  _inc?: InputMaybe<Banners_Inc_Input>;
  _set?: InputMaybe<Banners_Set_Input>;
  where: Banners_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Banners_By_PkArgs = {
  _inc?: InputMaybe<Banners_Inc_Input>;
  _set?: InputMaybe<Banners_Set_Input>;
  pk_columns: Banners_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Banners_CategoriesArgs = {
  _inc?: InputMaybe<Banners_Categories_Inc_Input>;
  _set?: InputMaybe<Banners_Categories_Set_Input>;
  where: Banners_Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Banners_Categories_By_PkArgs = {
  _inc?: InputMaybe<Banners_Categories_Inc_Input>;
  _set?: InputMaybe<Banners_Categories_Set_Input>;
  pk_columns: Banners_Categories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Banners_Categories_ManyArgs = {
  updates: Array<Banners_Categories_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Banners_ManyArgs = {
  updates: Array<Banners_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CategoriesArgs = {
  _append?: InputMaybe<Categories_Append_Input>;
  _delete_at_path?: InputMaybe<Categories_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Categories_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Categories_Delete_Key_Input>;
  _inc?: InputMaybe<Categories_Inc_Input>;
  _prepend?: InputMaybe<Categories_Prepend_Input>;
  _set?: InputMaybe<Categories_Set_Input>;
  where: Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Categories_By_PkArgs = {
  _append?: InputMaybe<Categories_Append_Input>;
  _delete_at_path?: InputMaybe<Categories_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Categories_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Categories_Delete_Key_Input>;
  _inc?: InputMaybe<Categories_Inc_Input>;
  _prepend?: InputMaybe<Categories_Prepend_Input>;
  _set?: InputMaybe<Categories_Set_Input>;
  pk_columns: Categories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Categories_ManyArgs = {
  updates: Array<Categories_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Category_KpisArgs = {
  _inc?: InputMaybe<Category_Kpis_Inc_Input>;
  _set?: InputMaybe<Category_Kpis_Set_Input>;
  where: Category_Kpis_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Category_Kpis_By_PkArgs = {
  _inc?: InputMaybe<Category_Kpis_Inc_Input>;
  _set?: InputMaybe<Category_Kpis_Set_Input>;
  pk_columns: Category_Kpis_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Category_Kpis_ManyArgs = {
  updates: Array<Category_Kpis_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Comments_LikesArgs = {
  _inc?: InputMaybe<Comments_Likes_Inc_Input>;
  _set?: InputMaybe<Comments_Likes_Set_Input>;
  where: Comments_Likes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Comments_Likes_By_PkArgs = {
  _inc?: InputMaybe<Comments_Likes_Inc_Input>;
  _set?: InputMaybe<Comments_Likes_Set_Input>;
  pk_columns: Comments_Likes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Comments_Likes_ManyArgs = {
  updates: Array<Comments_Likes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_GendersArgs = {
  _set?: InputMaybe<Genders_Set_Input>;
  where: Genders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Genders_By_PkArgs = {
  _set?: InputMaybe<Genders_Set_Input>;
  pk_columns: Genders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Genders_ManyArgs = {
  updates: Array<Genders_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Group_KpisArgs = {
  _inc?: InputMaybe<Group_Kpis_Inc_Input>;
  _set?: InputMaybe<Group_Kpis_Set_Input>;
  where: Group_Kpis_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Group_Kpis_By_PkArgs = {
  _inc?: InputMaybe<Group_Kpis_Inc_Input>;
  _set?: InputMaybe<Group_Kpis_Set_Input>;
  pk_columns: Group_Kpis_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Group_Kpis_ManyArgs = {
  updates: Array<Group_Kpis_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Image_SubtypesArgs = {
  _set?: InputMaybe<Image_Subtypes_Set_Input>;
  where: Image_Subtypes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Image_Subtypes_By_PkArgs = {
  _set?: InputMaybe<Image_Subtypes_Set_Input>;
  pk_columns: Image_Subtypes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Image_Subtypes_ManyArgs = {
  updates: Array<Image_Subtypes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Image_TypesArgs = {
  _set?: InputMaybe<Image_Types_Set_Input>;
  where: Image_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Image_Types_By_PkArgs = {
  _set?: InputMaybe<Image_Types_Set_Input>;
  pk_columns: Image_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Image_Types_ManyArgs = {
  updates: Array<Image_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ImagesArgs = {
  _inc?: InputMaybe<Images_Inc_Input>;
  _set?: InputMaybe<Images_Set_Input>;
  where: Images_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Images_By_PkArgs = {
  _inc?: InputMaybe<Images_Inc_Input>;
  _set?: InputMaybe<Images_Set_Input>;
  pk_columns: Images_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Images_ManyArgs = {
  updates: Array<Images_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_KpisArgs = {
  _append?: InputMaybe<Kpis_Append_Input>;
  _delete_at_path?: InputMaybe<Kpis_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Kpis_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Kpis_Delete_Key_Input>;
  _inc?: InputMaybe<Kpis_Inc_Input>;
  _prepend?: InputMaybe<Kpis_Prepend_Input>;
  _set?: InputMaybe<Kpis_Set_Input>;
  where: Kpis_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Kpis_By_PkArgs = {
  _append?: InputMaybe<Kpis_Append_Input>;
  _delete_at_path?: InputMaybe<Kpis_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Kpis_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Kpis_Delete_Key_Input>;
  _inc?: InputMaybe<Kpis_Inc_Input>;
  _prepend?: InputMaybe<Kpis_Prepend_Input>;
  _set?: InputMaybe<Kpis_Set_Input>;
  pk_columns: Kpis_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Kpis_ManyArgs = {
  updates: Array<Kpis_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LanguagesArgs = {
  _set?: InputMaybe<Languages_Set_Input>;
  where: Languages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Languages_By_PkArgs = {
  _set?: InputMaybe<Languages_Set_Input>;
  pk_columns: Languages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Languages_ManyArgs = {
  updates: Array<Languages_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Layout_Page_BottomsArgs = {
  _set?: InputMaybe<Layout_Page_Bottoms_Set_Input>;
  where: Layout_Page_Bottoms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Layout_Page_Bottoms_By_PkArgs = {
  _set?: InputMaybe<Layout_Page_Bottoms_Set_Input>;
  pk_columns: Layout_Page_Bottoms_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Layout_Page_Bottoms_ManyArgs = {
  updates: Array<Layout_Page_Bottoms_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Layout_Page_TopsArgs = {
  _set?: InputMaybe<Layout_Page_Tops_Set_Input>;
  where: Layout_Page_Tops_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Layout_Page_Tops_By_PkArgs = {
  _set?: InputMaybe<Layout_Page_Tops_Set_Input>;
  pk_columns: Layout_Page_Tops_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Layout_Page_Tops_ManyArgs = {
  updates: Array<Layout_Page_Tops_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Layout_PagesArgs = {
  _set?: InputMaybe<Layout_Pages_Set_Input>;
  where: Layout_Pages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Layout_Pages_By_PkArgs = {
  _set?: InputMaybe<Layout_Pages_Set_Input>;
  pk_columns: Layout_Pages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Layout_Pages_ManyArgs = {
  updates: Array<Layout_Pages_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Layout_PostsArgs = {
  _set?: InputMaybe<Layout_Posts_Set_Input>;
  where: Layout_Posts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Layout_Posts_By_PkArgs = {
  _set?: InputMaybe<Layout_Posts_Set_Input>;
  pk_columns: Layout_Posts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Layout_Posts_ManyArgs = {
  updates: Array<Layout_Posts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LayoutsArgs = {
  _set?: InputMaybe<Layouts_Set_Input>;
  where: Layouts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Layouts_By_PkArgs = {
  _set?: InputMaybe<Layouts_Set_Input>;
  pk_columns: Layouts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Layouts_ManyArgs = {
  updates: Array<Layouts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_News_LettersArgs = {
  _inc?: InputMaybe<News_Letters_Inc_Input>;
  _set?: InputMaybe<News_Letters_Set_Input>;
  where: News_Letters_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_News_Letters_By_PkArgs = {
  _inc?: InputMaybe<News_Letters_Inc_Input>;
  _set?: InputMaybe<News_Letters_Set_Input>;
  pk_columns: News_Letters_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_News_Letters_ManyArgs = {
  updates: Array<News_Letters_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PermissionsArgs = {
  _inc?: InputMaybe<Permissions_Inc_Input>;
  _set?: InputMaybe<Permissions_Set_Input>;
  where: Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Permissions_By_PkArgs = {
  _inc?: InputMaybe<Permissions_Inc_Input>;
  _set?: InputMaybe<Permissions_Set_Input>;
  pk_columns: Permissions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Permissions_ManyArgs = {
  updates: Array<Permissions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Permissions_RolesArgs = {
  _inc?: InputMaybe<Permissions_Roles_Inc_Input>;
  _set?: InputMaybe<Permissions_Roles_Set_Input>;
  where: Permissions_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Permissions_Roles_By_PkArgs = {
  _inc?: InputMaybe<Permissions_Roles_Inc_Input>;
  _set?: InputMaybe<Permissions_Roles_Set_Input>;
  pk_columns: Permissions_Roles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Permissions_Roles_ManyArgs = {
  updates: Array<Permissions_Roles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PostsArgs = {
  _append?: InputMaybe<Posts_Append_Input>;
  _delete_at_path?: InputMaybe<Posts_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Posts_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Posts_Delete_Key_Input>;
  _inc?: InputMaybe<Posts_Inc_Input>;
  _prepend?: InputMaybe<Posts_Prepend_Input>;
  _set?: InputMaybe<Posts_Set_Input>;
  where: Posts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Posts_By_PkArgs = {
  _append?: InputMaybe<Posts_Append_Input>;
  _delete_at_path?: InputMaybe<Posts_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Posts_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Posts_Delete_Key_Input>;
  _inc?: InputMaybe<Posts_Inc_Input>;
  _prepend?: InputMaybe<Posts_Prepend_Input>;
  _set?: InputMaybe<Posts_Set_Input>;
  pk_columns: Posts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Posts_CategoriesArgs = {
  _inc?: InputMaybe<Posts_Categories_Inc_Input>;
  _set?: InputMaybe<Posts_Categories_Set_Input>;
  where: Posts_Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Posts_Categories_By_PkArgs = {
  _inc?: InputMaybe<Posts_Categories_Inc_Input>;
  _set?: InputMaybe<Posts_Categories_Set_Input>;
  pk_columns: Posts_Categories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Posts_Categories_ManyArgs = {
  updates: Array<Posts_Categories_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Posts_CommentsArgs = {
  _inc?: InputMaybe<Posts_Comments_Inc_Input>;
  _set?: InputMaybe<Posts_Comments_Set_Input>;
  where: Posts_Comments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Posts_Comments_By_PkArgs = {
  _inc?: InputMaybe<Posts_Comments_Inc_Input>;
  _set?: InputMaybe<Posts_Comments_Set_Input>;
  pk_columns: Posts_Comments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Posts_Comments_ManyArgs = {
  updates: Array<Posts_Comments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Posts_KpisArgs = {
  _inc?: InputMaybe<Posts_Kpis_Inc_Input>;
  _set?: InputMaybe<Posts_Kpis_Set_Input>;
  where: Posts_Kpis_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Posts_Kpis_By_PkArgs = {
  _inc?: InputMaybe<Posts_Kpis_Inc_Input>;
  _set?: InputMaybe<Posts_Kpis_Set_Input>;
  pk_columns: Posts_Kpis_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Posts_Kpis_ManyArgs = {
  updates: Array<Posts_Kpis_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Posts_LikesArgs = {
  _inc?: InputMaybe<Posts_Likes_Inc_Input>;
  _set?: InputMaybe<Posts_Likes_Set_Input>;
  where: Posts_Likes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Posts_Likes_By_PkArgs = {
  _inc?: InputMaybe<Posts_Likes_Inc_Input>;
  _set?: InputMaybe<Posts_Likes_Set_Input>;
  pk_columns: Posts_Likes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Posts_Likes_ManyArgs = {
  updates: Array<Posts_Likes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Posts_ManyArgs = {
  updates: Array<Posts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Posts_SourcesArgs = {
  _inc?: InputMaybe<Posts_Sources_Inc_Input>;
  _set?: InputMaybe<Posts_Sources_Set_Input>;
  where: Posts_Sources_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Posts_Sources_By_PkArgs = {
  _inc?: InputMaybe<Posts_Sources_Inc_Input>;
  _set?: InputMaybe<Posts_Sources_Set_Input>;
  pk_columns: Posts_Sources_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Posts_Sources_ManyArgs = {
  updates: Array<Posts_Sources_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Posts_TagsArgs = {
  _inc?: InputMaybe<Posts_Tags_Inc_Input>;
  _set?: InputMaybe<Posts_Tags_Set_Input>;
  where: Posts_Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Posts_Tags_By_PkArgs = {
  _inc?: InputMaybe<Posts_Tags_Inc_Input>;
  _set?: InputMaybe<Posts_Tags_Set_Input>;
  pk_columns: Posts_Tags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Posts_Tags_ManyArgs = {
  updates: Array<Posts_Tags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Related_CategoriesArgs = {
  _inc?: InputMaybe<Related_Categories_Inc_Input>;
  _set?: InputMaybe<Related_Categories_Set_Input>;
  where: Related_Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Related_Categories_By_PkArgs = {
  _inc?: InputMaybe<Related_Categories_Inc_Input>;
  _set?: InputMaybe<Related_Categories_Set_Input>;
  pk_columns: Related_Categories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Related_Categories_ManyArgs = {
  updates: Array<Related_Categories_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RolesArgs = {
  _inc?: InputMaybe<Roles_Inc_Input>;
  _set?: InputMaybe<Roles_Set_Input>;
  where: Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Roles_By_PkArgs = {
  _inc?: InputMaybe<Roles_Inc_Input>;
  _set?: InputMaybe<Roles_Set_Input>;
  pk_columns: Roles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Roles_ManyArgs = {
  updates: Array<Roles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SettingsArgs = {
  _append?: InputMaybe<Settings_Append_Input>;
  _delete_at_path?: InputMaybe<Settings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Settings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Settings_Delete_Key_Input>;
  _inc?: InputMaybe<Settings_Inc_Input>;
  _prepend?: InputMaybe<Settings_Prepend_Input>;
  _set?: InputMaybe<Settings_Set_Input>;
  where: Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Settings_By_PkArgs = {
  _append?: InputMaybe<Settings_Append_Input>;
  _delete_at_path?: InputMaybe<Settings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Settings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Settings_Delete_Key_Input>;
  _inc?: InputMaybe<Settings_Inc_Input>;
  _prepend?: InputMaybe<Settings_Prepend_Input>;
  _set?: InputMaybe<Settings_Set_Input>;
  pk_columns: Settings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Settings_ManyArgs = {
  updates: Array<Settings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SourcesArgs = {
  _inc?: InputMaybe<Sources_Inc_Input>;
  _set?: InputMaybe<Sources_Set_Input>;
  where: Sources_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sources_By_PkArgs = {
  _inc?: InputMaybe<Sources_Inc_Input>;
  _set?: InputMaybe<Sources_Set_Input>;
  pk_columns: Sources_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sources_ManyArgs = {
  updates: Array<Sources_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TagsArgs = {
  _append?: InputMaybe<Tags_Append_Input>;
  _delete_at_path?: InputMaybe<Tags_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tags_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tags_Delete_Key_Input>;
  _inc?: InputMaybe<Tags_Inc_Input>;
  _prepend?: InputMaybe<Tags_Prepend_Input>;
  _set?: InputMaybe<Tags_Set_Input>;
  where: Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tags_By_PkArgs = {
  _append?: InputMaybe<Tags_Append_Input>;
  _delete_at_path?: InputMaybe<Tags_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tags_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tags_Delete_Key_Input>;
  _inc?: InputMaybe<Tags_Inc_Input>;
  _prepend?: InputMaybe<Tags_Prepend_Input>;
  _set?: InputMaybe<Tags_Set_Input>;
  pk_columns: Tags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tags_ManyArgs = {
  updates: Array<Tags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _inc?: InputMaybe<Users_Inc_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _inc?: InputMaybe<Users_Inc_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};


/** mutation root */
export type Mutation_RootVerifyEmailArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

/** columns and relationships of "news_letters" */
export type News_Letters = {
  __typename?: 'news_letters';
  content?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by?: Maybe<Users>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  deleted_by?: Maybe<Users>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  phone_number?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  updated_by?: Maybe<Users>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "news_letters" */
export type News_Letters_Aggregate = {
  __typename?: 'news_letters_aggregate';
  aggregate?: Maybe<News_Letters_Aggregate_Fields>;
  nodes: Array<News_Letters>;
};

export type News_Letters_Aggregate_Bool_Exp = {
  count?: InputMaybe<News_Letters_Aggregate_Bool_Exp_Count>;
};

export type News_Letters_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<News_Letters_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<News_Letters_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "news_letters" */
export type News_Letters_Aggregate_Fields = {
  __typename?: 'news_letters_aggregate_fields';
  avg?: Maybe<News_Letters_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<News_Letters_Max_Fields>;
  min?: Maybe<News_Letters_Min_Fields>;
  stddev?: Maybe<News_Letters_Stddev_Fields>;
  stddev_pop?: Maybe<News_Letters_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<News_Letters_Stddev_Samp_Fields>;
  sum?: Maybe<News_Letters_Sum_Fields>;
  var_pop?: Maybe<News_Letters_Var_Pop_Fields>;
  var_samp?: Maybe<News_Letters_Var_Samp_Fields>;
  variance?: Maybe<News_Letters_Variance_Fields>;
};


/** aggregate fields of "news_letters" */
export type News_Letters_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<News_Letters_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "news_letters" */
export type News_Letters_Aggregate_Order_By = {
  avg?: InputMaybe<News_Letters_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<News_Letters_Max_Order_By>;
  min?: InputMaybe<News_Letters_Min_Order_By>;
  stddev?: InputMaybe<News_Letters_Stddev_Order_By>;
  stddev_pop?: InputMaybe<News_Letters_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<News_Letters_Stddev_Samp_Order_By>;
  sum?: InputMaybe<News_Letters_Sum_Order_By>;
  var_pop?: InputMaybe<News_Letters_Var_Pop_Order_By>;
  var_samp?: InputMaybe<News_Letters_Var_Samp_Order_By>;
  variance?: InputMaybe<News_Letters_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "news_letters" */
export type News_Letters_Arr_Rel_Insert_Input = {
  data: Array<News_Letters_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<News_Letters_On_Conflict>;
};

/** aggregate avg on columns */
export type News_Letters_Avg_Fields = {
  __typename?: 'news_letters_avg_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "news_letters" */
export type News_Letters_Avg_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "news_letters". All fields are combined with a logical 'AND'. */
export type News_Letters_Bool_Exp = {
  _and?: InputMaybe<Array<News_Letters_Bool_Exp>>;
  _not?: InputMaybe<News_Letters_Bool_Exp>;
  _or?: InputMaybe<Array<News_Letters_Bool_Exp>>;
  content?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Users_Bool_Exp>;
  created_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_by?: InputMaybe<Users_Bool_Exp>;
  deleted_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Users_Bool_Exp>;
  updated_by_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "news_letters" */
export enum News_Letters_Constraint {
  /** unique or primary key constraint on columns "id" */
  NewsLettersPkey = 'news_letters_pkey'
}

/** input type for incrementing numeric columns in table "news_letters" */
export type News_Letters_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "news_letters" */
export type News_Letters_Insert_Input = {
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type News_Letters_Max_Fields = {
  __typename?: 'news_letters_max_fields';
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "news_letters" */
export type News_Letters_Max_Order_By = {
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type News_Letters_Min_Fields = {
  __typename?: 'news_letters_min_fields';
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "news_letters" */
export type News_Letters_Min_Order_By = {
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "news_letters" */
export type News_Letters_Mutation_Response = {
  __typename?: 'news_letters_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<News_Letters>;
};

/** on_conflict condition type for table "news_letters" */
export type News_Letters_On_Conflict = {
  constraint: News_Letters_Constraint;
  update_columns?: Array<News_Letters_Update_Column>;
  where?: InputMaybe<News_Letters_Bool_Exp>;
};

/** Ordering options when selecting data from "news_letters". */
export type News_Letters_Order_By = {
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Users_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by?: InputMaybe<Users_Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Users_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: news_letters */
export type News_Letters_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "news_letters" */
export enum News_Letters_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Email = 'email',
  /** column name */
  FullName = 'full_name',
  /** column name */
  Id = 'id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "news_letters" */
export type News_Letters_Set_Input = {
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type News_Letters_Stddev_Fields = {
  __typename?: 'news_letters_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "news_letters" */
export type News_Letters_Stddev_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type News_Letters_Stddev_Pop_Fields = {
  __typename?: 'news_letters_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "news_letters" */
export type News_Letters_Stddev_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type News_Letters_Stddev_Samp_Fields = {
  __typename?: 'news_letters_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "news_letters" */
export type News_Letters_Stddev_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "news_letters" */
export type News_Letters_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: News_Letters_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type News_Letters_Stream_Cursor_Value_Input = {
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type News_Letters_Sum_Fields = {
  __typename?: 'news_letters_sum_fields';
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "news_letters" */
export type News_Letters_Sum_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "news_letters" */
export enum News_Letters_Update_Column {
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Email = 'email',
  /** column name */
  FullName = 'full_name',
  /** column name */
  Id = 'id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type News_Letters_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<News_Letters_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<News_Letters_Set_Input>;
  /** filter the rows which have to be updated */
  where: News_Letters_Bool_Exp;
};

/** aggregate var_pop on columns */
export type News_Letters_Var_Pop_Fields = {
  __typename?: 'news_letters_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "news_letters" */
export type News_Letters_Var_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type News_Letters_Var_Samp_Fields = {
  __typename?: 'news_letters_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "news_letters" */
export type News_Letters_Var_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type News_Letters_Variance_Fields = {
  __typename?: 'news_letters_variance_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "news_letters" */
export type News_Letters_Variance_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "permissions" */
export type Permissions = {
  __typename?: 'permissions';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  created_by?: Maybe<Users>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  deleted_by?: Maybe<Users>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['bigint']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  permissions_roles: Array<Permissions_Roles>;
  /** An aggregate relationship */
  permissions_roles_aggregate: Permissions_Roles_Aggregate;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  updated_by?: Maybe<Users>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};


/** columns and relationships of "permissions" */
export type PermissionsPermissions_RolesArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissions_Roles_Order_By>>;
  where?: InputMaybe<Permissions_Roles_Bool_Exp>;
};


/** columns and relationships of "permissions" */
export type PermissionsPermissions_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissions_Roles_Order_By>>;
  where?: InputMaybe<Permissions_Roles_Bool_Exp>;
};

/** aggregated selection of "permissions" */
export type Permissions_Aggregate = {
  __typename?: 'permissions_aggregate';
  aggregate?: Maybe<Permissions_Aggregate_Fields>;
  nodes: Array<Permissions>;
};

export type Permissions_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Permissions_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Permissions_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Permissions_Aggregate_Bool_Exp_Count>;
};

export type Permissions_Aggregate_Bool_Exp_Bool_And = {
  arguments: Permissions_Select_Column_Permissions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Permissions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Permissions_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Permissions_Select_Column_Permissions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Permissions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Permissions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Permissions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "permissions" */
export type Permissions_Aggregate_Fields = {
  __typename?: 'permissions_aggregate_fields';
  avg?: Maybe<Permissions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Permissions_Max_Fields>;
  min?: Maybe<Permissions_Min_Fields>;
  stddev?: Maybe<Permissions_Stddev_Fields>;
  stddev_pop?: Maybe<Permissions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Permissions_Stddev_Samp_Fields>;
  sum?: Maybe<Permissions_Sum_Fields>;
  var_pop?: Maybe<Permissions_Var_Pop_Fields>;
  var_samp?: Maybe<Permissions_Var_Samp_Fields>;
  variance?: Maybe<Permissions_Variance_Fields>;
};


/** aggregate fields of "permissions" */
export type Permissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "permissions" */
export type Permissions_Aggregate_Order_By = {
  avg?: InputMaybe<Permissions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Permissions_Max_Order_By>;
  min?: InputMaybe<Permissions_Min_Order_By>;
  stddev?: InputMaybe<Permissions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Permissions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Permissions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Permissions_Sum_Order_By>;
  var_pop?: InputMaybe<Permissions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Permissions_Var_Samp_Order_By>;
  variance?: InputMaybe<Permissions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "permissions" */
export type Permissions_Arr_Rel_Insert_Input = {
  data: Array<Permissions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Permissions_On_Conflict>;
};

/** aggregate avg on columns */
export type Permissions_Avg_Fields = {
  __typename?: 'permissions_avg_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "permissions" */
export type Permissions_Avg_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "permissions". All fields are combined with a logical 'AND'. */
export type Permissions_Bool_Exp = {
  _and?: InputMaybe<Array<Permissions_Bool_Exp>>;
  _not?: InputMaybe<Permissions_Bool_Exp>;
  _or?: InputMaybe<Array<Permissions_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Users_Bool_Exp>;
  created_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_by?: InputMaybe<Users_Bool_Exp>;
  deleted_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  permissions_roles?: InputMaybe<Permissions_Roles_Bool_Exp>;
  permissions_roles_aggregate?: InputMaybe<Permissions_Roles_Aggregate_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Users_Bool_Exp>;
  updated_by_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "permissions" */
export enum Permissions_Constraint {
  /** unique or primary key constraint on columns "id" */
  PermissionsPkey = 'permissions_pkey'
}

/** input type for incrementing numeric columns in table "permissions" */
export type Permissions_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "permissions" */
export type Permissions_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions_roles?: InputMaybe<Permissions_Roles_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Permissions_Max_Fields = {
  __typename?: 'permissions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "permissions" */
export type Permissions_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Permissions_Min_Fields = {
  __typename?: 'permissions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "permissions" */
export type Permissions_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "permissions" */
export type Permissions_Mutation_Response = {
  __typename?: 'permissions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Permissions>;
};

/** input type for inserting object relation for remote table "permissions" */
export type Permissions_Obj_Rel_Insert_Input = {
  data: Permissions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Permissions_On_Conflict>;
};

/** on_conflict condition type for table "permissions" */
export type Permissions_On_Conflict = {
  constraint: Permissions_Constraint;
  update_columns?: Array<Permissions_Update_Column>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};

/** Ordering options when selecting data from "permissions". */
export type Permissions_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Users_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by?: InputMaybe<Users_Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  permissions_roles_aggregate?: InputMaybe<Permissions_Roles_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Users_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: permissions */
export type Permissions_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** columns and relationships of "permissions_roles" */
export type Permissions_Roles = {
  __typename?: 'permissions_roles';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by?: Maybe<Users>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  deleted_by?: Maybe<Users>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['bigint']['output'];
  /** An object relationship */
  permission: Permissions;
  permission_id: Scalars['bigint']['output'];
  /** An object relationship */
  role: Roles;
  role_id: Scalars['bigint']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  updated_by?: Maybe<Users>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "permissions_roles" */
export type Permissions_Roles_Aggregate = {
  __typename?: 'permissions_roles_aggregate';
  aggregate?: Maybe<Permissions_Roles_Aggregate_Fields>;
  nodes: Array<Permissions_Roles>;
};

export type Permissions_Roles_Aggregate_Bool_Exp = {
  count?: InputMaybe<Permissions_Roles_Aggregate_Bool_Exp_Count>;
};

export type Permissions_Roles_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Permissions_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Permissions_Roles_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "permissions_roles" */
export type Permissions_Roles_Aggregate_Fields = {
  __typename?: 'permissions_roles_aggregate_fields';
  avg?: Maybe<Permissions_Roles_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Permissions_Roles_Max_Fields>;
  min?: Maybe<Permissions_Roles_Min_Fields>;
  stddev?: Maybe<Permissions_Roles_Stddev_Fields>;
  stddev_pop?: Maybe<Permissions_Roles_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Permissions_Roles_Stddev_Samp_Fields>;
  sum?: Maybe<Permissions_Roles_Sum_Fields>;
  var_pop?: Maybe<Permissions_Roles_Var_Pop_Fields>;
  var_samp?: Maybe<Permissions_Roles_Var_Samp_Fields>;
  variance?: Maybe<Permissions_Roles_Variance_Fields>;
};


/** aggregate fields of "permissions_roles" */
export type Permissions_Roles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Permissions_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "permissions_roles" */
export type Permissions_Roles_Aggregate_Order_By = {
  avg?: InputMaybe<Permissions_Roles_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Permissions_Roles_Max_Order_By>;
  min?: InputMaybe<Permissions_Roles_Min_Order_By>;
  stddev?: InputMaybe<Permissions_Roles_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Permissions_Roles_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Permissions_Roles_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Permissions_Roles_Sum_Order_By>;
  var_pop?: InputMaybe<Permissions_Roles_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Permissions_Roles_Var_Samp_Order_By>;
  variance?: InputMaybe<Permissions_Roles_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "permissions_roles" */
export type Permissions_Roles_Arr_Rel_Insert_Input = {
  data: Array<Permissions_Roles_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Permissions_Roles_On_Conflict>;
};

/** aggregate avg on columns */
export type Permissions_Roles_Avg_Fields = {
  __typename?: 'permissions_roles_avg_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  permission_id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "permissions_roles" */
export type Permissions_Roles_Avg_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "permissions_roles". All fields are combined with a logical 'AND'. */
export type Permissions_Roles_Bool_Exp = {
  _and?: InputMaybe<Array<Permissions_Roles_Bool_Exp>>;
  _not?: InputMaybe<Permissions_Roles_Bool_Exp>;
  _or?: InputMaybe<Array<Permissions_Roles_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Users_Bool_Exp>;
  created_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_by?: InputMaybe<Users_Bool_Exp>;
  deleted_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  permission?: InputMaybe<Permissions_Bool_Exp>;
  permission_id?: InputMaybe<Bigint_Comparison_Exp>;
  role?: InputMaybe<Roles_Bool_Exp>;
  role_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Users_Bool_Exp>;
  updated_by_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "permissions_roles" */
export enum Permissions_Roles_Constraint {
  /** unique or primary key constraint on columns "id" */
  PermissionRolePkey = 'permission_role_pkey',
  /** unique or primary key constraint on columns "role_id", "permission_id" */
  PermissionsRolesRoleIdPermissionIdKey = 'permissions_roles_role_id_permission_id_key'
}

/** input type for incrementing numeric columns in table "permissions_roles" */
export type Permissions_Roles_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  permission_id?: InputMaybe<Scalars['bigint']['input']>;
  role_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "permissions_roles" */
export type Permissions_Roles_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  permission?: InputMaybe<Permissions_Obj_Rel_Insert_Input>;
  permission_id?: InputMaybe<Scalars['bigint']['input']>;
  role?: InputMaybe<Roles_Obj_Rel_Insert_Input>;
  role_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Permissions_Roles_Max_Fields = {
  __typename?: 'permissions_roles_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  permission_id?: Maybe<Scalars['bigint']['output']>;
  role_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "permissions_roles" */
export type Permissions_Roles_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Permissions_Roles_Min_Fields = {
  __typename?: 'permissions_roles_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  permission_id?: Maybe<Scalars['bigint']['output']>;
  role_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "permissions_roles" */
export type Permissions_Roles_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "permissions_roles" */
export type Permissions_Roles_Mutation_Response = {
  __typename?: 'permissions_roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Permissions_Roles>;
};

/** on_conflict condition type for table "permissions_roles" */
export type Permissions_Roles_On_Conflict = {
  constraint: Permissions_Roles_Constraint;
  update_columns?: Array<Permissions_Roles_Update_Column>;
  where?: InputMaybe<Permissions_Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "permissions_roles". */
export type Permissions_Roles_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Users_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by?: InputMaybe<Users_Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission?: InputMaybe<Permissions_Order_By>;
  permission_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Roles_Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Users_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: permissions_roles */
export type Permissions_Roles_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "permissions_roles" */
export enum Permissions_Roles_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  PermissionId = 'permission_id',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "permissions_roles" */
export type Permissions_Roles_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  permission_id?: InputMaybe<Scalars['bigint']['input']>;
  role_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Permissions_Roles_Stddev_Fields = {
  __typename?: 'permissions_roles_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  permission_id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "permissions_roles" */
export type Permissions_Roles_Stddev_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Permissions_Roles_Stddev_Pop_Fields = {
  __typename?: 'permissions_roles_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  permission_id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "permissions_roles" */
export type Permissions_Roles_Stddev_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Permissions_Roles_Stddev_Samp_Fields = {
  __typename?: 'permissions_roles_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  permission_id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "permissions_roles" */
export type Permissions_Roles_Stddev_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "permissions_roles" */
export type Permissions_Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Permissions_Roles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Permissions_Roles_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  permission_id?: InputMaybe<Scalars['bigint']['input']>;
  role_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Permissions_Roles_Sum_Fields = {
  __typename?: 'permissions_roles_sum_fields';
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  permission_id?: Maybe<Scalars['bigint']['output']>;
  role_id?: Maybe<Scalars['bigint']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "permissions_roles" */
export type Permissions_Roles_Sum_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "permissions_roles" */
export enum Permissions_Roles_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  PermissionId = 'permission_id',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Permissions_Roles_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Permissions_Roles_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Permissions_Roles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Permissions_Roles_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Permissions_Roles_Var_Pop_Fields = {
  __typename?: 'permissions_roles_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  permission_id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "permissions_roles" */
export type Permissions_Roles_Var_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Permissions_Roles_Var_Samp_Fields = {
  __typename?: 'permissions_roles_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  permission_id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "permissions_roles" */
export type Permissions_Roles_Var_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Permissions_Roles_Variance_Fields = {
  __typename?: 'permissions_roles_variance_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  permission_id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "permissions_roles" */
export type Permissions_Roles_Variance_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** select columns of table "permissions" */
export enum Permissions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "permissions_aggregate_bool_exp_bool_and_arguments_columns" columns of table "permissions" */
export enum Permissions_Select_Column_Permissions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "permissions_aggregate_bool_exp_bool_or_arguments_columns" columns of table "permissions" */
export enum Permissions_Select_Column_Permissions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "permissions" */
export type Permissions_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Permissions_Stddev_Fields = {
  __typename?: 'permissions_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "permissions" */
export type Permissions_Stddev_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Permissions_Stddev_Pop_Fields = {
  __typename?: 'permissions_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "permissions" */
export type Permissions_Stddev_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Permissions_Stddev_Samp_Fields = {
  __typename?: 'permissions_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "permissions" */
export type Permissions_Stddev_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "permissions" */
export type Permissions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Permissions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Permissions_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Permissions_Sum_Fields = {
  __typename?: 'permissions_sum_fields';
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "permissions" */
export type Permissions_Sum_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "permissions" */
export enum Permissions_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Permissions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Permissions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Permissions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Permissions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Permissions_Var_Pop_Fields = {
  __typename?: 'permissions_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "permissions" */
export type Permissions_Var_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Permissions_Var_Samp_Fields = {
  __typename?: 'permissions_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "permissions" */
export type Permissions_Var_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Permissions_Variance_Fields = {
  __typename?: 'permissions_variance_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "permissions" */
export type Permissions_Variance_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "posts" */
export type Posts = {
  __typename?: 'posts';
  /** An object relationship */
  author?: Maybe<Users>;
  author_id?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "get_post_content_i18n" */
  content?: Maybe<Scalars['String']['output']>;
  content_i18n?: Maybe<Scalars['jsonb']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by?: Maybe<Users>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  deleted_by?: Maybe<Users>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['bigint']['output'];
  /** A computed field, executes function "get_post_images" */
  images?: Maybe<Array<Images>>;
  is_hot?: Maybe<Scalars['Boolean']['output']>;
  layout_id?: Maybe<Layout_Posts_Enum>;
  /** An object relationship */
  layout_post?: Maybe<Layout_Posts>;
  location?: Maybe<Scalars['String']['output']>;
  pin_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  posts_categories: Array<Posts_Categories>;
  /** An aggregate relationship */
  posts_categories_aggregate: Posts_Categories_Aggregate;
  /** An array relationship */
  posts_comments: Array<Posts_Comments>;
  /** An aggregate relationship */
  posts_comments_aggregate: Posts_Comments_Aggregate;
  /** An object relationship */
  posts_comments_count?: Maybe<Posts_Comments_Count>;
  /** An array relationship */
  posts_kpis: Array<Posts_Kpis>;
  /** An aggregate relationship */
  posts_kpis_aggregate: Posts_Kpis_Aggregate;
  /** An array relationship */
  posts_likes: Array<Posts_Likes>;
  /** An aggregate relationship */
  posts_likes_aggregate: Posts_Likes_Aggregate;
  /** An object relationship */
  posts_likes_count?: Maybe<Posts_Likes_Count>;
  /** An array relationship */
  posts_sources: Array<Posts_Sources>;
  /** An aggregate relationship */
  posts_sources_aggregate: Posts_Sources_Aggregate;
  /** An array relationship */
  posts_tags: Array<Posts_Tags>;
  /** An aggregate relationship */
  posts_tags_aggregate: Posts_Tags_Aggregate;
  published_at?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "get_post_short_content_i18n" */
  short_content?: Maybe<Scalars['String']['output']>;
  short_content_i18n?: Maybe<Scalars['jsonb']['output']>;
  slug: Scalars['String']['output'];
  /** A computed field, executes function "get_post_thumbnail" */
  thumbnail?: Maybe<Array<Images>>;
  /** A computed field, executes function "get_post_title_i18n" */
  title?: Maybe<Scalars['String']['output']>;
  title_i18n?: Maybe<Scalars['jsonb']['output']>;
  total_views?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  updated_by?: Maybe<Users>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};


/** columns and relationships of "posts" */
export type PostsContent_I18nArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "posts" */
export type PostsImagesArgs = {
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


/** columns and relationships of "posts" */
export type PostsPosts_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Posts_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Categories_Order_By>>;
  where?: InputMaybe<Posts_Categories_Bool_Exp>;
};


/** columns and relationships of "posts" */
export type PostsPosts_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Categories_Order_By>>;
  where?: InputMaybe<Posts_Categories_Bool_Exp>;
};


/** columns and relationships of "posts" */
export type PostsPosts_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Posts_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Comments_Order_By>>;
  where?: InputMaybe<Posts_Comments_Bool_Exp>;
};


/** columns and relationships of "posts" */
export type PostsPosts_Comments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Comments_Order_By>>;
  where?: InputMaybe<Posts_Comments_Bool_Exp>;
};


/** columns and relationships of "posts" */
export type PostsPosts_KpisArgs = {
  distinct_on?: InputMaybe<Array<Posts_Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Kpis_Order_By>>;
  where?: InputMaybe<Posts_Kpis_Bool_Exp>;
};


/** columns and relationships of "posts" */
export type PostsPosts_Kpis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Kpis_Order_By>>;
  where?: InputMaybe<Posts_Kpis_Bool_Exp>;
};


/** columns and relationships of "posts" */
export type PostsPosts_LikesArgs = {
  distinct_on?: InputMaybe<Array<Posts_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Likes_Order_By>>;
  where?: InputMaybe<Posts_Likes_Bool_Exp>;
};


/** columns and relationships of "posts" */
export type PostsPosts_Likes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Likes_Order_By>>;
  where?: InputMaybe<Posts_Likes_Bool_Exp>;
};


/** columns and relationships of "posts" */
export type PostsPosts_SourcesArgs = {
  distinct_on?: InputMaybe<Array<Posts_Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Sources_Order_By>>;
  where?: InputMaybe<Posts_Sources_Bool_Exp>;
};


/** columns and relationships of "posts" */
export type PostsPosts_Sources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Sources_Order_By>>;
  where?: InputMaybe<Posts_Sources_Bool_Exp>;
};


/** columns and relationships of "posts" */
export type PostsPosts_TagsArgs = {
  distinct_on?: InputMaybe<Array<Posts_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Tags_Order_By>>;
  where?: InputMaybe<Posts_Tags_Bool_Exp>;
};


/** columns and relationships of "posts" */
export type PostsPosts_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Tags_Order_By>>;
  where?: InputMaybe<Posts_Tags_Bool_Exp>;
};


/** columns and relationships of "posts" */
export type PostsShort_Content_I18nArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "posts" */
export type PostsThumbnailArgs = {
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


/** columns and relationships of "posts" */
export type PostsTitle_I18nArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "posts" */
export type Posts_Aggregate = {
  __typename?: 'posts_aggregate';
  aggregate?: Maybe<Posts_Aggregate_Fields>;
  nodes: Array<Posts>;
};

export type Posts_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Posts_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Posts_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Posts_Aggregate_Bool_Exp_Count>;
};

export type Posts_Aggregate_Bool_Exp_Bool_And = {
  arguments: Posts_Select_Column_Posts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Posts_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Posts_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Posts_Select_Column_Posts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Posts_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Posts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Posts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Posts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "posts" */
export type Posts_Aggregate_Fields = {
  __typename?: 'posts_aggregate_fields';
  avg?: Maybe<Posts_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Posts_Max_Fields>;
  min?: Maybe<Posts_Min_Fields>;
  stddev?: Maybe<Posts_Stddev_Fields>;
  stddev_pop?: Maybe<Posts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Posts_Stddev_Samp_Fields>;
  sum?: Maybe<Posts_Sum_Fields>;
  var_pop?: Maybe<Posts_Var_Pop_Fields>;
  var_samp?: Maybe<Posts_Var_Samp_Fields>;
  variance?: Maybe<Posts_Variance_Fields>;
};


/** aggregate fields of "posts" */
export type Posts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Posts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "posts" */
export type Posts_Aggregate_Order_By = {
  avg?: InputMaybe<Posts_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Posts_Max_Order_By>;
  min?: InputMaybe<Posts_Min_Order_By>;
  stddev?: InputMaybe<Posts_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Posts_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Posts_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Posts_Sum_Order_By>;
  var_pop?: InputMaybe<Posts_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Posts_Var_Samp_Order_By>;
  variance?: InputMaybe<Posts_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Posts_Append_Input = {
  content_i18n?: InputMaybe<Scalars['jsonb']['input']>;
  short_content_i18n?: InputMaybe<Scalars['jsonb']['input']>;
  title_i18n?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "posts" */
export type Posts_Arr_Rel_Insert_Input = {
  data: Array<Posts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Posts_On_Conflict>;
};

/** aggregate avg on columns */
export type Posts_Avg_Fields = {
  __typename?: 'posts_avg_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  total_views?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "posts" */
export type Posts_Avg_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  total_views?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "posts". All fields are combined with a logical 'AND'. */
export type Posts_Bool_Exp = {
  _and?: InputMaybe<Array<Posts_Bool_Exp>>;
  _not?: InputMaybe<Posts_Bool_Exp>;
  _or?: InputMaybe<Array<Posts_Bool_Exp>>;
  author?: InputMaybe<Users_Bool_Exp>;
  author_id?: InputMaybe<Bigint_Comparison_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  content_i18n?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Users_Bool_Exp>;
  created_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_by?: InputMaybe<Users_Bool_Exp>;
  deleted_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  images?: InputMaybe<Images_Bool_Exp>;
  is_hot?: InputMaybe<Boolean_Comparison_Exp>;
  layout_id?: InputMaybe<Layout_Posts_Enum_Comparison_Exp>;
  layout_post?: InputMaybe<Layout_Posts_Bool_Exp>;
  location?: InputMaybe<String_Comparison_Exp>;
  pin_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  posts_categories?: InputMaybe<Posts_Categories_Bool_Exp>;
  posts_categories_aggregate?: InputMaybe<Posts_Categories_Aggregate_Bool_Exp>;
  posts_comments?: InputMaybe<Posts_Comments_Bool_Exp>;
  posts_comments_aggregate?: InputMaybe<Posts_Comments_Aggregate_Bool_Exp>;
  posts_comments_count?: InputMaybe<Posts_Comments_Count_Bool_Exp>;
  posts_kpis?: InputMaybe<Posts_Kpis_Bool_Exp>;
  posts_kpis_aggregate?: InputMaybe<Posts_Kpis_Aggregate_Bool_Exp>;
  posts_likes?: InputMaybe<Posts_Likes_Bool_Exp>;
  posts_likes_aggregate?: InputMaybe<Posts_Likes_Aggregate_Bool_Exp>;
  posts_likes_count?: InputMaybe<Posts_Likes_Count_Bool_Exp>;
  posts_sources?: InputMaybe<Posts_Sources_Bool_Exp>;
  posts_sources_aggregate?: InputMaybe<Posts_Sources_Aggregate_Bool_Exp>;
  posts_tags?: InputMaybe<Posts_Tags_Bool_Exp>;
  posts_tags_aggregate?: InputMaybe<Posts_Tags_Aggregate_Bool_Exp>;
  published_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  short_content?: InputMaybe<String_Comparison_Exp>;
  short_content_i18n?: InputMaybe<Jsonb_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  thumbnail?: InputMaybe<Images_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  title_i18n?: InputMaybe<Jsonb_Comparison_Exp>;
  total_views?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Users_Bool_Exp>;
  updated_by_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** columns and relationships of "posts_categories" */
export type Posts_Categories = {
  __typename?: 'posts_categories';
  /** An object relationship */
  category?: Maybe<Categories>;
  category_id?: Maybe<Scalars['bigint']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by?: Maybe<Users>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  deleted_by?: Maybe<Users>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['bigint']['output'];
  /** An object relationship */
  post?: Maybe<Posts>;
  post_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  updated_by?: Maybe<Users>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "posts_categories" */
export type Posts_Categories_Aggregate = {
  __typename?: 'posts_categories_aggregate';
  aggregate?: Maybe<Posts_Categories_Aggregate_Fields>;
  nodes: Array<Posts_Categories>;
};

export type Posts_Categories_Aggregate_Bool_Exp = {
  count?: InputMaybe<Posts_Categories_Aggregate_Bool_Exp_Count>;
};

export type Posts_Categories_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Posts_Categories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Posts_Categories_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "posts_categories" */
export type Posts_Categories_Aggregate_Fields = {
  __typename?: 'posts_categories_aggregate_fields';
  avg?: Maybe<Posts_Categories_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Posts_Categories_Max_Fields>;
  min?: Maybe<Posts_Categories_Min_Fields>;
  stddev?: Maybe<Posts_Categories_Stddev_Fields>;
  stddev_pop?: Maybe<Posts_Categories_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Posts_Categories_Stddev_Samp_Fields>;
  sum?: Maybe<Posts_Categories_Sum_Fields>;
  var_pop?: Maybe<Posts_Categories_Var_Pop_Fields>;
  var_samp?: Maybe<Posts_Categories_Var_Samp_Fields>;
  variance?: Maybe<Posts_Categories_Variance_Fields>;
};


/** aggregate fields of "posts_categories" */
export type Posts_Categories_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Posts_Categories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "posts_categories" */
export type Posts_Categories_Aggregate_Order_By = {
  avg?: InputMaybe<Posts_Categories_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Posts_Categories_Max_Order_By>;
  min?: InputMaybe<Posts_Categories_Min_Order_By>;
  stddev?: InputMaybe<Posts_Categories_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Posts_Categories_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Posts_Categories_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Posts_Categories_Sum_Order_By>;
  var_pop?: InputMaybe<Posts_Categories_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Posts_Categories_Var_Samp_Order_By>;
  variance?: InputMaybe<Posts_Categories_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "posts_categories" */
export type Posts_Categories_Arr_Rel_Insert_Input = {
  data: Array<Posts_Categories_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Posts_Categories_On_Conflict>;
};

/** aggregate avg on columns */
export type Posts_Categories_Avg_Fields = {
  __typename?: 'posts_categories_avg_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "posts_categories" */
export type Posts_Categories_Avg_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "posts_categories". All fields are combined with a logical 'AND'. */
export type Posts_Categories_Bool_Exp = {
  _and?: InputMaybe<Array<Posts_Categories_Bool_Exp>>;
  _not?: InputMaybe<Posts_Categories_Bool_Exp>;
  _or?: InputMaybe<Array<Posts_Categories_Bool_Exp>>;
  category?: InputMaybe<Categories_Bool_Exp>;
  category_id?: InputMaybe<Bigint_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Users_Bool_Exp>;
  created_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_by?: InputMaybe<Users_Bool_Exp>;
  deleted_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  post?: InputMaybe<Posts_Bool_Exp>;
  post_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Users_Bool_Exp>;
  updated_by_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "posts_categories" */
export enum Posts_Categories_Constraint {
  /** unique or primary key constraint on columns "id" */
  PostsCatogoriesPkey = 'posts_catogories_pkey'
}

/** input type for incrementing numeric columns in table "posts_categories" */
export type Posts_Categories_Inc_Input = {
  category_id?: InputMaybe<Scalars['bigint']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  post_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "posts_categories" */
export type Posts_Categories_Insert_Input = {
  category?: InputMaybe<Categories_Obj_Rel_Insert_Input>;
  category_id?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  post?: InputMaybe<Posts_Obj_Rel_Insert_Input>;
  post_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Posts_Categories_Max_Fields = {
  __typename?: 'posts_categories_max_fields';
  category_id?: Maybe<Scalars['bigint']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  post_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "posts_categories" */
export type Posts_Categories_Max_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Posts_Categories_Min_Fields = {
  __typename?: 'posts_categories_min_fields';
  category_id?: Maybe<Scalars['bigint']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  post_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "posts_categories" */
export type Posts_Categories_Min_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "posts_categories" */
export type Posts_Categories_Mutation_Response = {
  __typename?: 'posts_categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Posts_Categories>;
};

/** on_conflict condition type for table "posts_categories" */
export type Posts_Categories_On_Conflict = {
  constraint: Posts_Categories_Constraint;
  update_columns?: Array<Posts_Categories_Update_Column>;
  where?: InputMaybe<Posts_Categories_Bool_Exp>;
};

/** Ordering options when selecting data from "posts_categories". */
export type Posts_Categories_Order_By = {
  category?: InputMaybe<Categories_Order_By>;
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Users_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by?: InputMaybe<Users_Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post?: InputMaybe<Posts_Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Users_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: posts_categories */
export type Posts_Categories_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "posts_categories" */
export enum Posts_Categories_Select_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  PostId = 'post_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "posts_categories" */
export type Posts_Categories_Set_Input = {
  category_id?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  post_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Posts_Categories_Stddev_Fields = {
  __typename?: 'posts_categories_stddev_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "posts_categories" */
export type Posts_Categories_Stddev_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Posts_Categories_Stddev_Pop_Fields = {
  __typename?: 'posts_categories_stddev_pop_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "posts_categories" */
export type Posts_Categories_Stddev_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Posts_Categories_Stddev_Samp_Fields = {
  __typename?: 'posts_categories_stddev_samp_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "posts_categories" */
export type Posts_Categories_Stddev_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "posts_categories" */
export type Posts_Categories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Posts_Categories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Posts_Categories_Stream_Cursor_Value_Input = {
  category_id?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  post_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Posts_Categories_Sum_Fields = {
  __typename?: 'posts_categories_sum_fields';
  category_id?: Maybe<Scalars['bigint']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  post_id?: Maybe<Scalars['bigint']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "posts_categories" */
export type Posts_Categories_Sum_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "posts_categories" */
export enum Posts_Categories_Update_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  PostId = 'post_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Posts_Categories_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Posts_Categories_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Posts_Categories_Set_Input>;
  /** filter the rows which have to be updated */
  where: Posts_Categories_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Posts_Categories_Var_Pop_Fields = {
  __typename?: 'posts_categories_var_pop_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "posts_categories" */
export type Posts_Categories_Var_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Posts_Categories_Var_Samp_Fields = {
  __typename?: 'posts_categories_var_samp_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "posts_categories" */
export type Posts_Categories_Var_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Posts_Categories_Variance_Fields = {
  __typename?: 'posts_categories_variance_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "posts_categories" */
export type Posts_Categories_Variance_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "posts_comments" */
export type Posts_Comments = {
  __typename?: 'posts_comments';
  /** An array relationship */
  children: Array<Posts_Comments>;
  /** An aggregate relationship */
  children_aggregate: Posts_Comments_Aggregate;
  /** An array relationship */
  comments_likes: Array<Comments_Likes>;
  /** An aggregate relationship */
  comments_likes_aggregate: Comments_Likes_Aggregate;
  /** An object relationship */
  comments_likes_count?: Maybe<Comments_Likes_Count>;
  content: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by?: Maybe<Users>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  deleted_by?: Maybe<Users>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['bigint']['output'];
  /** An object relationship */
  parent_comment?: Maybe<Posts_Comments>;
  parent_comment_id?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  post: Posts;
  post_id: Scalars['bigint']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  updated_by?: Maybe<Users>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};


/** columns and relationships of "posts_comments" */
export type Posts_CommentsChildrenArgs = {
  distinct_on?: InputMaybe<Array<Posts_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Comments_Order_By>>;
  where?: InputMaybe<Posts_Comments_Bool_Exp>;
};


/** columns and relationships of "posts_comments" */
export type Posts_CommentsChildren_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Comments_Order_By>>;
  where?: InputMaybe<Posts_Comments_Bool_Exp>;
};


/** columns and relationships of "posts_comments" */
export type Posts_CommentsComments_LikesArgs = {
  distinct_on?: InputMaybe<Array<Comments_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Likes_Order_By>>;
  where?: InputMaybe<Comments_Likes_Bool_Exp>;
};


/** columns and relationships of "posts_comments" */
export type Posts_CommentsComments_Likes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comments_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Likes_Order_By>>;
  where?: InputMaybe<Comments_Likes_Bool_Exp>;
};

/** aggregated selection of "posts_comments" */
export type Posts_Comments_Aggregate = {
  __typename?: 'posts_comments_aggregate';
  aggregate?: Maybe<Posts_Comments_Aggregate_Fields>;
  nodes: Array<Posts_Comments>;
};

export type Posts_Comments_Aggregate_Bool_Exp = {
  count?: InputMaybe<Posts_Comments_Aggregate_Bool_Exp_Count>;
};

export type Posts_Comments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Posts_Comments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Posts_Comments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "posts_comments" */
export type Posts_Comments_Aggregate_Fields = {
  __typename?: 'posts_comments_aggregate_fields';
  avg?: Maybe<Posts_Comments_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Posts_Comments_Max_Fields>;
  min?: Maybe<Posts_Comments_Min_Fields>;
  stddev?: Maybe<Posts_Comments_Stddev_Fields>;
  stddev_pop?: Maybe<Posts_Comments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Posts_Comments_Stddev_Samp_Fields>;
  sum?: Maybe<Posts_Comments_Sum_Fields>;
  var_pop?: Maybe<Posts_Comments_Var_Pop_Fields>;
  var_samp?: Maybe<Posts_Comments_Var_Samp_Fields>;
  variance?: Maybe<Posts_Comments_Variance_Fields>;
};


/** aggregate fields of "posts_comments" */
export type Posts_Comments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Posts_Comments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "posts_comments" */
export type Posts_Comments_Aggregate_Order_By = {
  avg?: InputMaybe<Posts_Comments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Posts_Comments_Max_Order_By>;
  min?: InputMaybe<Posts_Comments_Min_Order_By>;
  stddev?: InputMaybe<Posts_Comments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Posts_Comments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Posts_Comments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Posts_Comments_Sum_Order_By>;
  var_pop?: InputMaybe<Posts_Comments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Posts_Comments_Var_Samp_Order_By>;
  variance?: InputMaybe<Posts_Comments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "posts_comments" */
export type Posts_Comments_Arr_Rel_Insert_Input = {
  data: Array<Posts_Comments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Posts_Comments_On_Conflict>;
};

/** aggregate avg on columns */
export type Posts_Comments_Avg_Fields = {
  __typename?: 'posts_comments_avg_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parent_comment_id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "posts_comments" */
export type Posts_Comments_Avg_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_comment_id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "posts_comments". All fields are combined with a logical 'AND'. */
export type Posts_Comments_Bool_Exp = {
  _and?: InputMaybe<Array<Posts_Comments_Bool_Exp>>;
  _not?: InputMaybe<Posts_Comments_Bool_Exp>;
  _or?: InputMaybe<Array<Posts_Comments_Bool_Exp>>;
  children?: InputMaybe<Posts_Comments_Bool_Exp>;
  children_aggregate?: InputMaybe<Posts_Comments_Aggregate_Bool_Exp>;
  comments_likes?: InputMaybe<Comments_Likes_Bool_Exp>;
  comments_likes_aggregate?: InputMaybe<Comments_Likes_Aggregate_Bool_Exp>;
  comments_likes_count?: InputMaybe<Comments_Likes_Count_Bool_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Users_Bool_Exp>;
  created_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_by?: InputMaybe<Users_Bool_Exp>;
  deleted_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  parent_comment?: InputMaybe<Posts_Comments_Bool_Exp>;
  parent_comment_id?: InputMaybe<Bigint_Comparison_Exp>;
  post?: InputMaybe<Posts_Bool_Exp>;
  post_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Users_Bool_Exp>;
  updated_by_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "posts_comments" */
export enum Posts_Comments_Constraint {
  /** unique or primary key constraint on columns "id" */
  CommentsPkey = 'comments_pkey'
}

/** columns and relationships of "posts_comments_count" */
export type Posts_Comments_Count = {
  __typename?: 'posts_comments_count';
  count?: Maybe<Scalars['bigint']['output']>;
  post_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "posts_comments_count" */
export type Posts_Comments_Count_Aggregate = {
  __typename?: 'posts_comments_count_aggregate';
  aggregate?: Maybe<Posts_Comments_Count_Aggregate_Fields>;
  nodes: Array<Posts_Comments_Count>;
};

/** aggregate fields of "posts_comments_count" */
export type Posts_Comments_Count_Aggregate_Fields = {
  __typename?: 'posts_comments_count_aggregate_fields';
  avg?: Maybe<Posts_Comments_Count_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Posts_Comments_Count_Max_Fields>;
  min?: Maybe<Posts_Comments_Count_Min_Fields>;
  stddev?: Maybe<Posts_Comments_Count_Stddev_Fields>;
  stddev_pop?: Maybe<Posts_Comments_Count_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Posts_Comments_Count_Stddev_Samp_Fields>;
  sum?: Maybe<Posts_Comments_Count_Sum_Fields>;
  var_pop?: Maybe<Posts_Comments_Count_Var_Pop_Fields>;
  var_samp?: Maybe<Posts_Comments_Count_Var_Samp_Fields>;
  variance?: Maybe<Posts_Comments_Count_Variance_Fields>;
};


/** aggregate fields of "posts_comments_count" */
export type Posts_Comments_Count_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Posts_Comments_Count_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Posts_Comments_Count_Avg_Fields = {
  __typename?: 'posts_comments_count_avg_fields';
  count?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "posts_comments_count". All fields are combined with a logical 'AND'. */
export type Posts_Comments_Count_Bool_Exp = {
  _and?: InputMaybe<Array<Posts_Comments_Count_Bool_Exp>>;
  _not?: InputMaybe<Posts_Comments_Count_Bool_Exp>;
  _or?: InputMaybe<Array<Posts_Comments_Count_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  post_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** input type for inserting data into table "posts_comments_count" */
export type Posts_Comments_Count_Insert_Input = {
  count?: InputMaybe<Scalars['bigint']['input']>;
  post_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Posts_Comments_Count_Max_Fields = {
  __typename?: 'posts_comments_count_max_fields';
  count?: Maybe<Scalars['bigint']['output']>;
  post_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Posts_Comments_Count_Min_Fields = {
  __typename?: 'posts_comments_count_min_fields';
  count?: Maybe<Scalars['bigint']['output']>;
  post_id?: Maybe<Scalars['bigint']['output']>;
};

/** input type for inserting object relation for remote table "posts_comments_count" */
export type Posts_Comments_Count_Obj_Rel_Insert_Input = {
  data: Posts_Comments_Count_Insert_Input;
};

/** Ordering options when selecting data from "posts_comments_count". */
export type Posts_Comments_Count_Order_By = {
  count?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
};

/** select columns of table "posts_comments_count" */
export enum Posts_Comments_Count_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  PostId = 'post_id'
}

/** aggregate stddev on columns */
export type Posts_Comments_Count_Stddev_Fields = {
  __typename?: 'posts_comments_count_stddev_fields';
  count?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Posts_Comments_Count_Stddev_Pop_Fields = {
  __typename?: 'posts_comments_count_stddev_pop_fields';
  count?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Posts_Comments_Count_Stddev_Samp_Fields = {
  __typename?: 'posts_comments_count_stddev_samp_fields';
  count?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "posts_comments_count" */
export type Posts_Comments_Count_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Posts_Comments_Count_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Posts_Comments_Count_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['bigint']['input']>;
  post_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Posts_Comments_Count_Sum_Fields = {
  __typename?: 'posts_comments_count_sum_fields';
  count?: Maybe<Scalars['bigint']['output']>;
  post_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Posts_Comments_Count_Var_Pop_Fields = {
  __typename?: 'posts_comments_count_var_pop_fields';
  count?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Posts_Comments_Count_Var_Samp_Fields = {
  __typename?: 'posts_comments_count_var_samp_fields';
  count?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Posts_Comments_Count_Variance_Fields = {
  __typename?: 'posts_comments_count_variance_fields';
  count?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
};

/** input type for incrementing numeric columns in table "posts_comments" */
export type Posts_Comments_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  parent_comment_id?: InputMaybe<Scalars['bigint']['input']>;
  post_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "posts_comments" */
export type Posts_Comments_Insert_Input = {
  children?: InputMaybe<Posts_Comments_Arr_Rel_Insert_Input>;
  comments_likes?: InputMaybe<Comments_Likes_Arr_Rel_Insert_Input>;
  comments_likes_count?: InputMaybe<Comments_Likes_Count_Obj_Rel_Insert_Input>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  parent_comment?: InputMaybe<Posts_Comments_Obj_Rel_Insert_Input>;
  parent_comment_id?: InputMaybe<Scalars['bigint']['input']>;
  post?: InputMaybe<Posts_Obj_Rel_Insert_Input>;
  post_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Posts_Comments_Max_Fields = {
  __typename?: 'posts_comments_max_fields';
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  parent_comment_id?: Maybe<Scalars['bigint']['output']>;
  post_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "posts_comments" */
export type Posts_Comments_Max_Order_By = {
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_comment_id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Posts_Comments_Min_Fields = {
  __typename?: 'posts_comments_min_fields';
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  parent_comment_id?: Maybe<Scalars['bigint']['output']>;
  post_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "posts_comments" */
export type Posts_Comments_Min_Order_By = {
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_comment_id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "posts_comments" */
export type Posts_Comments_Mutation_Response = {
  __typename?: 'posts_comments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Posts_Comments>;
};

/** input type for inserting object relation for remote table "posts_comments" */
export type Posts_Comments_Obj_Rel_Insert_Input = {
  data: Posts_Comments_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Posts_Comments_On_Conflict>;
};

/** on_conflict condition type for table "posts_comments" */
export type Posts_Comments_On_Conflict = {
  constraint: Posts_Comments_Constraint;
  update_columns?: Array<Posts_Comments_Update_Column>;
  where?: InputMaybe<Posts_Comments_Bool_Exp>;
};

/** Ordering options when selecting data from "posts_comments". */
export type Posts_Comments_Order_By = {
  children_aggregate?: InputMaybe<Posts_Comments_Aggregate_Order_By>;
  comments_likes_aggregate?: InputMaybe<Comments_Likes_Aggregate_Order_By>;
  comments_likes_count?: InputMaybe<Comments_Likes_Count_Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Users_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by?: InputMaybe<Users_Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_comment?: InputMaybe<Posts_Comments_Order_By>;
  parent_comment_id?: InputMaybe<Order_By>;
  post?: InputMaybe<Posts_Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Users_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: posts_comments */
export type Posts_Comments_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "posts_comments" */
export enum Posts_Comments_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  ParentCommentId = 'parent_comment_id',
  /** column name */
  PostId = 'post_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "posts_comments" */
export type Posts_Comments_Set_Input = {
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  parent_comment_id?: InputMaybe<Scalars['bigint']['input']>;
  post_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Posts_Comments_Stddev_Fields = {
  __typename?: 'posts_comments_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parent_comment_id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "posts_comments" */
export type Posts_Comments_Stddev_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_comment_id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Posts_Comments_Stddev_Pop_Fields = {
  __typename?: 'posts_comments_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parent_comment_id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "posts_comments" */
export type Posts_Comments_Stddev_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_comment_id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Posts_Comments_Stddev_Samp_Fields = {
  __typename?: 'posts_comments_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parent_comment_id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "posts_comments" */
export type Posts_Comments_Stddev_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_comment_id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "posts_comments" */
export type Posts_Comments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Posts_Comments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Posts_Comments_Stream_Cursor_Value_Input = {
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  parent_comment_id?: InputMaybe<Scalars['bigint']['input']>;
  post_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Posts_Comments_Sum_Fields = {
  __typename?: 'posts_comments_sum_fields';
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  parent_comment_id?: Maybe<Scalars['bigint']['output']>;
  post_id?: Maybe<Scalars['bigint']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "posts_comments" */
export type Posts_Comments_Sum_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_comment_id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "posts_comments" */
export enum Posts_Comments_Update_Column {
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  ParentCommentId = 'parent_comment_id',
  /** column name */
  PostId = 'post_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Posts_Comments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Posts_Comments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Posts_Comments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Posts_Comments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Posts_Comments_Var_Pop_Fields = {
  __typename?: 'posts_comments_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parent_comment_id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "posts_comments" */
export type Posts_Comments_Var_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_comment_id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Posts_Comments_Var_Samp_Fields = {
  __typename?: 'posts_comments_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parent_comment_id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "posts_comments" */
export type Posts_Comments_Var_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_comment_id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Posts_Comments_Variance_Fields = {
  __typename?: 'posts_comments_variance_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parent_comment_id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "posts_comments" */
export type Posts_Comments_Variance_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_comment_id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "posts" */
export enum Posts_Constraint {
  /** unique or primary key constraint on columns "id" */
  PostsPkey = 'posts_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Posts_Delete_At_Path_Input = {
  content_i18n?: InputMaybe<Array<Scalars['String']['input']>>;
  short_content_i18n?: InputMaybe<Array<Scalars['String']['input']>>;
  title_i18n?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Posts_Delete_Elem_Input = {
  content_i18n?: InputMaybe<Scalars['Int']['input']>;
  short_content_i18n?: InputMaybe<Scalars['Int']['input']>;
  title_i18n?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Posts_Delete_Key_Input = {
  content_i18n?: InputMaybe<Scalars['String']['input']>;
  short_content_i18n?: InputMaybe<Scalars['String']['input']>;
  title_i18n?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "posts" */
export type Posts_Inc_Input = {
  author_id?: InputMaybe<Scalars['bigint']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  total_views?: InputMaybe<Scalars['Int']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "posts" */
export type Posts_Insert_Input = {
  author?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  author_id?: InputMaybe<Scalars['bigint']['input']>;
  content_i18n?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_hot?: InputMaybe<Scalars['Boolean']['input']>;
  layout_id?: InputMaybe<Layout_Posts_Enum>;
  layout_post?: InputMaybe<Layout_Posts_Obj_Rel_Insert_Input>;
  location?: InputMaybe<Scalars['String']['input']>;
  pin_at?: InputMaybe<Scalars['timestamptz']['input']>;
  posts_categories?: InputMaybe<Posts_Categories_Arr_Rel_Insert_Input>;
  posts_comments?: InputMaybe<Posts_Comments_Arr_Rel_Insert_Input>;
  posts_comments_count?: InputMaybe<Posts_Comments_Count_Obj_Rel_Insert_Input>;
  posts_kpis?: InputMaybe<Posts_Kpis_Arr_Rel_Insert_Input>;
  posts_likes?: InputMaybe<Posts_Likes_Arr_Rel_Insert_Input>;
  posts_likes_count?: InputMaybe<Posts_Likes_Count_Obj_Rel_Insert_Input>;
  posts_sources?: InputMaybe<Posts_Sources_Arr_Rel_Insert_Input>;
  posts_tags?: InputMaybe<Posts_Tags_Arr_Rel_Insert_Input>;
  published_at?: InputMaybe<Scalars['timestamptz']['input']>;
  short_content_i18n?: InputMaybe<Scalars['jsonb']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title_i18n?: InputMaybe<Scalars['jsonb']['input']>;
  total_views?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** columns and relationships of "posts_kpis" */
export type Posts_Kpis = {
  __typename?: 'posts_kpis';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by?: Maybe<Users>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  deleted_by?: Maybe<Users>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  fee: Scalars['numeric']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  kpi?: Maybe<Kpis>;
  kpi_id?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  post?: Maybe<Posts>;
  post_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  updated_by?: Maybe<Users>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "posts_kpis" */
export type Posts_Kpis_Aggregate = {
  __typename?: 'posts_kpis_aggregate';
  aggregate?: Maybe<Posts_Kpis_Aggregate_Fields>;
  nodes: Array<Posts_Kpis>;
};

export type Posts_Kpis_Aggregate_Bool_Exp = {
  count?: InputMaybe<Posts_Kpis_Aggregate_Bool_Exp_Count>;
};

export type Posts_Kpis_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Posts_Kpis_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Posts_Kpis_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "posts_kpis" */
export type Posts_Kpis_Aggregate_Fields = {
  __typename?: 'posts_kpis_aggregate_fields';
  avg?: Maybe<Posts_Kpis_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Posts_Kpis_Max_Fields>;
  min?: Maybe<Posts_Kpis_Min_Fields>;
  stddev?: Maybe<Posts_Kpis_Stddev_Fields>;
  stddev_pop?: Maybe<Posts_Kpis_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Posts_Kpis_Stddev_Samp_Fields>;
  sum?: Maybe<Posts_Kpis_Sum_Fields>;
  var_pop?: Maybe<Posts_Kpis_Var_Pop_Fields>;
  var_samp?: Maybe<Posts_Kpis_Var_Samp_Fields>;
  variance?: Maybe<Posts_Kpis_Variance_Fields>;
};


/** aggregate fields of "posts_kpis" */
export type Posts_Kpis_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Posts_Kpis_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "posts_kpis" */
export type Posts_Kpis_Aggregate_Order_By = {
  avg?: InputMaybe<Posts_Kpis_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Posts_Kpis_Max_Order_By>;
  min?: InputMaybe<Posts_Kpis_Min_Order_By>;
  stddev?: InputMaybe<Posts_Kpis_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Posts_Kpis_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Posts_Kpis_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Posts_Kpis_Sum_Order_By>;
  var_pop?: InputMaybe<Posts_Kpis_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Posts_Kpis_Var_Samp_Order_By>;
  variance?: InputMaybe<Posts_Kpis_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "posts_kpis" */
export type Posts_Kpis_Arr_Rel_Insert_Input = {
  data: Array<Posts_Kpis_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Posts_Kpis_On_Conflict>;
};

/** aggregate avg on columns */
export type Posts_Kpis_Avg_Fields = {
  __typename?: 'posts_kpis_avg_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  fee?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  kpi_id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "posts_kpis" */
export type Posts_Kpis_Avg_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  fee?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kpi_id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "posts_kpis". All fields are combined with a logical 'AND'. */
export type Posts_Kpis_Bool_Exp = {
  _and?: InputMaybe<Array<Posts_Kpis_Bool_Exp>>;
  _not?: InputMaybe<Posts_Kpis_Bool_Exp>;
  _or?: InputMaybe<Array<Posts_Kpis_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Users_Bool_Exp>;
  created_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_by?: InputMaybe<Users_Bool_Exp>;
  deleted_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  fee?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  kpi?: InputMaybe<Kpis_Bool_Exp>;
  kpi_id?: InputMaybe<Bigint_Comparison_Exp>;
  post?: InputMaybe<Posts_Bool_Exp>;
  post_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Users_Bool_Exp>;
  updated_by_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "posts_kpis" */
export enum Posts_Kpis_Constraint {
  /** unique or primary key constraint on columns "id" */
  PostsKpisPkey = 'posts_kpis_pkey',
  /** unique or primary key constraint on columns "kpi_id", "post_id" */
  PostsKpisPostIdKpiIdKey = 'posts_kpis_post_id_kpi_id_key'
}

/** input type for incrementing numeric columns in table "posts_kpis" */
export type Posts_Kpis_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  fee?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  kpi_id?: InputMaybe<Scalars['bigint']['input']>;
  post_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "posts_kpis" */
export type Posts_Kpis_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  fee?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  kpi?: InputMaybe<Kpis_Obj_Rel_Insert_Input>;
  kpi_id?: InputMaybe<Scalars['bigint']['input']>;
  post?: InputMaybe<Posts_Obj_Rel_Insert_Input>;
  post_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Posts_Kpis_Max_Fields = {
  __typename?: 'posts_kpis_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  fee?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  kpi_id?: Maybe<Scalars['bigint']['output']>;
  post_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "posts_kpis" */
export type Posts_Kpis_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  fee?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kpi_id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Posts_Kpis_Min_Fields = {
  __typename?: 'posts_kpis_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  fee?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  kpi_id?: Maybe<Scalars['bigint']['output']>;
  post_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "posts_kpis" */
export type Posts_Kpis_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  fee?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kpi_id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "posts_kpis" */
export type Posts_Kpis_Mutation_Response = {
  __typename?: 'posts_kpis_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Posts_Kpis>;
};

/** on_conflict condition type for table "posts_kpis" */
export type Posts_Kpis_On_Conflict = {
  constraint: Posts_Kpis_Constraint;
  update_columns?: Array<Posts_Kpis_Update_Column>;
  where?: InputMaybe<Posts_Kpis_Bool_Exp>;
};

/** Ordering options when selecting data from "posts_kpis". */
export type Posts_Kpis_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Users_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by?: InputMaybe<Users_Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  fee?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kpi?: InputMaybe<Kpis_Order_By>;
  kpi_id?: InputMaybe<Order_By>;
  post?: InputMaybe<Posts_Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Users_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: posts_kpis */
export type Posts_Kpis_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "posts_kpis" */
export enum Posts_Kpis_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Fee = 'fee',
  /** column name */
  Id = 'id',
  /** column name */
  KpiId = 'kpi_id',
  /** column name */
  PostId = 'post_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "posts_kpis" */
export type Posts_Kpis_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  fee?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  kpi_id?: InputMaybe<Scalars['bigint']['input']>;
  post_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Posts_Kpis_Stddev_Fields = {
  __typename?: 'posts_kpis_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  fee?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  kpi_id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "posts_kpis" */
export type Posts_Kpis_Stddev_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  fee?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kpi_id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Posts_Kpis_Stddev_Pop_Fields = {
  __typename?: 'posts_kpis_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  fee?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  kpi_id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "posts_kpis" */
export type Posts_Kpis_Stddev_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  fee?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kpi_id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Posts_Kpis_Stddev_Samp_Fields = {
  __typename?: 'posts_kpis_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  fee?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  kpi_id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "posts_kpis" */
export type Posts_Kpis_Stddev_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  fee?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kpi_id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "posts_kpis" */
export type Posts_Kpis_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Posts_Kpis_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Posts_Kpis_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  fee?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  kpi_id?: InputMaybe<Scalars['bigint']['input']>;
  post_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Posts_Kpis_Sum_Fields = {
  __typename?: 'posts_kpis_sum_fields';
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  fee?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  kpi_id?: Maybe<Scalars['bigint']['output']>;
  post_id?: Maybe<Scalars['bigint']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "posts_kpis" */
export type Posts_Kpis_Sum_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  fee?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kpi_id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "posts_kpis" */
export enum Posts_Kpis_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Fee = 'fee',
  /** column name */
  Id = 'id',
  /** column name */
  KpiId = 'kpi_id',
  /** column name */
  PostId = 'post_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Posts_Kpis_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Posts_Kpis_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Posts_Kpis_Set_Input>;
  /** filter the rows which have to be updated */
  where: Posts_Kpis_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Posts_Kpis_Var_Pop_Fields = {
  __typename?: 'posts_kpis_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  fee?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  kpi_id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "posts_kpis" */
export type Posts_Kpis_Var_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  fee?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kpi_id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Posts_Kpis_Var_Samp_Fields = {
  __typename?: 'posts_kpis_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  fee?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  kpi_id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "posts_kpis" */
export type Posts_Kpis_Var_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  fee?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kpi_id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Posts_Kpis_Variance_Fields = {
  __typename?: 'posts_kpis_variance_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  fee?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  kpi_id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "posts_kpis" */
export type Posts_Kpis_Variance_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  fee?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kpi_id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "posts_likes" */
export type Posts_Likes = {
  __typename?: 'posts_likes';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by?: Maybe<Users>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['bigint']['output'];
  /** An object relationship */
  post: Posts;
  post_id: Scalars['bigint']['output'];
};

/** aggregated selection of "posts_likes" */
export type Posts_Likes_Aggregate = {
  __typename?: 'posts_likes_aggregate';
  aggregate?: Maybe<Posts_Likes_Aggregate_Fields>;
  nodes: Array<Posts_Likes>;
};

export type Posts_Likes_Aggregate_Bool_Exp = {
  count?: InputMaybe<Posts_Likes_Aggregate_Bool_Exp_Count>;
};

export type Posts_Likes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Posts_Likes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Posts_Likes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "posts_likes" */
export type Posts_Likes_Aggregate_Fields = {
  __typename?: 'posts_likes_aggregate_fields';
  avg?: Maybe<Posts_Likes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Posts_Likes_Max_Fields>;
  min?: Maybe<Posts_Likes_Min_Fields>;
  stddev?: Maybe<Posts_Likes_Stddev_Fields>;
  stddev_pop?: Maybe<Posts_Likes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Posts_Likes_Stddev_Samp_Fields>;
  sum?: Maybe<Posts_Likes_Sum_Fields>;
  var_pop?: Maybe<Posts_Likes_Var_Pop_Fields>;
  var_samp?: Maybe<Posts_Likes_Var_Samp_Fields>;
  variance?: Maybe<Posts_Likes_Variance_Fields>;
};


/** aggregate fields of "posts_likes" */
export type Posts_Likes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Posts_Likes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "posts_likes" */
export type Posts_Likes_Aggregate_Order_By = {
  avg?: InputMaybe<Posts_Likes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Posts_Likes_Max_Order_By>;
  min?: InputMaybe<Posts_Likes_Min_Order_By>;
  stddev?: InputMaybe<Posts_Likes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Posts_Likes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Posts_Likes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Posts_Likes_Sum_Order_By>;
  var_pop?: InputMaybe<Posts_Likes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Posts_Likes_Var_Samp_Order_By>;
  variance?: InputMaybe<Posts_Likes_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "posts_likes" */
export type Posts_Likes_Arr_Rel_Insert_Input = {
  data: Array<Posts_Likes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Posts_Likes_On_Conflict>;
};

/** aggregate avg on columns */
export type Posts_Likes_Avg_Fields = {
  __typename?: 'posts_likes_avg_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "posts_likes" */
export type Posts_Likes_Avg_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "posts_likes". All fields are combined with a logical 'AND'. */
export type Posts_Likes_Bool_Exp = {
  _and?: InputMaybe<Array<Posts_Likes_Bool_Exp>>;
  _not?: InputMaybe<Posts_Likes_Bool_Exp>;
  _or?: InputMaybe<Array<Posts_Likes_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Users_Bool_Exp>;
  created_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  post?: InputMaybe<Posts_Bool_Exp>;
  post_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "posts_likes" */
export enum Posts_Likes_Constraint {
  /** unique or primary key constraint on columns "id" */
  PostsLikesPkey = 'posts_likes_pkey',
  /** unique or primary key constraint on columns "post_id", "created_by_id" */
  PostsLikesPostIdCreatedByIdKey = 'posts_likes_post_id_created_by_id_key'
}

/** columns and relationships of "posts_likes_count" */
export type Posts_Likes_Count = {
  __typename?: 'posts_likes_count';
  count?: Maybe<Scalars['bigint']['output']>;
  post_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "posts_likes_count" */
export type Posts_Likes_Count_Aggregate = {
  __typename?: 'posts_likes_count_aggregate';
  aggregate?: Maybe<Posts_Likes_Count_Aggregate_Fields>;
  nodes: Array<Posts_Likes_Count>;
};

/** aggregate fields of "posts_likes_count" */
export type Posts_Likes_Count_Aggregate_Fields = {
  __typename?: 'posts_likes_count_aggregate_fields';
  avg?: Maybe<Posts_Likes_Count_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Posts_Likes_Count_Max_Fields>;
  min?: Maybe<Posts_Likes_Count_Min_Fields>;
  stddev?: Maybe<Posts_Likes_Count_Stddev_Fields>;
  stddev_pop?: Maybe<Posts_Likes_Count_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Posts_Likes_Count_Stddev_Samp_Fields>;
  sum?: Maybe<Posts_Likes_Count_Sum_Fields>;
  var_pop?: Maybe<Posts_Likes_Count_Var_Pop_Fields>;
  var_samp?: Maybe<Posts_Likes_Count_Var_Samp_Fields>;
  variance?: Maybe<Posts_Likes_Count_Variance_Fields>;
};


/** aggregate fields of "posts_likes_count" */
export type Posts_Likes_Count_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Posts_Likes_Count_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Posts_Likes_Count_Avg_Fields = {
  __typename?: 'posts_likes_count_avg_fields';
  count?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "posts_likes_count". All fields are combined with a logical 'AND'. */
export type Posts_Likes_Count_Bool_Exp = {
  _and?: InputMaybe<Array<Posts_Likes_Count_Bool_Exp>>;
  _not?: InputMaybe<Posts_Likes_Count_Bool_Exp>;
  _or?: InputMaybe<Array<Posts_Likes_Count_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  post_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** input type for inserting data into table "posts_likes_count" */
export type Posts_Likes_Count_Insert_Input = {
  count?: InputMaybe<Scalars['bigint']['input']>;
  post_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Posts_Likes_Count_Max_Fields = {
  __typename?: 'posts_likes_count_max_fields';
  count?: Maybe<Scalars['bigint']['output']>;
  post_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Posts_Likes_Count_Min_Fields = {
  __typename?: 'posts_likes_count_min_fields';
  count?: Maybe<Scalars['bigint']['output']>;
  post_id?: Maybe<Scalars['bigint']['output']>;
};

/** input type for inserting object relation for remote table "posts_likes_count" */
export type Posts_Likes_Count_Obj_Rel_Insert_Input = {
  data: Posts_Likes_Count_Insert_Input;
};

/** Ordering options when selecting data from "posts_likes_count". */
export type Posts_Likes_Count_Order_By = {
  count?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
};

/** select columns of table "posts_likes_count" */
export enum Posts_Likes_Count_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  PostId = 'post_id'
}

/** aggregate stddev on columns */
export type Posts_Likes_Count_Stddev_Fields = {
  __typename?: 'posts_likes_count_stddev_fields';
  count?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Posts_Likes_Count_Stddev_Pop_Fields = {
  __typename?: 'posts_likes_count_stddev_pop_fields';
  count?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Posts_Likes_Count_Stddev_Samp_Fields = {
  __typename?: 'posts_likes_count_stddev_samp_fields';
  count?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "posts_likes_count" */
export type Posts_Likes_Count_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Posts_Likes_Count_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Posts_Likes_Count_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['bigint']['input']>;
  post_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Posts_Likes_Count_Sum_Fields = {
  __typename?: 'posts_likes_count_sum_fields';
  count?: Maybe<Scalars['bigint']['output']>;
  post_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Posts_Likes_Count_Var_Pop_Fields = {
  __typename?: 'posts_likes_count_var_pop_fields';
  count?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Posts_Likes_Count_Var_Samp_Fields = {
  __typename?: 'posts_likes_count_var_samp_fields';
  count?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Posts_Likes_Count_Variance_Fields = {
  __typename?: 'posts_likes_count_variance_fields';
  count?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
};

/** input type for incrementing numeric columns in table "posts_likes" */
export type Posts_Likes_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  post_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "posts_likes" */
export type Posts_Likes_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  post?: InputMaybe<Posts_Obj_Rel_Insert_Input>;
  post_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Posts_Likes_Max_Fields = {
  __typename?: 'posts_likes_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  post_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "posts_likes" */
export type Posts_Likes_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Posts_Likes_Min_Fields = {
  __typename?: 'posts_likes_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  post_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "posts_likes" */
export type Posts_Likes_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "posts_likes" */
export type Posts_Likes_Mutation_Response = {
  __typename?: 'posts_likes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Posts_Likes>;
};

/** on_conflict condition type for table "posts_likes" */
export type Posts_Likes_On_Conflict = {
  constraint: Posts_Likes_Constraint;
  update_columns?: Array<Posts_Likes_Update_Column>;
  where?: InputMaybe<Posts_Likes_Bool_Exp>;
};

/** Ordering options when selecting data from "posts_likes". */
export type Posts_Likes_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Users_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post?: InputMaybe<Posts_Order_By>;
  post_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: posts_likes */
export type Posts_Likes_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "posts_likes" */
export enum Posts_Likes_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  PostId = 'post_id'
}

/** input type for updating data in table "posts_likes" */
export type Posts_Likes_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  post_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Posts_Likes_Stddev_Fields = {
  __typename?: 'posts_likes_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "posts_likes" */
export type Posts_Likes_Stddev_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Posts_Likes_Stddev_Pop_Fields = {
  __typename?: 'posts_likes_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "posts_likes" */
export type Posts_Likes_Stddev_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Posts_Likes_Stddev_Samp_Fields = {
  __typename?: 'posts_likes_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "posts_likes" */
export type Posts_Likes_Stddev_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "posts_likes" */
export type Posts_Likes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Posts_Likes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Posts_Likes_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  post_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Posts_Likes_Sum_Fields = {
  __typename?: 'posts_likes_sum_fields';
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  post_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "posts_likes" */
export type Posts_Likes_Sum_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
};

/** update columns of table "posts_likes" */
export enum Posts_Likes_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  PostId = 'post_id'
}

export type Posts_Likes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Posts_Likes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Posts_Likes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Posts_Likes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Posts_Likes_Var_Pop_Fields = {
  __typename?: 'posts_likes_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "posts_likes" */
export type Posts_Likes_Var_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Posts_Likes_Var_Samp_Fields = {
  __typename?: 'posts_likes_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "posts_likes" */
export type Posts_Likes_Var_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Posts_Likes_Variance_Fields = {
  __typename?: 'posts_likes_variance_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "posts_likes" */
export type Posts_Likes_Variance_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Posts_Max_Fields = {
  __typename?: 'posts_max_fields';
  author_id?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "get_post_content_i18n" */
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  pin_at?: Maybe<Scalars['timestamptz']['output']>;
  published_at?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "get_post_short_content_i18n" */
  short_content?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "get_post_title_i18n" */
  title?: Maybe<Scalars['String']['output']>;
  total_views?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "posts" */
export type Posts_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  pin_at?: InputMaybe<Order_By>;
  published_at?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  total_views?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Posts_Min_Fields = {
  __typename?: 'posts_min_fields';
  author_id?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "get_post_content_i18n" */
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  pin_at?: Maybe<Scalars['timestamptz']['output']>;
  published_at?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "get_post_short_content_i18n" */
  short_content?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "get_post_title_i18n" */
  title?: Maybe<Scalars['String']['output']>;
  total_views?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "posts" */
export type Posts_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  pin_at?: InputMaybe<Order_By>;
  published_at?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  total_views?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "posts" */
export type Posts_Mutation_Response = {
  __typename?: 'posts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Posts>;
};

/** input type for inserting object relation for remote table "posts" */
export type Posts_Obj_Rel_Insert_Input = {
  data: Posts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Posts_On_Conflict>;
};

/** on_conflict condition type for table "posts" */
export type Posts_On_Conflict = {
  constraint: Posts_Constraint;
  update_columns?: Array<Posts_Update_Column>;
  where?: InputMaybe<Posts_Bool_Exp>;
};

/** Ordering options when selecting data from "posts". */
export type Posts_Order_By = {
  author?: InputMaybe<Users_Order_By>;
  author_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  content_i18n?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Users_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by?: InputMaybe<Users_Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Images_Aggregate_Order_By>;
  is_hot?: InputMaybe<Order_By>;
  layout_id?: InputMaybe<Order_By>;
  layout_post?: InputMaybe<Layout_Posts_Order_By>;
  location?: InputMaybe<Order_By>;
  pin_at?: InputMaybe<Order_By>;
  posts_categories_aggregate?: InputMaybe<Posts_Categories_Aggregate_Order_By>;
  posts_comments_aggregate?: InputMaybe<Posts_Comments_Aggregate_Order_By>;
  posts_comments_count?: InputMaybe<Posts_Comments_Count_Order_By>;
  posts_kpis_aggregate?: InputMaybe<Posts_Kpis_Aggregate_Order_By>;
  posts_likes_aggregate?: InputMaybe<Posts_Likes_Aggregate_Order_By>;
  posts_likes_count?: InputMaybe<Posts_Likes_Count_Order_By>;
  posts_sources_aggregate?: InputMaybe<Posts_Sources_Aggregate_Order_By>;
  posts_tags_aggregate?: InputMaybe<Posts_Tags_Aggregate_Order_By>;
  published_at?: InputMaybe<Order_By>;
  short_content?: InputMaybe<Order_By>;
  short_content_i18n?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  thumbnail_aggregate?: InputMaybe<Images_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
  title_i18n?: InputMaybe<Order_By>;
  total_views?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Users_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: posts */
export type Posts_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Posts_Prepend_Input = {
  content_i18n?: InputMaybe<Scalars['jsonb']['input']>;
  short_content_i18n?: InputMaybe<Scalars['jsonb']['input']>;
  title_i18n?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "posts" */
export enum Posts_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  ContentI18n = 'content_i18n',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsHot = 'is_hot',
  /** column name */
  LayoutId = 'layout_id',
  /** column name */
  Location = 'location',
  /** column name */
  PinAt = 'pin_at',
  /** column name */
  PublishedAt = 'published_at',
  /** column name */
  ShortContentI18n = 'short_content_i18n',
  /** column name */
  Slug = 'slug',
  /** column name */
  TitleI18n = 'title_i18n',
  /** column name */
  TotalViews = 'total_views',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "posts_aggregate_bool_exp_bool_and_arguments_columns" columns of table "posts" */
export enum Posts_Select_Column_Posts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsHot = 'is_hot'
}

/** select "posts_aggregate_bool_exp_bool_or_arguments_columns" columns of table "posts" */
export enum Posts_Select_Column_Posts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsHot = 'is_hot'
}

/** input type for updating data in table "posts" */
export type Posts_Set_Input = {
  author_id?: InputMaybe<Scalars['bigint']['input']>;
  content_i18n?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_hot?: InputMaybe<Scalars['Boolean']['input']>;
  layout_id?: InputMaybe<Layout_Posts_Enum>;
  location?: InputMaybe<Scalars['String']['input']>;
  pin_at?: InputMaybe<Scalars['timestamptz']['input']>;
  published_at?: InputMaybe<Scalars['timestamptz']['input']>;
  short_content_i18n?: InputMaybe<Scalars['jsonb']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title_i18n?: InputMaybe<Scalars['jsonb']['input']>;
  total_views?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** columns and relationships of "posts_sources" */
export type Posts_Sources = {
  __typename?: 'posts_sources';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by?: Maybe<Users>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  deleted_by?: Maybe<Users>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['bigint']['output'];
  /** An object relationship */
  post?: Maybe<Posts>;
  post_id?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  source?: Maybe<Sources>;
  source_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  updated_by?: Maybe<Users>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "posts_sources" */
export type Posts_Sources_Aggregate = {
  __typename?: 'posts_sources_aggregate';
  aggregate?: Maybe<Posts_Sources_Aggregate_Fields>;
  nodes: Array<Posts_Sources>;
};

export type Posts_Sources_Aggregate_Bool_Exp = {
  count?: InputMaybe<Posts_Sources_Aggregate_Bool_Exp_Count>;
};

export type Posts_Sources_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Posts_Sources_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Posts_Sources_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "posts_sources" */
export type Posts_Sources_Aggregate_Fields = {
  __typename?: 'posts_sources_aggregate_fields';
  avg?: Maybe<Posts_Sources_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Posts_Sources_Max_Fields>;
  min?: Maybe<Posts_Sources_Min_Fields>;
  stddev?: Maybe<Posts_Sources_Stddev_Fields>;
  stddev_pop?: Maybe<Posts_Sources_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Posts_Sources_Stddev_Samp_Fields>;
  sum?: Maybe<Posts_Sources_Sum_Fields>;
  var_pop?: Maybe<Posts_Sources_Var_Pop_Fields>;
  var_samp?: Maybe<Posts_Sources_Var_Samp_Fields>;
  variance?: Maybe<Posts_Sources_Variance_Fields>;
};


/** aggregate fields of "posts_sources" */
export type Posts_Sources_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Posts_Sources_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "posts_sources" */
export type Posts_Sources_Aggregate_Order_By = {
  avg?: InputMaybe<Posts_Sources_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Posts_Sources_Max_Order_By>;
  min?: InputMaybe<Posts_Sources_Min_Order_By>;
  stddev?: InputMaybe<Posts_Sources_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Posts_Sources_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Posts_Sources_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Posts_Sources_Sum_Order_By>;
  var_pop?: InputMaybe<Posts_Sources_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Posts_Sources_Var_Samp_Order_By>;
  variance?: InputMaybe<Posts_Sources_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "posts_sources" */
export type Posts_Sources_Arr_Rel_Insert_Input = {
  data: Array<Posts_Sources_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Posts_Sources_On_Conflict>;
};

/** aggregate avg on columns */
export type Posts_Sources_Avg_Fields = {
  __typename?: 'posts_sources_avg_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  source_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "posts_sources" */
export type Posts_Sources_Avg_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  source_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "posts_sources". All fields are combined with a logical 'AND'. */
export type Posts_Sources_Bool_Exp = {
  _and?: InputMaybe<Array<Posts_Sources_Bool_Exp>>;
  _not?: InputMaybe<Posts_Sources_Bool_Exp>;
  _or?: InputMaybe<Array<Posts_Sources_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Users_Bool_Exp>;
  created_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_by?: InputMaybe<Users_Bool_Exp>;
  deleted_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  post?: InputMaybe<Posts_Bool_Exp>;
  post_id?: InputMaybe<Bigint_Comparison_Exp>;
  source?: InputMaybe<Sources_Bool_Exp>;
  source_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Users_Bool_Exp>;
  updated_by_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "posts_sources" */
export enum Posts_Sources_Constraint {
  /** unique or primary key constraint on columns "id" */
  PostsSourcesPkey = 'posts_sources_pkey'
}

/** input type for incrementing numeric columns in table "posts_sources" */
export type Posts_Sources_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  post_id?: InputMaybe<Scalars['bigint']['input']>;
  source_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "posts_sources" */
export type Posts_Sources_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  post?: InputMaybe<Posts_Obj_Rel_Insert_Input>;
  post_id?: InputMaybe<Scalars['bigint']['input']>;
  source?: InputMaybe<Sources_Obj_Rel_Insert_Input>;
  source_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Posts_Sources_Max_Fields = {
  __typename?: 'posts_sources_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  post_id?: Maybe<Scalars['bigint']['output']>;
  source_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "posts_sources" */
export type Posts_Sources_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  source_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Posts_Sources_Min_Fields = {
  __typename?: 'posts_sources_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  post_id?: Maybe<Scalars['bigint']['output']>;
  source_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "posts_sources" */
export type Posts_Sources_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  source_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "posts_sources" */
export type Posts_Sources_Mutation_Response = {
  __typename?: 'posts_sources_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Posts_Sources>;
};

/** on_conflict condition type for table "posts_sources" */
export type Posts_Sources_On_Conflict = {
  constraint: Posts_Sources_Constraint;
  update_columns?: Array<Posts_Sources_Update_Column>;
  where?: InputMaybe<Posts_Sources_Bool_Exp>;
};

/** Ordering options when selecting data from "posts_sources". */
export type Posts_Sources_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Users_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by?: InputMaybe<Users_Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post?: InputMaybe<Posts_Order_By>;
  post_id?: InputMaybe<Order_By>;
  source?: InputMaybe<Sources_Order_By>;
  source_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Users_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: posts_sources */
export type Posts_Sources_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "posts_sources" */
export enum Posts_Sources_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  PostId = 'post_id',
  /** column name */
  SourceId = 'source_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "posts_sources" */
export type Posts_Sources_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  post_id?: InputMaybe<Scalars['bigint']['input']>;
  source_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Posts_Sources_Stddev_Fields = {
  __typename?: 'posts_sources_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  source_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "posts_sources" */
export type Posts_Sources_Stddev_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  source_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Posts_Sources_Stddev_Pop_Fields = {
  __typename?: 'posts_sources_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  source_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "posts_sources" */
export type Posts_Sources_Stddev_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  source_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Posts_Sources_Stddev_Samp_Fields = {
  __typename?: 'posts_sources_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  source_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "posts_sources" */
export type Posts_Sources_Stddev_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  source_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "posts_sources" */
export type Posts_Sources_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Posts_Sources_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Posts_Sources_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  post_id?: InputMaybe<Scalars['bigint']['input']>;
  source_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Posts_Sources_Sum_Fields = {
  __typename?: 'posts_sources_sum_fields';
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  post_id?: Maybe<Scalars['bigint']['output']>;
  source_id?: Maybe<Scalars['bigint']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "posts_sources" */
export type Posts_Sources_Sum_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  source_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "posts_sources" */
export enum Posts_Sources_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  PostId = 'post_id',
  /** column name */
  SourceId = 'source_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Posts_Sources_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Posts_Sources_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Posts_Sources_Set_Input>;
  /** filter the rows which have to be updated */
  where: Posts_Sources_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Posts_Sources_Var_Pop_Fields = {
  __typename?: 'posts_sources_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  source_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "posts_sources" */
export type Posts_Sources_Var_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  source_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Posts_Sources_Var_Samp_Fields = {
  __typename?: 'posts_sources_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  source_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "posts_sources" */
export type Posts_Sources_Var_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  source_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Posts_Sources_Variance_Fields = {
  __typename?: 'posts_sources_variance_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  source_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "posts_sources" */
export type Posts_Sources_Variance_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  source_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev on columns */
export type Posts_Stddev_Fields = {
  __typename?: 'posts_stddev_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  total_views?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "posts" */
export type Posts_Stddev_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  total_views?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Posts_Stddev_Pop_Fields = {
  __typename?: 'posts_stddev_pop_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  total_views?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "posts" */
export type Posts_Stddev_Pop_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  total_views?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Posts_Stddev_Samp_Fields = {
  __typename?: 'posts_stddev_samp_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  total_views?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "posts" */
export type Posts_Stddev_Samp_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  total_views?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "posts" */
export type Posts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Posts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Posts_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['bigint']['input']>;
  content_i18n?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_hot?: InputMaybe<Scalars['Boolean']['input']>;
  layout_id?: InputMaybe<Layout_Posts_Enum>;
  location?: InputMaybe<Scalars['String']['input']>;
  pin_at?: InputMaybe<Scalars['timestamptz']['input']>;
  published_at?: InputMaybe<Scalars['timestamptz']['input']>;
  short_content_i18n?: InputMaybe<Scalars['jsonb']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title_i18n?: InputMaybe<Scalars['jsonb']['input']>;
  total_views?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Posts_Sum_Fields = {
  __typename?: 'posts_sum_fields';
  author_id?: Maybe<Scalars['bigint']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  total_views?: Maybe<Scalars['Int']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "posts" */
export type Posts_Sum_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  total_views?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "posts_tags" */
export type Posts_Tags = {
  __typename?: 'posts_tags';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by?: Maybe<Users>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  deleted_by?: Maybe<Users>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['bigint']['output'];
  /** An object relationship */
  post?: Maybe<Posts>;
  post_id?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  tag?: Maybe<Tags>;
  tag_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  updated_by?: Maybe<Users>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "posts_tags" */
export type Posts_Tags_Aggregate = {
  __typename?: 'posts_tags_aggregate';
  aggregate?: Maybe<Posts_Tags_Aggregate_Fields>;
  nodes: Array<Posts_Tags>;
};

export type Posts_Tags_Aggregate_Bool_Exp = {
  count?: InputMaybe<Posts_Tags_Aggregate_Bool_Exp_Count>;
};

export type Posts_Tags_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Posts_Tags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Posts_Tags_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "posts_tags" */
export type Posts_Tags_Aggregate_Fields = {
  __typename?: 'posts_tags_aggregate_fields';
  avg?: Maybe<Posts_Tags_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Posts_Tags_Max_Fields>;
  min?: Maybe<Posts_Tags_Min_Fields>;
  stddev?: Maybe<Posts_Tags_Stddev_Fields>;
  stddev_pop?: Maybe<Posts_Tags_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Posts_Tags_Stddev_Samp_Fields>;
  sum?: Maybe<Posts_Tags_Sum_Fields>;
  var_pop?: Maybe<Posts_Tags_Var_Pop_Fields>;
  var_samp?: Maybe<Posts_Tags_Var_Samp_Fields>;
  variance?: Maybe<Posts_Tags_Variance_Fields>;
};


/** aggregate fields of "posts_tags" */
export type Posts_Tags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Posts_Tags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "posts_tags" */
export type Posts_Tags_Aggregate_Order_By = {
  avg?: InputMaybe<Posts_Tags_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Posts_Tags_Max_Order_By>;
  min?: InputMaybe<Posts_Tags_Min_Order_By>;
  stddev?: InputMaybe<Posts_Tags_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Posts_Tags_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Posts_Tags_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Posts_Tags_Sum_Order_By>;
  var_pop?: InputMaybe<Posts_Tags_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Posts_Tags_Var_Samp_Order_By>;
  variance?: InputMaybe<Posts_Tags_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "posts_tags" */
export type Posts_Tags_Arr_Rel_Insert_Input = {
  data: Array<Posts_Tags_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Posts_Tags_On_Conflict>;
};

/** aggregate avg on columns */
export type Posts_Tags_Avg_Fields = {
  __typename?: 'posts_tags_avg_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  tag_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "posts_tags" */
export type Posts_Tags_Avg_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "posts_tags". All fields are combined with a logical 'AND'. */
export type Posts_Tags_Bool_Exp = {
  _and?: InputMaybe<Array<Posts_Tags_Bool_Exp>>;
  _not?: InputMaybe<Posts_Tags_Bool_Exp>;
  _or?: InputMaybe<Array<Posts_Tags_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Users_Bool_Exp>;
  created_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_by?: InputMaybe<Users_Bool_Exp>;
  deleted_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  post?: InputMaybe<Posts_Bool_Exp>;
  post_id?: InputMaybe<Bigint_Comparison_Exp>;
  tag?: InputMaybe<Tags_Bool_Exp>;
  tag_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Users_Bool_Exp>;
  updated_by_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "posts_tags" */
export enum Posts_Tags_Constraint {
  /** unique or primary key constraint on columns "id" */
  PostsTagsPkey = 'posts_tags_pkey'
}

/** input type for incrementing numeric columns in table "posts_tags" */
export type Posts_Tags_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  post_id?: InputMaybe<Scalars['bigint']['input']>;
  tag_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "posts_tags" */
export type Posts_Tags_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  post?: InputMaybe<Posts_Obj_Rel_Insert_Input>;
  post_id?: InputMaybe<Scalars['bigint']['input']>;
  tag?: InputMaybe<Tags_Obj_Rel_Insert_Input>;
  tag_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Posts_Tags_Max_Fields = {
  __typename?: 'posts_tags_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  post_id?: Maybe<Scalars['bigint']['output']>;
  tag_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "posts_tags" */
export type Posts_Tags_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Posts_Tags_Min_Fields = {
  __typename?: 'posts_tags_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  post_id?: Maybe<Scalars['bigint']['output']>;
  tag_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "posts_tags" */
export type Posts_Tags_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "posts_tags" */
export type Posts_Tags_Mutation_Response = {
  __typename?: 'posts_tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Posts_Tags>;
};

/** on_conflict condition type for table "posts_tags" */
export type Posts_Tags_On_Conflict = {
  constraint: Posts_Tags_Constraint;
  update_columns?: Array<Posts_Tags_Update_Column>;
  where?: InputMaybe<Posts_Tags_Bool_Exp>;
};

/** Ordering options when selecting data from "posts_tags". */
export type Posts_Tags_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Users_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by?: InputMaybe<Users_Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post?: InputMaybe<Posts_Order_By>;
  post_id?: InputMaybe<Order_By>;
  tag?: InputMaybe<Tags_Order_By>;
  tag_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Users_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: posts_tags */
export type Posts_Tags_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "posts_tags" */
export enum Posts_Tags_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  PostId = 'post_id',
  /** column name */
  TagId = 'tag_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "posts_tags" */
export type Posts_Tags_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  post_id?: InputMaybe<Scalars['bigint']['input']>;
  tag_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Posts_Tags_Stddev_Fields = {
  __typename?: 'posts_tags_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  tag_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "posts_tags" */
export type Posts_Tags_Stddev_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Posts_Tags_Stddev_Pop_Fields = {
  __typename?: 'posts_tags_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  tag_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "posts_tags" */
export type Posts_Tags_Stddev_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Posts_Tags_Stddev_Samp_Fields = {
  __typename?: 'posts_tags_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  tag_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "posts_tags" */
export type Posts_Tags_Stddev_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "posts_tags" */
export type Posts_Tags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Posts_Tags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Posts_Tags_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  post_id?: InputMaybe<Scalars['bigint']['input']>;
  tag_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Posts_Tags_Sum_Fields = {
  __typename?: 'posts_tags_sum_fields';
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  post_id?: Maybe<Scalars['bigint']['output']>;
  tag_id?: Maybe<Scalars['bigint']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "posts_tags" */
export type Posts_Tags_Sum_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "posts_tags" */
export enum Posts_Tags_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  PostId = 'post_id',
  /** column name */
  TagId = 'tag_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Posts_Tags_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Posts_Tags_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Posts_Tags_Set_Input>;
  /** filter the rows which have to be updated */
  where: Posts_Tags_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Posts_Tags_Var_Pop_Fields = {
  __typename?: 'posts_tags_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  tag_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "posts_tags" */
export type Posts_Tags_Var_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Posts_Tags_Var_Samp_Fields = {
  __typename?: 'posts_tags_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  tag_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "posts_tags" */
export type Posts_Tags_Var_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Posts_Tags_Variance_Fields = {
  __typename?: 'posts_tags_variance_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  tag_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "posts_tags" */
export type Posts_Tags_Variance_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "posts" */
export enum Posts_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  ContentI18n = 'content_i18n',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsHot = 'is_hot',
  /** column name */
  LayoutId = 'layout_id',
  /** column name */
  Location = 'location',
  /** column name */
  PinAt = 'pin_at',
  /** column name */
  PublishedAt = 'published_at',
  /** column name */
  ShortContentI18n = 'short_content_i18n',
  /** column name */
  Slug = 'slug',
  /** column name */
  TitleI18n = 'title_i18n',
  /** column name */
  TotalViews = 'total_views',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Posts_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Posts_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Posts_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Posts_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Posts_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Posts_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Posts_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Posts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Posts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Posts_Var_Pop_Fields = {
  __typename?: 'posts_var_pop_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  total_views?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "posts" */
export type Posts_Var_Pop_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  total_views?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Posts_Var_Samp_Fields = {
  __typename?: 'posts_var_samp_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  total_views?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "posts" */
export type Posts_Var_Samp_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  total_views?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Posts_Variance_Fields = {
  __typename?: 'posts_variance_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  total_views?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "posts" */
export type Posts_Variance_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  total_views?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "advertisement_types" */
  advertisement_types: Array<Advertisement_Types>;
  /** fetch aggregated fields from the table: "advertisement_types" */
  advertisement_types_aggregate: Advertisement_Types_Aggregate;
  /** fetch data from the table: "advertisement_types" using primary key columns */
  advertisement_types_by_pk?: Maybe<Advertisement_Types>;
  /** fetch data from the table: "advertisements" */
  advertisements: Array<Advertisements>;
  /** fetch aggregated fields from the table: "advertisements" */
  advertisements_aggregate: Advertisements_Aggregate;
  /** fetch data from the table: "advertisements" using primary key columns */
  advertisements_by_pk?: Maybe<Advertisements>;
  /** An array relationship */
  banners: Array<Banners>;
  /** An aggregate relationship */
  banners_aggregate: Banners_Aggregate;
  /** fetch data from the table: "banners" using primary key columns */
  banners_by_pk?: Maybe<Banners>;
  /** An array relationship */
  banners_categories: Array<Banners_Categories>;
  /** An aggregate relationship */
  banners_categories_aggregate: Banners_Categories_Aggregate;
  /** fetch data from the table: "banners_categories" using primary key columns */
  banners_categories_by_pk?: Maybe<Banners_Categories>;
  /** An array relationship */
  categories: Array<Categories>;
  /** An aggregate relationship */
  categories_aggregate: Categories_Aggregate;
  /** fetch data from the table: "categories" using primary key columns */
  categories_by_pk?: Maybe<Categories>;
  /** fetch data from the table: "categories_full_slug" */
  categories_full_slug: Array<Categories_Full_Slug>;
  /** fetch aggregated fields from the table: "categories_full_slug" */
  categories_full_slug_aggregate: Categories_Full_Slug_Aggregate;
  /** fetch data from the table: "category_kpis" */
  category_kpis: Array<Category_Kpis>;
  /** fetch aggregated fields from the table: "category_kpis" */
  category_kpis_aggregate: Category_Kpis_Aggregate;
  /** fetch data from the table: "category_kpis" using primary key columns */
  category_kpis_by_pk?: Maybe<Category_Kpis>;
  /** An array relationship */
  comments_likes: Array<Comments_Likes>;
  /** An aggregate relationship */
  comments_likes_aggregate: Comments_Likes_Aggregate;
  /** fetch data from the table: "comments_likes" using primary key columns */
  comments_likes_by_pk?: Maybe<Comments_Likes>;
  /** fetch data from the table: "comments_likes_count" */
  comments_likes_count: Array<Comments_Likes_Count>;
  /** fetch aggregated fields from the table: "comments_likes_count" */
  comments_likes_count_aggregate: Comments_Likes_Count_Aggregate;
  /** fetch data from the table: "genders" */
  genders: Array<Genders>;
  /** fetch aggregated fields from the table: "genders" */
  genders_aggregate: Genders_Aggregate;
  /** fetch data from the table: "genders" using primary key columns */
  genders_by_pk?: Maybe<Genders>;
  /** execute function "get_all_posts" which returns "posts" */
  get_all_posts: Array<Posts>;
  /** execute function "get_all_posts" and query aggregates on result of table type "posts" */
  get_all_posts_aggregate: Posts_Aggregate;
  /** execute function "get_banner_images" which returns "images" */
  get_banner_images: Array<Images>;
  /** execute function "get_banner_images" and query aggregates on result of table type "images" */
  get_banner_images_aggregate: Images_Aggregate;
  /** execute function "get_post_images" which returns "images" */
  get_post_images: Array<Images>;
  /** execute function "get_post_images" and query aggregates on result of table type "images" */
  get_post_images_aggregate: Images_Aggregate;
  /** execute function "get_post_thumbnail" which returns "images" */
  get_post_thumbnail: Array<Images>;
  /** execute function "get_post_thumbnail" and query aggregates on result of table type "images" */
  get_post_thumbnail_aggregate: Images_Aggregate;
  /** execute function "get_posts_by_category_id" which returns "posts" */
  get_posts_by_category_id: Array<Posts>;
  /** execute function "get_posts_by_category_id" and query aggregates on result of table type "posts" */
  get_posts_by_category_id_aggregate: Posts_Aggregate;
  /** execute function "get_user_avatar" which returns "images" */
  get_user_avatar: Array<Images>;
  /** execute function "get_user_avatar" and query aggregates on result of table type "images" */
  get_user_avatar_aggregate: Images_Aggregate;
  /** An array relationship */
  group_kpis: Array<Group_Kpis>;
  /** An aggregate relationship */
  group_kpis_aggregate: Group_Kpis_Aggregate;
  /** fetch data from the table: "group_kpis" using primary key columns */
  group_kpis_by_pk?: Maybe<Group_Kpis>;
  /** fetch data from the table: "image_subtypes" */
  image_subtypes: Array<Image_Subtypes>;
  /** fetch aggregated fields from the table: "image_subtypes" */
  image_subtypes_aggregate: Image_Subtypes_Aggregate;
  /** fetch data from the table: "image_subtypes" using primary key columns */
  image_subtypes_by_pk?: Maybe<Image_Subtypes>;
  /** fetch data from the table: "image_types" */
  image_types: Array<Image_Types>;
  /** fetch aggregated fields from the table: "image_types" */
  image_types_aggregate: Image_Types_Aggregate;
  /** fetch data from the table: "image_types" using primary key columns */
  image_types_by_pk?: Maybe<Image_Types>;
  /** An array relationship */
  images: Array<Images>;
  /** An aggregate relationship */
  images_aggregate: Images_Aggregate;
  /** fetch data from the table: "images" using primary key columns */
  images_by_pk?: Maybe<Images>;
  /** An array relationship */
  kpis: Array<Kpis>;
  /** An aggregate relationship */
  kpis_aggregate: Kpis_Aggregate;
  /** fetch data from the table: "kpis" using primary key columns */
  kpis_by_pk?: Maybe<Kpis>;
  /** fetch data from the table: "languages" */
  languages: Array<Languages>;
  /** fetch aggregated fields from the table: "languages" */
  languages_aggregate: Languages_Aggregate;
  /** fetch data from the table: "languages" using primary key columns */
  languages_by_pk?: Maybe<Languages>;
  /** fetch data from the table: "layout_page_bottoms" */
  layout_page_bottoms: Array<Layout_Page_Bottoms>;
  /** fetch aggregated fields from the table: "layout_page_bottoms" */
  layout_page_bottoms_aggregate: Layout_Page_Bottoms_Aggregate;
  /** fetch data from the table: "layout_page_bottoms" using primary key columns */
  layout_page_bottoms_by_pk?: Maybe<Layout_Page_Bottoms>;
  /** fetch data from the table: "layout_page_tops" */
  layout_page_tops: Array<Layout_Page_Tops>;
  /** fetch aggregated fields from the table: "layout_page_tops" */
  layout_page_tops_aggregate: Layout_Page_Tops_Aggregate;
  /** fetch data from the table: "layout_page_tops" using primary key columns */
  layout_page_tops_by_pk?: Maybe<Layout_Page_Tops>;
  /** fetch data from the table: "layout_pages" */
  layout_pages: Array<Layout_Pages>;
  /** fetch aggregated fields from the table: "layout_pages" */
  layout_pages_aggregate: Layout_Pages_Aggregate;
  /** fetch data from the table: "layout_pages" using primary key columns */
  layout_pages_by_pk?: Maybe<Layout_Pages>;
  /** fetch data from the table: "layout_posts" */
  layout_posts: Array<Layout_Posts>;
  /** fetch aggregated fields from the table: "layout_posts" */
  layout_posts_aggregate: Layout_Posts_Aggregate;
  /** fetch data from the table: "layout_posts" using primary key columns */
  layout_posts_by_pk?: Maybe<Layout_Posts>;
  /** fetch data from the table: "layouts" */
  layouts: Array<Layouts>;
  /** fetch aggregated fields from the table: "layouts" */
  layouts_aggregate: Layouts_Aggregate;
  /** fetch data from the table: "layouts" using primary key columns */
  layouts_by_pk?: Maybe<Layouts>;
  /** An array relationship */
  news_letters: Array<News_Letters>;
  /** An aggregate relationship */
  news_letters_aggregate: News_Letters_Aggregate;
  /** fetch data from the table: "news_letters" using primary key columns */
  news_letters_by_pk?: Maybe<News_Letters>;
  /** An array relationship */
  permissions: Array<Permissions>;
  /** An aggregate relationship */
  permissions_aggregate: Permissions_Aggregate;
  /** fetch data from the table: "permissions" using primary key columns */
  permissions_by_pk?: Maybe<Permissions>;
  /** An array relationship */
  permissions_roles: Array<Permissions_Roles>;
  /** An aggregate relationship */
  permissions_roles_aggregate: Permissions_Roles_Aggregate;
  /** fetch data from the table: "permissions_roles" using primary key columns */
  permissions_roles_by_pk?: Maybe<Permissions_Roles>;
  /** An array relationship */
  posts: Array<Posts>;
  /** An aggregate relationship */
  posts_aggregate: Posts_Aggregate;
  /** fetch data from the table: "posts" using primary key columns */
  posts_by_pk?: Maybe<Posts>;
  /** An array relationship */
  posts_categories: Array<Posts_Categories>;
  /** An aggregate relationship */
  posts_categories_aggregate: Posts_Categories_Aggregate;
  /** fetch data from the table: "posts_categories" using primary key columns */
  posts_categories_by_pk?: Maybe<Posts_Categories>;
  /** An array relationship */
  posts_comments: Array<Posts_Comments>;
  /** An aggregate relationship */
  posts_comments_aggregate: Posts_Comments_Aggregate;
  /** fetch data from the table: "posts_comments" using primary key columns */
  posts_comments_by_pk?: Maybe<Posts_Comments>;
  /** fetch data from the table: "posts_comments_count" */
  posts_comments_count: Array<Posts_Comments_Count>;
  /** fetch aggregated fields from the table: "posts_comments_count" */
  posts_comments_count_aggregate: Posts_Comments_Count_Aggregate;
  /** An array relationship */
  posts_kpis: Array<Posts_Kpis>;
  /** An aggregate relationship */
  posts_kpis_aggregate: Posts_Kpis_Aggregate;
  /** fetch data from the table: "posts_kpis" using primary key columns */
  posts_kpis_by_pk?: Maybe<Posts_Kpis>;
  /** An array relationship */
  posts_likes: Array<Posts_Likes>;
  /** An aggregate relationship */
  posts_likes_aggregate: Posts_Likes_Aggregate;
  /** fetch data from the table: "posts_likes" using primary key columns */
  posts_likes_by_pk?: Maybe<Posts_Likes>;
  /** fetch data from the table: "posts_likes_count" */
  posts_likes_count: Array<Posts_Likes_Count>;
  /** fetch aggregated fields from the table: "posts_likes_count" */
  posts_likes_count_aggregate: Posts_Likes_Count_Aggregate;
  /** An array relationship */
  posts_sources: Array<Posts_Sources>;
  /** An aggregate relationship */
  posts_sources_aggregate: Posts_Sources_Aggregate;
  /** fetch data from the table: "posts_sources" using primary key columns */
  posts_sources_by_pk?: Maybe<Posts_Sources>;
  /** An array relationship */
  posts_tags: Array<Posts_Tags>;
  /** An aggregate relationship */
  posts_tags_aggregate: Posts_Tags_Aggregate;
  /** fetch data from the table: "posts_tags" using primary key columns */
  posts_tags_by_pk?: Maybe<Posts_Tags>;
  /** An array relationship */
  related_categories: Array<Related_Categories>;
  /** An aggregate relationship */
  related_categories_aggregate: Related_Categories_Aggregate;
  /** fetch data from the table: "related_categories" using primary key columns */
  related_categories_by_pk?: Maybe<Related_Categories>;
  /** An array relationship */
  roles: Array<Roles>;
  /** An aggregate relationship */
  roles_aggregate: Roles_Aggregate;
  /** fetch data from the table: "roles" using primary key columns */
  roles_by_pk?: Maybe<Roles>;
  /** execute function "search_posts" which returns "posts" */
  search_posts: Array<Posts>;
  /** execute function "search_posts" and query aggregates on result of table type "posts" */
  search_posts_aggregate: Posts_Aggregate;
  /** fetch data from the table: "settings" */
  settings: Array<Settings>;
  /** fetch aggregated fields from the table: "settings" */
  settings_aggregate: Settings_Aggregate;
  /** fetch data from the table: "settings" using primary key columns */
  settings_by_pk?: Maybe<Settings>;
  /** An array relationship */
  sources: Array<Sources>;
  /** An aggregate relationship */
  sources_aggregate: Sources_Aggregate;
  /** fetch data from the table: "sources" using primary key columns */
  sources_by_pk?: Maybe<Sources>;
  /** An array relationship */
  tags: Array<Tags>;
  /** An aggregate relationship */
  tags_aggregate: Tags_Aggregate;
  /** fetch data from the table: "tags" using primary key columns */
  tags_by_pk?: Maybe<Tags>;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
};


export type Query_RootAdvertisement_TypesArgs = {
  distinct_on?: InputMaybe<Array<Advertisement_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Advertisement_Types_Order_By>>;
  where?: InputMaybe<Advertisement_Types_Bool_Exp>;
};


export type Query_RootAdvertisement_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Advertisement_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Advertisement_Types_Order_By>>;
  where?: InputMaybe<Advertisement_Types_Bool_Exp>;
};


export type Query_RootAdvertisement_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootAdvertisementsArgs = {
  distinct_on?: InputMaybe<Array<Advertisements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Advertisements_Order_By>>;
  where?: InputMaybe<Advertisements_Bool_Exp>;
};


export type Query_RootAdvertisements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Advertisements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Advertisements_Order_By>>;
  where?: InputMaybe<Advertisements_Bool_Exp>;
};


export type Query_RootAdvertisements_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootBannersArgs = {
  distinct_on?: InputMaybe<Array<Banners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Banners_Order_By>>;
  where?: InputMaybe<Banners_Bool_Exp>;
};


export type Query_RootBanners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Banners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Banners_Order_By>>;
  where?: InputMaybe<Banners_Bool_Exp>;
};


export type Query_RootBanners_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootBanners_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Banners_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Banners_Categories_Order_By>>;
  where?: InputMaybe<Banners_Categories_Bool_Exp>;
};


export type Query_RootBanners_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Banners_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Banners_Categories_Order_By>>;
  where?: InputMaybe<Banners_Categories_Bool_Exp>;
};


export type Query_RootBanners_Categories_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootCategoriesArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


export type Query_RootCategories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


export type Query_RootCategories_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootCategories_Full_SlugArgs = {
  distinct_on?: InputMaybe<Array<Categories_Full_Slug_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Categories_Full_Slug_Order_By>>;
  where?: InputMaybe<Categories_Full_Slug_Bool_Exp>;
};


export type Query_RootCategories_Full_Slug_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Categories_Full_Slug_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Categories_Full_Slug_Order_By>>;
  where?: InputMaybe<Categories_Full_Slug_Bool_Exp>;
};


export type Query_RootCategory_KpisArgs = {
  distinct_on?: InputMaybe<Array<Category_Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Category_Kpis_Order_By>>;
  where?: InputMaybe<Category_Kpis_Bool_Exp>;
};


export type Query_RootCategory_Kpis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Category_Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Category_Kpis_Order_By>>;
  where?: InputMaybe<Category_Kpis_Bool_Exp>;
};


export type Query_RootCategory_Kpis_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootComments_LikesArgs = {
  distinct_on?: InputMaybe<Array<Comments_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Likes_Order_By>>;
  where?: InputMaybe<Comments_Likes_Bool_Exp>;
};


export type Query_RootComments_Likes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comments_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Likes_Order_By>>;
  where?: InputMaybe<Comments_Likes_Bool_Exp>;
};


export type Query_RootComments_Likes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootComments_Likes_CountArgs = {
  distinct_on?: InputMaybe<Array<Comments_Likes_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Likes_Count_Order_By>>;
  where?: InputMaybe<Comments_Likes_Count_Bool_Exp>;
};


export type Query_RootComments_Likes_Count_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comments_Likes_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Likes_Count_Order_By>>;
  where?: InputMaybe<Comments_Likes_Count_Bool_Exp>;
};


export type Query_RootGendersArgs = {
  distinct_on?: InputMaybe<Array<Genders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Genders_Order_By>>;
  where?: InputMaybe<Genders_Bool_Exp>;
};


export type Query_RootGenders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Genders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Genders_Order_By>>;
  where?: InputMaybe<Genders_Bool_Exp>;
};


export type Query_RootGenders_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootGet_All_PostsArgs = {
  args: Get_All_Posts_Args;
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


export type Query_RootGet_All_Posts_AggregateArgs = {
  args: Get_All_Posts_Args;
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


export type Query_RootGet_Banner_ImagesArgs = {
  args: Get_Banner_Images_Args;
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


export type Query_RootGet_Banner_Images_AggregateArgs = {
  args: Get_Banner_Images_Args;
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


export type Query_RootGet_Post_ImagesArgs = {
  args: Get_Post_Images_Args;
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


export type Query_RootGet_Post_Images_AggregateArgs = {
  args: Get_Post_Images_Args;
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


export type Query_RootGet_Post_ThumbnailArgs = {
  args: Get_Post_Thumbnail_Args;
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


export type Query_RootGet_Post_Thumbnail_AggregateArgs = {
  args: Get_Post_Thumbnail_Args;
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


export type Query_RootGet_Posts_By_Category_IdArgs = {
  args: Get_Posts_By_Category_Id_Args;
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


export type Query_RootGet_Posts_By_Category_Id_AggregateArgs = {
  args: Get_Posts_By_Category_Id_Args;
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


export type Query_RootGet_User_AvatarArgs = {
  args: Get_User_Avatar_Args;
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


export type Query_RootGet_User_Avatar_AggregateArgs = {
  args: Get_User_Avatar_Args;
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


export type Query_RootGroup_KpisArgs = {
  distinct_on?: InputMaybe<Array<Group_Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Group_Kpis_Order_By>>;
  where?: InputMaybe<Group_Kpis_Bool_Exp>;
};


export type Query_RootGroup_Kpis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Group_Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Group_Kpis_Order_By>>;
  where?: InputMaybe<Group_Kpis_Bool_Exp>;
};


export type Query_RootGroup_Kpis_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootImage_SubtypesArgs = {
  distinct_on?: InputMaybe<Array<Image_Subtypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Image_Subtypes_Order_By>>;
  where?: InputMaybe<Image_Subtypes_Bool_Exp>;
};


export type Query_RootImage_Subtypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Image_Subtypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Image_Subtypes_Order_By>>;
  where?: InputMaybe<Image_Subtypes_Bool_Exp>;
};


export type Query_RootImage_Subtypes_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootImage_TypesArgs = {
  distinct_on?: InputMaybe<Array<Image_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Image_Types_Order_By>>;
  where?: InputMaybe<Image_Types_Bool_Exp>;
};


export type Query_RootImage_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Image_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Image_Types_Order_By>>;
  where?: InputMaybe<Image_Types_Bool_Exp>;
};


export type Query_RootImage_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootImagesArgs = {
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


export type Query_RootImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


export type Query_RootImages_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootKpisArgs = {
  distinct_on?: InputMaybe<Array<Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Kpis_Order_By>>;
  where?: InputMaybe<Kpis_Bool_Exp>;
};


export type Query_RootKpis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Kpis_Order_By>>;
  where?: InputMaybe<Kpis_Bool_Exp>;
};


export type Query_RootKpis_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootLanguagesArgs = {
  distinct_on?: InputMaybe<Array<Languages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Languages_Order_By>>;
  where?: InputMaybe<Languages_Bool_Exp>;
};


export type Query_RootLanguages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Languages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Languages_Order_By>>;
  where?: InputMaybe<Languages_Bool_Exp>;
};


export type Query_RootLanguages_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootLayout_Page_BottomsArgs = {
  distinct_on?: InputMaybe<Array<Layout_Page_Bottoms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Layout_Page_Bottoms_Order_By>>;
  where?: InputMaybe<Layout_Page_Bottoms_Bool_Exp>;
};


export type Query_RootLayout_Page_Bottoms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Layout_Page_Bottoms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Layout_Page_Bottoms_Order_By>>;
  where?: InputMaybe<Layout_Page_Bottoms_Bool_Exp>;
};


export type Query_RootLayout_Page_Bottoms_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootLayout_Page_TopsArgs = {
  distinct_on?: InputMaybe<Array<Layout_Page_Tops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Layout_Page_Tops_Order_By>>;
  where?: InputMaybe<Layout_Page_Tops_Bool_Exp>;
};


export type Query_RootLayout_Page_Tops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Layout_Page_Tops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Layout_Page_Tops_Order_By>>;
  where?: InputMaybe<Layout_Page_Tops_Bool_Exp>;
};


export type Query_RootLayout_Page_Tops_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootLayout_PagesArgs = {
  distinct_on?: InputMaybe<Array<Layout_Pages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Layout_Pages_Order_By>>;
  where?: InputMaybe<Layout_Pages_Bool_Exp>;
};


export type Query_RootLayout_Pages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Layout_Pages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Layout_Pages_Order_By>>;
  where?: InputMaybe<Layout_Pages_Bool_Exp>;
};


export type Query_RootLayout_Pages_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootLayout_PostsArgs = {
  distinct_on?: InputMaybe<Array<Layout_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Layout_Posts_Order_By>>;
  where?: InputMaybe<Layout_Posts_Bool_Exp>;
};


export type Query_RootLayout_Posts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Layout_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Layout_Posts_Order_By>>;
  where?: InputMaybe<Layout_Posts_Bool_Exp>;
};


export type Query_RootLayout_Posts_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootLayoutsArgs = {
  distinct_on?: InputMaybe<Array<Layouts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Layouts_Order_By>>;
  where?: InputMaybe<Layouts_Bool_Exp>;
};


export type Query_RootLayouts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Layouts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Layouts_Order_By>>;
  where?: InputMaybe<Layouts_Bool_Exp>;
};


export type Query_RootLayouts_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootNews_LettersArgs = {
  distinct_on?: InputMaybe<Array<News_Letters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<News_Letters_Order_By>>;
  where?: InputMaybe<News_Letters_Bool_Exp>;
};


export type Query_RootNews_Letters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<News_Letters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<News_Letters_Order_By>>;
  where?: InputMaybe<News_Letters_Bool_Exp>;
};


export type Query_RootNews_Letters_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootPermissionsArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissions_Order_By>>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};


export type Query_RootPermissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissions_Order_By>>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};


export type Query_RootPermissions_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootPermissions_RolesArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissions_Roles_Order_By>>;
  where?: InputMaybe<Permissions_Roles_Bool_Exp>;
};


export type Query_RootPermissions_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissions_Roles_Order_By>>;
  where?: InputMaybe<Permissions_Roles_Bool_Exp>;
};


export type Query_RootPermissions_Roles_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootPostsArgs = {
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


export type Query_RootPosts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


export type Query_RootPosts_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootPosts_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Posts_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Categories_Order_By>>;
  where?: InputMaybe<Posts_Categories_Bool_Exp>;
};


export type Query_RootPosts_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Categories_Order_By>>;
  where?: InputMaybe<Posts_Categories_Bool_Exp>;
};


export type Query_RootPosts_Categories_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootPosts_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Posts_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Comments_Order_By>>;
  where?: InputMaybe<Posts_Comments_Bool_Exp>;
};


export type Query_RootPosts_Comments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Comments_Order_By>>;
  where?: InputMaybe<Posts_Comments_Bool_Exp>;
};


export type Query_RootPosts_Comments_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootPosts_Comments_CountArgs = {
  distinct_on?: InputMaybe<Array<Posts_Comments_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Comments_Count_Order_By>>;
  where?: InputMaybe<Posts_Comments_Count_Bool_Exp>;
};


export type Query_RootPosts_Comments_Count_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Comments_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Comments_Count_Order_By>>;
  where?: InputMaybe<Posts_Comments_Count_Bool_Exp>;
};


export type Query_RootPosts_KpisArgs = {
  distinct_on?: InputMaybe<Array<Posts_Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Kpis_Order_By>>;
  where?: InputMaybe<Posts_Kpis_Bool_Exp>;
};


export type Query_RootPosts_Kpis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Kpis_Order_By>>;
  where?: InputMaybe<Posts_Kpis_Bool_Exp>;
};


export type Query_RootPosts_Kpis_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootPosts_LikesArgs = {
  distinct_on?: InputMaybe<Array<Posts_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Likes_Order_By>>;
  where?: InputMaybe<Posts_Likes_Bool_Exp>;
};


export type Query_RootPosts_Likes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Likes_Order_By>>;
  where?: InputMaybe<Posts_Likes_Bool_Exp>;
};


export type Query_RootPosts_Likes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootPosts_Likes_CountArgs = {
  distinct_on?: InputMaybe<Array<Posts_Likes_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Likes_Count_Order_By>>;
  where?: InputMaybe<Posts_Likes_Count_Bool_Exp>;
};


export type Query_RootPosts_Likes_Count_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Likes_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Likes_Count_Order_By>>;
  where?: InputMaybe<Posts_Likes_Count_Bool_Exp>;
};


export type Query_RootPosts_SourcesArgs = {
  distinct_on?: InputMaybe<Array<Posts_Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Sources_Order_By>>;
  where?: InputMaybe<Posts_Sources_Bool_Exp>;
};


export type Query_RootPosts_Sources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Sources_Order_By>>;
  where?: InputMaybe<Posts_Sources_Bool_Exp>;
};


export type Query_RootPosts_Sources_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootPosts_TagsArgs = {
  distinct_on?: InputMaybe<Array<Posts_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Tags_Order_By>>;
  where?: InputMaybe<Posts_Tags_Bool_Exp>;
};


export type Query_RootPosts_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Tags_Order_By>>;
  where?: InputMaybe<Posts_Tags_Bool_Exp>;
};


export type Query_RootPosts_Tags_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootRelated_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Related_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Related_Categories_Order_By>>;
  where?: InputMaybe<Related_Categories_Bool_Exp>;
};


export type Query_RootRelated_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Related_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Related_Categories_Order_By>>;
  where?: InputMaybe<Related_Categories_Bool_Exp>;
};


export type Query_RootRelated_Categories_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootRolesArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Query_RootRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Query_RootRoles_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootSearch_PostsArgs = {
  args: Search_Posts_Args;
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


export type Query_RootSearch_Posts_AggregateArgs = {
  args: Search_Posts_Args;
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


export type Query_RootSettingsArgs = {
  distinct_on?: InputMaybe<Array<Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Settings_Order_By>>;
  where?: InputMaybe<Settings_Bool_Exp>;
};


export type Query_RootSettings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Settings_Order_By>>;
  where?: InputMaybe<Settings_Bool_Exp>;
};


export type Query_RootSettings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootSourcesArgs = {
  distinct_on?: InputMaybe<Array<Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sources_Order_By>>;
  where?: InputMaybe<Sources_Bool_Exp>;
};


export type Query_RootSources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sources_Order_By>>;
  where?: InputMaybe<Sources_Bool_Exp>;
};


export type Query_RootSources_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootTagsArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Query_RootTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Query_RootTags_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  id: Scalars['bigint']['input'];
};

/** columns and relationships of "related_categories" */
export type Related_Categories = {
  __typename?: 'related_categories';
  /** An object relationship */
  category: Categories;
  category_id: Scalars['Int']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  created_by?: Maybe<Users>;
  created_by_id?: Maybe<Scalars['Int']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  deleted_by?: Maybe<Users>;
  deleted_by_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['bigint']['output'];
  related_id: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  updated_by?: Maybe<Users>;
  updated_by_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "related_categories" */
export type Related_Categories_Aggregate = {
  __typename?: 'related_categories_aggregate';
  aggregate?: Maybe<Related_Categories_Aggregate_Fields>;
  nodes: Array<Related_Categories>;
};

export type Related_Categories_Aggregate_Bool_Exp = {
  count?: InputMaybe<Related_Categories_Aggregate_Bool_Exp_Count>;
};

export type Related_Categories_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Related_Categories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Related_Categories_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "related_categories" */
export type Related_Categories_Aggregate_Fields = {
  __typename?: 'related_categories_aggregate_fields';
  avg?: Maybe<Related_Categories_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Related_Categories_Max_Fields>;
  min?: Maybe<Related_Categories_Min_Fields>;
  stddev?: Maybe<Related_Categories_Stddev_Fields>;
  stddev_pop?: Maybe<Related_Categories_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Related_Categories_Stddev_Samp_Fields>;
  sum?: Maybe<Related_Categories_Sum_Fields>;
  var_pop?: Maybe<Related_Categories_Var_Pop_Fields>;
  var_samp?: Maybe<Related_Categories_Var_Samp_Fields>;
  variance?: Maybe<Related_Categories_Variance_Fields>;
};


/** aggregate fields of "related_categories" */
export type Related_Categories_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Related_Categories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "related_categories" */
export type Related_Categories_Aggregate_Order_By = {
  avg?: InputMaybe<Related_Categories_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Related_Categories_Max_Order_By>;
  min?: InputMaybe<Related_Categories_Min_Order_By>;
  stddev?: InputMaybe<Related_Categories_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Related_Categories_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Related_Categories_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Related_Categories_Sum_Order_By>;
  var_pop?: InputMaybe<Related_Categories_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Related_Categories_Var_Samp_Order_By>;
  variance?: InputMaybe<Related_Categories_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "related_categories" */
export type Related_Categories_Arr_Rel_Insert_Input = {
  data: Array<Related_Categories_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Related_Categories_On_Conflict>;
};

/** aggregate avg on columns */
export type Related_Categories_Avg_Fields = {
  __typename?: 'related_categories_avg_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  related_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "related_categories" */
export type Related_Categories_Avg_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  related_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "related_categories". All fields are combined with a logical 'AND'. */
export type Related_Categories_Bool_Exp = {
  _and?: InputMaybe<Array<Related_Categories_Bool_Exp>>;
  _not?: InputMaybe<Related_Categories_Bool_Exp>;
  _or?: InputMaybe<Array<Related_Categories_Bool_Exp>>;
  category?: InputMaybe<Categories_Bool_Exp>;
  category_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Users_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_by?: InputMaybe<Users_Bool_Exp>;
  deleted_by_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  related_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Users_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "related_categories" */
export enum Related_Categories_Constraint {
  /** unique or primary key constraint on columns "id" */
  RelatedCategoriesPkey = 'related_categories_pkey'
}

/** input type for incrementing numeric columns in table "related_categories" */
export type Related_Categories_Inc_Input = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  created_by_id?: InputMaybe<Scalars['Int']['input']>;
  deleted_by_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  related_id?: InputMaybe<Scalars['Int']['input']>;
  updated_by_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "related_categories" */
export type Related_Categories_Insert_Input = {
  category?: InputMaybe<Categories_Obj_Rel_Insert_Input>;
  category_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['Int']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  deleted_by_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  related_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Related_Categories_Max_Fields = {
  __typename?: 'related_categories_max_fields';
  category_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['Int']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  related_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "related_categories" */
export type Related_Categories_Max_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  related_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Related_Categories_Min_Fields = {
  __typename?: 'related_categories_min_fields';
  category_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['Int']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  related_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "related_categories" */
export type Related_Categories_Min_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  related_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "related_categories" */
export type Related_Categories_Mutation_Response = {
  __typename?: 'related_categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Related_Categories>;
};

/** on_conflict condition type for table "related_categories" */
export type Related_Categories_On_Conflict = {
  constraint: Related_Categories_Constraint;
  update_columns?: Array<Related_Categories_Update_Column>;
  where?: InputMaybe<Related_Categories_Bool_Exp>;
};

/** Ordering options when selecting data from "related_categories". */
export type Related_Categories_Order_By = {
  category?: InputMaybe<Categories_Order_By>;
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Users_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by?: InputMaybe<Users_Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  related_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Users_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: related_categories */
export type Related_Categories_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "related_categories" */
export enum Related_Categories_Select_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  RelatedId = 'related_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "related_categories" */
export type Related_Categories_Set_Input = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['Int']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  related_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Related_Categories_Stddev_Fields = {
  __typename?: 'related_categories_stddev_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  related_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "related_categories" */
export type Related_Categories_Stddev_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  related_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Related_Categories_Stddev_Pop_Fields = {
  __typename?: 'related_categories_stddev_pop_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  related_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "related_categories" */
export type Related_Categories_Stddev_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  related_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Related_Categories_Stddev_Samp_Fields = {
  __typename?: 'related_categories_stddev_samp_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  related_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "related_categories" */
export type Related_Categories_Stddev_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  related_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "related_categories" */
export type Related_Categories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Related_Categories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Related_Categories_Stream_Cursor_Value_Input = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['Int']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  related_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Related_Categories_Sum_Fields = {
  __typename?: 'related_categories_sum_fields';
  category_id?: Maybe<Scalars['Int']['output']>;
  created_by_id?: Maybe<Scalars['Int']['output']>;
  deleted_by_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  related_id?: Maybe<Scalars['Int']['output']>;
  updated_by_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "related_categories" */
export type Related_Categories_Sum_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  related_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "related_categories" */
export enum Related_Categories_Update_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  RelatedId = 'related_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Related_Categories_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Related_Categories_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Related_Categories_Set_Input>;
  /** filter the rows which have to be updated */
  where: Related_Categories_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Related_Categories_Var_Pop_Fields = {
  __typename?: 'related_categories_var_pop_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  related_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "related_categories" */
export type Related_Categories_Var_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  related_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Related_Categories_Var_Samp_Fields = {
  __typename?: 'related_categories_var_samp_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  related_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "related_categories" */
export type Related_Categories_Var_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  related_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Related_Categories_Variance_Fields = {
  __typename?: 'related_categories_variance_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  related_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "related_categories" */
export type Related_Categories_Variance_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  related_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "roles" */
export type Roles = {
  __typename?: 'roles';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  created_by?: Maybe<Users>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  deleted_by?: Maybe<Users>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['bigint']['output'];
  is_access_cms: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  permissions_roles: Array<Permissions_Roles>;
  /** An aggregate relationship */
  permissions_roles_aggregate: Permissions_Roles_Aggregate;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  updated_by?: Maybe<Users>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
};


/** columns and relationships of "roles" */
export type RolesPermissions_RolesArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissions_Roles_Order_By>>;
  where?: InputMaybe<Permissions_Roles_Bool_Exp>;
};


/** columns and relationships of "roles" */
export type RolesPermissions_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissions_Roles_Order_By>>;
  where?: InputMaybe<Permissions_Roles_Bool_Exp>;
};


/** columns and relationships of "roles" */
export type RolesUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** columns and relationships of "roles" */
export type RolesUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** aggregated selection of "roles" */
export type Roles_Aggregate = {
  __typename?: 'roles_aggregate';
  aggregate?: Maybe<Roles_Aggregate_Fields>;
  nodes: Array<Roles>;
};

export type Roles_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Roles_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Roles_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Roles_Aggregate_Bool_Exp_Count>;
};

export type Roles_Aggregate_Bool_Exp_Bool_And = {
  arguments: Roles_Select_Column_Roles_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Roles_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Roles_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Roles_Select_Column_Roles_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Roles_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Roles_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Roles_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "roles" */
export type Roles_Aggregate_Fields = {
  __typename?: 'roles_aggregate_fields';
  avg?: Maybe<Roles_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Roles_Max_Fields>;
  min?: Maybe<Roles_Min_Fields>;
  stddev?: Maybe<Roles_Stddev_Fields>;
  stddev_pop?: Maybe<Roles_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Roles_Stddev_Samp_Fields>;
  sum?: Maybe<Roles_Sum_Fields>;
  var_pop?: Maybe<Roles_Var_Pop_Fields>;
  var_samp?: Maybe<Roles_Var_Samp_Fields>;
  variance?: Maybe<Roles_Variance_Fields>;
};


/** aggregate fields of "roles" */
export type Roles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "roles" */
export type Roles_Aggregate_Order_By = {
  avg?: InputMaybe<Roles_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Roles_Max_Order_By>;
  min?: InputMaybe<Roles_Min_Order_By>;
  stddev?: InputMaybe<Roles_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Roles_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Roles_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Roles_Sum_Order_By>;
  var_pop?: InputMaybe<Roles_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Roles_Var_Samp_Order_By>;
  variance?: InputMaybe<Roles_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "roles" */
export type Roles_Arr_Rel_Insert_Input = {
  data: Array<Roles_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Roles_On_Conflict>;
};

/** aggregate avg on columns */
export type Roles_Avg_Fields = {
  __typename?: 'roles_avg_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "roles" */
export type Roles_Avg_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "roles". All fields are combined with a logical 'AND'. */
export type Roles_Bool_Exp = {
  _and?: InputMaybe<Array<Roles_Bool_Exp>>;
  _not?: InputMaybe<Roles_Bool_Exp>;
  _or?: InputMaybe<Array<Roles_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<Users_Bool_Exp>;
  created_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  deleted_by?: InputMaybe<Users_Bool_Exp>;
  deleted_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_access_cms?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  permissions_roles?: InputMaybe<Permissions_Roles_Bool_Exp>;
  permissions_roles_aggregate?: InputMaybe<Permissions_Roles_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<Users_Bool_Exp>;
  updated_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  users?: InputMaybe<Users_Bool_Exp>;
  users_aggregate?: InputMaybe<Users_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "roles" */
export enum Roles_Constraint {
  /** unique or primary key constraint on columns "id" */
  RolesPkey = 'roles_pkey'
}

/** input type for incrementing numeric columns in table "roles" */
export type Roles_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "roles" */
export type Roles_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_access_cms?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions_roles?: InputMaybe<Permissions_Roles_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  updated_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
  users?: InputMaybe<Users_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Roles_Max_Fields = {
  __typename?: 'roles_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "roles" */
export type Roles_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Roles_Min_Fields = {
  __typename?: 'roles_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "roles" */
export type Roles_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "roles" */
export type Roles_Mutation_Response = {
  __typename?: 'roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Roles>;
};

/** input type for inserting object relation for remote table "roles" */
export type Roles_Obj_Rel_Insert_Input = {
  data: Roles_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Roles_On_Conflict>;
};

/** on_conflict condition type for table "roles" */
export type Roles_On_Conflict = {
  constraint: Roles_Constraint;
  update_columns?: Array<Roles_Update_Column>;
  where?: InputMaybe<Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "roles". */
export type Roles_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Users_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by?: InputMaybe<Users_Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_access_cms?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  permissions_roles_aggregate?: InputMaybe<Permissions_Roles_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Users_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  users_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
};

/** primary key columns input for table: roles */
export type Roles_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "roles" */
export enum Roles_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsAccessCms = 'is_access_cms',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "roles_aggregate_bool_exp_bool_and_arguments_columns" columns of table "roles" */
export enum Roles_Select_Column_Roles_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsAccessCms = 'is_access_cms'
}

/** select "roles_aggregate_bool_exp_bool_or_arguments_columns" columns of table "roles" */
export enum Roles_Select_Column_Roles_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsAccessCms = 'is_access_cms'
}

/** input type for updating data in table "roles" */
export type Roles_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_access_cms?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Roles_Stddev_Fields = {
  __typename?: 'roles_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "roles" */
export type Roles_Stddev_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Roles_Stddev_Pop_Fields = {
  __typename?: 'roles_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "roles" */
export type Roles_Stddev_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Roles_Stddev_Samp_Fields = {
  __typename?: 'roles_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "roles" */
export type Roles_Stddev_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "roles" */
export type Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Roles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Roles_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_access_cms?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Roles_Sum_Fields = {
  __typename?: 'roles_sum_fields';
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "roles" */
export type Roles_Sum_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "roles" */
export enum Roles_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsAccessCms = 'is_access_cms',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Roles_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Roles_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Roles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Roles_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Roles_Var_Pop_Fields = {
  __typename?: 'roles_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "roles" */
export type Roles_Var_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Roles_Var_Samp_Fields = {
  __typename?: 'roles_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "roles" */
export type Roles_Var_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Roles_Variance_Fields = {
  __typename?: 'roles_variance_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "roles" */
export type Roles_Variance_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

export type Search_Posts_Args = {
  lang?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "settings" */
export type Settings = {
  __typename?: 'settings';
  /** A computed field, executes function "get_setting_ad_quote" */
  ad_quote?: Maybe<Array<Images>>;
  /** A computed field, executes function "get_setting_display_banner_quote" */
  display_banner_quote?: Maybe<Array<Images>>;
  /** A computed field, executes function "get_setting_favicon" */
  favicon?: Maybe<Array<Images>>;
  id: Scalars['Int']['output'];
  /** A computed field, executes function "get_setting_logo" */
  logo?: Maybe<Array<Images>>;
  /** A computed field, executes function "get_setting_pr_post_quote" */
  pr_post_quote?: Maybe<Array<Images>>;
  type: Scalars['String']['output'];
  value: Scalars['jsonb']['output'];
};


/** columns and relationships of "settings" */
export type SettingsAd_QuoteArgs = {
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


/** columns and relationships of "settings" */
export type SettingsDisplay_Banner_QuoteArgs = {
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


/** columns and relationships of "settings" */
export type SettingsFaviconArgs = {
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


/** columns and relationships of "settings" */
export type SettingsLogoArgs = {
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


/** columns and relationships of "settings" */
export type SettingsPr_Post_QuoteArgs = {
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


/** columns and relationships of "settings" */
export type SettingsValueArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "settings" */
export type Settings_Aggregate = {
  __typename?: 'settings_aggregate';
  aggregate?: Maybe<Settings_Aggregate_Fields>;
  nodes: Array<Settings>;
};

/** aggregate fields of "settings" */
export type Settings_Aggregate_Fields = {
  __typename?: 'settings_aggregate_fields';
  avg?: Maybe<Settings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Settings_Max_Fields>;
  min?: Maybe<Settings_Min_Fields>;
  stddev?: Maybe<Settings_Stddev_Fields>;
  stddev_pop?: Maybe<Settings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Settings_Stddev_Samp_Fields>;
  sum?: Maybe<Settings_Sum_Fields>;
  var_pop?: Maybe<Settings_Var_Pop_Fields>;
  var_samp?: Maybe<Settings_Var_Samp_Fields>;
  variance?: Maybe<Settings_Variance_Fields>;
};


/** aggregate fields of "settings" */
export type Settings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Settings_Append_Input = {
  value?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Settings_Avg_Fields = {
  __typename?: 'settings_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "settings". All fields are combined with a logical 'AND'. */
export type Settings_Bool_Exp = {
  _and?: InputMaybe<Array<Settings_Bool_Exp>>;
  _not?: InputMaybe<Settings_Bool_Exp>;
  _or?: InputMaybe<Array<Settings_Bool_Exp>>;
  ad_quote?: InputMaybe<Images_Bool_Exp>;
  display_banner_quote?: InputMaybe<Images_Bool_Exp>;
  favicon?: InputMaybe<Images_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  logo?: InputMaybe<Images_Bool_Exp>;
  pr_post_quote?: InputMaybe<Images_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "settings" */
export enum Settings_Constraint {
  /** unique or primary key constraint on columns "id" */
  SettingsPkey = 'settings_pkey',
  /** unique or primary key constraint on columns "type" */
  SettingsTypeKey = 'settings_type_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Settings_Delete_At_Path_Input = {
  value?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Settings_Delete_Elem_Input = {
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Settings_Delete_Key_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "settings" */
export type Settings_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "settings" */
export type Settings_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type Settings_Max_Fields = {
  __typename?: 'settings_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Settings_Min_Fields = {
  __typename?: 'settings_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "settings" */
export type Settings_Mutation_Response = {
  __typename?: 'settings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Settings>;
};

/** on_conflict condition type for table "settings" */
export type Settings_On_Conflict = {
  constraint: Settings_Constraint;
  update_columns?: Array<Settings_Update_Column>;
  where?: InputMaybe<Settings_Bool_Exp>;
};

/** Ordering options when selecting data from "settings". */
export type Settings_Order_By = {
  ad_quote_aggregate?: InputMaybe<Images_Aggregate_Order_By>;
  display_banner_quote_aggregate?: InputMaybe<Images_Aggregate_Order_By>;
  favicon_aggregate?: InputMaybe<Images_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  logo_aggregate?: InputMaybe<Images_Aggregate_Order_By>;
  pr_post_quote_aggregate?: InputMaybe<Images_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: settings */
export type Settings_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Settings_Prepend_Input = {
  value?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "settings" */
export enum Settings_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "settings" */
export type Settings_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate stddev on columns */
export type Settings_Stddev_Fields = {
  __typename?: 'settings_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Settings_Stddev_Pop_Fields = {
  __typename?: 'settings_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Settings_Stddev_Samp_Fields = {
  __typename?: 'settings_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "settings" */
export type Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Settings_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate sum on columns */
export type Settings_Sum_Fields = {
  __typename?: 'settings_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "settings" */
export enum Settings_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type',
  /** column name */
  Value = 'value'
}

export type Settings_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Settings_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Settings_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Settings_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Settings_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Settings_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Settings_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Settings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Settings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Settings_Var_Pop_Fields = {
  __typename?: 'settings_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Settings_Var_Samp_Fields = {
  __typename?: 'settings_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Settings_Variance_Fields = {
  __typename?: 'settings_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "sources" */
export type Sources = {
  __typename?: 'sources';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by?: Maybe<Users>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  deleted_by?: Maybe<Users>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['bigint']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  posts_sources: Array<Posts_Sources>;
  /** An aggregate relationship */
  posts_sources_aggregate: Posts_Sources_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  updated_by?: Maybe<Users>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "sources" */
export type SourcesPosts_SourcesArgs = {
  distinct_on?: InputMaybe<Array<Posts_Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Sources_Order_By>>;
  where?: InputMaybe<Posts_Sources_Bool_Exp>;
};


/** columns and relationships of "sources" */
export type SourcesPosts_Sources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Sources_Order_By>>;
  where?: InputMaybe<Posts_Sources_Bool_Exp>;
};

/** aggregated selection of "sources" */
export type Sources_Aggregate = {
  __typename?: 'sources_aggregate';
  aggregate?: Maybe<Sources_Aggregate_Fields>;
  nodes: Array<Sources>;
};

export type Sources_Aggregate_Bool_Exp = {
  count?: InputMaybe<Sources_Aggregate_Bool_Exp_Count>;
};

export type Sources_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Sources_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Sources_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "sources" */
export type Sources_Aggregate_Fields = {
  __typename?: 'sources_aggregate_fields';
  avg?: Maybe<Sources_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Sources_Max_Fields>;
  min?: Maybe<Sources_Min_Fields>;
  stddev?: Maybe<Sources_Stddev_Fields>;
  stddev_pop?: Maybe<Sources_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sources_Stddev_Samp_Fields>;
  sum?: Maybe<Sources_Sum_Fields>;
  var_pop?: Maybe<Sources_Var_Pop_Fields>;
  var_samp?: Maybe<Sources_Var_Samp_Fields>;
  variance?: Maybe<Sources_Variance_Fields>;
};


/** aggregate fields of "sources" */
export type Sources_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sources_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "sources" */
export type Sources_Aggregate_Order_By = {
  avg?: InputMaybe<Sources_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sources_Max_Order_By>;
  min?: InputMaybe<Sources_Min_Order_By>;
  stddev?: InputMaybe<Sources_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Sources_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Sources_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Sources_Sum_Order_By>;
  var_pop?: InputMaybe<Sources_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Sources_Var_Samp_Order_By>;
  variance?: InputMaybe<Sources_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "sources" */
export type Sources_Arr_Rel_Insert_Input = {
  data: Array<Sources_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Sources_On_Conflict>;
};

/** aggregate avg on columns */
export type Sources_Avg_Fields = {
  __typename?: 'sources_avg_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "sources" */
export type Sources_Avg_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sources". All fields are combined with a logical 'AND'. */
export type Sources_Bool_Exp = {
  _and?: InputMaybe<Array<Sources_Bool_Exp>>;
  _not?: InputMaybe<Sources_Bool_Exp>;
  _or?: InputMaybe<Array<Sources_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Users_Bool_Exp>;
  created_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_by?: InputMaybe<Users_Bool_Exp>;
  deleted_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  posts_sources?: InputMaybe<Posts_Sources_Bool_Exp>;
  posts_sources_aggregate?: InputMaybe<Posts_Sources_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Users_Bool_Exp>;
  updated_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "sources" */
export enum Sources_Constraint {
  /** unique or primary key constraint on columns "id" */
  SourcesPkey = 'sources_pkey'
}

/** input type for incrementing numeric columns in table "sources" */
export type Sources_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "sources" */
export type Sources_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  posts_sources?: InputMaybe<Posts_Sources_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Sources_Max_Fields = {
  __typename?: 'sources_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "sources" */
export type Sources_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sources_Min_Fields = {
  __typename?: 'sources_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "sources" */
export type Sources_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sources" */
export type Sources_Mutation_Response = {
  __typename?: 'sources_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Sources>;
};

/** input type for inserting object relation for remote table "sources" */
export type Sources_Obj_Rel_Insert_Input = {
  data: Sources_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sources_On_Conflict>;
};

/** on_conflict condition type for table "sources" */
export type Sources_On_Conflict = {
  constraint: Sources_Constraint;
  update_columns?: Array<Sources_Update_Column>;
  where?: InputMaybe<Sources_Bool_Exp>;
};

/** Ordering options when selecting data from "sources". */
export type Sources_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Users_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by?: InputMaybe<Users_Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  posts_sources_aggregate?: InputMaybe<Posts_Sources_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Users_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sources */
export type Sources_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "sources" */
export enum Sources_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "sources" */
export type Sources_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Sources_Stddev_Fields = {
  __typename?: 'sources_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "sources" */
export type Sources_Stddev_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Sources_Stddev_Pop_Fields = {
  __typename?: 'sources_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "sources" */
export type Sources_Stddev_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Sources_Stddev_Samp_Fields = {
  __typename?: 'sources_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "sources" */
export type Sources_Stddev_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "sources" */
export type Sources_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sources_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sources_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Sources_Sum_Fields = {
  __typename?: 'sources_sum_fields';
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "sources" */
export type Sources_Sum_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "sources" */
export enum Sources_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Url = 'url'
}

export type Sources_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sources_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sources_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sources_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sources_Var_Pop_Fields = {
  __typename?: 'sources_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "sources" */
export type Sources_Var_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Sources_Var_Samp_Fields = {
  __typename?: 'sources_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "sources" */
export type Sources_Var_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Sources_Variance_Fields = {
  __typename?: 'sources_variance_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "sources" */
export type Sources_Variance_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "advertisement_types" */
  advertisement_types: Array<Advertisement_Types>;
  /** fetch aggregated fields from the table: "advertisement_types" */
  advertisement_types_aggregate: Advertisement_Types_Aggregate;
  /** fetch data from the table: "advertisement_types" using primary key columns */
  advertisement_types_by_pk?: Maybe<Advertisement_Types>;
  /** fetch data from the table in a streaming manner: "advertisement_types" */
  advertisement_types_stream: Array<Advertisement_Types>;
  /** fetch data from the table: "advertisements" */
  advertisements: Array<Advertisements>;
  /** fetch aggregated fields from the table: "advertisements" */
  advertisements_aggregate: Advertisements_Aggregate;
  /** fetch data from the table: "advertisements" using primary key columns */
  advertisements_by_pk?: Maybe<Advertisements>;
  /** fetch data from the table in a streaming manner: "advertisements" */
  advertisements_stream: Array<Advertisements>;
  /** An array relationship */
  banners: Array<Banners>;
  /** An aggregate relationship */
  banners_aggregate: Banners_Aggregate;
  /** fetch data from the table: "banners" using primary key columns */
  banners_by_pk?: Maybe<Banners>;
  /** An array relationship */
  banners_categories: Array<Banners_Categories>;
  /** An aggregate relationship */
  banners_categories_aggregate: Banners_Categories_Aggregate;
  /** fetch data from the table: "banners_categories" using primary key columns */
  banners_categories_by_pk?: Maybe<Banners_Categories>;
  /** fetch data from the table in a streaming manner: "banners_categories" */
  banners_categories_stream: Array<Banners_Categories>;
  /** fetch data from the table in a streaming manner: "banners" */
  banners_stream: Array<Banners>;
  /** An array relationship */
  categories: Array<Categories>;
  /** An aggregate relationship */
  categories_aggregate: Categories_Aggregate;
  /** fetch data from the table: "categories" using primary key columns */
  categories_by_pk?: Maybe<Categories>;
  /** fetch data from the table: "categories_full_slug" */
  categories_full_slug: Array<Categories_Full_Slug>;
  /** fetch aggregated fields from the table: "categories_full_slug" */
  categories_full_slug_aggregate: Categories_Full_Slug_Aggregate;
  /** fetch data from the table in a streaming manner: "categories_full_slug" */
  categories_full_slug_stream: Array<Categories_Full_Slug>;
  /** fetch data from the table in a streaming manner: "categories" */
  categories_stream: Array<Categories>;
  /** fetch data from the table: "category_kpis" */
  category_kpis: Array<Category_Kpis>;
  /** fetch aggregated fields from the table: "category_kpis" */
  category_kpis_aggregate: Category_Kpis_Aggregate;
  /** fetch data from the table: "category_kpis" using primary key columns */
  category_kpis_by_pk?: Maybe<Category_Kpis>;
  /** fetch data from the table in a streaming manner: "category_kpis" */
  category_kpis_stream: Array<Category_Kpis>;
  /** An array relationship */
  comments_likes: Array<Comments_Likes>;
  /** An aggregate relationship */
  comments_likes_aggregate: Comments_Likes_Aggregate;
  /** fetch data from the table: "comments_likes" using primary key columns */
  comments_likes_by_pk?: Maybe<Comments_Likes>;
  /** fetch data from the table: "comments_likes_count" */
  comments_likes_count: Array<Comments_Likes_Count>;
  /** fetch aggregated fields from the table: "comments_likes_count" */
  comments_likes_count_aggregate: Comments_Likes_Count_Aggregate;
  /** fetch data from the table in a streaming manner: "comments_likes_count" */
  comments_likes_count_stream: Array<Comments_Likes_Count>;
  /** fetch data from the table in a streaming manner: "comments_likes" */
  comments_likes_stream: Array<Comments_Likes>;
  /** fetch data from the table: "genders" */
  genders: Array<Genders>;
  /** fetch aggregated fields from the table: "genders" */
  genders_aggregate: Genders_Aggregate;
  /** fetch data from the table: "genders" using primary key columns */
  genders_by_pk?: Maybe<Genders>;
  /** fetch data from the table in a streaming manner: "genders" */
  genders_stream: Array<Genders>;
  /** execute function "get_all_posts" which returns "posts" */
  get_all_posts: Array<Posts>;
  /** execute function "get_all_posts" and query aggregates on result of table type "posts" */
  get_all_posts_aggregate: Posts_Aggregate;
  /** execute function "get_banner_images" which returns "images" */
  get_banner_images: Array<Images>;
  /** execute function "get_banner_images" and query aggregates on result of table type "images" */
  get_banner_images_aggregate: Images_Aggregate;
  /** execute function "get_post_images" which returns "images" */
  get_post_images: Array<Images>;
  /** execute function "get_post_images" and query aggregates on result of table type "images" */
  get_post_images_aggregate: Images_Aggregate;
  /** execute function "get_post_thumbnail" which returns "images" */
  get_post_thumbnail: Array<Images>;
  /** execute function "get_post_thumbnail" and query aggregates on result of table type "images" */
  get_post_thumbnail_aggregate: Images_Aggregate;
  /** execute function "get_posts_by_category_id" which returns "posts" */
  get_posts_by_category_id: Array<Posts>;
  /** execute function "get_posts_by_category_id" and query aggregates on result of table type "posts" */
  get_posts_by_category_id_aggregate: Posts_Aggregate;
  /** execute function "get_user_avatar" which returns "images" */
  get_user_avatar: Array<Images>;
  /** execute function "get_user_avatar" and query aggregates on result of table type "images" */
  get_user_avatar_aggregate: Images_Aggregate;
  /** An array relationship */
  group_kpis: Array<Group_Kpis>;
  /** An aggregate relationship */
  group_kpis_aggregate: Group_Kpis_Aggregate;
  /** fetch data from the table: "group_kpis" using primary key columns */
  group_kpis_by_pk?: Maybe<Group_Kpis>;
  /** fetch data from the table in a streaming manner: "group_kpis" */
  group_kpis_stream: Array<Group_Kpis>;
  /** fetch data from the table: "image_subtypes" */
  image_subtypes: Array<Image_Subtypes>;
  /** fetch aggregated fields from the table: "image_subtypes" */
  image_subtypes_aggregate: Image_Subtypes_Aggregate;
  /** fetch data from the table: "image_subtypes" using primary key columns */
  image_subtypes_by_pk?: Maybe<Image_Subtypes>;
  /** fetch data from the table in a streaming manner: "image_subtypes" */
  image_subtypes_stream: Array<Image_Subtypes>;
  /** fetch data from the table: "image_types" */
  image_types: Array<Image_Types>;
  /** fetch aggregated fields from the table: "image_types" */
  image_types_aggregate: Image_Types_Aggregate;
  /** fetch data from the table: "image_types" using primary key columns */
  image_types_by_pk?: Maybe<Image_Types>;
  /** fetch data from the table in a streaming manner: "image_types" */
  image_types_stream: Array<Image_Types>;
  /** An array relationship */
  images: Array<Images>;
  /** An aggregate relationship */
  images_aggregate: Images_Aggregate;
  /** fetch data from the table: "images" using primary key columns */
  images_by_pk?: Maybe<Images>;
  /** fetch data from the table in a streaming manner: "images" */
  images_stream: Array<Images>;
  /** An array relationship */
  kpis: Array<Kpis>;
  /** An aggregate relationship */
  kpis_aggregate: Kpis_Aggregate;
  /** fetch data from the table: "kpis" using primary key columns */
  kpis_by_pk?: Maybe<Kpis>;
  /** fetch data from the table in a streaming manner: "kpis" */
  kpis_stream: Array<Kpis>;
  /** fetch data from the table: "languages" */
  languages: Array<Languages>;
  /** fetch aggregated fields from the table: "languages" */
  languages_aggregate: Languages_Aggregate;
  /** fetch data from the table: "languages" using primary key columns */
  languages_by_pk?: Maybe<Languages>;
  /** fetch data from the table in a streaming manner: "languages" */
  languages_stream: Array<Languages>;
  /** fetch data from the table: "layout_page_bottoms" */
  layout_page_bottoms: Array<Layout_Page_Bottoms>;
  /** fetch aggregated fields from the table: "layout_page_bottoms" */
  layout_page_bottoms_aggregate: Layout_Page_Bottoms_Aggregate;
  /** fetch data from the table: "layout_page_bottoms" using primary key columns */
  layout_page_bottoms_by_pk?: Maybe<Layout_Page_Bottoms>;
  /** fetch data from the table in a streaming manner: "layout_page_bottoms" */
  layout_page_bottoms_stream: Array<Layout_Page_Bottoms>;
  /** fetch data from the table: "layout_page_tops" */
  layout_page_tops: Array<Layout_Page_Tops>;
  /** fetch aggregated fields from the table: "layout_page_tops" */
  layout_page_tops_aggregate: Layout_Page_Tops_Aggregate;
  /** fetch data from the table: "layout_page_tops" using primary key columns */
  layout_page_tops_by_pk?: Maybe<Layout_Page_Tops>;
  /** fetch data from the table in a streaming manner: "layout_page_tops" */
  layout_page_tops_stream: Array<Layout_Page_Tops>;
  /** fetch data from the table: "layout_pages" */
  layout_pages: Array<Layout_Pages>;
  /** fetch aggregated fields from the table: "layout_pages" */
  layout_pages_aggregate: Layout_Pages_Aggregate;
  /** fetch data from the table: "layout_pages" using primary key columns */
  layout_pages_by_pk?: Maybe<Layout_Pages>;
  /** fetch data from the table in a streaming manner: "layout_pages" */
  layout_pages_stream: Array<Layout_Pages>;
  /** fetch data from the table: "layout_posts" */
  layout_posts: Array<Layout_Posts>;
  /** fetch aggregated fields from the table: "layout_posts" */
  layout_posts_aggregate: Layout_Posts_Aggregate;
  /** fetch data from the table: "layout_posts" using primary key columns */
  layout_posts_by_pk?: Maybe<Layout_Posts>;
  /** fetch data from the table in a streaming manner: "layout_posts" */
  layout_posts_stream: Array<Layout_Posts>;
  /** fetch data from the table: "layouts" */
  layouts: Array<Layouts>;
  /** fetch aggregated fields from the table: "layouts" */
  layouts_aggregate: Layouts_Aggregate;
  /** fetch data from the table: "layouts" using primary key columns */
  layouts_by_pk?: Maybe<Layouts>;
  /** fetch data from the table in a streaming manner: "layouts" */
  layouts_stream: Array<Layouts>;
  /** An array relationship */
  news_letters: Array<News_Letters>;
  /** An aggregate relationship */
  news_letters_aggregate: News_Letters_Aggregate;
  /** fetch data from the table: "news_letters" using primary key columns */
  news_letters_by_pk?: Maybe<News_Letters>;
  /** fetch data from the table in a streaming manner: "news_letters" */
  news_letters_stream: Array<News_Letters>;
  /** An array relationship */
  permissions: Array<Permissions>;
  /** An aggregate relationship */
  permissions_aggregate: Permissions_Aggregate;
  /** fetch data from the table: "permissions" using primary key columns */
  permissions_by_pk?: Maybe<Permissions>;
  /** An array relationship */
  permissions_roles: Array<Permissions_Roles>;
  /** An aggregate relationship */
  permissions_roles_aggregate: Permissions_Roles_Aggregate;
  /** fetch data from the table: "permissions_roles" using primary key columns */
  permissions_roles_by_pk?: Maybe<Permissions_Roles>;
  /** fetch data from the table in a streaming manner: "permissions_roles" */
  permissions_roles_stream: Array<Permissions_Roles>;
  /** fetch data from the table in a streaming manner: "permissions" */
  permissions_stream: Array<Permissions>;
  /** An array relationship */
  posts: Array<Posts>;
  /** An aggregate relationship */
  posts_aggregate: Posts_Aggregate;
  /** fetch data from the table: "posts" using primary key columns */
  posts_by_pk?: Maybe<Posts>;
  /** An array relationship */
  posts_categories: Array<Posts_Categories>;
  /** An aggregate relationship */
  posts_categories_aggregate: Posts_Categories_Aggregate;
  /** fetch data from the table: "posts_categories" using primary key columns */
  posts_categories_by_pk?: Maybe<Posts_Categories>;
  /** fetch data from the table in a streaming manner: "posts_categories" */
  posts_categories_stream: Array<Posts_Categories>;
  /** An array relationship */
  posts_comments: Array<Posts_Comments>;
  /** An aggregate relationship */
  posts_comments_aggregate: Posts_Comments_Aggregate;
  /** fetch data from the table: "posts_comments" using primary key columns */
  posts_comments_by_pk?: Maybe<Posts_Comments>;
  /** fetch data from the table: "posts_comments_count" */
  posts_comments_count: Array<Posts_Comments_Count>;
  /** fetch aggregated fields from the table: "posts_comments_count" */
  posts_comments_count_aggregate: Posts_Comments_Count_Aggregate;
  /** fetch data from the table in a streaming manner: "posts_comments_count" */
  posts_comments_count_stream: Array<Posts_Comments_Count>;
  /** fetch data from the table in a streaming manner: "posts_comments" */
  posts_comments_stream: Array<Posts_Comments>;
  /** An array relationship */
  posts_kpis: Array<Posts_Kpis>;
  /** An aggregate relationship */
  posts_kpis_aggregate: Posts_Kpis_Aggregate;
  /** fetch data from the table: "posts_kpis" using primary key columns */
  posts_kpis_by_pk?: Maybe<Posts_Kpis>;
  /** fetch data from the table in a streaming manner: "posts_kpis" */
  posts_kpis_stream: Array<Posts_Kpis>;
  /** An array relationship */
  posts_likes: Array<Posts_Likes>;
  /** An aggregate relationship */
  posts_likes_aggregate: Posts_Likes_Aggregate;
  /** fetch data from the table: "posts_likes" using primary key columns */
  posts_likes_by_pk?: Maybe<Posts_Likes>;
  /** fetch data from the table: "posts_likes_count" */
  posts_likes_count: Array<Posts_Likes_Count>;
  /** fetch aggregated fields from the table: "posts_likes_count" */
  posts_likes_count_aggregate: Posts_Likes_Count_Aggregate;
  /** fetch data from the table in a streaming manner: "posts_likes_count" */
  posts_likes_count_stream: Array<Posts_Likes_Count>;
  /** fetch data from the table in a streaming manner: "posts_likes" */
  posts_likes_stream: Array<Posts_Likes>;
  /** An array relationship */
  posts_sources: Array<Posts_Sources>;
  /** An aggregate relationship */
  posts_sources_aggregate: Posts_Sources_Aggregate;
  /** fetch data from the table: "posts_sources" using primary key columns */
  posts_sources_by_pk?: Maybe<Posts_Sources>;
  /** fetch data from the table in a streaming manner: "posts_sources" */
  posts_sources_stream: Array<Posts_Sources>;
  /** fetch data from the table in a streaming manner: "posts" */
  posts_stream: Array<Posts>;
  /** An array relationship */
  posts_tags: Array<Posts_Tags>;
  /** An aggregate relationship */
  posts_tags_aggregate: Posts_Tags_Aggregate;
  /** fetch data from the table: "posts_tags" using primary key columns */
  posts_tags_by_pk?: Maybe<Posts_Tags>;
  /** fetch data from the table in a streaming manner: "posts_tags" */
  posts_tags_stream: Array<Posts_Tags>;
  /** An array relationship */
  related_categories: Array<Related_Categories>;
  /** An aggregate relationship */
  related_categories_aggregate: Related_Categories_Aggregate;
  /** fetch data from the table: "related_categories" using primary key columns */
  related_categories_by_pk?: Maybe<Related_Categories>;
  /** fetch data from the table in a streaming manner: "related_categories" */
  related_categories_stream: Array<Related_Categories>;
  /** An array relationship */
  roles: Array<Roles>;
  /** An aggregate relationship */
  roles_aggregate: Roles_Aggregate;
  /** fetch data from the table: "roles" using primary key columns */
  roles_by_pk?: Maybe<Roles>;
  /** fetch data from the table in a streaming manner: "roles" */
  roles_stream: Array<Roles>;
  /** execute function "search_posts" which returns "posts" */
  search_posts: Array<Posts>;
  /** execute function "search_posts" and query aggregates on result of table type "posts" */
  search_posts_aggregate: Posts_Aggregate;
  /** fetch data from the table: "settings" */
  settings: Array<Settings>;
  /** fetch aggregated fields from the table: "settings" */
  settings_aggregate: Settings_Aggregate;
  /** fetch data from the table: "settings" using primary key columns */
  settings_by_pk?: Maybe<Settings>;
  /** fetch data from the table in a streaming manner: "settings" */
  settings_stream: Array<Settings>;
  /** An array relationship */
  sources: Array<Sources>;
  /** An aggregate relationship */
  sources_aggregate: Sources_Aggregate;
  /** fetch data from the table: "sources" using primary key columns */
  sources_by_pk?: Maybe<Sources>;
  /** fetch data from the table in a streaming manner: "sources" */
  sources_stream: Array<Sources>;
  /** An array relationship */
  tags: Array<Tags>;
  /** An aggregate relationship */
  tags_aggregate: Tags_Aggregate;
  /** fetch data from the table: "tags" using primary key columns */
  tags_by_pk?: Maybe<Tags>;
  /** fetch data from the table in a streaming manner: "tags" */
  tags_stream: Array<Tags>;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<Users>;
};


export type Subscription_RootAdvertisement_TypesArgs = {
  distinct_on?: InputMaybe<Array<Advertisement_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Advertisement_Types_Order_By>>;
  where?: InputMaybe<Advertisement_Types_Bool_Exp>;
};


export type Subscription_RootAdvertisement_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Advertisement_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Advertisement_Types_Order_By>>;
  where?: InputMaybe<Advertisement_Types_Bool_Exp>;
};


export type Subscription_RootAdvertisement_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootAdvertisement_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Advertisement_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Advertisement_Types_Bool_Exp>;
};


export type Subscription_RootAdvertisementsArgs = {
  distinct_on?: InputMaybe<Array<Advertisements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Advertisements_Order_By>>;
  where?: InputMaybe<Advertisements_Bool_Exp>;
};


export type Subscription_RootAdvertisements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Advertisements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Advertisements_Order_By>>;
  where?: InputMaybe<Advertisements_Bool_Exp>;
};


export type Subscription_RootAdvertisements_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootAdvertisements_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Advertisements_Stream_Cursor_Input>>;
  where?: InputMaybe<Advertisements_Bool_Exp>;
};


export type Subscription_RootBannersArgs = {
  distinct_on?: InputMaybe<Array<Banners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Banners_Order_By>>;
  where?: InputMaybe<Banners_Bool_Exp>;
};


export type Subscription_RootBanners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Banners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Banners_Order_By>>;
  where?: InputMaybe<Banners_Bool_Exp>;
};


export type Subscription_RootBanners_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootBanners_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Banners_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Banners_Categories_Order_By>>;
  where?: InputMaybe<Banners_Categories_Bool_Exp>;
};


export type Subscription_RootBanners_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Banners_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Banners_Categories_Order_By>>;
  where?: InputMaybe<Banners_Categories_Bool_Exp>;
};


export type Subscription_RootBanners_Categories_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootBanners_Categories_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Banners_Categories_Stream_Cursor_Input>>;
  where?: InputMaybe<Banners_Categories_Bool_Exp>;
};


export type Subscription_RootBanners_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Banners_Stream_Cursor_Input>>;
  where?: InputMaybe<Banners_Bool_Exp>;
};


export type Subscription_RootCategoriesArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


export type Subscription_RootCategories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


export type Subscription_RootCategories_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootCategories_Full_SlugArgs = {
  distinct_on?: InputMaybe<Array<Categories_Full_Slug_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Categories_Full_Slug_Order_By>>;
  where?: InputMaybe<Categories_Full_Slug_Bool_Exp>;
};


export type Subscription_RootCategories_Full_Slug_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Categories_Full_Slug_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Categories_Full_Slug_Order_By>>;
  where?: InputMaybe<Categories_Full_Slug_Bool_Exp>;
};


export type Subscription_RootCategories_Full_Slug_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Categories_Full_Slug_Stream_Cursor_Input>>;
  where?: InputMaybe<Categories_Full_Slug_Bool_Exp>;
};


export type Subscription_RootCategories_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Categories_Stream_Cursor_Input>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


export type Subscription_RootCategory_KpisArgs = {
  distinct_on?: InputMaybe<Array<Category_Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Category_Kpis_Order_By>>;
  where?: InputMaybe<Category_Kpis_Bool_Exp>;
};


export type Subscription_RootCategory_Kpis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Category_Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Category_Kpis_Order_By>>;
  where?: InputMaybe<Category_Kpis_Bool_Exp>;
};


export type Subscription_RootCategory_Kpis_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootCategory_Kpis_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Category_Kpis_Stream_Cursor_Input>>;
  where?: InputMaybe<Category_Kpis_Bool_Exp>;
};


export type Subscription_RootComments_LikesArgs = {
  distinct_on?: InputMaybe<Array<Comments_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Likes_Order_By>>;
  where?: InputMaybe<Comments_Likes_Bool_Exp>;
};


export type Subscription_RootComments_Likes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comments_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Likes_Order_By>>;
  where?: InputMaybe<Comments_Likes_Bool_Exp>;
};


export type Subscription_RootComments_Likes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootComments_Likes_CountArgs = {
  distinct_on?: InputMaybe<Array<Comments_Likes_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Likes_Count_Order_By>>;
  where?: InputMaybe<Comments_Likes_Count_Bool_Exp>;
};


export type Subscription_RootComments_Likes_Count_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comments_Likes_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Likes_Count_Order_By>>;
  where?: InputMaybe<Comments_Likes_Count_Bool_Exp>;
};


export type Subscription_RootComments_Likes_Count_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Comments_Likes_Count_Stream_Cursor_Input>>;
  where?: InputMaybe<Comments_Likes_Count_Bool_Exp>;
};


export type Subscription_RootComments_Likes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Comments_Likes_Stream_Cursor_Input>>;
  where?: InputMaybe<Comments_Likes_Bool_Exp>;
};


export type Subscription_RootGendersArgs = {
  distinct_on?: InputMaybe<Array<Genders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Genders_Order_By>>;
  where?: InputMaybe<Genders_Bool_Exp>;
};


export type Subscription_RootGenders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Genders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Genders_Order_By>>;
  where?: InputMaybe<Genders_Bool_Exp>;
};


export type Subscription_RootGenders_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootGenders_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Genders_Stream_Cursor_Input>>;
  where?: InputMaybe<Genders_Bool_Exp>;
};


export type Subscription_RootGet_All_PostsArgs = {
  args: Get_All_Posts_Args;
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


export type Subscription_RootGet_All_Posts_AggregateArgs = {
  args: Get_All_Posts_Args;
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


export type Subscription_RootGet_Banner_ImagesArgs = {
  args: Get_Banner_Images_Args;
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


export type Subscription_RootGet_Banner_Images_AggregateArgs = {
  args: Get_Banner_Images_Args;
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


export type Subscription_RootGet_Post_ImagesArgs = {
  args: Get_Post_Images_Args;
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


export type Subscription_RootGet_Post_Images_AggregateArgs = {
  args: Get_Post_Images_Args;
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


export type Subscription_RootGet_Post_ThumbnailArgs = {
  args: Get_Post_Thumbnail_Args;
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


export type Subscription_RootGet_Post_Thumbnail_AggregateArgs = {
  args: Get_Post_Thumbnail_Args;
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


export type Subscription_RootGet_Posts_By_Category_IdArgs = {
  args: Get_Posts_By_Category_Id_Args;
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


export type Subscription_RootGet_Posts_By_Category_Id_AggregateArgs = {
  args: Get_Posts_By_Category_Id_Args;
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


export type Subscription_RootGet_User_AvatarArgs = {
  args: Get_User_Avatar_Args;
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


export type Subscription_RootGet_User_Avatar_AggregateArgs = {
  args: Get_User_Avatar_Args;
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


export type Subscription_RootGroup_KpisArgs = {
  distinct_on?: InputMaybe<Array<Group_Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Group_Kpis_Order_By>>;
  where?: InputMaybe<Group_Kpis_Bool_Exp>;
};


export type Subscription_RootGroup_Kpis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Group_Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Group_Kpis_Order_By>>;
  where?: InputMaybe<Group_Kpis_Bool_Exp>;
};


export type Subscription_RootGroup_Kpis_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootGroup_Kpis_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Group_Kpis_Stream_Cursor_Input>>;
  where?: InputMaybe<Group_Kpis_Bool_Exp>;
};


export type Subscription_RootImage_SubtypesArgs = {
  distinct_on?: InputMaybe<Array<Image_Subtypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Image_Subtypes_Order_By>>;
  where?: InputMaybe<Image_Subtypes_Bool_Exp>;
};


export type Subscription_RootImage_Subtypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Image_Subtypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Image_Subtypes_Order_By>>;
  where?: InputMaybe<Image_Subtypes_Bool_Exp>;
};


export type Subscription_RootImage_Subtypes_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootImage_Subtypes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Image_Subtypes_Stream_Cursor_Input>>;
  where?: InputMaybe<Image_Subtypes_Bool_Exp>;
};


export type Subscription_RootImage_TypesArgs = {
  distinct_on?: InputMaybe<Array<Image_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Image_Types_Order_By>>;
  where?: InputMaybe<Image_Types_Bool_Exp>;
};


export type Subscription_RootImage_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Image_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Image_Types_Order_By>>;
  where?: InputMaybe<Image_Types_Bool_Exp>;
};


export type Subscription_RootImage_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootImage_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Image_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Image_Types_Bool_Exp>;
};


export type Subscription_RootImagesArgs = {
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


export type Subscription_RootImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


export type Subscription_RootImages_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootImages_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Images_Stream_Cursor_Input>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


export type Subscription_RootKpisArgs = {
  distinct_on?: InputMaybe<Array<Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Kpis_Order_By>>;
  where?: InputMaybe<Kpis_Bool_Exp>;
};


export type Subscription_RootKpis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Kpis_Order_By>>;
  where?: InputMaybe<Kpis_Bool_Exp>;
};


export type Subscription_RootKpis_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootKpis_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Kpis_Stream_Cursor_Input>>;
  where?: InputMaybe<Kpis_Bool_Exp>;
};


export type Subscription_RootLanguagesArgs = {
  distinct_on?: InputMaybe<Array<Languages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Languages_Order_By>>;
  where?: InputMaybe<Languages_Bool_Exp>;
};


export type Subscription_RootLanguages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Languages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Languages_Order_By>>;
  where?: InputMaybe<Languages_Bool_Exp>;
};


export type Subscription_RootLanguages_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootLanguages_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Languages_Stream_Cursor_Input>>;
  where?: InputMaybe<Languages_Bool_Exp>;
};


export type Subscription_RootLayout_Page_BottomsArgs = {
  distinct_on?: InputMaybe<Array<Layout_Page_Bottoms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Layout_Page_Bottoms_Order_By>>;
  where?: InputMaybe<Layout_Page_Bottoms_Bool_Exp>;
};


export type Subscription_RootLayout_Page_Bottoms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Layout_Page_Bottoms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Layout_Page_Bottoms_Order_By>>;
  where?: InputMaybe<Layout_Page_Bottoms_Bool_Exp>;
};


export type Subscription_RootLayout_Page_Bottoms_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootLayout_Page_Bottoms_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Layout_Page_Bottoms_Stream_Cursor_Input>>;
  where?: InputMaybe<Layout_Page_Bottoms_Bool_Exp>;
};


export type Subscription_RootLayout_Page_TopsArgs = {
  distinct_on?: InputMaybe<Array<Layout_Page_Tops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Layout_Page_Tops_Order_By>>;
  where?: InputMaybe<Layout_Page_Tops_Bool_Exp>;
};


export type Subscription_RootLayout_Page_Tops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Layout_Page_Tops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Layout_Page_Tops_Order_By>>;
  where?: InputMaybe<Layout_Page_Tops_Bool_Exp>;
};


export type Subscription_RootLayout_Page_Tops_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootLayout_Page_Tops_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Layout_Page_Tops_Stream_Cursor_Input>>;
  where?: InputMaybe<Layout_Page_Tops_Bool_Exp>;
};


export type Subscription_RootLayout_PagesArgs = {
  distinct_on?: InputMaybe<Array<Layout_Pages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Layout_Pages_Order_By>>;
  where?: InputMaybe<Layout_Pages_Bool_Exp>;
};


export type Subscription_RootLayout_Pages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Layout_Pages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Layout_Pages_Order_By>>;
  where?: InputMaybe<Layout_Pages_Bool_Exp>;
};


export type Subscription_RootLayout_Pages_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootLayout_Pages_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Layout_Pages_Stream_Cursor_Input>>;
  where?: InputMaybe<Layout_Pages_Bool_Exp>;
};


export type Subscription_RootLayout_PostsArgs = {
  distinct_on?: InputMaybe<Array<Layout_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Layout_Posts_Order_By>>;
  where?: InputMaybe<Layout_Posts_Bool_Exp>;
};


export type Subscription_RootLayout_Posts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Layout_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Layout_Posts_Order_By>>;
  where?: InputMaybe<Layout_Posts_Bool_Exp>;
};


export type Subscription_RootLayout_Posts_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootLayout_Posts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Layout_Posts_Stream_Cursor_Input>>;
  where?: InputMaybe<Layout_Posts_Bool_Exp>;
};


export type Subscription_RootLayoutsArgs = {
  distinct_on?: InputMaybe<Array<Layouts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Layouts_Order_By>>;
  where?: InputMaybe<Layouts_Bool_Exp>;
};


export type Subscription_RootLayouts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Layouts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Layouts_Order_By>>;
  where?: InputMaybe<Layouts_Bool_Exp>;
};


export type Subscription_RootLayouts_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootLayouts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Layouts_Stream_Cursor_Input>>;
  where?: InputMaybe<Layouts_Bool_Exp>;
};


export type Subscription_RootNews_LettersArgs = {
  distinct_on?: InputMaybe<Array<News_Letters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<News_Letters_Order_By>>;
  where?: InputMaybe<News_Letters_Bool_Exp>;
};


export type Subscription_RootNews_Letters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<News_Letters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<News_Letters_Order_By>>;
  where?: InputMaybe<News_Letters_Bool_Exp>;
};


export type Subscription_RootNews_Letters_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootNews_Letters_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<News_Letters_Stream_Cursor_Input>>;
  where?: InputMaybe<News_Letters_Bool_Exp>;
};


export type Subscription_RootPermissionsArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissions_Order_By>>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};


export type Subscription_RootPermissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissions_Order_By>>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};


export type Subscription_RootPermissions_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootPermissions_RolesArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissions_Roles_Order_By>>;
  where?: InputMaybe<Permissions_Roles_Bool_Exp>;
};


export type Subscription_RootPermissions_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissions_Roles_Order_By>>;
  where?: InputMaybe<Permissions_Roles_Bool_Exp>;
};


export type Subscription_RootPermissions_Roles_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootPermissions_Roles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Permissions_Roles_Stream_Cursor_Input>>;
  where?: InputMaybe<Permissions_Roles_Bool_Exp>;
};


export type Subscription_RootPermissions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Permissions_Stream_Cursor_Input>>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};


export type Subscription_RootPostsArgs = {
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


export type Subscription_RootPosts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


export type Subscription_RootPosts_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootPosts_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Posts_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Categories_Order_By>>;
  where?: InputMaybe<Posts_Categories_Bool_Exp>;
};


export type Subscription_RootPosts_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Categories_Order_By>>;
  where?: InputMaybe<Posts_Categories_Bool_Exp>;
};


export type Subscription_RootPosts_Categories_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootPosts_Categories_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Posts_Categories_Stream_Cursor_Input>>;
  where?: InputMaybe<Posts_Categories_Bool_Exp>;
};


export type Subscription_RootPosts_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Posts_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Comments_Order_By>>;
  where?: InputMaybe<Posts_Comments_Bool_Exp>;
};


export type Subscription_RootPosts_Comments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Comments_Order_By>>;
  where?: InputMaybe<Posts_Comments_Bool_Exp>;
};


export type Subscription_RootPosts_Comments_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootPosts_Comments_CountArgs = {
  distinct_on?: InputMaybe<Array<Posts_Comments_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Comments_Count_Order_By>>;
  where?: InputMaybe<Posts_Comments_Count_Bool_Exp>;
};


export type Subscription_RootPosts_Comments_Count_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Comments_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Comments_Count_Order_By>>;
  where?: InputMaybe<Posts_Comments_Count_Bool_Exp>;
};


export type Subscription_RootPosts_Comments_Count_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Posts_Comments_Count_Stream_Cursor_Input>>;
  where?: InputMaybe<Posts_Comments_Count_Bool_Exp>;
};


export type Subscription_RootPosts_Comments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Posts_Comments_Stream_Cursor_Input>>;
  where?: InputMaybe<Posts_Comments_Bool_Exp>;
};


export type Subscription_RootPosts_KpisArgs = {
  distinct_on?: InputMaybe<Array<Posts_Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Kpis_Order_By>>;
  where?: InputMaybe<Posts_Kpis_Bool_Exp>;
};


export type Subscription_RootPosts_Kpis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Kpis_Order_By>>;
  where?: InputMaybe<Posts_Kpis_Bool_Exp>;
};


export type Subscription_RootPosts_Kpis_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootPosts_Kpis_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Posts_Kpis_Stream_Cursor_Input>>;
  where?: InputMaybe<Posts_Kpis_Bool_Exp>;
};


export type Subscription_RootPosts_LikesArgs = {
  distinct_on?: InputMaybe<Array<Posts_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Likes_Order_By>>;
  where?: InputMaybe<Posts_Likes_Bool_Exp>;
};


export type Subscription_RootPosts_Likes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Likes_Order_By>>;
  where?: InputMaybe<Posts_Likes_Bool_Exp>;
};


export type Subscription_RootPosts_Likes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootPosts_Likes_CountArgs = {
  distinct_on?: InputMaybe<Array<Posts_Likes_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Likes_Count_Order_By>>;
  where?: InputMaybe<Posts_Likes_Count_Bool_Exp>;
};


export type Subscription_RootPosts_Likes_Count_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Likes_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Likes_Count_Order_By>>;
  where?: InputMaybe<Posts_Likes_Count_Bool_Exp>;
};


export type Subscription_RootPosts_Likes_Count_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Posts_Likes_Count_Stream_Cursor_Input>>;
  where?: InputMaybe<Posts_Likes_Count_Bool_Exp>;
};


export type Subscription_RootPosts_Likes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Posts_Likes_Stream_Cursor_Input>>;
  where?: InputMaybe<Posts_Likes_Bool_Exp>;
};


export type Subscription_RootPosts_SourcesArgs = {
  distinct_on?: InputMaybe<Array<Posts_Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Sources_Order_By>>;
  where?: InputMaybe<Posts_Sources_Bool_Exp>;
};


export type Subscription_RootPosts_Sources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Sources_Order_By>>;
  where?: InputMaybe<Posts_Sources_Bool_Exp>;
};


export type Subscription_RootPosts_Sources_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootPosts_Sources_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Posts_Sources_Stream_Cursor_Input>>;
  where?: InputMaybe<Posts_Sources_Bool_Exp>;
};


export type Subscription_RootPosts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Posts_Stream_Cursor_Input>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


export type Subscription_RootPosts_TagsArgs = {
  distinct_on?: InputMaybe<Array<Posts_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Tags_Order_By>>;
  where?: InputMaybe<Posts_Tags_Bool_Exp>;
};


export type Subscription_RootPosts_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Tags_Order_By>>;
  where?: InputMaybe<Posts_Tags_Bool_Exp>;
};


export type Subscription_RootPosts_Tags_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootPosts_Tags_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Posts_Tags_Stream_Cursor_Input>>;
  where?: InputMaybe<Posts_Tags_Bool_Exp>;
};


export type Subscription_RootRelated_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Related_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Related_Categories_Order_By>>;
  where?: InputMaybe<Related_Categories_Bool_Exp>;
};


export type Subscription_RootRelated_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Related_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Related_Categories_Order_By>>;
  where?: InputMaybe<Related_Categories_Bool_Exp>;
};


export type Subscription_RootRelated_Categories_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootRelated_Categories_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Related_Categories_Stream_Cursor_Input>>;
  where?: InputMaybe<Related_Categories_Bool_Exp>;
};


export type Subscription_RootRolesArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Subscription_RootRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Subscription_RootRoles_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootRoles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Roles_Stream_Cursor_Input>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Subscription_RootSearch_PostsArgs = {
  args: Search_Posts_Args;
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


export type Subscription_RootSearch_Posts_AggregateArgs = {
  args: Search_Posts_Args;
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


export type Subscription_RootSettingsArgs = {
  distinct_on?: InputMaybe<Array<Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Settings_Order_By>>;
  where?: InputMaybe<Settings_Bool_Exp>;
};


export type Subscription_RootSettings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Settings_Order_By>>;
  where?: InputMaybe<Settings_Bool_Exp>;
};


export type Subscription_RootSettings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootSettings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<Settings_Bool_Exp>;
};


export type Subscription_RootSourcesArgs = {
  distinct_on?: InputMaybe<Array<Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sources_Order_By>>;
  where?: InputMaybe<Sources_Bool_Exp>;
};


export type Subscription_RootSources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sources_Order_By>>;
  where?: InputMaybe<Sources_Bool_Exp>;
};


export type Subscription_RootSources_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootSources_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sources_Stream_Cursor_Input>>;
  where?: InputMaybe<Sources_Bool_Exp>;
};


export type Subscription_RootTagsArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Subscription_RootTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Subscription_RootTags_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootTags_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tags_Stream_Cursor_Input>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** columns and relationships of "tags" */
export type Tags = {
  __typename?: 'tags';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by?: Maybe<Users>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  deleted_by?: Maybe<Users>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['bigint']['output'];
  is_hot?: Maybe<Scalars['Boolean']['output']>;
  /** A computed field, executes function "get_tag_name_i18n" */
  name?: Maybe<Scalars['String']['output']>;
  name_i18n?: Maybe<Scalars['jsonb']['output']>;
  pin_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  posts_tags: Array<Posts_Tags>;
  /** An aggregate relationship */
  posts_tags_aggregate: Posts_Tags_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  updated_by?: Maybe<Users>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};


/** columns and relationships of "tags" */
export type TagsName_I18nArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "tags" */
export type TagsPosts_TagsArgs = {
  distinct_on?: InputMaybe<Array<Posts_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Tags_Order_By>>;
  where?: InputMaybe<Posts_Tags_Bool_Exp>;
};


/** columns and relationships of "tags" */
export type TagsPosts_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Tags_Order_By>>;
  where?: InputMaybe<Posts_Tags_Bool_Exp>;
};

/** aggregated selection of "tags" */
export type Tags_Aggregate = {
  __typename?: 'tags_aggregate';
  aggregate?: Maybe<Tags_Aggregate_Fields>;
  nodes: Array<Tags>;
};

export type Tags_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Tags_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Tags_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Tags_Aggregate_Bool_Exp_Count>;
};

export type Tags_Aggregate_Bool_Exp_Bool_And = {
  arguments: Tags_Select_Column_Tags_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tags_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tags_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Tags_Select_Column_Tags_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tags_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tags_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tags_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tags" */
export type Tags_Aggregate_Fields = {
  __typename?: 'tags_aggregate_fields';
  avg?: Maybe<Tags_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Tags_Max_Fields>;
  min?: Maybe<Tags_Min_Fields>;
  stddev?: Maybe<Tags_Stddev_Fields>;
  stddev_pop?: Maybe<Tags_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tags_Stddev_Samp_Fields>;
  sum?: Maybe<Tags_Sum_Fields>;
  var_pop?: Maybe<Tags_Var_Pop_Fields>;
  var_samp?: Maybe<Tags_Var_Samp_Fields>;
  variance?: Maybe<Tags_Variance_Fields>;
};


/** aggregate fields of "tags" */
export type Tags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tags" */
export type Tags_Aggregate_Order_By = {
  avg?: InputMaybe<Tags_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tags_Max_Order_By>;
  min?: InputMaybe<Tags_Min_Order_By>;
  stddev?: InputMaybe<Tags_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Tags_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Tags_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Tags_Sum_Order_By>;
  var_pop?: InputMaybe<Tags_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Tags_Var_Samp_Order_By>;
  variance?: InputMaybe<Tags_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tags_Append_Input = {
  name_i18n?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tags" */
export type Tags_Arr_Rel_Insert_Input = {
  data: Array<Tags_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tags_On_Conflict>;
};

/** aggregate avg on columns */
export type Tags_Avg_Fields = {
  __typename?: 'tags_avg_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tags" */
export type Tags_Avg_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tags". All fields are combined with a logical 'AND'. */
export type Tags_Bool_Exp = {
  _and?: InputMaybe<Array<Tags_Bool_Exp>>;
  _not?: InputMaybe<Tags_Bool_Exp>;
  _or?: InputMaybe<Array<Tags_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Users_Bool_Exp>;
  created_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_by?: InputMaybe<Users_Bool_Exp>;
  deleted_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_hot?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  name_i18n?: InputMaybe<Jsonb_Comparison_Exp>;
  pin_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  posts_tags?: InputMaybe<Posts_Tags_Bool_Exp>;
  posts_tags_aggregate?: InputMaybe<Posts_Tags_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Users_Bool_Exp>;
  updated_by_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "tags" */
export enum Tags_Constraint {
  /** unique or primary key constraint on columns "id" */
  TagsPkey = 'tags_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tags_Delete_At_Path_Input = {
  name_i18n?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tags_Delete_Elem_Input = {
  name_i18n?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tags_Delete_Key_Input = {
  name_i18n?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "tags" */
export type Tags_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "tags" */
export type Tags_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_hot?: InputMaybe<Scalars['Boolean']['input']>;
  name_i18n?: InputMaybe<Scalars['jsonb']['input']>;
  pin_at?: InputMaybe<Scalars['timestamptz']['input']>;
  posts_tags?: InputMaybe<Posts_Tags_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Tags_Max_Fields = {
  __typename?: 'tags_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "get_tag_name_i18n" */
  name?: Maybe<Scalars['String']['output']>;
  pin_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "tags" */
export type Tags_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pin_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tags_Min_Fields = {
  __typename?: 'tags_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "get_tag_name_i18n" */
  name?: Maybe<Scalars['String']['output']>;
  pin_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "tags" */
export type Tags_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pin_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tags" */
export type Tags_Mutation_Response = {
  __typename?: 'tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tags>;
};

/** input type for inserting object relation for remote table "tags" */
export type Tags_Obj_Rel_Insert_Input = {
  data: Tags_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tags_On_Conflict>;
};

/** on_conflict condition type for table "tags" */
export type Tags_On_Conflict = {
  constraint: Tags_Constraint;
  update_columns?: Array<Tags_Update_Column>;
  where?: InputMaybe<Tags_Bool_Exp>;
};

/** Ordering options when selecting data from "tags". */
export type Tags_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Users_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by?: InputMaybe<Users_Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_hot?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_i18n?: InputMaybe<Order_By>;
  pin_at?: InputMaybe<Order_By>;
  posts_tags_aggregate?: InputMaybe<Posts_Tags_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Users_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tags */
export type Tags_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tags_Prepend_Input = {
  name_i18n?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tags" */
export enum Tags_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsHot = 'is_hot',
  /** column name */
  NameI18n = 'name_i18n',
  /** column name */
  PinAt = 'pin_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "tags_aggregate_bool_exp_bool_and_arguments_columns" columns of table "tags" */
export enum Tags_Select_Column_Tags_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsHot = 'is_hot'
}

/** select "tags_aggregate_bool_exp_bool_or_arguments_columns" columns of table "tags" */
export enum Tags_Select_Column_Tags_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsHot = 'is_hot'
}

/** input type for updating data in table "tags" */
export type Tags_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_hot?: InputMaybe<Scalars['Boolean']['input']>;
  name_i18n?: InputMaybe<Scalars['jsonb']['input']>;
  pin_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Tags_Stddev_Fields = {
  __typename?: 'tags_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tags" */
export type Tags_Stddev_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Tags_Stddev_Pop_Fields = {
  __typename?: 'tags_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "tags" */
export type Tags_Stddev_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Tags_Stddev_Samp_Fields = {
  __typename?: 'tags_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "tags" */
export type Tags_Stddev_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "tags" */
export type Tags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tags_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_hot?: InputMaybe<Scalars['Boolean']['input']>;
  name_i18n?: InputMaybe<Scalars['jsonb']['input']>;
  pin_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Tags_Sum_Fields = {
  __typename?: 'tags_sum_fields';
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "tags" */
export type Tags_Sum_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "tags" */
export enum Tags_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsHot = 'is_hot',
  /** column name */
  NameI18n = 'name_i18n',
  /** column name */
  PinAt = 'pin_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Tags_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tags_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tags_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tags_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tags_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tags_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tags_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tags_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tags_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tags_Var_Pop_Fields = {
  __typename?: 'tags_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "tags" */
export type Tags_Var_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Tags_Var_Samp_Fields = {
  __typename?: 'tags_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "tags" */
export type Tags_Var_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Tags_Variance_Fields = {
  __typename?: 'tags_variance_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tags" */
export type Tags_Variance_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  address?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "get_user_avatar" */
  avatar?: Maybe<Array<Images>>;
  /** An array relationship */
  banners: Array<Banners>;
  /** An array relationship */
  bannersByDeletedById: Array<Banners>;
  /** An aggregate relationship */
  bannersByDeletedById_aggregate: Banners_Aggregate;
  /** An array relationship */
  bannersByUpdatedById: Array<Banners>;
  /** An aggregate relationship */
  bannersByUpdatedById_aggregate: Banners_Aggregate;
  /** An aggregate relationship */
  banners_aggregate: Banners_Aggregate;
  /** An array relationship */
  categories: Array<Categories>;
  /** An array relationship */
  categoriesByDeletedById: Array<Categories>;
  /** An aggregate relationship */
  categoriesByDeletedById_aggregate: Categories_Aggregate;
  /** An array relationship */
  categoriesByUpdatedById: Array<Categories>;
  /** An aggregate relationship */
  categoriesByUpdatedById_aggregate: Categories_Aggregate;
  /** An aggregate relationship */
  categories_aggregate: Categories_Aggregate;
  /** An array relationship */
  comments: Array<Posts_Comments>;
  /** An aggregate relationship */
  comments_aggregate: Posts_Comments_Aggregate;
  /** An array relationship */
  comments_likes: Array<Comments_Likes>;
  /** An aggregate relationship */
  comments_likes_aggregate: Comments_Likes_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by?: Maybe<Users>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  deleted_by?: Maybe<Users>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  dob?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Genders_Enum>;
  /** An array relationship */
  groupKpisByDeletedById: Array<Group_Kpis>;
  /** An aggregate relationship */
  groupKpisByDeletedById_aggregate: Group_Kpis_Aggregate;
  /** An array relationship */
  groupKpisByUpdatedById: Array<Group_Kpis>;
  /** An aggregate relationship */
  groupKpisByUpdatedById_aggregate: Group_Kpis_Aggregate;
  /** An array relationship */
  group_kpis: Array<Group_Kpis>;
  /** An aggregate relationship */
  group_kpis_aggregate: Group_Kpis_Aggregate;
  hasura_role?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  /** An array relationship */
  images: Array<Images>;
  /** An array relationship */
  imagesByDeletedById: Array<Images>;
  /** An aggregate relationship */
  imagesByDeletedById_aggregate: Images_Aggregate;
  /** An array relationship */
  imagesByUpdatedById: Array<Images>;
  /** An aggregate relationship */
  imagesByUpdatedById_aggregate: Images_Aggregate;
  /** An aggregate relationship */
  images_aggregate: Images_Aggregate;
  is_email_verified?: Maybe<Scalars['Boolean']['output']>;
  is_phone_verified?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  kpis: Array<Kpis>;
  /** An array relationship */
  kpisByDeletedById: Array<Kpis>;
  /** An aggregate relationship */
  kpisByDeletedById_aggregate: Kpis_Aggregate;
  /** An array relationship */
  kpisByUpdatedById: Array<Kpis>;
  /** An aggregate relationship */
  kpisByUpdatedById_aggregate: Kpis_Aggregate;
  /** An aggregate relationship */
  kpis_aggregate: Kpis_Aggregate;
  /** An array relationship */
  newsLettersByDeletedById: Array<News_Letters>;
  /** An aggregate relationship */
  newsLettersByDeletedById_aggregate: News_Letters_Aggregate;
  /** An array relationship */
  newsLettersByUpdatedById: Array<News_Letters>;
  /** An aggregate relationship */
  newsLettersByUpdatedById_aggregate: News_Letters_Aggregate;
  /** An array relationship */
  news_letters: Array<News_Letters>;
  /** An aggregate relationship */
  news_letters_aggregate: News_Letters_Aggregate;
  password?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  permissions: Array<Permissions>;
  /** An array relationship */
  permissionsByDeletedById: Array<Permissions>;
  /** An aggregate relationship */
  permissionsByDeletedById_aggregate: Permissions_Aggregate;
  /** An array relationship */
  permissionsByUpdatedById: Array<Permissions>;
  /** An aggregate relationship */
  permissionsByUpdatedById_aggregate: Permissions_Aggregate;
  /** An array relationship */
  permissionsRolesByDeletedById: Array<Permissions_Roles>;
  /** An aggregate relationship */
  permissionsRolesByDeletedById_aggregate: Permissions_Roles_Aggregate;
  /** An array relationship */
  permissionsRolesByUpdatedById: Array<Permissions_Roles>;
  /** An aggregate relationship */
  permissionsRolesByUpdatedById_aggregate: Permissions_Roles_Aggregate;
  /** An aggregate relationship */
  permissions_aggregate: Permissions_Aggregate;
  /** An array relationship */
  permissions_roles: Array<Permissions_Roles>;
  /** An aggregate relationship */
  permissions_roles_aggregate: Permissions_Roles_Aggregate;
  phone_number?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  posts: Array<Posts>;
  /** An array relationship */
  postsByCreatedById: Array<Posts>;
  /** An aggregate relationship */
  postsByCreatedById_aggregate: Posts_Aggregate;
  /** An array relationship */
  postsByDeletedById: Array<Posts>;
  /** An aggregate relationship */
  postsByDeletedById_aggregate: Posts_Aggregate;
  /** An array relationship */
  postsByUpdatedById: Array<Posts>;
  /** An aggregate relationship */
  postsByUpdatedById_aggregate: Posts_Aggregate;
  /** An array relationship */
  postsCatogoriesByDeletedById: Array<Posts_Categories>;
  /** An aggregate relationship */
  postsCatogoriesByDeletedById_aggregate: Posts_Categories_Aggregate;
  /** An array relationship */
  postsCatogoriesByUpdatedById: Array<Posts_Categories>;
  /** An aggregate relationship */
  postsCatogoriesByUpdatedById_aggregate: Posts_Categories_Aggregate;
  /** An array relationship */
  postsKpisByDeletedById: Array<Posts_Kpis>;
  /** An aggregate relationship */
  postsKpisByDeletedById_aggregate: Posts_Kpis_Aggregate;
  /** An array relationship */
  postsKpisByUpdatedById: Array<Posts_Kpis>;
  /** An aggregate relationship */
  postsKpisByUpdatedById_aggregate: Posts_Kpis_Aggregate;
  /** An array relationship */
  postsSourcesByDeletedById: Array<Posts_Sources>;
  /** An aggregate relationship */
  postsSourcesByDeletedById_aggregate: Posts_Sources_Aggregate;
  /** An array relationship */
  postsSourcesByUpdatedById: Array<Posts_Sources>;
  /** An aggregate relationship */
  postsSourcesByUpdatedById_aggregate: Posts_Sources_Aggregate;
  /** An array relationship */
  postsTagsByDeletedById: Array<Posts_Tags>;
  /** An aggregate relationship */
  postsTagsByDeletedById_aggregate: Posts_Tags_Aggregate;
  /** An array relationship */
  postsTagsByUpdatedById: Array<Posts_Tags>;
  /** An aggregate relationship */
  postsTagsByUpdatedById_aggregate: Posts_Tags_Aggregate;
  /** An aggregate relationship */
  posts_aggregate: Posts_Aggregate;
  /** An array relationship */
  posts_catogories: Array<Posts_Categories>;
  /** An aggregate relationship */
  posts_catogories_aggregate: Posts_Categories_Aggregate;
  /** An array relationship */
  posts_kpis: Array<Posts_Kpis>;
  /** An aggregate relationship */
  posts_kpis_aggregate: Posts_Kpis_Aggregate;
  /** An array relationship */
  posts_likes: Array<Posts_Likes>;
  /** An aggregate relationship */
  posts_likes_aggregate: Posts_Likes_Aggregate;
  /** An array relationship */
  posts_sources: Array<Posts_Sources>;
  /** An aggregate relationship */
  posts_sources_aggregate: Posts_Sources_Aggregate;
  /** An array relationship */
  posts_tags: Array<Posts_Tags>;
  /** An aggregate relationship */
  posts_tags_aggregate: Posts_Tags_Aggregate;
  preferred_language: Languages_Enum;
  /** An array relationship */
  relatedCategoriesByDeletedById: Array<Related_Categories>;
  /** An aggregate relationship */
  relatedCategoriesByDeletedById_aggregate: Related_Categories_Aggregate;
  /** An array relationship */
  relatedCategoriesByUpdatedById: Array<Related_Categories>;
  /** An aggregate relationship */
  relatedCategoriesByUpdatedById_aggregate: Related_Categories_Aggregate;
  /** An array relationship */
  related_categories: Array<Related_Categories>;
  /** An aggregate relationship */
  related_categories_aggregate: Related_Categories_Aggregate;
  /** An object relationship */
  role?: Maybe<Roles>;
  role_id?: Maybe<Scalars['bigint']['output']>;
  /** An array relationship */
  roles: Array<Roles>;
  /** An array relationship */
  rolesByDeletedById: Array<Roles>;
  /** An aggregate relationship */
  rolesByDeletedById_aggregate: Roles_Aggregate;
  /** An array relationship */
  rolesByUpdatedById: Array<Roles>;
  /** An aggregate relationship */
  rolesByUpdatedById_aggregate: Roles_Aggregate;
  /** An aggregate relationship */
  roles_aggregate: Roles_Aggregate;
  /** An array relationship */
  sources: Array<Sources>;
  /** An array relationship */
  sourcesByDeletedById: Array<Sources>;
  /** An aggregate relationship */
  sourcesByDeletedById_aggregate: Sources_Aggregate;
  /** An array relationship */
  sourcesByUpdatedById: Array<Sources>;
  /** An aggregate relationship */
  sourcesByUpdatedById_aggregate: Sources_Aggregate;
  /** An aggregate relationship */
  sources_aggregate: Sources_Aggregate;
  /** An array relationship */
  tags: Array<Tags>;
  /** An array relationship */
  tagsByDeletedById: Array<Tags>;
  /** An aggregate relationship */
  tagsByDeletedById_aggregate: Tags_Aggregate;
  /** An array relationship */
  tagsByUpdatedById: Array<Tags>;
  /** An aggregate relationship */
  tagsByUpdatedById_aggregate: Tags_Aggregate;
  /** An aggregate relationship */
  tags_aggregate: Tags_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  updated_by?: Maybe<Users>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  users: Array<Users>;
  /** An array relationship */
  usersByDeletedById: Array<Users>;
  /** An aggregate relationship */
  usersByDeletedById_aggregate: Users_Aggregate;
  /** An array relationship */
  usersByUpdatedById: Array<Users>;
  /** An aggregate relationship */
  usersByUpdatedById_aggregate: Users_Aggregate;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
};


/** columns and relationships of "users" */
export type UsersAvatarArgs = {
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBannersArgs = {
  distinct_on?: InputMaybe<Array<Banners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Banners_Order_By>>;
  where?: InputMaybe<Banners_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBannersByDeletedByIdArgs = {
  distinct_on?: InputMaybe<Array<Banners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Banners_Order_By>>;
  where?: InputMaybe<Banners_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBannersByDeletedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Banners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Banners_Order_By>>;
  where?: InputMaybe<Banners_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBannersByUpdatedByIdArgs = {
  distinct_on?: InputMaybe<Array<Banners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Banners_Order_By>>;
  where?: InputMaybe<Banners_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBannersByUpdatedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Banners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Banners_Order_By>>;
  where?: InputMaybe<Banners_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBanners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Banners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Banners_Order_By>>;
  where?: InputMaybe<Banners_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCategoriesArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCategoriesByDeletedByIdArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCategoriesByDeletedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCategoriesByUpdatedByIdArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCategoriesByUpdatedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCategories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCommentsArgs = {
  distinct_on?: InputMaybe<Array<Posts_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Comments_Order_By>>;
  where?: InputMaybe<Posts_Comments_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Comments_Order_By>>;
  where?: InputMaybe<Posts_Comments_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersComments_LikesArgs = {
  distinct_on?: InputMaybe<Array<Comments_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Likes_Order_By>>;
  where?: InputMaybe<Comments_Likes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersComments_Likes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comments_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Likes_Order_By>>;
  where?: InputMaybe<Comments_Likes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersGroupKpisByDeletedByIdArgs = {
  distinct_on?: InputMaybe<Array<Group_Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Group_Kpis_Order_By>>;
  where?: InputMaybe<Group_Kpis_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersGroupKpisByDeletedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Group_Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Group_Kpis_Order_By>>;
  where?: InputMaybe<Group_Kpis_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersGroupKpisByUpdatedByIdArgs = {
  distinct_on?: InputMaybe<Array<Group_Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Group_Kpis_Order_By>>;
  where?: InputMaybe<Group_Kpis_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersGroupKpisByUpdatedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Group_Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Group_Kpis_Order_By>>;
  where?: InputMaybe<Group_Kpis_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersGroup_KpisArgs = {
  distinct_on?: InputMaybe<Array<Group_Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Group_Kpis_Order_By>>;
  where?: InputMaybe<Group_Kpis_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersGroup_Kpis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Group_Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Group_Kpis_Order_By>>;
  where?: InputMaybe<Group_Kpis_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersImagesArgs = {
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersImagesByDeletedByIdArgs = {
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersImagesByDeletedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersImagesByUpdatedByIdArgs = {
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersImagesByUpdatedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersKpisArgs = {
  distinct_on?: InputMaybe<Array<Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Kpis_Order_By>>;
  where?: InputMaybe<Kpis_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersKpisByDeletedByIdArgs = {
  distinct_on?: InputMaybe<Array<Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Kpis_Order_By>>;
  where?: InputMaybe<Kpis_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersKpisByDeletedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Kpis_Order_By>>;
  where?: InputMaybe<Kpis_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersKpisByUpdatedByIdArgs = {
  distinct_on?: InputMaybe<Array<Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Kpis_Order_By>>;
  where?: InputMaybe<Kpis_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersKpisByUpdatedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Kpis_Order_By>>;
  where?: InputMaybe<Kpis_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersKpis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Kpis_Order_By>>;
  where?: InputMaybe<Kpis_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersNewsLettersByDeletedByIdArgs = {
  distinct_on?: InputMaybe<Array<News_Letters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<News_Letters_Order_By>>;
  where?: InputMaybe<News_Letters_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersNewsLettersByDeletedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<News_Letters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<News_Letters_Order_By>>;
  where?: InputMaybe<News_Letters_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersNewsLettersByUpdatedByIdArgs = {
  distinct_on?: InputMaybe<Array<News_Letters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<News_Letters_Order_By>>;
  where?: InputMaybe<News_Letters_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersNewsLettersByUpdatedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<News_Letters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<News_Letters_Order_By>>;
  where?: InputMaybe<News_Letters_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersNews_LettersArgs = {
  distinct_on?: InputMaybe<Array<News_Letters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<News_Letters_Order_By>>;
  where?: InputMaybe<News_Letters_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersNews_Letters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<News_Letters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<News_Letters_Order_By>>;
  where?: InputMaybe<News_Letters_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPermissionsArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissions_Order_By>>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPermissionsByDeletedByIdArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissions_Order_By>>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPermissionsByDeletedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissions_Order_By>>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPermissionsByUpdatedByIdArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissions_Order_By>>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPermissionsByUpdatedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissions_Order_By>>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPermissionsRolesByDeletedByIdArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissions_Roles_Order_By>>;
  where?: InputMaybe<Permissions_Roles_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPermissionsRolesByDeletedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissions_Roles_Order_By>>;
  where?: InputMaybe<Permissions_Roles_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPermissionsRolesByUpdatedByIdArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissions_Roles_Order_By>>;
  where?: InputMaybe<Permissions_Roles_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPermissionsRolesByUpdatedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissions_Roles_Order_By>>;
  where?: InputMaybe<Permissions_Roles_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPermissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissions_Order_By>>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPermissions_RolesArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissions_Roles_Order_By>>;
  where?: InputMaybe<Permissions_Roles_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPermissions_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissions_Roles_Order_By>>;
  where?: InputMaybe<Permissions_Roles_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPostsArgs = {
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPostsByCreatedByIdArgs = {
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPostsByCreatedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPostsByDeletedByIdArgs = {
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPostsByDeletedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPostsByUpdatedByIdArgs = {
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPostsByUpdatedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPostsCatogoriesByDeletedByIdArgs = {
  distinct_on?: InputMaybe<Array<Posts_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Categories_Order_By>>;
  where?: InputMaybe<Posts_Categories_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPostsCatogoriesByDeletedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Categories_Order_By>>;
  where?: InputMaybe<Posts_Categories_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPostsCatogoriesByUpdatedByIdArgs = {
  distinct_on?: InputMaybe<Array<Posts_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Categories_Order_By>>;
  where?: InputMaybe<Posts_Categories_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPostsCatogoriesByUpdatedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Categories_Order_By>>;
  where?: InputMaybe<Posts_Categories_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPostsKpisByDeletedByIdArgs = {
  distinct_on?: InputMaybe<Array<Posts_Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Kpis_Order_By>>;
  where?: InputMaybe<Posts_Kpis_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPostsKpisByDeletedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Kpis_Order_By>>;
  where?: InputMaybe<Posts_Kpis_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPostsKpisByUpdatedByIdArgs = {
  distinct_on?: InputMaybe<Array<Posts_Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Kpis_Order_By>>;
  where?: InputMaybe<Posts_Kpis_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPostsKpisByUpdatedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Kpis_Order_By>>;
  where?: InputMaybe<Posts_Kpis_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPostsSourcesByDeletedByIdArgs = {
  distinct_on?: InputMaybe<Array<Posts_Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Sources_Order_By>>;
  where?: InputMaybe<Posts_Sources_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPostsSourcesByDeletedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Sources_Order_By>>;
  where?: InputMaybe<Posts_Sources_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPostsSourcesByUpdatedByIdArgs = {
  distinct_on?: InputMaybe<Array<Posts_Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Sources_Order_By>>;
  where?: InputMaybe<Posts_Sources_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPostsSourcesByUpdatedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Sources_Order_By>>;
  where?: InputMaybe<Posts_Sources_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPostsTagsByDeletedByIdArgs = {
  distinct_on?: InputMaybe<Array<Posts_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Tags_Order_By>>;
  where?: InputMaybe<Posts_Tags_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPostsTagsByDeletedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Tags_Order_By>>;
  where?: InputMaybe<Posts_Tags_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPostsTagsByUpdatedByIdArgs = {
  distinct_on?: InputMaybe<Array<Posts_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Tags_Order_By>>;
  where?: InputMaybe<Posts_Tags_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPostsTagsByUpdatedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Tags_Order_By>>;
  where?: InputMaybe<Posts_Tags_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPosts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPosts_CatogoriesArgs = {
  distinct_on?: InputMaybe<Array<Posts_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Categories_Order_By>>;
  where?: InputMaybe<Posts_Categories_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPosts_Catogories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Categories_Order_By>>;
  where?: InputMaybe<Posts_Categories_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPosts_KpisArgs = {
  distinct_on?: InputMaybe<Array<Posts_Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Kpis_Order_By>>;
  where?: InputMaybe<Posts_Kpis_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPosts_Kpis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Kpis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Kpis_Order_By>>;
  where?: InputMaybe<Posts_Kpis_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPosts_LikesArgs = {
  distinct_on?: InputMaybe<Array<Posts_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Likes_Order_By>>;
  where?: InputMaybe<Posts_Likes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPosts_Likes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Likes_Order_By>>;
  where?: InputMaybe<Posts_Likes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPosts_SourcesArgs = {
  distinct_on?: InputMaybe<Array<Posts_Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Sources_Order_By>>;
  where?: InputMaybe<Posts_Sources_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPosts_Sources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Sources_Order_By>>;
  where?: InputMaybe<Posts_Sources_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPosts_TagsArgs = {
  distinct_on?: InputMaybe<Array<Posts_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Tags_Order_By>>;
  where?: InputMaybe<Posts_Tags_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPosts_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Tags_Order_By>>;
  where?: InputMaybe<Posts_Tags_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRelatedCategoriesByDeletedByIdArgs = {
  distinct_on?: InputMaybe<Array<Related_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Related_Categories_Order_By>>;
  where?: InputMaybe<Related_Categories_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRelatedCategoriesByDeletedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Related_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Related_Categories_Order_By>>;
  where?: InputMaybe<Related_Categories_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRelatedCategoriesByUpdatedByIdArgs = {
  distinct_on?: InputMaybe<Array<Related_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Related_Categories_Order_By>>;
  where?: InputMaybe<Related_Categories_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRelatedCategoriesByUpdatedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Related_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Related_Categories_Order_By>>;
  where?: InputMaybe<Related_Categories_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRelated_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Related_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Related_Categories_Order_By>>;
  where?: InputMaybe<Related_Categories_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRelated_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Related_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Related_Categories_Order_By>>;
  where?: InputMaybe<Related_Categories_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRolesArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRolesByDeletedByIdArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRolesByDeletedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRolesByUpdatedByIdArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRolesByUpdatedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSourcesArgs = {
  distinct_on?: InputMaybe<Array<Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sources_Order_By>>;
  where?: InputMaybe<Sources_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSourcesByDeletedByIdArgs = {
  distinct_on?: InputMaybe<Array<Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sources_Order_By>>;
  where?: InputMaybe<Sources_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSourcesByDeletedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sources_Order_By>>;
  where?: InputMaybe<Sources_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSourcesByUpdatedByIdArgs = {
  distinct_on?: InputMaybe<Array<Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sources_Order_By>>;
  where?: InputMaybe<Sources_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSourcesByUpdatedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sources_Order_By>>;
  where?: InputMaybe<Sources_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sources_Order_By>>;
  where?: InputMaybe<Sources_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTagsArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTagsByDeletedByIdArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTagsByDeletedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTagsByUpdatedByIdArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTagsByUpdatedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsersByDeletedByIdArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsersByDeletedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsersByUpdatedByIdArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsersByUpdatedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

export type Users_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Users_Aggregate_Bool_Exp_Count>;
};

export type Users_Aggregate_Bool_Exp_Bool_And = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  avg?: Maybe<Users_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
  stddev?: Maybe<Users_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Sum_Fields>;
  var_pop?: Maybe<Users_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Var_Samp_Fields>;
  variance?: Maybe<Users_Variance_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "users" */
export type Users_Aggregate_Order_By = {
  avg?: InputMaybe<Users_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Max_Order_By>;
  min?: InputMaybe<Users_Min_Order_By>;
  stddev?: InputMaybe<Users_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Users_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Users_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Users_Sum_Order_By>;
  var_pop?: InputMaybe<Users_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Users_Var_Samp_Order_By>;
  variance?: InputMaybe<Users_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "users" */
export type Users_Arr_Rel_Insert_Input = {
  data: Array<Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** aggregate avg on columns */
export type Users_Avg_Fields = {
  __typename?: 'users_avg_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "users" */
export type Users_Avg_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  avatar?: InputMaybe<Images_Bool_Exp>;
  banners?: InputMaybe<Banners_Bool_Exp>;
  bannersByDeletedById?: InputMaybe<Banners_Bool_Exp>;
  bannersByDeletedById_aggregate?: InputMaybe<Banners_Aggregate_Bool_Exp>;
  bannersByUpdatedById?: InputMaybe<Banners_Bool_Exp>;
  bannersByUpdatedById_aggregate?: InputMaybe<Banners_Aggregate_Bool_Exp>;
  banners_aggregate?: InputMaybe<Banners_Aggregate_Bool_Exp>;
  categories?: InputMaybe<Categories_Bool_Exp>;
  categoriesByDeletedById?: InputMaybe<Categories_Bool_Exp>;
  categoriesByDeletedById_aggregate?: InputMaybe<Categories_Aggregate_Bool_Exp>;
  categoriesByUpdatedById?: InputMaybe<Categories_Bool_Exp>;
  categoriesByUpdatedById_aggregate?: InputMaybe<Categories_Aggregate_Bool_Exp>;
  categories_aggregate?: InputMaybe<Categories_Aggregate_Bool_Exp>;
  comments?: InputMaybe<Posts_Comments_Bool_Exp>;
  comments_aggregate?: InputMaybe<Posts_Comments_Aggregate_Bool_Exp>;
  comments_likes?: InputMaybe<Comments_Likes_Bool_Exp>;
  comments_likes_aggregate?: InputMaybe<Comments_Likes_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Users_Bool_Exp>;
  created_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_by?: InputMaybe<Users_Bool_Exp>;
  deleted_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  dob?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<Genders_Enum_Comparison_Exp>;
  groupKpisByDeletedById?: InputMaybe<Group_Kpis_Bool_Exp>;
  groupKpisByDeletedById_aggregate?: InputMaybe<Group_Kpis_Aggregate_Bool_Exp>;
  groupKpisByUpdatedById?: InputMaybe<Group_Kpis_Bool_Exp>;
  groupKpisByUpdatedById_aggregate?: InputMaybe<Group_Kpis_Aggregate_Bool_Exp>;
  group_kpis?: InputMaybe<Group_Kpis_Bool_Exp>;
  group_kpis_aggregate?: InputMaybe<Group_Kpis_Aggregate_Bool_Exp>;
  hasura_role?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  images?: InputMaybe<Images_Bool_Exp>;
  imagesByDeletedById?: InputMaybe<Images_Bool_Exp>;
  imagesByDeletedById_aggregate?: InputMaybe<Images_Aggregate_Bool_Exp>;
  imagesByUpdatedById?: InputMaybe<Images_Bool_Exp>;
  imagesByUpdatedById_aggregate?: InputMaybe<Images_Aggregate_Bool_Exp>;
  images_aggregate?: InputMaybe<Images_Aggregate_Bool_Exp>;
  is_email_verified?: InputMaybe<Boolean_Comparison_Exp>;
  is_phone_verified?: InputMaybe<Boolean_Comparison_Exp>;
  kpis?: InputMaybe<Kpis_Bool_Exp>;
  kpisByDeletedById?: InputMaybe<Kpis_Bool_Exp>;
  kpisByDeletedById_aggregate?: InputMaybe<Kpis_Aggregate_Bool_Exp>;
  kpisByUpdatedById?: InputMaybe<Kpis_Bool_Exp>;
  kpisByUpdatedById_aggregate?: InputMaybe<Kpis_Aggregate_Bool_Exp>;
  kpis_aggregate?: InputMaybe<Kpis_Aggregate_Bool_Exp>;
  newsLettersByDeletedById?: InputMaybe<News_Letters_Bool_Exp>;
  newsLettersByDeletedById_aggregate?: InputMaybe<News_Letters_Aggregate_Bool_Exp>;
  newsLettersByUpdatedById?: InputMaybe<News_Letters_Bool_Exp>;
  newsLettersByUpdatedById_aggregate?: InputMaybe<News_Letters_Aggregate_Bool_Exp>;
  news_letters?: InputMaybe<News_Letters_Bool_Exp>;
  news_letters_aggregate?: InputMaybe<News_Letters_Aggregate_Bool_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  permissions?: InputMaybe<Permissions_Bool_Exp>;
  permissionsByDeletedById?: InputMaybe<Permissions_Bool_Exp>;
  permissionsByDeletedById_aggregate?: InputMaybe<Permissions_Aggregate_Bool_Exp>;
  permissionsByUpdatedById?: InputMaybe<Permissions_Bool_Exp>;
  permissionsByUpdatedById_aggregate?: InputMaybe<Permissions_Aggregate_Bool_Exp>;
  permissionsRolesByDeletedById?: InputMaybe<Permissions_Roles_Bool_Exp>;
  permissionsRolesByDeletedById_aggregate?: InputMaybe<Permissions_Roles_Aggregate_Bool_Exp>;
  permissionsRolesByUpdatedById?: InputMaybe<Permissions_Roles_Bool_Exp>;
  permissionsRolesByUpdatedById_aggregate?: InputMaybe<Permissions_Roles_Aggregate_Bool_Exp>;
  permissions_aggregate?: InputMaybe<Permissions_Aggregate_Bool_Exp>;
  permissions_roles?: InputMaybe<Permissions_Roles_Bool_Exp>;
  permissions_roles_aggregate?: InputMaybe<Permissions_Roles_Aggregate_Bool_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  posts?: InputMaybe<Posts_Bool_Exp>;
  postsByCreatedById?: InputMaybe<Posts_Bool_Exp>;
  postsByCreatedById_aggregate?: InputMaybe<Posts_Aggregate_Bool_Exp>;
  postsByDeletedById?: InputMaybe<Posts_Bool_Exp>;
  postsByDeletedById_aggregate?: InputMaybe<Posts_Aggregate_Bool_Exp>;
  postsByUpdatedById?: InputMaybe<Posts_Bool_Exp>;
  postsByUpdatedById_aggregate?: InputMaybe<Posts_Aggregate_Bool_Exp>;
  postsCatogoriesByDeletedById?: InputMaybe<Posts_Categories_Bool_Exp>;
  postsCatogoriesByDeletedById_aggregate?: InputMaybe<Posts_Categories_Aggregate_Bool_Exp>;
  postsCatogoriesByUpdatedById?: InputMaybe<Posts_Categories_Bool_Exp>;
  postsCatogoriesByUpdatedById_aggregate?: InputMaybe<Posts_Categories_Aggregate_Bool_Exp>;
  postsKpisByDeletedById?: InputMaybe<Posts_Kpis_Bool_Exp>;
  postsKpisByDeletedById_aggregate?: InputMaybe<Posts_Kpis_Aggregate_Bool_Exp>;
  postsKpisByUpdatedById?: InputMaybe<Posts_Kpis_Bool_Exp>;
  postsKpisByUpdatedById_aggregate?: InputMaybe<Posts_Kpis_Aggregate_Bool_Exp>;
  postsSourcesByDeletedById?: InputMaybe<Posts_Sources_Bool_Exp>;
  postsSourcesByDeletedById_aggregate?: InputMaybe<Posts_Sources_Aggregate_Bool_Exp>;
  postsSourcesByUpdatedById?: InputMaybe<Posts_Sources_Bool_Exp>;
  postsSourcesByUpdatedById_aggregate?: InputMaybe<Posts_Sources_Aggregate_Bool_Exp>;
  postsTagsByDeletedById?: InputMaybe<Posts_Tags_Bool_Exp>;
  postsTagsByDeletedById_aggregate?: InputMaybe<Posts_Tags_Aggregate_Bool_Exp>;
  postsTagsByUpdatedById?: InputMaybe<Posts_Tags_Bool_Exp>;
  postsTagsByUpdatedById_aggregate?: InputMaybe<Posts_Tags_Aggregate_Bool_Exp>;
  posts_aggregate?: InputMaybe<Posts_Aggregate_Bool_Exp>;
  posts_catogories?: InputMaybe<Posts_Categories_Bool_Exp>;
  posts_catogories_aggregate?: InputMaybe<Posts_Categories_Aggregate_Bool_Exp>;
  posts_kpis?: InputMaybe<Posts_Kpis_Bool_Exp>;
  posts_kpis_aggregate?: InputMaybe<Posts_Kpis_Aggregate_Bool_Exp>;
  posts_likes?: InputMaybe<Posts_Likes_Bool_Exp>;
  posts_likes_aggregate?: InputMaybe<Posts_Likes_Aggregate_Bool_Exp>;
  posts_sources?: InputMaybe<Posts_Sources_Bool_Exp>;
  posts_sources_aggregate?: InputMaybe<Posts_Sources_Aggregate_Bool_Exp>;
  posts_tags?: InputMaybe<Posts_Tags_Bool_Exp>;
  posts_tags_aggregate?: InputMaybe<Posts_Tags_Aggregate_Bool_Exp>;
  preferred_language?: InputMaybe<Languages_Enum_Comparison_Exp>;
  relatedCategoriesByDeletedById?: InputMaybe<Related_Categories_Bool_Exp>;
  relatedCategoriesByDeletedById_aggregate?: InputMaybe<Related_Categories_Aggregate_Bool_Exp>;
  relatedCategoriesByUpdatedById?: InputMaybe<Related_Categories_Bool_Exp>;
  relatedCategoriesByUpdatedById_aggregate?: InputMaybe<Related_Categories_Aggregate_Bool_Exp>;
  related_categories?: InputMaybe<Related_Categories_Bool_Exp>;
  related_categories_aggregate?: InputMaybe<Related_Categories_Aggregate_Bool_Exp>;
  role?: InputMaybe<Roles_Bool_Exp>;
  role_id?: InputMaybe<Bigint_Comparison_Exp>;
  roles?: InputMaybe<Roles_Bool_Exp>;
  rolesByDeletedById?: InputMaybe<Roles_Bool_Exp>;
  rolesByDeletedById_aggregate?: InputMaybe<Roles_Aggregate_Bool_Exp>;
  rolesByUpdatedById?: InputMaybe<Roles_Bool_Exp>;
  rolesByUpdatedById_aggregate?: InputMaybe<Roles_Aggregate_Bool_Exp>;
  roles_aggregate?: InputMaybe<Roles_Aggregate_Bool_Exp>;
  sources?: InputMaybe<Sources_Bool_Exp>;
  sourcesByDeletedById?: InputMaybe<Sources_Bool_Exp>;
  sourcesByDeletedById_aggregate?: InputMaybe<Sources_Aggregate_Bool_Exp>;
  sourcesByUpdatedById?: InputMaybe<Sources_Bool_Exp>;
  sourcesByUpdatedById_aggregate?: InputMaybe<Sources_Aggregate_Bool_Exp>;
  sources_aggregate?: InputMaybe<Sources_Aggregate_Bool_Exp>;
  tags?: InputMaybe<Tags_Bool_Exp>;
  tagsByDeletedById?: InputMaybe<Tags_Bool_Exp>;
  tagsByDeletedById_aggregate?: InputMaybe<Tags_Aggregate_Bool_Exp>;
  tagsByUpdatedById?: InputMaybe<Tags_Bool_Exp>;
  tagsByUpdatedById_aggregate?: InputMaybe<Tags_Aggregate_Bool_Exp>;
  tags_aggregate?: InputMaybe<Tags_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Users_Bool_Exp>;
  updated_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  users?: InputMaybe<Users_Bool_Exp>;
  usersByDeletedById?: InputMaybe<Users_Bool_Exp>;
  usersByDeletedById_aggregate?: InputMaybe<Users_Aggregate_Bool_Exp>;
  usersByUpdatedById?: InputMaybe<Users_Bool_Exp>;
  usersByUpdatedById_aggregate?: InputMaybe<Users_Aggregate_Bool_Exp>;
  users_aggregate?: InputMaybe<Users_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey'
}

/** input type for incrementing numeric columns in table "users" */
export type Users_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  role_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  banners?: InputMaybe<Banners_Arr_Rel_Insert_Input>;
  bannersByDeletedById?: InputMaybe<Banners_Arr_Rel_Insert_Input>;
  bannersByUpdatedById?: InputMaybe<Banners_Arr_Rel_Insert_Input>;
  categories?: InputMaybe<Categories_Arr_Rel_Insert_Input>;
  categoriesByDeletedById?: InputMaybe<Categories_Arr_Rel_Insert_Input>;
  categoriesByUpdatedById?: InputMaybe<Categories_Arr_Rel_Insert_Input>;
  comments?: InputMaybe<Posts_Comments_Arr_Rel_Insert_Input>;
  comments_likes?: InputMaybe<Comments_Likes_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  dob?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Genders_Enum>;
  groupKpisByDeletedById?: InputMaybe<Group_Kpis_Arr_Rel_Insert_Input>;
  groupKpisByUpdatedById?: InputMaybe<Group_Kpis_Arr_Rel_Insert_Input>;
  group_kpis?: InputMaybe<Group_Kpis_Arr_Rel_Insert_Input>;
  hasura_role?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  images?: InputMaybe<Images_Arr_Rel_Insert_Input>;
  imagesByDeletedById?: InputMaybe<Images_Arr_Rel_Insert_Input>;
  imagesByUpdatedById?: InputMaybe<Images_Arr_Rel_Insert_Input>;
  is_email_verified?: InputMaybe<Scalars['Boolean']['input']>;
  is_phone_verified?: InputMaybe<Scalars['Boolean']['input']>;
  kpis?: InputMaybe<Kpis_Arr_Rel_Insert_Input>;
  kpisByDeletedById?: InputMaybe<Kpis_Arr_Rel_Insert_Input>;
  kpisByUpdatedById?: InputMaybe<Kpis_Arr_Rel_Insert_Input>;
  newsLettersByDeletedById?: InputMaybe<News_Letters_Arr_Rel_Insert_Input>;
  newsLettersByUpdatedById?: InputMaybe<News_Letters_Arr_Rel_Insert_Input>;
  news_letters?: InputMaybe<News_Letters_Arr_Rel_Insert_Input>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Permissions_Arr_Rel_Insert_Input>;
  permissionsByDeletedById?: InputMaybe<Permissions_Arr_Rel_Insert_Input>;
  permissionsByUpdatedById?: InputMaybe<Permissions_Arr_Rel_Insert_Input>;
  permissionsRolesByDeletedById?: InputMaybe<Permissions_Roles_Arr_Rel_Insert_Input>;
  permissionsRolesByUpdatedById?: InputMaybe<Permissions_Roles_Arr_Rel_Insert_Input>;
  permissions_roles?: InputMaybe<Permissions_Roles_Arr_Rel_Insert_Input>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  posts?: InputMaybe<Posts_Arr_Rel_Insert_Input>;
  postsByCreatedById?: InputMaybe<Posts_Arr_Rel_Insert_Input>;
  postsByDeletedById?: InputMaybe<Posts_Arr_Rel_Insert_Input>;
  postsByUpdatedById?: InputMaybe<Posts_Arr_Rel_Insert_Input>;
  postsCatogoriesByDeletedById?: InputMaybe<Posts_Categories_Arr_Rel_Insert_Input>;
  postsCatogoriesByUpdatedById?: InputMaybe<Posts_Categories_Arr_Rel_Insert_Input>;
  postsKpisByDeletedById?: InputMaybe<Posts_Kpis_Arr_Rel_Insert_Input>;
  postsKpisByUpdatedById?: InputMaybe<Posts_Kpis_Arr_Rel_Insert_Input>;
  postsSourcesByDeletedById?: InputMaybe<Posts_Sources_Arr_Rel_Insert_Input>;
  postsSourcesByUpdatedById?: InputMaybe<Posts_Sources_Arr_Rel_Insert_Input>;
  postsTagsByDeletedById?: InputMaybe<Posts_Tags_Arr_Rel_Insert_Input>;
  postsTagsByUpdatedById?: InputMaybe<Posts_Tags_Arr_Rel_Insert_Input>;
  posts_catogories?: InputMaybe<Posts_Categories_Arr_Rel_Insert_Input>;
  posts_kpis?: InputMaybe<Posts_Kpis_Arr_Rel_Insert_Input>;
  posts_likes?: InputMaybe<Posts_Likes_Arr_Rel_Insert_Input>;
  posts_sources?: InputMaybe<Posts_Sources_Arr_Rel_Insert_Input>;
  posts_tags?: InputMaybe<Posts_Tags_Arr_Rel_Insert_Input>;
  preferred_language?: InputMaybe<Languages_Enum>;
  relatedCategoriesByDeletedById?: InputMaybe<Related_Categories_Arr_Rel_Insert_Input>;
  relatedCategoriesByUpdatedById?: InputMaybe<Related_Categories_Arr_Rel_Insert_Input>;
  related_categories?: InputMaybe<Related_Categories_Arr_Rel_Insert_Input>;
  role?: InputMaybe<Roles_Obj_Rel_Insert_Input>;
  role_id?: InputMaybe<Scalars['bigint']['input']>;
  roles?: InputMaybe<Roles_Arr_Rel_Insert_Input>;
  rolesByDeletedById?: InputMaybe<Roles_Arr_Rel_Insert_Input>;
  rolesByUpdatedById?: InputMaybe<Roles_Arr_Rel_Insert_Input>;
  sources?: InputMaybe<Sources_Arr_Rel_Insert_Input>;
  sourcesByDeletedById?: InputMaybe<Sources_Arr_Rel_Insert_Input>;
  sourcesByUpdatedById?: InputMaybe<Sources_Arr_Rel_Insert_Input>;
  tags?: InputMaybe<Tags_Arr_Rel_Insert_Input>;
  tagsByDeletedById?: InputMaybe<Tags_Arr_Rel_Insert_Input>;
  tagsByUpdatedById?: InputMaybe<Tags_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Users_Arr_Rel_Insert_Input>;
  usersByDeletedById?: InputMaybe<Users_Arr_Rel_Insert_Input>;
  usersByUpdatedById?: InputMaybe<Users_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  dob?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  hasura_role?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  role_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "users" */
export type Users_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  dob?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  hasura_role?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  dob?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  hasura_role?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  role_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "users" */
export type Users_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  dob?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  hasura_role?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  address?: InputMaybe<Order_By>;
  avatar_aggregate?: InputMaybe<Images_Aggregate_Order_By>;
  bannersByDeletedById_aggregate?: InputMaybe<Banners_Aggregate_Order_By>;
  bannersByUpdatedById_aggregate?: InputMaybe<Banners_Aggregate_Order_By>;
  banners_aggregate?: InputMaybe<Banners_Aggregate_Order_By>;
  categoriesByDeletedById_aggregate?: InputMaybe<Categories_Aggregate_Order_By>;
  categoriesByUpdatedById_aggregate?: InputMaybe<Categories_Aggregate_Order_By>;
  categories_aggregate?: InputMaybe<Categories_Aggregate_Order_By>;
  comments_aggregate?: InputMaybe<Posts_Comments_Aggregate_Order_By>;
  comments_likes_aggregate?: InputMaybe<Comments_Likes_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Users_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by?: InputMaybe<Users_Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  dob?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  groupKpisByDeletedById_aggregate?: InputMaybe<Group_Kpis_Aggregate_Order_By>;
  groupKpisByUpdatedById_aggregate?: InputMaybe<Group_Kpis_Aggregate_Order_By>;
  group_kpis_aggregate?: InputMaybe<Group_Kpis_Aggregate_Order_By>;
  hasura_role?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imagesByDeletedById_aggregate?: InputMaybe<Images_Aggregate_Order_By>;
  imagesByUpdatedById_aggregate?: InputMaybe<Images_Aggregate_Order_By>;
  images_aggregate?: InputMaybe<Images_Aggregate_Order_By>;
  is_email_verified?: InputMaybe<Order_By>;
  is_phone_verified?: InputMaybe<Order_By>;
  kpisByDeletedById_aggregate?: InputMaybe<Kpis_Aggregate_Order_By>;
  kpisByUpdatedById_aggregate?: InputMaybe<Kpis_Aggregate_Order_By>;
  kpis_aggregate?: InputMaybe<Kpis_Aggregate_Order_By>;
  newsLettersByDeletedById_aggregate?: InputMaybe<News_Letters_Aggregate_Order_By>;
  newsLettersByUpdatedById_aggregate?: InputMaybe<News_Letters_Aggregate_Order_By>;
  news_letters_aggregate?: InputMaybe<News_Letters_Aggregate_Order_By>;
  password?: InputMaybe<Order_By>;
  permissionsByDeletedById_aggregate?: InputMaybe<Permissions_Aggregate_Order_By>;
  permissionsByUpdatedById_aggregate?: InputMaybe<Permissions_Aggregate_Order_By>;
  permissionsRolesByDeletedById_aggregate?: InputMaybe<Permissions_Roles_Aggregate_Order_By>;
  permissionsRolesByUpdatedById_aggregate?: InputMaybe<Permissions_Roles_Aggregate_Order_By>;
  permissions_aggregate?: InputMaybe<Permissions_Aggregate_Order_By>;
  permissions_roles_aggregate?: InputMaybe<Permissions_Roles_Aggregate_Order_By>;
  phone_number?: InputMaybe<Order_By>;
  postsByCreatedById_aggregate?: InputMaybe<Posts_Aggregate_Order_By>;
  postsByDeletedById_aggregate?: InputMaybe<Posts_Aggregate_Order_By>;
  postsByUpdatedById_aggregate?: InputMaybe<Posts_Aggregate_Order_By>;
  postsCatogoriesByDeletedById_aggregate?: InputMaybe<Posts_Categories_Aggregate_Order_By>;
  postsCatogoriesByUpdatedById_aggregate?: InputMaybe<Posts_Categories_Aggregate_Order_By>;
  postsKpisByDeletedById_aggregate?: InputMaybe<Posts_Kpis_Aggregate_Order_By>;
  postsKpisByUpdatedById_aggregate?: InputMaybe<Posts_Kpis_Aggregate_Order_By>;
  postsSourcesByDeletedById_aggregate?: InputMaybe<Posts_Sources_Aggregate_Order_By>;
  postsSourcesByUpdatedById_aggregate?: InputMaybe<Posts_Sources_Aggregate_Order_By>;
  postsTagsByDeletedById_aggregate?: InputMaybe<Posts_Tags_Aggregate_Order_By>;
  postsTagsByUpdatedById_aggregate?: InputMaybe<Posts_Tags_Aggregate_Order_By>;
  posts_aggregate?: InputMaybe<Posts_Aggregate_Order_By>;
  posts_catogories_aggregate?: InputMaybe<Posts_Categories_Aggregate_Order_By>;
  posts_kpis_aggregate?: InputMaybe<Posts_Kpis_Aggregate_Order_By>;
  posts_likes_aggregate?: InputMaybe<Posts_Likes_Aggregate_Order_By>;
  posts_sources_aggregate?: InputMaybe<Posts_Sources_Aggregate_Order_By>;
  posts_tags_aggregate?: InputMaybe<Posts_Tags_Aggregate_Order_By>;
  preferred_language?: InputMaybe<Order_By>;
  relatedCategoriesByDeletedById_aggregate?: InputMaybe<Related_Categories_Aggregate_Order_By>;
  relatedCategoriesByUpdatedById_aggregate?: InputMaybe<Related_Categories_Aggregate_Order_By>;
  related_categories_aggregate?: InputMaybe<Related_Categories_Aggregate_Order_By>;
  role?: InputMaybe<Roles_Order_By>;
  role_id?: InputMaybe<Order_By>;
  rolesByDeletedById_aggregate?: InputMaybe<Roles_Aggregate_Order_By>;
  rolesByUpdatedById_aggregate?: InputMaybe<Roles_Aggregate_Order_By>;
  roles_aggregate?: InputMaybe<Roles_Aggregate_Order_By>;
  sourcesByDeletedById_aggregate?: InputMaybe<Sources_Aggregate_Order_By>;
  sourcesByUpdatedById_aggregate?: InputMaybe<Sources_Aggregate_Order_By>;
  sources_aggregate?: InputMaybe<Sources_Aggregate_Order_By>;
  tagsByDeletedById_aggregate?: InputMaybe<Tags_Aggregate_Order_By>;
  tagsByUpdatedById_aggregate?: InputMaybe<Tags_Aggregate_Order_By>;
  tags_aggregate?: InputMaybe<Tags_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Users_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
  usersByDeletedById_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
  usersByUpdatedById_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
  users_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Dob = 'dob',
  /** column name */
  Email = 'email',
  /** column name */
  FullName = 'full_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  HasuraRole = 'hasura_role',
  /** column name */
  Id = 'id',
  /** column name */
  IsEmailVerified = 'is_email_verified',
  /** column name */
  IsPhoneVerified = 'is_phone_verified',
  /** column name */
  Password = 'password',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PreferredLanguage = 'preferred_language',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Username = 'username'
}

/** select "users_aggregate_bool_exp_bool_and_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsEmailVerified = 'is_email_verified',
  /** column name */
  IsPhoneVerified = 'is_phone_verified'
}

/** select "users_aggregate_bool_exp_bool_or_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsEmailVerified = 'is_email_verified',
  /** column name */
  IsPhoneVerified = 'is_phone_verified'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  dob?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Genders_Enum>;
  hasura_role?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_email_verified?: InputMaybe<Scalars['Boolean']['input']>;
  is_phone_verified?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  preferred_language?: InputMaybe<Languages_Enum>;
  role_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Users_Stddev_Fields = {
  __typename?: 'users_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "users" */
export type Users_Stddev_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Users_Stddev_Pop_Fields = {
  __typename?: 'users_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "users" */
export type Users_Stddev_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Users_Stddev_Samp_Fields = {
  __typename?: 'users_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "users" */
export type Users_Stddev_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['bigint']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['bigint']['input']>;
  dob?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Genders_Enum>;
  hasura_role?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_email_verified?: InputMaybe<Scalars['Boolean']['input']>;
  is_phone_verified?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  preferred_language?: InputMaybe<Languages_Enum>;
  role_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['bigint']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Users_Sum_Fields = {
  __typename?: 'users_sum_fields';
  created_by_id?: Maybe<Scalars['bigint']['output']>;
  deleted_by_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  role_id?: Maybe<Scalars['bigint']['output']>;
  updated_by_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "users" */
export type Users_Sum_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Dob = 'dob',
  /** column name */
  Email = 'email',
  /** column name */
  FullName = 'full_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  HasuraRole = 'hasura_role',
  /** column name */
  Id = 'id',
  /** column name */
  IsEmailVerified = 'is_email_verified',
  /** column name */
  IsPhoneVerified = 'is_phone_verified',
  /** column name */
  Password = 'password',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PreferredLanguage = 'preferred_language',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Username = 'username'
}

export type Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Users_Var_Pop_Fields = {
  __typename?: 'users_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "users" */
export type Users_Var_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Users_Var_Samp_Fields = {
  __typename?: 'users_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "users" */
export type Users_Var_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Users_Variance_Fields = {
  __typename?: 'users_variance_fields';
  created_by_id?: Maybe<Scalars['Float']['output']>;
  deleted_by_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  updated_by_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "users" */
export type Users_Variance_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

export type InfoAdvertisementMutationVariables = Exact<{
  objects: Array<Advertisements_Insert_Input> | Advertisements_Insert_Input;
}>;


export type InfoAdvertisementMutation = { __typename?: 'mutation_root', insert_advertisements?: { __typename?: 'advertisements_mutation_response', affected_rows: number } | null };

export type RegisterMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
}>;


export type RegisterMutation = { __typename?: 'mutation_root', register?: { __typename?: 'RegisterOutput', code: string, data?: any | null, message?: string | null } | null };

export type VerifyEmailMutationVariables = Exact<{
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type VerifyEmailMutation = { __typename?: 'mutation_root', verifyEmail?: { __typename?: 'VerifyEmailOutput', code: string, data?: any | null, message?: string | null } | null };

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ForgotPasswordMutation = { __typename?: 'mutation_root', forgotPassword?: { __typename?: 'ForgotPasswordOutput', code: string, data?: any | null, message?: string | null } | null };

export type ResendConfirmMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ResendConfirmMutation = { __typename?: 'mutation_root', resendConfirm?: { __typename?: 'ResendConfirmOutput', code: string, data?: any | null, message?: string | null } | null };

export type ResetPasswordMutationVariables = Exact<{
  code: Scalars['String']['input'];
  newPassword?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename?: 'mutation_root', resetPassword?: { __typename?: 'ResetPasswordOutput', code: string, data?: any | null, message?: string | null } | null };

export type PostCommentMutationVariables = Exact<{
  object: Posts_Comments_Insert_Input;
}>;


export type PostCommentMutation = { __typename?: 'mutation_root', responseComment?: { __typename?: 'posts_comments', id: any, content: string, createdAt: any, parentCommentId?: any | null, PostId: any, createdBy?: { __typename?: 'users', username?: string | null, email?: string | null, id: any, firstName?: string | null } | null, commentsLikesCount?: { __typename?: 'comments_likes_count', count?: any | null } | null, children: Array<{ __typename?: 'posts_comments', content: string, id: any, createdAt: any, parentCommentId?: any | null, postId: any, commentsLikesCount?: { __typename?: 'comments_likes_count', count?: any | null } | null, createdBy?: { __typename?: 'users', email?: string | null, id: any, firstName?: string | null } | null }> } | null };

export type DeleteCommentMutationVariables = Exact<{
  deletePostsCommentsByPkId: Scalars['bigint']['input'];
}>;


export type DeleteCommentMutation = { __typename?: 'mutation_root', deleteComments?: { __typename?: 'posts_comments', id: any } | null };

export type UpdateCommentMutationVariables = Exact<{
  pkColumns: Posts_Comments_Pk_Columns_Input;
  set?: InputMaybe<Posts_Comments_Set_Input>;
}>;


export type UpdateCommentMutation = { __typename?: 'mutation_root', updatePostByPk?: { __typename?: 'posts_comments', id: any, content: string, createdAt: any, parentCommentId?: any | null, postId: any, createdBy?: { __typename?: 'users', username?: string | null, email?: string | null, id: any, firstName?: string | null } | null, commentsLikesCount?: { __typename?: 'comments_likes_count', count?: any | null } | null, children: Array<{ __typename?: 'posts_comments', children: Array<{ __typename?: 'posts_comments', id: any }> }> } | null };

export type LikeCommentMutationVariables = Exact<{
  object: Comments_Likes_Insert_Input;
}>;


export type LikeCommentMutation = { __typename?: 'mutation_root', insert_comments_likes_one?: { __typename?: 'comments_likes', commentId: any, createdById?: any | null } | null };

export type UnLikedCommentMutationVariables = Exact<{
  where: Comments_Likes_Bool_Exp;
}>;


export type UnLikedCommentMutation = { __typename?: 'mutation_root', delete_comments_likes?: { __typename?: 'comments_likes_mutation_response', affected_rows: number } | null };

export type InfoContactMutationVariables = Exact<{
  objects: Array<News_Letters_Insert_Input> | News_Letters_Insert_Input;
}>;


export type InfoContactMutation = { __typename?: 'mutation_root', insertNewsLetters?: { __typename?: 'news_letters_mutation_response', affected_rows: number } | null };

export type UnlikePostByPkMutationVariables = Exact<{
  deletePostsLikesByPkId: Scalars['bigint']['input'];
}>;


export type UnlikePostByPkMutation = { __typename?: 'mutation_root', delete_posts_likes_by_pk?: { __typename?: 'posts_likes', post_id: any, created_by_id?: any | null } | null };

export type LikePostByPkMutationVariables = Exact<{
  objects: Array<Posts_Likes_Insert_Input> | Posts_Likes_Insert_Input;
}>;


export type LikePostByPkMutation = { __typename?: 'mutation_root', insert_posts_likes?: { __typename?: 'posts_likes_mutation_response', affected_rows: number } | null };

export type ChangeLanguageMutationVariables = Exact<{
  pkColumns: Users_Pk_Columns_Input;
  set?: InputMaybe<Users_Set_Input>;
}>;


export type ChangeLanguageMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', preferred_language: Languages_Enum } | null };

export type UpdateInforUserMutationVariables = Exact<{
  pkColumns: Users_Pk_Columns_Input;
  set?: InputMaybe<Users_Set_Input>;
}>;


export type UpdateInforUserMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', gender?: Genders_Enum | null, dob?: any | null, address?: string | null, fullName?: string | null, phoneNumber?: string | null } | null };

export type GetBannerQueryVariables = Exact<{
  where?: InputMaybe<Banners_Bool_Exp>;
  orderBy?: InputMaybe<Array<Banners_Order_By> | Banners_Order_By>;
}>;


export type GetBannerQuery = { __typename?: 'query_root', banners: Array<{ __typename?: 'banners', position?: Image_Subtypes_Enum | null, targetLink?: string | null, images?: Array<{ __typename?: 'images', object_id: any, filename: string, type: Image_Types_Enum }> | null }> };

export type GetAllCategoriesHomepageQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Categories_Bool_Exp>;
  postsCategoriesLimit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Categories_Order_By> | Categories_Order_By>;
  allPostsOrderBy?: InputMaybe<Array<Posts_Order_By> | Posts_Order_By>;
}>;


export type GetAllCategoriesHomepageQuery = { __typename?: 'query_root', categories: Array<{ __typename?: 'categories', id: any, name?: string | null, slug: string, updatedAt?: any | null, layoutAtHome?: Layouts_Enum | null, orderAtHome?: number | null, pathFullSlug?: { __typename?: 'categories_full_slug', fullSlug?: string | null } | null, children: Array<{ __typename?: 'categories', name?: string | null, slug: string, id: any, pathFullSlug?: { __typename?: 'categories_full_slug', fullSlug?: string | null } | null }>, allPosts?: Array<{ __typename?: 'posts', id: any, slug: string, title?: string | null, shortContent?: string | null, publishedAt?: any | null, createdAt: any, thumbnail?: Array<{ __typename?: 'images', filename: string, type: Image_Types_Enum, objectId: any }> | null, postsCategories: Array<{ __typename?: 'posts_categories', category?: { __typename?: 'categories', slug: string, name?: string | null, id: any, pathFullSlug?: { __typename?: 'categories_full_slug', fullSlug?: string | null } | null } | null }> }> | null }> };

export type GetCategoryBySlugQueryVariables = Exact<{
  where?: InputMaybe<Categories_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  allPostsChildLimit?: InputMaybe<Scalars['Int']['input']>;
  allPostsChildOrderBy?: InputMaybe<Array<Posts_Order_By> | Posts_Order_By>;
  allPostsLimit?: InputMaybe<Scalars['Int']['input']>;
  allPostsOrderBy?: InputMaybe<Array<Posts_Order_By> | Posts_Order_By>;
  allPostsWhere?: InputMaybe<Posts_Bool_Exp>;
}>;


export type GetCategoryBySlugQuery = { __typename?: 'query_root', categories: Array<{ __typename?: 'categories', id: any, name?: string | null, slug: string, layoutAtParentCate?: Layouts_Enum | null, layoutPage?: Layout_Pages_Enum | null, layoutPageTop?: Layout_Page_Tops_Enum | null, layoutPageBottom?: Layout_Page_Bottoms_Enum | null, pathFullSlug?: { __typename?: 'categories_full_slug', fullSlug?: string | null } | null, children: Array<{ __typename?: 'categories', slug: string, name?: string | null, id: any, layoutAtParentCate?: Layouts_Enum | null, pathFullSlug?: { __typename?: 'categories_full_slug', fullSlug?: string | null } | null, children: Array<{ __typename?: 'categories', slug: string, name?: string | null, id: any, pathFullSlug?: { __typename?: 'categories_full_slug', fullSlug?: string | null } | null }>, allPosts?: Array<{ __typename?: 'posts', id: any, slug: string, title?: string | null, shortContent?: string | null, publishedAt?: any | null, createdAt: any, thumbnail?: Array<{ __typename?: 'images', filename: string, type: Image_Types_Enum, objectId: any }> | null, postsCategories: Array<{ __typename?: 'posts_categories', category?: { __typename?: 'categories', id: any, slug: string, name?: string | null, pathFullSlug?: { __typename?: 'categories_full_slug', fullSlug?: string | null } | null } | null }> }> | null }>, relatedCategories: Array<{ __typename?: 'related_categories', category: { __typename?: 'categories', name?: string | null, slug: string, pathFullSlug?: { __typename?: 'categories_full_slug', fullSlug?: string | null } | null, children: Array<{ __typename?: 'categories', slug: string, name?: string | null, id: any, pathFullSlug?: { __typename?: 'categories_full_slug', fullSlug?: string | null } | null }>, allPosts?: Array<{ __typename?: 'posts', id: any, slug: string, title?: string | null, shortContent?: string | null, publishedAt?: any | null, createdAt: any, thumbnail?: Array<{ __typename?: 'images', filename: string, type: Image_Types_Enum, objectId: any }> | null, postsCategories: Array<{ __typename?: 'posts_categories', category?: { __typename?: 'categories', id: any, name?: string | null, slug: string, pathFullSlug?: { __typename?: 'categories_full_slug', fullSlug?: string | null } | null } | null }> }> | null } }>, allPosts?: Array<{ __typename?: 'posts', id: any, slug: string, title?: string | null, shortContent?: string | null, publishedAt?: any | null, createdAt: any, thumbnail?: Array<{ __typename?: 'images', filename: string, type: Image_Types_Enum, objectId: any }> | null, postsCategories: Array<{ __typename?: 'posts_categories', category?: { __typename?: 'categories', id: any, name?: string | null, slug: string, pathFullSlug?: { __typename?: 'categories_full_slug', fullSlug?: string | null } | null } | null }> }> | null }> };

export type GetCategoriesHeaderQueryVariables = Exact<{
  where?: InputMaybe<Categories_Bool_Exp>;
  orderBy?: InputMaybe<Array<Categories_Order_By> | Categories_Order_By>;
}>;


export type GetCategoriesHeaderQuery = { __typename?: 'query_root', categories: Array<{ __typename?: 'categories', slug: string, name?: string | null }> };

export type GetCommentByPostIdQueryVariables = Exact<{
  postId?: InputMaybe<Scalars['bigint']['input']>;
  orderBy?: InputMaybe<Array<Posts_Comments_Order_By> | Posts_Comments_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCommentByPostIdQuery = { __typename?: 'query_root', postComments: Array<{ __typename?: 'posts_comments', content: string, id: any, postId: any, parentCommentId?: any | null, createdAt: any, createdBy?: { __typename?: 'users', username?: string | null, id: any, email?: string | null, firstName?: string | null } | null, children: Array<{ __typename?: 'posts_comments', content: string, id: any, postId: any, parentCommentId?: any | null, createdAt: any, createdBy?: { __typename?: 'users', username?: string | null, id: any, email?: string | null, firstName?: string | null } | null, comments_likes_count?: { __typename?: 'comments_likes_count', count?: any | null } | null, comments_likes: Array<{ __typename?: 'comments_likes', created_by_id?: any | null, comment_id: any }> }>, comments_likes_count?: { __typename?: 'comments_likes_count', count?: any | null } | null, comments_likes: Array<{ __typename?: 'comments_likes', created_by_id?: any | null, comment_id: any }> }>, posts_comments_aggregate: { __typename?: 'posts_comments_aggregate', aggregate?: { __typename?: 'posts_comments_aggregate_fields', count: number } | null }, posts_comments_count: Array<{ __typename?: 'posts_comments_count', count?: any | null }> };

export type GetPostByIdQueryVariables = Exact<{
  postsByPkId: Scalars['bigint']['input'];
}>;


export type GetPostByIdQuery = { __typename?: 'query_root', postsByPk?: { __typename?: 'posts', id: any, content?: string | null, slug: string, title?: string | null, layoutId?: Layout_Posts_Enum | null, totalViews?: number | null, publishedAt?: any | null, shortContent?: string | null, createdAt: any, postsCategories: Array<{ __typename?: 'posts_categories', category?: { __typename?: 'categories', name?: string | null, slug: string, id: any, path_full_slug?: { __typename?: 'categories_full_slug', full_slug?: string | null } | null } | null }>, images?: Array<{ __typename?: 'images', filename: string, type: Image_Types_Enum, objectId: any }> | null, thumbnail?: Array<{ __typename?: 'images', filename: string, type: Image_Types_Enum, objectId: any }> | null, postsTags: Array<{ __typename?: 'posts_tags', tag?: { __typename?: 'tags', id: any, name?: string | null } | null }>, author?: { __typename?: 'users', username?: string | null, id: any, fullName?: string | null } | null, postsSources: Array<{ __typename?: 'posts_sources', source?: { __typename?: 'sources', name?: string | null } | null }> } | null };

export type GetPostsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<Posts_Order_By> | Posts_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Posts_Bool_Exp>;
}>;


export type GetPostsQuery = { __typename?: 'query_root', posts: Array<{ __typename?: 'posts', id: any, title?: string | null, slug: string, location?: string | null, publishedAt?: any | null, shortContent?: string | null, createdAt: any, layoutId?: Layout_Posts_Enum | null, thumbnail?: Array<{ __typename?: 'images', filename: string, type: Image_Types_Enum, objectId: any }> | null, postsCategories: Array<{ __typename?: 'posts_categories', category?: { __typename?: 'categories', id: any, name?: string | null, slug: string, pathFullSlug?: { __typename?: 'categories_full_slug', full_slug?: string | null } | null } | null }> }>, postsAggregate: { __typename?: 'posts_aggregate', aggregate?: { __typename?: 'posts_aggregate_fields', count: number } | null } };

export type SearchPostsQueryVariables = Exact<{
  args: Search_Posts_Args;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Posts_Order_By> | Posts_Order_By>;
  where?: InputMaybe<Posts_Bool_Exp>;
}>;


export type SearchPostsQuery = { __typename?: 'query_root', posts: Array<{ __typename?: 'posts', id: any, slug: string, title?: string | null, shortContent?: string | null, publishedAt?: any | null, createdAt: any, thumbnail?: Array<{ __typename?: 'images', filename: string, type: Image_Types_Enum, objectId: any }> | null, postsCategories: Array<{ __typename?: 'posts_categories', category?: { __typename?: 'categories', id: any, slug: string, name?: string | null } | null }> }>, searchPostsAggregate: { __typename?: 'posts_aggregate', aggregate?: { __typename?: 'posts_aggregate_fields', count: number } | null } };

export type GetPostsByCategoryIdQueryVariables = Exact<{
  args: Get_Posts_By_Category_Id_Args;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Posts_Order_By> | Posts_Order_By>;
  where?: InputMaybe<Posts_Bool_Exp>;
}>;


export type GetPostsByCategoryIdQuery = { __typename?: 'query_root', get_posts_by_category_id: Array<{ __typename?: 'posts', id: any, slug: string, title?: string | null, shortContent?: string | null, publishedAt?: any | null, createdAt: any, thumbnail?: Array<{ __typename?: 'images', filename: string, type: Image_Types_Enum, objectId: any }> | null, postsCategories: Array<{ __typename?: 'posts_categories', category?: { __typename?: 'categories', id: any, slug: string, name?: string | null, pathFullSlug?: { __typename?: 'categories_full_slug', fullSlug?: string | null } | null } | null }> }>, postAggregate: { __typename?: 'posts_aggregate', aggregate?: { __typename?: 'posts_aggregate_fields', count: number } | null } };

export type GetLikesByPostIdQueryVariables = Exact<{
  where?: InputMaybe<Posts_Bool_Exp>;
  postsLikesWhere2?: InputMaybe<Posts_Likes_Bool_Exp>;
}>;


export type GetLikesByPostIdQuery = { __typename?: 'query_root', posts: Array<{ __typename?: 'posts', postsLikesCount?: { __typename?: 'posts_likes_count', count?: any | null } | null, postsLikes: Array<{ __typename?: 'posts_likes', id: any }> }> };

export type GetSeoSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSeoSettingsQuery = { __typename?: 'query_root', settings: Array<{ __typename?: 'settings', type: string, value: any, logo?: Array<{ __typename?: 'images', filename: string, objectId: any }> | null, favicon?: Array<{ __typename?: 'images', filename: string, objectId: any }> | null, adQuote?: Array<{ __typename?: 'images', filename: string, type: Image_Types_Enum, objectId: any }> | null, displayBannerQuote?: Array<{ __typename?: 'images', filename: string, type: Image_Types_Enum, objectId: any }> | null, prPostQuote?: Array<{ __typename?: 'images', filename: string, type: Image_Types_Enum, objectId: any }> | null }> };

export type GetSourceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSourceQuery = { __typename?: 'query_root', sources: Array<{ __typename?: 'sources', id: any, name?: string | null }> };

export type GetAllTagsQueryVariables = Exact<{
  where?: InputMaybe<Tags_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllTagsQuery = { __typename?: 'query_root', tags: Array<{ __typename?: 'tags', id: any, name?: string | null, isHot?: boolean | null }> };

export type GetUserByAwsUserNameQueryVariables = Exact<{
  userId: Scalars['bigint']['input'];
}>;


export type GetUserByAwsUserNameQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', email?: string | null, address?: string | null, gender?: Genders_Enum | null, dob?: any | null, fullName?: string | null, phoneNumber?: string | null, createdAt: any }> };


export const InfoAdvertisementDocument = gql`
    mutation InfoAdvertisement($objects: [advertisements_insert_input!]!) {
  insert_advertisements(objects: $objects) {
    affected_rows
  }
}
    `;
export type InfoAdvertisementMutationFn = Apollo.MutationFunction<InfoAdvertisementMutation, InfoAdvertisementMutationVariables>;

/**
 * __useInfoAdvertisementMutation__
 *
 * To run a mutation, you first call `useInfoAdvertisementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInfoAdvertisementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [infoAdvertisementMutation, { data, loading, error }] = useInfoAdvertisementMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInfoAdvertisementMutation(baseOptions?: Apollo.MutationHookOptions<InfoAdvertisementMutation, InfoAdvertisementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InfoAdvertisementMutation, InfoAdvertisementMutationVariables>(InfoAdvertisementDocument, options);
      }
export type InfoAdvertisementMutationHookResult = ReturnType<typeof useInfoAdvertisementMutation>;
export type InfoAdvertisementMutationResult = Apollo.MutationResult<InfoAdvertisementMutation>;
export type InfoAdvertisementMutationOptions = Apollo.BaseMutationOptions<InfoAdvertisementMutation, InfoAdvertisementMutationVariables>;
export const RegisterDocument = gql`
    mutation Register($email: String!, $password: String!, $displayName: String) {
  register(email: $email, password: $password, display_name: $displayName) {
    code
    data
    message
  }
}
    `;
export type RegisterMutationFn = Apollo.MutationFunction<RegisterMutation, RegisterMutationVariables>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      displayName: // value for 'displayName'
 *   },
 * });
 */
export function useRegisterMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMutation, RegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, options);
      }
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const VerifyEmailDocument = gql`
    mutation VerifyEmail($code: String!, $email: String!) {
  verifyEmail(code: $code, email: $email) {
    code
    data
    message
  }
}
    `;
export type VerifyEmailMutationFn = Apollo.MutationFunction<VerifyEmailMutation, VerifyEmailMutationVariables>;

/**
 * __useVerifyEmailMutation__
 *
 * To run a mutation, you first call `useVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailMutation, { data, loading, error }] = useVerifyEmailMutation({
 *   variables: {
 *      code: // value for 'code'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useVerifyEmailMutation(baseOptions?: Apollo.MutationHookOptions<VerifyEmailMutation, VerifyEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyEmailMutation, VerifyEmailMutationVariables>(VerifyEmailDocument, options);
      }
export type VerifyEmailMutationHookResult = ReturnType<typeof useVerifyEmailMutation>;
export type VerifyEmailMutationResult = Apollo.MutationResult<VerifyEmailMutation>;
export type VerifyEmailMutationOptions = Apollo.BaseMutationOptions<VerifyEmailMutation, VerifyEmailMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword($email: String!) {
  forgotPassword(email: $email) {
    code
    data
    message
  }
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const ResendConfirmDocument = gql`
    mutation ResendConfirm($email: String!) {
  resendConfirm(email: $email) {
    code
    data
    message
  }
}
    `;
export type ResendConfirmMutationFn = Apollo.MutationFunction<ResendConfirmMutation, ResendConfirmMutationVariables>;

/**
 * __useResendConfirmMutation__
 *
 * To run a mutation, you first call `useResendConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendConfirmMutation, { data, loading, error }] = useResendConfirmMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResendConfirmMutation(baseOptions?: Apollo.MutationHookOptions<ResendConfirmMutation, ResendConfirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendConfirmMutation, ResendConfirmMutationVariables>(ResendConfirmDocument, options);
      }
export type ResendConfirmMutationHookResult = ReturnType<typeof useResendConfirmMutation>;
export type ResendConfirmMutationResult = Apollo.MutationResult<ResendConfirmMutation>;
export type ResendConfirmMutationOptions = Apollo.BaseMutationOptions<ResendConfirmMutation, ResendConfirmMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($code: String!, $newPassword: String, $email: String!) {
  resetPassword(code: $code, newPassword: $newPassword, email: $email) {
    code
    data
    message
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      code: // value for 'code'
 *      newPassword: // value for 'newPassword'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const PostCommentDocument = gql`
    mutation PostComment($object: posts_comments_insert_input!) {
  responseComment: insert_posts_comments_one(object: $object) {
    id
    content
    createdAt: created_at
    parentCommentId: parent_comment_id
    PostId: post_id
    createdBy: created_by {
      firstName: full_name
      username
      email
      id
    }
    commentsLikesCount: comments_likes_count {
      count
    }
    children {
      content
      commentsLikesCount: comments_likes_count {
        count
      }
      createdAt: created_at
      createdBy: created_by {
        firstName: full_name
        email
        id
      }
      parentCommentId: parent_comment_id
      id
      postId: post_id
    }
  }
}
    `;
export type PostCommentMutationFn = Apollo.MutationFunction<PostCommentMutation, PostCommentMutationVariables>;

/**
 * __usePostCommentMutation__
 *
 * To run a mutation, you first call `usePostCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postCommentMutation, { data, loading, error }] = usePostCommentMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function usePostCommentMutation(baseOptions?: Apollo.MutationHookOptions<PostCommentMutation, PostCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostCommentMutation, PostCommentMutationVariables>(PostCommentDocument, options);
      }
export type PostCommentMutationHookResult = ReturnType<typeof usePostCommentMutation>;
export type PostCommentMutationResult = Apollo.MutationResult<PostCommentMutation>;
export type PostCommentMutationOptions = Apollo.BaseMutationOptions<PostCommentMutation, PostCommentMutationVariables>;
export const DeleteCommentDocument = gql`
    mutation DeleteComment($deletePostsCommentsByPkId: bigint!) {
  deleteComments: delete_posts_comments_by_pk(id: $deletePostsCommentsByPkId) {
    id
  }
}
    `;
export type DeleteCommentMutationFn = Apollo.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      deletePostsCommentsByPkId: // value for 'deletePostsCommentsByPkId'
 *   },
 * });
 */
export function useDeleteCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, options);
      }
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = Apollo.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const UpdateCommentDocument = gql`
    mutation UpdateComment($pkColumns: posts_comments_pk_columns_input!, $set: posts_comments_set_input) {
  updatePostByPk: update_posts_comments_by_pk(pk_columns: $pkColumns, _set: $set) {
    id
    content
    createdAt: created_at
    parentCommentId: parent_comment_id
    postId: post_id
    createdBy: created_by {
      firstName: full_name
      username
      email
      id
    }
    commentsLikesCount: comments_likes_count {
      count
    }
    children {
      children {
        id
      }
    }
  }
}
    `;
export type UpdateCommentMutationFn = Apollo.MutationFunction<UpdateCommentMutation, UpdateCommentMutationVariables>;

/**
 * __useUpdateCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentMutation, { data, loading, error }] = useUpdateCommentMutation({
 *   variables: {
 *      pkColumns: // value for 'pkColumns'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdateCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommentMutation, UpdateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommentMutation, UpdateCommentMutationVariables>(UpdateCommentDocument, options);
      }
export type UpdateCommentMutationHookResult = ReturnType<typeof useUpdateCommentMutation>;
export type UpdateCommentMutationResult = Apollo.MutationResult<UpdateCommentMutation>;
export type UpdateCommentMutationOptions = Apollo.BaseMutationOptions<UpdateCommentMutation, UpdateCommentMutationVariables>;
export const LikeCommentDocument = gql`
    mutation LikeComment($object: comments_likes_insert_input!) {
  insert_comments_likes_one(object: $object) {
    commentId: comment_id
    createdById: created_by_id
  }
}
    `;
export type LikeCommentMutationFn = Apollo.MutationFunction<LikeCommentMutation, LikeCommentMutationVariables>;

/**
 * __useLikeCommentMutation__
 *
 * To run a mutation, you first call `useLikeCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLikeCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [likeCommentMutation, { data, loading, error }] = useLikeCommentMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useLikeCommentMutation(baseOptions?: Apollo.MutationHookOptions<LikeCommentMutation, LikeCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LikeCommentMutation, LikeCommentMutationVariables>(LikeCommentDocument, options);
      }
export type LikeCommentMutationHookResult = ReturnType<typeof useLikeCommentMutation>;
export type LikeCommentMutationResult = Apollo.MutationResult<LikeCommentMutation>;
export type LikeCommentMutationOptions = Apollo.BaseMutationOptions<LikeCommentMutation, LikeCommentMutationVariables>;
export const UnLikedCommentDocument = gql`
    mutation UnLikedComment($where: comments_likes_bool_exp!) {
  delete_comments_likes(where: $where) {
    affected_rows
  }
}
    `;
export type UnLikedCommentMutationFn = Apollo.MutationFunction<UnLikedCommentMutation, UnLikedCommentMutationVariables>;

/**
 * __useUnLikedCommentMutation__
 *
 * To run a mutation, you first call `useUnLikedCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnLikedCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unLikedCommentMutation, { data, loading, error }] = useUnLikedCommentMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUnLikedCommentMutation(baseOptions?: Apollo.MutationHookOptions<UnLikedCommentMutation, UnLikedCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnLikedCommentMutation, UnLikedCommentMutationVariables>(UnLikedCommentDocument, options);
      }
export type UnLikedCommentMutationHookResult = ReturnType<typeof useUnLikedCommentMutation>;
export type UnLikedCommentMutationResult = Apollo.MutationResult<UnLikedCommentMutation>;
export type UnLikedCommentMutationOptions = Apollo.BaseMutationOptions<UnLikedCommentMutation, UnLikedCommentMutationVariables>;
export const InfoContactDocument = gql`
    mutation InfoContact($objects: [news_letters_insert_input!]!) {
  insertNewsLetters: insert_news_letters(objects: $objects) {
    affected_rows
  }
}
    `;
export type InfoContactMutationFn = Apollo.MutationFunction<InfoContactMutation, InfoContactMutationVariables>;

/**
 * __useInfoContactMutation__
 *
 * To run a mutation, you first call `useInfoContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInfoContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [infoContactMutation, { data, loading, error }] = useInfoContactMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInfoContactMutation(baseOptions?: Apollo.MutationHookOptions<InfoContactMutation, InfoContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InfoContactMutation, InfoContactMutationVariables>(InfoContactDocument, options);
      }
export type InfoContactMutationHookResult = ReturnType<typeof useInfoContactMutation>;
export type InfoContactMutationResult = Apollo.MutationResult<InfoContactMutation>;
export type InfoContactMutationOptions = Apollo.BaseMutationOptions<InfoContactMutation, InfoContactMutationVariables>;
export const UnlikePostByPkDocument = gql`
    mutation UnlikePostByPk($deletePostsLikesByPkId: bigint!) {
  delete_posts_likes_by_pk(id: $deletePostsLikesByPkId) {
    post_id
    created_by_id
  }
}
    `;
export type UnlikePostByPkMutationFn = Apollo.MutationFunction<UnlikePostByPkMutation, UnlikePostByPkMutationVariables>;

/**
 * __useUnlikePostByPkMutation__
 *
 * To run a mutation, you first call `useUnlikePostByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlikePostByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlikePostByPkMutation, { data, loading, error }] = useUnlikePostByPkMutation({
 *   variables: {
 *      deletePostsLikesByPkId: // value for 'deletePostsLikesByPkId'
 *   },
 * });
 */
export function useUnlikePostByPkMutation(baseOptions?: Apollo.MutationHookOptions<UnlikePostByPkMutation, UnlikePostByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlikePostByPkMutation, UnlikePostByPkMutationVariables>(UnlikePostByPkDocument, options);
      }
export type UnlikePostByPkMutationHookResult = ReturnType<typeof useUnlikePostByPkMutation>;
export type UnlikePostByPkMutationResult = Apollo.MutationResult<UnlikePostByPkMutation>;
export type UnlikePostByPkMutationOptions = Apollo.BaseMutationOptions<UnlikePostByPkMutation, UnlikePostByPkMutationVariables>;
export const LikePostByPkDocument = gql`
    mutation LikePostByPk($objects: [posts_likes_insert_input!]!) {
  insert_posts_likes(objects: $objects) {
    affected_rows
  }
}
    `;
export type LikePostByPkMutationFn = Apollo.MutationFunction<LikePostByPkMutation, LikePostByPkMutationVariables>;

/**
 * __useLikePostByPkMutation__
 *
 * To run a mutation, you first call `useLikePostByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLikePostByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [likePostByPkMutation, { data, loading, error }] = useLikePostByPkMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useLikePostByPkMutation(baseOptions?: Apollo.MutationHookOptions<LikePostByPkMutation, LikePostByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LikePostByPkMutation, LikePostByPkMutationVariables>(LikePostByPkDocument, options);
      }
export type LikePostByPkMutationHookResult = ReturnType<typeof useLikePostByPkMutation>;
export type LikePostByPkMutationResult = Apollo.MutationResult<LikePostByPkMutation>;
export type LikePostByPkMutationOptions = Apollo.BaseMutationOptions<LikePostByPkMutation, LikePostByPkMutationVariables>;
export const ChangeLanguageDocument = gql`
    mutation ChangeLanguage($pkColumns: users_pk_columns_input!, $set: users_set_input) {
  update_users_by_pk(pk_columns: $pkColumns, _set: $set) {
    preferred_language
  }
}
    `;
export type ChangeLanguageMutationFn = Apollo.MutationFunction<ChangeLanguageMutation, ChangeLanguageMutationVariables>;

/**
 * __useChangeLanguageMutation__
 *
 * To run a mutation, you first call `useChangeLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeLanguageMutation, { data, loading, error }] = useChangeLanguageMutation({
 *   variables: {
 *      pkColumns: // value for 'pkColumns'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useChangeLanguageMutation(baseOptions?: Apollo.MutationHookOptions<ChangeLanguageMutation, ChangeLanguageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeLanguageMutation, ChangeLanguageMutationVariables>(ChangeLanguageDocument, options);
      }
export type ChangeLanguageMutationHookResult = ReturnType<typeof useChangeLanguageMutation>;
export type ChangeLanguageMutationResult = Apollo.MutationResult<ChangeLanguageMutation>;
export type ChangeLanguageMutationOptions = Apollo.BaseMutationOptions<ChangeLanguageMutation, ChangeLanguageMutationVariables>;
export const UpdateInforUserDocument = gql`
    mutation updateInforUser($pkColumns: users_pk_columns_input!, $set: users_set_input) {
  update_users_by_pk(pk_columns: $pkColumns, _set: $set) {
    fullName: full_name
    gender
    dob
    address
    phoneNumber: phone_number
  }
}
    `;
export type UpdateInforUserMutationFn = Apollo.MutationFunction<UpdateInforUserMutation, UpdateInforUserMutationVariables>;

/**
 * __useUpdateInforUserMutation__
 *
 * To run a mutation, you first call `useUpdateInforUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInforUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInforUserMutation, { data, loading, error }] = useUpdateInforUserMutation({
 *   variables: {
 *      pkColumns: // value for 'pkColumns'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdateInforUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInforUserMutation, UpdateInforUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInforUserMutation, UpdateInforUserMutationVariables>(UpdateInforUserDocument, options);
      }
export type UpdateInforUserMutationHookResult = ReturnType<typeof useUpdateInforUserMutation>;
export type UpdateInforUserMutationResult = Apollo.MutationResult<UpdateInforUserMutation>;
export type UpdateInforUserMutationOptions = Apollo.BaseMutationOptions<UpdateInforUserMutation, UpdateInforUserMutationVariables>;
export const GetBannerDocument = gql`
    query getBanner($where: banners_bool_exp, $orderBy: [banners_order_by!]) {
  banners(where: $where, order_by: $orderBy) {
    images {
      object_id
      filename
      type
    }
    position
    targetLink: target_link
  }
}
    `;

/**
 * __useGetBannerQuery__
 *
 * To run a query within a React component, call `useGetBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBannerQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetBannerQuery(baseOptions?: Apollo.QueryHookOptions<GetBannerQuery, GetBannerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBannerQuery, GetBannerQueryVariables>(GetBannerDocument, options);
      }
export function useGetBannerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBannerQuery, GetBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBannerQuery, GetBannerQueryVariables>(GetBannerDocument, options);
        }
export function useGetBannerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBannerQuery, GetBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBannerQuery, GetBannerQueryVariables>(GetBannerDocument, options);
        }
export type GetBannerQueryHookResult = ReturnType<typeof useGetBannerQuery>;
export type GetBannerLazyQueryHookResult = ReturnType<typeof useGetBannerLazyQuery>;
export type GetBannerSuspenseQueryHookResult = ReturnType<typeof useGetBannerSuspenseQuery>;
export type GetBannerQueryResult = Apollo.QueryResult<GetBannerQuery, GetBannerQueryVariables>;
export const GetAllCategoriesHomepageDocument = gql`
    query getAllCategoriesHomepage($limit: Int, $where: categories_bool_exp, $postsCategoriesLimit: Int, $orderBy: [categories_order_by!], $allPostsOrderBy: [posts_order_by!]) {
  categories(limit: $limit, where: $where, order_by: $orderBy) {
    id
    name
    slug
    pathFullSlug: path_full_slug {
      fullSlug: full_slug
    }
    updatedAt: updated_at
    layoutAtHome: layout_at_home
    children {
      name
      slug
      pathFullSlug: path_full_slug {
        fullSlug: full_slug
      }
      id
    }
    orderAtHome: order_at_home
    allPosts: all_posts(limit: $postsCategoriesLimit, order_by: $allPostsOrderBy) {
      id
      slug
      shortContent: short_content
      title
      publishedAt: published_at
      thumbnail {
        filename
        type
        objectId: object_id
      }
      postsCategories: posts_categories {
        category {
          pathFullSlug: path_full_slug {
            fullSlug: full_slug
          }
          slug
          name
          id
        }
      }
      createdAt: created_at
    }
  }
}
    `;

/**
 * __useGetAllCategoriesHomepageQuery__
 *
 * To run a query within a React component, call `useGetAllCategoriesHomepageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCategoriesHomepageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCategoriesHomepageQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *      postsCategoriesLimit: // value for 'postsCategoriesLimit'
 *      orderBy: // value for 'orderBy'
 *      allPostsOrderBy: // value for 'allPostsOrderBy'
 *   },
 * });
 */
export function useGetAllCategoriesHomepageQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCategoriesHomepageQuery, GetAllCategoriesHomepageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCategoriesHomepageQuery, GetAllCategoriesHomepageQueryVariables>(GetAllCategoriesHomepageDocument, options);
      }
export function useGetAllCategoriesHomepageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCategoriesHomepageQuery, GetAllCategoriesHomepageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCategoriesHomepageQuery, GetAllCategoriesHomepageQueryVariables>(GetAllCategoriesHomepageDocument, options);
        }
export function useGetAllCategoriesHomepageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllCategoriesHomepageQuery, GetAllCategoriesHomepageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCategoriesHomepageQuery, GetAllCategoriesHomepageQueryVariables>(GetAllCategoriesHomepageDocument, options);
        }
export type GetAllCategoriesHomepageQueryHookResult = ReturnType<typeof useGetAllCategoriesHomepageQuery>;
export type GetAllCategoriesHomepageLazyQueryHookResult = ReturnType<typeof useGetAllCategoriesHomepageLazyQuery>;
export type GetAllCategoriesHomepageSuspenseQueryHookResult = ReturnType<typeof useGetAllCategoriesHomepageSuspenseQuery>;
export type GetAllCategoriesHomepageQueryResult = Apollo.QueryResult<GetAllCategoriesHomepageQuery, GetAllCategoriesHomepageQueryVariables>;
export const GetCategoryBySlugDocument = gql`
    query getCategoryBySlug($where: categories_bool_exp, $limit: Int, $allPostsChildLimit: Int, $allPostsChildOrderBy: [posts_order_by!], $allPostsLimit: Int, $allPostsOrderBy: [posts_order_by!], $allPostsWhere: posts_bool_exp) {
  categories(where: $where, limit: $limit) {
    id
    name
    slug
    pathFullSlug: path_full_slug {
      fullSlug: full_slug
    }
    layoutAtParentCate: layout_at_parent_cate
    layoutPage: layout_page
    children {
      layoutAtParentCate: layout_at_parent_cate
      slug
      pathFullSlug: path_full_slug {
        fullSlug: full_slug
      }
      name
      id
      children {
        slug
        name
        id
        pathFullSlug: path_full_slug {
          fullSlug: full_slug
        }
      }
      allPosts: all_posts(limit: $allPostsChildLimit, order_by: $allPostsChildOrderBy) {
        id
        slug
        title
        thumbnail {
          filename
          type
          objectId: object_id
        }
        shortContent: short_content
        publishedAt: published_at
        createdAt: created_at
        postsCategories: posts_categories {
          category {
            id
            slug
            name
            pathFullSlug: path_full_slug {
              fullSlug: full_slug
            }
          }
        }
      }
    }
    relatedCategories: related_categories {
      category {
        name
        slug
        pathFullSlug: path_full_slug {
          fullSlug: full_slug
        }
        children {
          slug
          pathFullSlug: path_full_slug {
            fullSlug: full_slug
          }
          name
          id
        }
        allPosts: all_posts(limit: $allPostsChildLimit, order_by: $allPostsChildOrderBy) {
          id
          slug
          title
          thumbnail {
            filename
            type
            objectId: object_id
          }
          shortContent: short_content
          publishedAt: published_at
          createdAt: created_at
          postsCategories: posts_categories {
            category {
              id
              name
              slug
              pathFullSlug: path_full_slug {
                fullSlug: full_slug
              }
            }
          }
        }
      }
    }
    allPosts: all_posts(
      limit: $allPostsLimit
      order_by: $allPostsOrderBy
      where: $allPostsWhere
    ) {
      id
      slug
      title
      thumbnail {
        filename
        type
        objectId: object_id
      }
      shortContent: short_content
      publishedAt: published_at
      createdAt: created_at
      postsCategories: posts_categories {
        category {
          id
          name
          slug
          pathFullSlug: path_full_slug {
            fullSlug: full_slug
          }
        }
      }
    }
    layoutPageTop: layout_page_top
    layoutPageBottom: layout_page_bottom
  }
}
    `;

/**
 * __useGetCategoryBySlugQuery__
 *
 * To run a query within a React component, call `useGetCategoryBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryBySlugQuery({
 *   variables: {
 *      where: // value for 'where'
 *      limit: // value for 'limit'
 *      allPostsChildLimit: // value for 'allPostsChildLimit'
 *      allPostsChildOrderBy: // value for 'allPostsChildOrderBy'
 *      allPostsLimit: // value for 'allPostsLimit'
 *      allPostsOrderBy: // value for 'allPostsOrderBy'
 *      allPostsWhere: // value for 'allPostsWhere'
 *   },
 * });
 */
export function useGetCategoryBySlugQuery(baseOptions?: Apollo.QueryHookOptions<GetCategoryBySlugQuery, GetCategoryBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoryBySlugQuery, GetCategoryBySlugQueryVariables>(GetCategoryBySlugDocument, options);
      }
export function useGetCategoryBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryBySlugQuery, GetCategoryBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoryBySlugQuery, GetCategoryBySlugQueryVariables>(GetCategoryBySlugDocument, options);
        }
export function useGetCategoryBySlugSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCategoryBySlugQuery, GetCategoryBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoryBySlugQuery, GetCategoryBySlugQueryVariables>(GetCategoryBySlugDocument, options);
        }
export type GetCategoryBySlugQueryHookResult = ReturnType<typeof useGetCategoryBySlugQuery>;
export type GetCategoryBySlugLazyQueryHookResult = ReturnType<typeof useGetCategoryBySlugLazyQuery>;
export type GetCategoryBySlugSuspenseQueryHookResult = ReturnType<typeof useGetCategoryBySlugSuspenseQuery>;
export type GetCategoryBySlugQueryResult = Apollo.QueryResult<GetCategoryBySlugQuery, GetCategoryBySlugQueryVariables>;
export const GetCategoriesHeaderDocument = gql`
    query GetCategoriesHeader($where: categories_bool_exp, $orderBy: [categories_order_by!]) {
  categories(where: $where, order_by: $orderBy) {
    slug
    name
  }
}
    `;

/**
 * __useGetCategoriesHeaderQuery__
 *
 * To run a query within a React component, call `useGetCategoriesHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesHeaderQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetCategoriesHeaderQuery(baseOptions?: Apollo.QueryHookOptions<GetCategoriesHeaderQuery, GetCategoriesHeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesHeaderQuery, GetCategoriesHeaderQueryVariables>(GetCategoriesHeaderDocument, options);
      }
export function useGetCategoriesHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesHeaderQuery, GetCategoriesHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesHeaderQuery, GetCategoriesHeaderQueryVariables>(GetCategoriesHeaderDocument, options);
        }
export function useGetCategoriesHeaderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCategoriesHeaderQuery, GetCategoriesHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoriesHeaderQuery, GetCategoriesHeaderQueryVariables>(GetCategoriesHeaderDocument, options);
        }
export type GetCategoriesHeaderQueryHookResult = ReturnType<typeof useGetCategoriesHeaderQuery>;
export type GetCategoriesHeaderLazyQueryHookResult = ReturnType<typeof useGetCategoriesHeaderLazyQuery>;
export type GetCategoriesHeaderSuspenseQueryHookResult = ReturnType<typeof useGetCategoriesHeaderSuspenseQuery>;
export type GetCategoriesHeaderQueryResult = Apollo.QueryResult<GetCategoriesHeaderQuery, GetCategoriesHeaderQueryVariables>;
export const GetCommentByPostIdDocument = gql`
    query GetCommentByPostId($postId: bigint, $orderBy: [posts_comments_order_by!], $limit: Int, $offset: Int) {
  postComments: posts_comments(
    where: {post_id: {_eq: $postId}, parent_comment_id: {_is_null: true}}
    order_by: $orderBy
    limit: $limit
    offset: $offset
  ) {
    content
    id
    postId: post_id
    parentCommentId: parent_comment_id
    createdAt: created_at
    createdBy: created_by {
      firstName: full_name
      username
      id
      email
    }
    children {
      content
      id
      postId: post_id
      parentCommentId: parent_comment_id
      createdAt: created_at
      createdBy: created_by {
        firstName: full_name
        username
        id
        email
      }
      comments_likes_count {
        count
      }
      comments_likes {
        created_by_id
        comment_id
      }
    }
    comments_likes_count {
      count
    }
    comments_likes {
      created_by_id
      comment_id
    }
  }
  posts_comments_aggregate(
    where: {post_id: {_eq: $postId}, parent_comment_id: {_is_null: true}}
  ) {
    aggregate {
      count
    }
  }
  posts_comments_count(where: {post_id: {_eq: $postId}}) {
    count
  }
}
    `;

/**
 * __useGetCommentByPostIdQuery__
 *
 * To run a query within a React component, call `useGetCommentByPostIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentByPostIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentByPostIdQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *      orderBy: // value for 'orderBy'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetCommentByPostIdQuery(baseOptions?: Apollo.QueryHookOptions<GetCommentByPostIdQuery, GetCommentByPostIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommentByPostIdQuery, GetCommentByPostIdQueryVariables>(GetCommentByPostIdDocument, options);
      }
export function useGetCommentByPostIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommentByPostIdQuery, GetCommentByPostIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommentByPostIdQuery, GetCommentByPostIdQueryVariables>(GetCommentByPostIdDocument, options);
        }
export function useGetCommentByPostIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommentByPostIdQuery, GetCommentByPostIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommentByPostIdQuery, GetCommentByPostIdQueryVariables>(GetCommentByPostIdDocument, options);
        }
export type GetCommentByPostIdQueryHookResult = ReturnType<typeof useGetCommentByPostIdQuery>;
export type GetCommentByPostIdLazyQueryHookResult = ReturnType<typeof useGetCommentByPostIdLazyQuery>;
export type GetCommentByPostIdSuspenseQueryHookResult = ReturnType<typeof useGetCommentByPostIdSuspenseQuery>;
export type GetCommentByPostIdQueryResult = Apollo.QueryResult<GetCommentByPostIdQuery, GetCommentByPostIdQueryVariables>;
export const GetPostByIdDocument = gql`
    query GetPostById($postsByPkId: bigint!) {
  postsByPk: posts_by_pk(id: $postsByPkId) {
    id
    content
    layoutId: layout_id
    postsCategories: posts_categories {
      category {
        name
        slug
        id
        path_full_slug {
          full_slug
        }
      }
    }
    images {
      filename
      type
      objectId: object_id
    }
    slug
    title
    thumbnail {
      filename
      type
      objectId: object_id
    }
    totalViews: total_views
    publishedAt: published_at
    shortContent: short_content
    postsTags: posts_tags {
      tag {
        id
        name
      }
    }
    author {
      username
      id
      fullName: full_name
    }
    createdAt: created_at
    postsSources: posts_sources {
      source {
        name
      }
    }
  }
}
    `;

/**
 * __useGetPostByIdQuery__
 *
 * To run a query within a React component, call `useGetPostByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostByIdQuery({
 *   variables: {
 *      postsByPkId: // value for 'postsByPkId'
 *   },
 * });
 */
export function useGetPostByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPostByIdQuery, GetPostByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostByIdQuery, GetPostByIdQueryVariables>(GetPostByIdDocument, options);
      }
export function useGetPostByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostByIdQuery, GetPostByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostByIdQuery, GetPostByIdQueryVariables>(GetPostByIdDocument, options);
        }
export function useGetPostByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPostByIdQuery, GetPostByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPostByIdQuery, GetPostByIdQueryVariables>(GetPostByIdDocument, options);
        }
export type GetPostByIdQueryHookResult = ReturnType<typeof useGetPostByIdQuery>;
export type GetPostByIdLazyQueryHookResult = ReturnType<typeof useGetPostByIdLazyQuery>;
export type GetPostByIdSuspenseQueryHookResult = ReturnType<typeof useGetPostByIdSuspenseQuery>;
export type GetPostByIdQueryResult = Apollo.QueryResult<GetPostByIdQuery, GetPostByIdQueryVariables>;
export const GetPostsDocument = gql`
    query GetPosts($orderBy: [posts_order_by!], $limit: Int, $offset: Int, $where: posts_bool_exp) {
  posts(order_by: $orderBy, limit: $limit, offset: $offset, where: $where) {
    id
    title
    slug
    thumbnail {
      filename
      type
      objectId: object_id
    }
    postsCategories: posts_categories {
      category {
        id
        name
        slug
        pathFullSlug: path_full_slug {
          full_slug
        }
      }
    }
    publishedAt: published_at
    shortContent: short_content
    createdAt: created_at
    location
    layoutId: layout_id
  }
  postsAggregate: posts_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetPostsQuery__
 *
 * To run a query within a React component, call `useGetPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetPostsQuery(baseOptions?: Apollo.QueryHookOptions<GetPostsQuery, GetPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostsQuery, GetPostsQueryVariables>(GetPostsDocument, options);
      }
export function useGetPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostsQuery, GetPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostsQuery, GetPostsQueryVariables>(GetPostsDocument, options);
        }
export function useGetPostsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPostsQuery, GetPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPostsQuery, GetPostsQueryVariables>(GetPostsDocument, options);
        }
export type GetPostsQueryHookResult = ReturnType<typeof useGetPostsQuery>;
export type GetPostsLazyQueryHookResult = ReturnType<typeof useGetPostsLazyQuery>;
export type GetPostsSuspenseQueryHookResult = ReturnType<typeof useGetPostsSuspenseQuery>;
export type GetPostsQueryResult = Apollo.QueryResult<GetPostsQuery, GetPostsQueryVariables>;
export const SearchPostsDocument = gql`
    query searchPosts($args: search_posts_args!, $limit: Int, $offset: Int, $orderBy: [posts_order_by!], $where: posts_bool_exp) {
  posts: search_posts(
    args: $args
    limit: $limit
    offset: $offset
    order_by: $orderBy
    where: $where
  ) {
    id
    slug
    shortContent: short_content
    title
    publishedAt: published_at
    createdAt: created_at
    thumbnail {
      filename
      type
      objectId: object_id
    }
    postsCategories: posts_categories {
      category {
        id
        slug
        name
      }
    }
  }
  searchPostsAggregate: search_posts_aggregate(args: $args, where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useSearchPostsQuery__
 *
 * To run a query within a React component, call `useSearchPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPostsQuery({
 *   variables: {
 *      args: // value for 'args'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSearchPostsQuery(baseOptions: Apollo.QueryHookOptions<SearchPostsQuery, SearchPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPostsQuery, SearchPostsQueryVariables>(SearchPostsDocument, options);
      }
export function useSearchPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPostsQuery, SearchPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPostsQuery, SearchPostsQueryVariables>(SearchPostsDocument, options);
        }
export function useSearchPostsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchPostsQuery, SearchPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchPostsQuery, SearchPostsQueryVariables>(SearchPostsDocument, options);
        }
export type SearchPostsQueryHookResult = ReturnType<typeof useSearchPostsQuery>;
export type SearchPostsLazyQueryHookResult = ReturnType<typeof useSearchPostsLazyQuery>;
export type SearchPostsSuspenseQueryHookResult = ReturnType<typeof useSearchPostsSuspenseQuery>;
export type SearchPostsQueryResult = Apollo.QueryResult<SearchPostsQuery, SearchPostsQueryVariables>;
export const GetPostsByCategoryIdDocument = gql`
    query GetPostsByCategoryId($args: get_posts_by_category_id_args!, $limit: Int, $offset: Int, $orderBy: [posts_order_by!], $where: posts_bool_exp) {
  get_posts_by_category_id(
    args: $args
    limit: $limit
    offset: $offset
    order_by: $orderBy
    where: $where
  ) {
    id
    slug
    title
    thumbnail {
      filename
      type
      objectId: object_id
    }
    shortContent: short_content
    publishedAt: published_at
    createdAt: created_at
    postsCategories: posts_categories {
      category {
        id
        slug
        name
        pathFullSlug: path_full_slug {
          fullSlug: full_slug
        }
      }
    }
  }
  postAggregate: get_posts_by_category_id_aggregate(args: $args, where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetPostsByCategoryIdQuery__
 *
 * To run a query within a React component, call `useGetPostsByCategoryIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsByCategoryIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsByCategoryIdQuery({
 *   variables: {
 *      args: // value for 'args'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetPostsByCategoryIdQuery(baseOptions: Apollo.QueryHookOptions<GetPostsByCategoryIdQuery, GetPostsByCategoryIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostsByCategoryIdQuery, GetPostsByCategoryIdQueryVariables>(GetPostsByCategoryIdDocument, options);
      }
export function useGetPostsByCategoryIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostsByCategoryIdQuery, GetPostsByCategoryIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostsByCategoryIdQuery, GetPostsByCategoryIdQueryVariables>(GetPostsByCategoryIdDocument, options);
        }
export function useGetPostsByCategoryIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPostsByCategoryIdQuery, GetPostsByCategoryIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPostsByCategoryIdQuery, GetPostsByCategoryIdQueryVariables>(GetPostsByCategoryIdDocument, options);
        }
export type GetPostsByCategoryIdQueryHookResult = ReturnType<typeof useGetPostsByCategoryIdQuery>;
export type GetPostsByCategoryIdLazyQueryHookResult = ReturnType<typeof useGetPostsByCategoryIdLazyQuery>;
export type GetPostsByCategoryIdSuspenseQueryHookResult = ReturnType<typeof useGetPostsByCategoryIdSuspenseQuery>;
export type GetPostsByCategoryIdQueryResult = Apollo.QueryResult<GetPostsByCategoryIdQuery, GetPostsByCategoryIdQueryVariables>;
export const GetLikesByPostIdDocument = gql`
    query GetLikesByPostId($where: posts_bool_exp, $postsLikesWhere2: posts_likes_bool_exp) {
  posts(where: $where) {
    postsLikesCount: posts_likes_count {
      count
    }
    postsLikes: posts_likes(where: $postsLikesWhere2) {
      id
    }
  }
}
    `;

/**
 * __useGetLikesByPostIdQuery__
 *
 * To run a query within a React component, call `useGetLikesByPostIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLikesByPostIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLikesByPostIdQuery({
 *   variables: {
 *      where: // value for 'where'
 *      postsLikesWhere2: // value for 'postsLikesWhere2'
 *   },
 * });
 */
export function useGetLikesByPostIdQuery(baseOptions?: Apollo.QueryHookOptions<GetLikesByPostIdQuery, GetLikesByPostIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLikesByPostIdQuery, GetLikesByPostIdQueryVariables>(GetLikesByPostIdDocument, options);
      }
export function useGetLikesByPostIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLikesByPostIdQuery, GetLikesByPostIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLikesByPostIdQuery, GetLikesByPostIdQueryVariables>(GetLikesByPostIdDocument, options);
        }
export function useGetLikesByPostIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLikesByPostIdQuery, GetLikesByPostIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLikesByPostIdQuery, GetLikesByPostIdQueryVariables>(GetLikesByPostIdDocument, options);
        }
export type GetLikesByPostIdQueryHookResult = ReturnType<typeof useGetLikesByPostIdQuery>;
export type GetLikesByPostIdLazyQueryHookResult = ReturnType<typeof useGetLikesByPostIdLazyQuery>;
export type GetLikesByPostIdSuspenseQueryHookResult = ReturnType<typeof useGetLikesByPostIdSuspenseQuery>;
export type GetLikesByPostIdQueryResult = Apollo.QueryResult<GetLikesByPostIdQuery, GetLikesByPostIdQueryVariables>;
export const GetSeoSettingsDocument = gql`
    query GetSeoSettings {
  settings {
    type
    logo {
      filename
      objectId: object_id
    }
    favicon {
      filename
      objectId: object_id
    }
    value
    adQuote: ad_quote {
      filename
      type
      objectId: object_id
    }
    displayBannerQuote: display_banner_quote {
      objectId: object_id
      filename
      type
    }
    prPostQuote: pr_post_quote {
      filename
      objectId: object_id
      type
    }
  }
}
    `;

/**
 * __useGetSeoSettingsQuery__
 *
 * To run a query within a React component, call `useGetSeoSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeoSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeoSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSeoSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetSeoSettingsQuery, GetSeoSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSeoSettingsQuery, GetSeoSettingsQueryVariables>(GetSeoSettingsDocument, options);
      }
export function useGetSeoSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSeoSettingsQuery, GetSeoSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSeoSettingsQuery, GetSeoSettingsQueryVariables>(GetSeoSettingsDocument, options);
        }
export function useGetSeoSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSeoSettingsQuery, GetSeoSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSeoSettingsQuery, GetSeoSettingsQueryVariables>(GetSeoSettingsDocument, options);
        }
export type GetSeoSettingsQueryHookResult = ReturnType<typeof useGetSeoSettingsQuery>;
export type GetSeoSettingsLazyQueryHookResult = ReturnType<typeof useGetSeoSettingsLazyQuery>;
export type GetSeoSettingsSuspenseQueryHookResult = ReturnType<typeof useGetSeoSettingsSuspenseQuery>;
export type GetSeoSettingsQueryResult = Apollo.QueryResult<GetSeoSettingsQuery, GetSeoSettingsQueryVariables>;
export const GetSourceDocument = gql`
    query getSource {
  sources {
    id
    name
  }
}
    `;

/**
 * __useGetSourceQuery__
 *
 * To run a query within a React component, call `useGetSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSourceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSourceQuery(baseOptions?: Apollo.QueryHookOptions<GetSourceQuery, GetSourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSourceQuery, GetSourceQueryVariables>(GetSourceDocument, options);
      }
export function useGetSourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSourceQuery, GetSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSourceQuery, GetSourceQueryVariables>(GetSourceDocument, options);
        }
export function useGetSourceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSourceQuery, GetSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSourceQuery, GetSourceQueryVariables>(GetSourceDocument, options);
        }
export type GetSourceQueryHookResult = ReturnType<typeof useGetSourceQuery>;
export type GetSourceLazyQueryHookResult = ReturnType<typeof useGetSourceLazyQuery>;
export type GetSourceSuspenseQueryHookResult = ReturnType<typeof useGetSourceSuspenseQuery>;
export type GetSourceQueryResult = Apollo.QueryResult<GetSourceQuery, GetSourceQueryVariables>;
export const GetAllTagsDocument = gql`
    query getAllTags($where: tags_bool_exp, $limit: Int) {
  tags(where: $where, limit: $limit) {
    id
    name
    isHot: is_hot
  }
}
    `;

/**
 * __useGetAllTagsQuery__
 *
 * To run a query within a React component, call `useGetAllTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTagsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAllTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllTagsQuery, GetAllTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTagsQuery, GetAllTagsQueryVariables>(GetAllTagsDocument, options);
      }
export function useGetAllTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTagsQuery, GetAllTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTagsQuery, GetAllTagsQueryVariables>(GetAllTagsDocument, options);
        }
export function useGetAllTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllTagsQuery, GetAllTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllTagsQuery, GetAllTagsQueryVariables>(GetAllTagsDocument, options);
        }
export type GetAllTagsQueryHookResult = ReturnType<typeof useGetAllTagsQuery>;
export type GetAllTagsLazyQueryHookResult = ReturnType<typeof useGetAllTagsLazyQuery>;
export type GetAllTagsSuspenseQueryHookResult = ReturnType<typeof useGetAllTagsSuspenseQuery>;
export type GetAllTagsQueryResult = Apollo.QueryResult<GetAllTagsQuery, GetAllTagsQueryVariables>;
export const GetUserByAwsUserNameDocument = gql`
    query GetUserByAWSUserName($userId: bigint!) {
  users(where: {id: {_eq: $userId}}) {
    email
    fullName: full_name
    phoneNumber: phone_number
    createdAt: created_at
    address
    gender
    dob
  }
}
    `;

/**
 * __useGetUserByAwsUserNameQuery__
 *
 * To run a query within a React component, call `useGetUserByAwsUserNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByAwsUserNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByAwsUserNameQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserByAwsUserNameQuery(baseOptions: Apollo.QueryHookOptions<GetUserByAwsUserNameQuery, GetUserByAwsUserNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByAwsUserNameQuery, GetUserByAwsUserNameQueryVariables>(GetUserByAwsUserNameDocument, options);
      }
export function useGetUserByAwsUserNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByAwsUserNameQuery, GetUserByAwsUserNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByAwsUserNameQuery, GetUserByAwsUserNameQueryVariables>(GetUserByAwsUserNameDocument, options);
        }
export function useGetUserByAwsUserNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserByAwsUserNameQuery, GetUserByAwsUserNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserByAwsUserNameQuery, GetUserByAwsUserNameQueryVariables>(GetUserByAwsUserNameDocument, options);
        }
export type GetUserByAwsUserNameQueryHookResult = ReturnType<typeof useGetUserByAwsUserNameQuery>;
export type GetUserByAwsUserNameLazyQueryHookResult = ReturnType<typeof useGetUserByAwsUserNameLazyQuery>;
export type GetUserByAwsUserNameSuspenseQueryHookResult = ReturnType<typeof useGetUserByAwsUserNameSuspenseQuery>;
export type GetUserByAwsUserNameQueryResult = Apollo.QueryResult<GetUserByAwsUserNameQuery, GetUserByAwsUserNameQueryVariables>;